/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Api
 * Gorilla Works Marketing API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddCrmContactSourceFieldParams,
  AddCrmMailingListMembersParams,
  AddressListDeletionInput,
  AddressListDeletionResult,
  AddressListDeletionReview,
  AddressListInput,
  AddressListUpdate,
  AddressMemberQuantityInput,
  AddressMemberQuantityResult,
  AddressMembershipInput,
  AddressMembershipReceipt,
  AddressMembershipResult,
  AdjustPropertyUsageTracking200,
  AdsCustomerSelection,
  AdsCustomersResponse,
  AdsIntegrationStatus,
  AgencyMailAccount,
  AgencyMailPage,
  AgencyMailSummary,
  AppDashboard,
  ArchiveLobMailAutomationDefinitionParams,
  Audience,
  AudienceInput,
  AutomationStatusIssues,
  AutomationStatusResponse,
  BillingContact,
  BillingContactUpdate,
  BlogAdminState,
  BlogPostControlInput,
  BlogSettingsInput,
  BlogSyncInput,
  BlogSyncResult,
  BulkMarkSeoChangesPreExisting200,
  BulkMarkSeoChangesPreExistingBody,
  Campaign,
  CampaignAttribution,
  CampaignAttributionAnalysis,
  CampaignInput,
  CampaignMailAssociationInput,
  CampaignMailReporting,
  CampaignPage,
  CampaignUpdate,
  CancelCompanyKnowledgeResearchParams,
  CancelLobMailAutomationRunParams,
  CancelLobMailBody,
  Cart,
  CartItemInput,
  CartItemUpdate,
  CheckoutLinkCreate,
  CheckoutLinkItem,
  ClarityCredentialInput,
  ClarityMetrics,
  ClarityWindowInput,
  ClearCrmMailingListCellOverrideParams,
  ClearPropertyTrendSelection200,
  CompanyKnowledge,
  CompanyKnowledgeContext,
  CompanyKnowledgeHistory,
  CompanyKnowledgeInput,
  CompanyKnowledgeRestoreInput,
  CompanyKnowledgeRevision,
  ConfirmLobMailAutomationRunParams,
  ContactConfirmation,
  ContactInput,
  ContactReviewReceipt,
  ContactSourceCatalog,
  Coupon,
  CouponValidationResult,
  CreateCheckoutLink201,
  CreateCouponRequest,
  CreateCrmContactSourceParams,
  CreateCrmMailingListParams,
  CreateLobAddressBookFieldBody,
  CreateLobAddressBookFieldParams,
  CreateLobAddressBookListParams,
  CreateLobMailAutomationDefinitionParams,
  CreateLobMailAutomationEventRunParams,
  CreateLobMailAutomationRunParams,
  CreateLobUploadBody,
  CreateLobUploadExportBody,
  CrmArtworkFields,
  CrmContact,
  CrmContactImportInput,
  CrmContactImportKey,
  CrmContactImportResult,
  CrmContactImportSettings,
  CrmContactListResponse,
  CrmContactSearchResponse,
  CrmContactSource,
  CrmContactSourceFieldInput,
  CrmContactSourceInput,
  CrmContactSources,
  CrmContactUpdate,
  CrmContactUpdateResult,
  CrmMailAutomationEventInput,
  CrmMailAutomationWebhookResult,
  CrmMailingList,
  CrmMailingListColumnLockResult,
  CrmMailingListCreateInput,
  CrmMailingListMemberAddInput,
  CrmMailingListMemberMutationResult,
  CrmMailingListMemberValue,
  CrmMailingListMembersResponse,
  CrmMailingListUpdateInput,
  CurrentRetainedStudyResult,
  CustomOrderItem,
  DailySeriesResponse,
  DeleteCrmMailingList200,
  DeleteCrmMailingListParams,
  DeleteLobAddressBookFieldParams,
  DeleteLobAddressBookListParams,
  DeleteLobAddressParams,
  DeleteLobMailAutomationDraftParams,
  DeleteLobMailAutomationSender200,
  DeleteLobMailAutomationSenderParams,
  DeleteReviewedAddressListParams,
  DownloadCompanyKnowledgeResearchErrorsParams,
  DownloadRetainedReferenceStudy200One,
  DownloadRetainedReferenceStudyParams,
  EddmRecommendInput,
  EddmRoute,
  EddmRouteScored,
  EditAddressListMembershipsParams,
  ErrorEnvelope,
  ErrorResponse,
  ExportLobAddressImportSourceParams,
  ExportLobMailTrackingParams,
  ExportLobReportEventsCsvParams,
  ExportMailAnalyticsCsvParams,
  ExportPropertyBuilder200Two,
  ExportPropertyBuilderParams,
  ExportRidRecipientsCsvParams,
  GaIntegrationStatus,
  GaPropertiesResponse,
  GaPropertySelection,
  GenerateLobQrMailingTokensParams,
  GenerateLobQrTestProofParams,
  GetAddressMembershipReceiptParams,
  GetAgencyMailSummaryParams,
  GetClarityMetricsParams,
  GetCompanyKnowledgeContextParams,
  GetCompanyKnowledgeParams,
  GetCompanyKnowledgeResearchParams,
  GetCompanyKnowledgeRevisionParams,
  GetCrmContactImportSettingsParams,
  GetCrmContactParams,
  GetCrmMailingListParams,
  GetCrmMailingListPreviewMemberParams,
  GetCurrentRetainedReferenceStudyParams,
  GetEddmRouteGeometry200,
  GetEddmRouteGeometryParams,
  GetEddmRoutesParams,
  GetLobAddressBook200,
  GetLobAddressBookFields200,
  GetLobAddressBookFieldsParams,
  GetLobAddressBookListMembers200,
  GetLobAddressBookListMembersParams,
  GetLobAddressBookLists200,
  GetLobAddressBookListsParams,
  GetLobAddressBookParams,
  GetLobAddressBookPropertyData200,
  GetLobAddressBookPropertyDataParams,
  GetLobAddressImportSelection200,
  GetLobAddressImportStatusParams,
  GetLobAddressParams,
  GetLobAutomationMailpieceProof200,
  GetLobAutomationMailpieceProofParams,
  GetLobAutomationStatusIssuesParams,
  GetLobAutomationStatusParams,
  GetLobCampaignAudienceSample200,
  GetLobCampaignMailpieceProof200,
  GetLobCampaignMailpieceProofParams,
  GetLobContactMailpieces200,
  GetLobContactMailpiecesParams,
  GetLobMailAutomationDefinitionParams,
  GetLobMailAutomationDraftDiscardStatus200,
  GetLobMailAutomationDraftDiscardStatusParams,
  GetLobMailAutomationParams,
  GetLobMailAutomationRunParams,
  GetLobMailAutomationSenderAddress200,
  GetLobMailAutomationSenderAddressParams,
  GetLobMailCapabilitiesParams,
  GetLobPropertyAudienceListsParams,
  GetLobQrAnalyticsParams,
  GetLobQrMailingTokensParams,
  GetLobQrTestProofParams,
  GetLobRecipientMailpieces200,
  GetLobRecipientMailpiecesParams,
  GetLobReportSummaryParams,
  GetLobResourceProofParams,
  GetLobTemplateParams,
  GetMailAnalyticsPieceParams,
  GetMailAnalyticsReportParams,
  GetMailClientIdentityParams,
  GetMailIntelligenceParams,
  GetMailOutcomeMapping200,
  GetMailOutcomeMappingParams,
  GetMailOutcomeSources200,
  GetMailReportingAccess200,
  GetMailedDesignAssetParams,
  GetMetaCommentsOverviewParams,
  GetMetaPostActivitySummaryParams,
  GetPropertyBuilder200,
  GetPropertyBuilderGeojson200,
  GetPropertyBuilderImageLinks200,
  GetPropertyBuilderImageLinksParams,
  GetPropertyBuilderPublishOperation200,
  GetPropertyBuilderPublishOperationParams,
  GetPropertyBuilderRecord200,
  GetPropertyBuilderRecords200,
  GetPropertyBuilderRecordsParams,
  GetPropertyBuilderSavedCount200,
  GetPropertyBuilderSavedCount503,
  GetPublicMapCarrierGeometryParams,
  GetPublicMapCarrierRoutes200Item,
  GetPublicMapCarrierRoutesParams,
  GetPublicMapGeocode200,
  GetPublicMapGeocodeParams,
  GetPublicMapRadiusParams,
  GetPublicMapReverseGeocode200,
  GetPublicMapReverseGeocodeParams,
  GetPublicMapStates200Item,
  GetReferenceAddressListsParams,
  GetReferenceIntelligenceParams,
  GetReportsBotToolSpec200,
  GetReportsDailySeriesParams,
  GetReportsOverviewParams,
  GetReportsSearchQueriesParams,
  GetReportsTrafficSourcesParams,
  GetRetainedPropertyDetail200,
  GetRetainedPropertyList200,
  GetRetainedPropertyListMembersParams,
  GetSavedMailArtworkParams,
  GetSavedMailRanking200,
  GetSavedPropertyRefinement200,
  GetSeoChangesParams,
  GetSeoPageVisitsParams,
  GetSeoSourcesParams,
  GetUnifiedAttributionParams,
  GoogleAdsCampaignOptionsPage,
  GoogleAdsCampaignPage,
  GoogleAdsKeywordPage,
  GoogleAdsOverlapPage,
  GoogleAdsSearchTermPage,
  HealthStatus,
  Invitation,
  InvitationInput,
  JobLocationDetail,
  JobLocationDetailParams,
  JobLocationPage,
  JobLocationQuery,
  JobLocationRecordInput,
  JobLocationReviewInput,
  KnowledgeResearchHistory,
  KnowledgeResearchInput,
  KnowledgeResearchJob,
  KnowledgeResearchReport,
  KnowledgeResearchStatus,
  ListAgencyMailSectionParams,
  ListCampaignsPagedParams,
  ListCheckoutLinksParams,
  ListCheckoutPaymentEmailDeliveries200Item,
  ListCompanyKnowledgeHistoryParams,
  ListCompanyKnowledgeResearchHistoryParams,
  ListCrmArtworkFieldsParams,
  ListCrmContactSourcesParams,
  ListCrmContactsParams,
  ListCrmMailingListMembersParams,
  ListCrmMailingLists200,
  ListCrmMailingListsParams,
  ListGoogleAdsCampaignOptionsParams,
  ListGoogleAdsKeywordOverlapParams,
  ListGoogleAdsReportCampaignsParams,
  ListGoogleAdsReportKeywordsParams,
  ListGoogleAdsSearchTermsParams,
  ListKnowledgeDocuments200,
  ListKnowledgeDocumentsParams,
  ListLobAddressImportRowsParams,
  ListLobAddressImports200,
  ListLobAddressesParams,
  ListLobCampaignQrMailpiecesParams,
  ListLobInsertOrdersParams,
  ListLobInsertsParams,
  ListLobMailAutomationDefinitions200,
  ListLobMailAutomationDefinitionsParams,
  ListLobMailAutomationDrafts200,
  ListLobMailAutomationDraftsParams,
  ListLobMailAutomationRunsParams,
  ListLobMailAutomationSenders200,
  ListLobMailAutomationSendersParams,
  ListLobMailHistoryParams,
  ListLobMailParams,
  ListLobManagedResourcesParams,
  ListLobReportEventsParams,
  ListLobTemplateVersionsParams,
  ListLobTemplatesParams,
  ListMailAnalyticsPiecesParams,
  ListMetaDailyInsightsParams,
  ListMetaPostActivityParams,
  ListMetaPostCommentsParams,
  ListMetaPostsParams,
  ListRidRecipientsParams,
  LobActionConfirmation,
  LobAddressBookField,
  LobAddressBookList,
  LobAddressImportAccepted,
  LobAddressImportDetail,
  LobAddressImportPreview,
  LobAddressImportRows,
  LobAddressImportSelection,
  LobAddressImportStatus,
  LobAddressImportValidationSummary,
  LobAddressInput,
  LobAddressVerificationResult,
  LobAddressVerificationSelection,
  LobArtworkPreflightInput,
  LobArtworkPreflightResult,
  LobArtworkRegisterInput,
  LobArtworkRegisterResult,
  LobArtworkUploadUrlInput,
  LobArtworkUploadUrlResult,
  LobAutomationDraft,
  LobAutomationDraftInput,
  LobAutomationSender,
  LobAutomationSenderInput,
  LobBulkEnvelope,
  LobCampaignAudienceCsvInput,
  LobCampaignAudienceDraft,
  LobCampaignAudienceInput,
  LobCampaignContinueInput,
  LobCampaignCreateInput,
  LobCampaignCreativeInput,
  LobCampaignDraftRequest,
  LobCampaignPatchInput,
  LobCampaignQrMailpieces,
  LobCampaignReviewEnvelope,
  LobCampaignSendInput,
  LobCapabilities,
  LobInsertInput,
  LobInsertUpdate,
  LobInventoryOrderInput,
  LobMailAudienceReview,
  LobMailAudienceReviewInput,
  LobMailAutomationArchiveResult,
  LobMailAutomationDefinition,
  LobMailAutomationDefinitionInput,
  LobMailAutomationDefinitionUpdateInput,
  LobMailAutomationEventRunResult,
  LobMailAutomationKeyResponse,
  LobMailAutomationOccurrenceResult,
  LobMailAutomationPreparation,
  LobMailAutomationRescheduleInput,
  LobMailAutomationResponse,
  LobMailAutomationRunConfirmInput,
  LobMailAutomationRunCreated,
  LobMailAutomationRunDetail,
  LobMailAutomationRunDispatchResult,
  LobMailAutomationRunListResponse,
  LobMailAutomationRunPreview,
  LobMailAutomationRunPreviewInput,
  LobMailAutomationSchedulerResult,
  LobMailAutomationVersionInput,
  LobMailDispatchProgress,
  LobMailEventStartInput,
  LobMailInput,
  LobMailPreviewProgress,
  LobMailStatus,
  LobManagedInput,
  LobMutationControl,
  LobOperationalEnvelope,
  LobPage,
  LobPostcardPreparationInput,
  LobPostcardPreparationResult,
  LobPrintLayoutInput,
  LobPrintLayoutResponse,
  LobPropertyAudienceCatalog,
  LobQrLogoInput,
  LobQrProofInput,
  LobQrTestProof,
  LobQrTokenBatch,
  LobQrTokenBatchInput,
  LobResource,
  LobTemplateInput,
  LobTemplatePreview,
  LobVerificationInput,
  LobWebhookEvent,
  LockLobAddressBookListColumnBody,
  LockLobAddressBookListColumnParams,
  MailAnalyticsPieceResponse,
  MailAnalyticsPiecesResponse,
  MailAnalyticsRefreshInput,
  MailAnalyticsRefreshResponse,
  MailAnalyticsReportResponse,
  MailClientIdentity,
  MailIntelligenceReport,
  MailIntelligenceScope,
  MailOutcomeInput,
  MailOutcomeMappingInput,
  MailPreparationReceipt,
  MailPreparationStartInput,
  MailRankSelectionInput,
  MailRankingInput,
  MailingList,
  MailingListInput,
  MetaCommentsOverview,
  MetaCommentsResponse,
  MetaCommentsSummaryRequest,
  MetaCommentsSummaryResponse,
  MetaDailyInsightsResponse,
  MetaPostActivityResponse,
  MetaPostActivitySummary,
  MetaPostHistoryResponse,
  MetaPostsResponse,
  MetaStatusResponse,
  MetaSyncResult,
  OkResponse,
  Order,
  OrderInput,
  OrderSummary,
  OrderUpdateInput,
  OverrideLobAddressBookListCellBody,
  OverrideLobAddressBookListCellParams,
  PatchSeoChangeEventBody,
  PauseLobMailAutomationDispatch200,
  PauseLobMailAutomationDispatchBody,
  PauseLobMailAutomationDispatchParams,
  PaymentMethodsResponse,
  PreflightLobMailArtworkParams,
  PrepareLobPostcardArtworkParams,
  PreviewLobAutomationArtwork200,
  PreviewLobAutomationArtworkParams,
  PreviewLobCampaignPrintLayoutParams,
  PreviewLobMailAutomationRunParams,
  PreviewLobPrintLayoutParams,
  PreviewLobQrLogo200,
  PreviewLobQrLogoParams,
  PreviewMailOutcomeMapping200,
  PreviewMailRanking200,
  PreviewPublishedLobTemplateParams,
  Product,
  PropertyBuilderAction200,
  PropertyBuilderAction429,
  PropertyBuilderActionInput,
  PropertyUsageAllowances,
  PropertyUsageTrackingInput,
  PublicMapGeometry,
  PublicMapStats,
  QueryJobLocationsParams,
  QuoteInput,
  ReadinessCheck200,
  ReadinessCheck503,
  ReceiveLobWebhook200,
  RecoverLobAddressImportValues200,
  RecoverLobAddressImportValuesParams,
  RedeemCouponRequest,
  ReferenceAnalysisConsent,
  ReferenceAnalysisResult,
  ReferenceCoverageInput,
  ReferenceCoverageResult,
  ReferenceIdentityInput,
  ReferenceListCollection,
  ReferenceMemoryRemoval,
  ReferenceMemoryResult,
  ReferencePlanInput,
  ReferencePlanResult,
  ReferenceRankingInput,
  ReferenceRankingResult,
  ReferenceRecordCollection,
  ReferenceStudyCatalog,
  ReferenceVersionInput,
  RegisterLobMailArtworkParams,
  RegisterLobMailAutomationSenderParams,
  RegisterLobPrivateFileBody,
  RegisterLobQrLogo200,
  RegisterLobQrLogoParams,
  RemoveCrmMailingListMember200,
  RemoveCrmMailingListMemberParams,
  RemoveKnowledgeDocument200,
  RemoveKnowledgeDocumentParams,
  RenameLobAddressBookFieldBody,
  RenameLobAddressBookFieldParams,
  RepairAddressTaxpayerNamesParams,
  ReportsApiConnection,
  ReportsApiKeyInput,
  ReportsApiKeyReveal,
  ReportsApiRevocation,
  ReportsOverview,
  ReportsSearchQueriesResponse,
  ReportsTrafficSourcesResponse,
  RequestKnowledgeDocumentUpload201,
  RequestKnowledgeDocumentUploadBody,
  RequestKnowledgeDocumentUploadParams,
  RequestLobMailArtworkUploadUrlParams,
  RequestLobQrLogoUpload200,
  RequestLobQrLogoUploadParams,
  RescheduleLobMailAutomationRunParams,
  ResetLobAddressBookListCellParams,
  RestoreCompanyKnowledgeParams,
  RetainedMatchingConsent,
  RetainedPropertyMemberPage,
  RetainedSelectionResult,
  RetainedStudyConsent,
  RetainedStudyInput,
  RetainedStudyRecoveryInput,
  RetainedStudyResult,
  RetainedStudySelection,
  RetryJobLocations200,
  RetryJobLocationsParams,
  ReviewAddressListDeletionParams,
  ReviewJobLocationParams,
  ReviewLobMailAudienceParams,
  ReviewLobRecipients200,
  ReviewLobRecipientsBody,
  ReviewLobRecipientsParams,
  RidCollectorInput,
  RidInstallationTest,
  RidIntegration,
  RidIntegrationInput,
  RidLinkInput,
  RidPublicConfig,
  RidRecipientReport,
  RidVisit,
  RotateCrmContactImportKeyParams,
  RotateCrmContactSourceKeyParams,
  SaveCompanyKnowledgeParams,
  SaveLobMailAutomationDraftParams,
  SaveMailIntelligenceOutcome200,
  SaveMailRankedList200,
  SavedDesign,
  SavedDesignInput,
  SavedDesignPatch,
  SavedMailArtworkPage,
  SavedMailArtworkReceipt,
  SavedMailArtworkVisibility,
  ScIntegrationStatus,
  ScSiteSelection,
  ScSitesResponse,
  SearchCrmContactsParams,
  SearchLobRecipients200,
  SearchLobRecipientsParams,
  SelectAddressListQuantityParams,
  SeoChangeEvent,
  SeoChangesResponse,
  SeoPageVisitsResponse,
  SeoSiteAnalysisResponse,
  SeoSourcesResponse,
  SeoStatusResponse,
  SetCrmMailingListCellOverrideBody,
  SetCrmMailingListCellOverrideParams,
  SetCrmMailingListColumnLockBody,
  SetCrmMailingListColumnLockParams,
  SetLobMailAutomationDefaultSenderBody,
  SetLobMailAutomationDefaultSenderParams,
  SetSavedMailArtworkVisibilityParams,
  SetupIntentResponse,
  StartCompanyKnowledgeResearchParams,
  StartLobMailPreparationParams,
  StartMailIntelligenceAnalysis202,
  SubscriptionCheckoutRequest,
  SubscriptionCheckoutResponse,
  SubscriptionInvoice,
  SubscriptionPlan,
  SubscriptionPortalResponse,
  SubscriptionStatus,
  SuccessResponse,
  SyncResult,
  TaxpayerNameRepairInput,
  TaxpayerNameRepairResult,
  Tenant,
  TenantInput,
  TenantMember,
  TenantUpdate,
  TrendSelectionClearInput,
  UnifiedAttributionResponse,
  UpdateCouponRequest,
  UpdateCrmContactParams,
  UpdateCrmMailingListParams,
  UpdateLobAddressBookListParams,
  UpdateLobAddressBookValues200,
  UpdateLobAddressBookValuesBody,
  UpdateLobAddressBookValuesParams,
  UpdateLobAddressParams,
  UpdateLobMailAutomationDefinitionParams,
  UploadUrlRequest,
  UploadUrlResponse,
  UserProfile,
  UserProfileUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicMapStatesUrl = () => {




  return `/api/public/map-intel/states`
}

/**
 * @summary Available public Census coverage; no tenant data
 */
export const getPublicMapStates = async ( options?: RequestInit): Promise<GetPublicMapStates200Item[]> => {

  return customFetch<GetPublicMapStates200Item[]>(getGetPublicMapStatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapStatesQueryKey = () => {
    return [
    `/api/public/map-intel/states`
    ] as const;
    }


export const getGetPublicMapStatesQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapStates>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapStatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapStates>>> = ({ signal }) => getPublicMapStates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapStates>>>
export type GetPublicMapStatesQueryError = ErrorType<void>


export function useGetPublicMapStates<TData = Awaited<ReturnType<typeof getPublicMapStates>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapStates>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapStates<TData = Awaited<ReturnType<typeof getPublicMapStates>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapStates>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapStates<TData = Awaited<ReturnType<typeof getPublicMapStates>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Available public Census coverage; no tenant data
 */

export function useGetPublicMapStates<TData = Awaited<ReturnType<typeof getPublicMapStates>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapStatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapStaticDataUrl = (state: string,
    kind: 'stats' | 'routes',) => {




  return `/api/public/map-intel/static-data/${state}/${kind}`
}

export const getPublicMapStaticData = async (state: string,
    kind: 'stats' | 'routes', options?: RequestInit): Promise<PublicMapStats | PublicMapGeometry> => {

  return customFetch<PublicMapStats | PublicMapGeometry>(getGetPublicMapStaticDataUrl(state,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapStaticDataQueryKey = (state: string,
    kind: 'stats' | 'routes',) => {
    return [
    `/api/public/map-intel/static-data/${state}/${kind}`
    ] as const;
    }


export const getGetPublicMapStaticDataQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapStaticData>>, TError = ErrorType<void>>(state: string,
    kind: 'stats' | 'routes', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapStaticDataQueryKey(state,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapStaticData>>> = ({ signal }) => getPublicMapStaticData(state,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: state !== null && state !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapStaticDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapStaticData>>>
export type GetPublicMapStaticDataQueryError = ErrorType<void>


export function useGetPublicMapStaticData<TData = Awaited<ReturnType<typeof getPublicMapStaticData>>, TError = ErrorType<void>>(
 state: string,
    kind: 'stats' | 'routes', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapStaticData>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapStaticData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapStaticData<TData = Awaited<ReturnType<typeof getPublicMapStaticData>>, TError = ErrorType<void>>(
 state: string,
    kind: 'stats' | 'routes', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapStaticData>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapStaticData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapStaticData<TData = Awaited<ReturnType<typeof getPublicMapStaticData>>, TError = ErrorType<void>>(
 state: string,
    kind: 'stats' | 'routes', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapStaticData<TData = Awaited<ReturnType<typeof getPublicMapStaticData>>, TError = ErrorType<void>>(
 state: string,
    kind: 'stats' | 'routes', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapStaticData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapStaticDataQueryOptions(state,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapGeocodeUrl = (params: GetPublicMapGeocodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/map-intel/geocode?${stringifiedParams}` : `/api/public/map-intel/geocode`
}

export const getPublicMapGeocode = async (params: GetPublicMapGeocodeParams, options?: RequestInit): Promise<GetPublicMapGeocode200> => {

  return customFetch<GetPublicMapGeocode200>(getGetPublicMapGeocodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapGeocodeQueryKey = (params?: GetPublicMapGeocodeParams,) => {
    return [
    `/api/public/map-intel/geocode`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicMapGeocodeQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapGeocode>>, TError = ErrorType<void>>(params: GetPublicMapGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapGeocodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapGeocode>>> = ({ signal }) => getPublicMapGeocode(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapGeocodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapGeocode>>>
export type GetPublicMapGeocodeQueryError = ErrorType<void>


export function useGetPublicMapGeocode<TData = Awaited<ReturnType<typeof getPublicMapGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapGeocodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapGeocode>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapGeocode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapGeocode<TData = Awaited<ReturnType<typeof getPublicMapGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapGeocode>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapGeocode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapGeocode<TData = Awaited<ReturnType<typeof getPublicMapGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapGeocode<TData = Awaited<ReturnType<typeof getPublicMapGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapGeocodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapReverseGeocodeUrl = (params: GetPublicMapReverseGeocodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/map-intel/reverse-geocode?${stringifiedParams}` : `/api/public/map-intel/reverse-geocode`
}

export const getPublicMapReverseGeocode = async (params: GetPublicMapReverseGeocodeParams, options?: RequestInit): Promise<GetPublicMapReverseGeocode200> => {

  return customFetch<GetPublicMapReverseGeocode200>(getGetPublicMapReverseGeocodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapReverseGeocodeQueryKey = (params?: GetPublicMapReverseGeocodeParams,) => {
    return [
    `/api/public/map-intel/reverse-geocode`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicMapReverseGeocodeQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError = ErrorType<void>>(params: GetPublicMapReverseGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapReverseGeocodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>> = ({ signal }) => getPublicMapReverseGeocode(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapReverseGeocodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>>
export type GetPublicMapReverseGeocodeQueryError = ErrorType<void>


export function useGetPublicMapReverseGeocode<TData = Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapReverseGeocodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapReverseGeocode>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapReverseGeocode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapReverseGeocode<TData = Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapReverseGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapReverseGeocode>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapReverseGeocode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapReverseGeocode<TData = Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapReverseGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapReverseGeocode<TData = Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError = ErrorType<void>>(
 params: GetPublicMapReverseGeocodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapReverseGeocode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapReverseGeocodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapRadiusUrl = (params: GetPublicMapRadiusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/map-intel/zips-in-radius?${stringifiedParams}` : `/api/public/map-intel/zips-in-radius`
}

export const getPublicMapRadius = async (params: GetPublicMapRadiusParams, options?: RequestInit): Promise<PublicMapGeometry> => {

  return customFetch<PublicMapGeometry>(getGetPublicMapRadiusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapRadiusQueryKey = (params?: GetPublicMapRadiusParams,) => {
    return [
    `/api/public/map-intel/zips-in-radius`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicMapRadiusQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapRadius>>, TError = ErrorType<void>>(params: GetPublicMapRadiusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapRadiusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapRadius>>> = ({ signal }) => getPublicMapRadius(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapRadiusQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapRadius>>>
export type GetPublicMapRadiusQueryError = ErrorType<void>


export function useGetPublicMapRadius<TData = Awaited<ReturnType<typeof getPublicMapRadius>>, TError = ErrorType<void>>(
 params: GetPublicMapRadiusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapRadius>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapRadius>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapRadius<TData = Awaited<ReturnType<typeof getPublicMapRadius>>, TError = ErrorType<void>>(
 params: GetPublicMapRadiusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapRadius>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapRadius>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapRadius<TData = Awaited<ReturnType<typeof getPublicMapRadius>>, TError = ErrorType<void>>(
 params: GetPublicMapRadiusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapRadius<TData = Awaited<ReturnType<typeof getPublicMapRadius>>, TError = ErrorType<void>>(
 params: GetPublicMapRadiusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapRadius>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapRadiusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapCarrierRoutesUrl = (params: GetPublicMapCarrierRoutesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/map-intel/routes?${stringifiedParams}` : `/api/public/map-intel/routes`
}

export const getPublicMapCarrierRoutes = async (params: GetPublicMapCarrierRoutesParams, options?: RequestInit): Promise<GetPublicMapCarrierRoutes200Item[]> => {

  return customFetch<GetPublicMapCarrierRoutes200Item[]>(getGetPublicMapCarrierRoutesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapCarrierRoutesQueryKey = (params?: GetPublicMapCarrierRoutesParams,) => {
    return [
    `/api/public/map-intel/routes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicMapCarrierRoutesQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError = ErrorType<void>>(params: GetPublicMapCarrierRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapCarrierRoutesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>> = ({ signal }) => getPublicMapCarrierRoutes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapCarrierRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>>
export type GetPublicMapCarrierRoutesQueryError = ErrorType<void>


export function useGetPublicMapCarrierRoutes<TData = Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierRoutesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapCarrierRoutes<TData = Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapCarrierRoutes<TData = Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapCarrierRoutes<TData = Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapCarrierRoutesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMapCarrierGeometryUrl = (params: GetPublicMapCarrierGeometryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/map-intel/routes/geometry?${stringifiedParams}` : `/api/public/map-intel/routes/geometry`
}

export const getPublicMapCarrierGeometry = async (params: GetPublicMapCarrierGeometryParams, options?: RequestInit): Promise<PublicMapGeometry> => {

  return customFetch<PublicMapGeometry>(getGetPublicMapCarrierGeometryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMapCarrierGeometryQueryKey = (params?: GetPublicMapCarrierGeometryParams,) => {
    return [
    `/api/public/map-intel/routes/geometry`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicMapCarrierGeometryQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError = ErrorType<void>>(params: GetPublicMapCarrierGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMapCarrierGeometryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>> = ({ signal }) => getPublicMapCarrierGeometry(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMapCarrierGeometryQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>>
export type GetPublicMapCarrierGeometryQueryError = ErrorType<void>


export function useGetPublicMapCarrierGeometry<TData = Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierGeometryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapCarrierGeometry<TData = Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>,
          TError,
          Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMapCarrierGeometry<TData = Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicMapCarrierGeometry<TData = Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError = ErrorType<void>>(
 params: GetPublicMapCarrierGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMapCarrierGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMapCarrierGeometryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAgencyMailAccountsUrl = () => {




  return `/api/agency-mail/accounts`
}

export const listAgencyMailAccounts = async ( options?: RequestInit): Promise<AgencyMailAccount[]> => {

  return customFetch<AgencyMailAccount[]>(getListAgencyMailAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgencyMailAccountsQueryKey = () => {
    return [
    `/api/agency-mail/accounts`
    ] as const;
    }


export const getListAgencyMailAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgencyMailAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgencyMailAccounts>>> = ({ signal }) => listAgencyMailAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgencyMailAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgencyMailAccounts>>>
export type ListAgencyMailAccountsQueryError = ErrorType<unknown>


export function useListAgencyMailAccounts<TData = Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgencyMailAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAgencyMailAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgencyMailAccounts<TData = Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgencyMailAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAgencyMailAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgencyMailAccounts<TData = Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAgencyMailAccounts<TData = Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgencyMailAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyMailSummaryUrl = (params: GetAgencyMailSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency-mail/summary?${stringifiedParams}` : `/api/agency-mail/summary`
}

export const getAgencyMailSummary = async (params: GetAgencyMailSummaryParams, options?: RequestInit): Promise<AgencyMailSummary> => {

  return customFetch<AgencyMailSummary>(getGetAgencyMailSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyMailSummaryQueryKey = (params?: GetAgencyMailSummaryParams,) => {
    return [
    `/api/agency-mail/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyMailSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyMailSummary>>, TError = ErrorType<unknown>>(params: GetAgencyMailSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyMailSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyMailSummary>>> = ({ signal }) => getAgencyMailSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgencyMailSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyMailSummary>>>
export type GetAgencyMailSummaryQueryError = ErrorType<unknown>


export function useGetAgencyMailSummary<TData = Awaited<ReturnType<typeof getAgencyMailSummary>>, TError = ErrorType<unknown>>(
 params: GetAgencyMailSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgencyMailSummary>>,
          TError,
          Awaited<ReturnType<typeof getAgencyMailSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgencyMailSummary<TData = Awaited<ReturnType<typeof getAgencyMailSummary>>, TError = ErrorType<unknown>>(
 params: GetAgencyMailSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgencyMailSummary>>,
          TError,
          Awaited<ReturnType<typeof getAgencyMailSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgencyMailSummary<TData = Awaited<ReturnType<typeof getAgencyMailSummary>>, TError = ErrorType<unknown>>(
 params: GetAgencyMailSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAgencyMailSummary<TData = Awaited<ReturnType<typeof getAgencyMailSummary>>, TError = ErrorType<unknown>>(
 params: GetAgencyMailSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgencyMailSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgencyMailSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAgencyMailSectionUrl = (section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency-mail/sections/${section}?${stringifiedParams}` : `/api/agency-mail/sections/${section}`
}

export const listAgencyMailSection = async (section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options?: RequestInit): Promise<AgencyMailPage> => {

  return customFetch<AgencyMailPage>(getListAgencyMailSectionUrl(section,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgencyMailSectionQueryKey = (section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params?: ListAgencyMailSectionParams,) => {
    return [
    `/api/agency-mail/sections/${section}`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAgencyMailSectionQueryOptions = <TData = Awaited<ReturnType<typeof listAgencyMailSection>>, TError = ErrorType<unknown>>(section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgencyMailSectionQueryKey(section,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgencyMailSection>>> = ({ signal }) => listAgencyMailSection(section,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: section !== null && section !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgencyMailSectionQueryResult = NonNullable<Awaited<ReturnType<typeof listAgencyMailSection>>>
export type ListAgencyMailSectionQueryError = ErrorType<unknown>


export function useListAgencyMailSection<TData = Awaited<ReturnType<typeof listAgencyMailSection>>, TError = ErrorType<unknown>>(
 section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgencyMailSection>>,
          TError,
          Awaited<ReturnType<typeof listAgencyMailSection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgencyMailSection<TData = Awaited<ReturnType<typeof listAgencyMailSection>>, TError = ErrorType<unknown>>(
 section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgencyMailSection>>,
          TError,
          Awaited<ReturnType<typeof listAgencyMailSection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgencyMailSection<TData = Awaited<ReturnType<typeof listAgencyMailSection>>, TError = ErrorType<unknown>>(
 section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAgencyMailSection<TData = Awaited<ReturnType<typeof listAgencyMailSection>>, TError = ErrorType<unknown>>(
 section: 'activity' | 'campaigns' | 'log' | 'templates' | 'addresses' | 'analytics' | 'inventory' | 'crm' | 'lists' | 'definitions' | 'automations' | 'configured' | 'scheduled',
    params: ListAgencyMailSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgencyMailSection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgencyMailSectionQueryOptions(section,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSavedMailArtworkUrl = (params: GetSavedMailArtworkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork/library?${stringifiedParams}` : `/api/lob-mail/automation/artwork/library`
}

/**
 * @summary Bounded local artwork library; no provider calls
 */
export const getSavedMailArtwork = async (params: GetSavedMailArtworkParams, options?: RequestInit): Promise<SavedMailArtworkPage> => {

  return customFetch<SavedMailArtworkPage>(getGetSavedMailArtworkUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedMailArtworkQueryKey = (params?: GetSavedMailArtworkParams,) => {
    return [
    `/api/lob-mail/automation/artwork/library`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSavedMailArtworkQueryOptions = <TData = Awaited<ReturnType<typeof getSavedMailArtwork>>, TError = ErrorType<void>>(params: GetSavedMailArtworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedMailArtworkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedMailArtwork>>> = ({ signal }) => getSavedMailArtwork(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedMailArtworkQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedMailArtwork>>>
export type GetSavedMailArtworkQueryError = ErrorType<void>


export function useGetSavedMailArtwork<TData = Awaited<ReturnType<typeof getSavedMailArtwork>>, TError = ErrorType<void>>(
 params: GetSavedMailArtworkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedMailArtwork>>,
          TError,
          Awaited<ReturnType<typeof getSavedMailArtwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedMailArtwork<TData = Awaited<ReturnType<typeof getSavedMailArtwork>>, TError = ErrorType<void>>(
 params: GetSavedMailArtworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedMailArtwork>>,
          TError,
          Awaited<ReturnType<typeof getSavedMailArtwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedMailArtwork<TData = Awaited<ReturnType<typeof getSavedMailArtwork>>, TError = ErrorType<void>>(
 params: GetSavedMailArtworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bounded local artwork library; no provider calls
 */

export function useGetSavedMailArtwork<TData = Awaited<ReturnType<typeof getSavedMailArtwork>>, TError = ErrorType<void>>(
 params: GetSavedMailArtworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedMailArtworkQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetSavedMailArtworkVisibilityUrl = (id: string,
    params?: SetSavedMailArtworkVisibilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork/library/${id}/visibility?${stringifiedParams}` : `/api/lob-mail/automation/artwork/library/${id}/visibility`
}

/**
 * @summary Manager-only local archive or restore; no mail or provider deletion
 */
export const setSavedMailArtworkVisibility = async (id: string,
    savedMailArtworkVisibility: SavedMailArtworkVisibility,
    params?: SetSavedMailArtworkVisibilityParams, options?: RequestInit): Promise<SavedMailArtworkReceipt> => {

  return customFetch<SavedMailArtworkReceipt>(getSetSavedMailArtworkVisibilityUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedMailArtworkVisibility)
  }
);}




export const getSetSavedMailArtworkVisibilityMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>, TError,{id: string;data: BodyType<SavedMailArtworkVisibility>;params?: SetSavedMailArtworkVisibilityParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>, TError,{id: string;data: BodyType<SavedMailArtworkVisibility>;params?: SetSavedMailArtworkVisibilityParams}, TContext> => {

const mutationKey = ['setSavedMailArtworkVisibility'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>, {id: string;data: BodyType<SavedMailArtworkVisibility>;params?: SetSavedMailArtworkVisibilityParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  setSavedMailArtworkVisibility(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSavedMailArtworkVisibilityMutationResult = NonNullable<Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>>
    export type SetSavedMailArtworkVisibilityMutationBody = BodyType<SavedMailArtworkVisibility>
    export type SetSavedMailArtworkVisibilityMutationError = ErrorType<void>

    /**
 * @summary Manager-only local archive or restore; no mail or provider deletion
 */
export const useSetSavedMailArtworkVisibility = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>, TError,{id: string;data: BodyType<SavedMailArtworkVisibility>;params?: SetSavedMailArtworkVisibilityParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSavedMailArtworkVisibility>>,
        TError,
        {id: string;data: BodyType<SavedMailArtworkVisibility>;params?: SetSavedMailArtworkVisibilityParams},
        TContext
      > => {
      return useMutation(getSetSavedMailArtworkVisibilityMutationOptions(options), queryClient);
    }

export const getSelectAddressListQuantityUrl = (id: number,
    params?: SelectAddressListQuantityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/member-selection?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/member-selection`
}

/**
 * Uses the members table's effective-value search and ascending recipient-reference order, starting at the beginning. Requires editable client scope and current source version. Local references only; no acquisition, mail or automation.
 * @summary Resolve the first N distinct matching members across all pages
 */
export const selectAddressListQuantity = async (id: number,
    addressMemberQuantityInput: AddressMemberQuantityInput,
    params?: SelectAddressListQuantityParams, options?: RequestInit): Promise<AddressMemberQuantityResult> => {

  return customFetch<AddressMemberQuantityResult>(getSelectAddressListQuantityUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressMemberQuantityInput)
  }
);}




export const getSelectAddressListQuantityMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectAddressListQuantity>>, TError,{id: number;data: BodyType<AddressMemberQuantityInput>;params?: SelectAddressListQuantityParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectAddressListQuantity>>, TError,{id: number;data: BodyType<AddressMemberQuantityInput>;params?: SelectAddressListQuantityParams}, TContext> => {

const mutationKey = ['selectAddressListQuantity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectAddressListQuantity>>, {id: number;data: BodyType<AddressMemberQuantityInput>;params?: SelectAddressListQuantityParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  selectAddressListQuantity(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectAddressListQuantityMutationResult = NonNullable<Awaited<ReturnType<typeof selectAddressListQuantity>>>
    export type SelectAddressListQuantityMutationBody = BodyType<AddressMemberQuantityInput>
    export type SelectAddressListQuantityMutationError = ErrorType<void>

    /**
 * @summary Resolve the first N distinct matching members across all pages
 */
export const useSelectAddressListQuantity = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectAddressListQuantity>>, TError,{id: number;data: BodyType<AddressMemberQuantityInput>;params?: SelectAddressListQuantityParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selectAddressListQuantity>>,
        TError,
        {id: number;data: BodyType<AddressMemberQuantityInput>;params?: SelectAddressListQuantityParams},
        TContext
      > => {
      return useMutation(getSelectAddressListQuantityMutationOptions(options), queryClient);
    }

export const getGetRetainedPropertyListUrl = (id: string,) => {




  return `/api/property-builder/lists/${id}`
}

/**
 * @summary Read an agency-local saved list without provider access
 */
export const getRetainedPropertyList = async (id: string, options?: RequestInit): Promise<GetRetainedPropertyList200> => {

  return customFetch<GetRetainedPropertyList200>(getGetRetainedPropertyListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetainedPropertyListQueryKey = (id: string,) => {
    return [
    `/api/property-builder/lists/${id}`
    ] as const;
    }


export const getGetRetainedPropertyListQueryOptions = <TData = Awaited<ReturnType<typeof getRetainedPropertyList>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetainedPropertyListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetainedPropertyList>>> = ({ signal }) => getRetainedPropertyList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetainedPropertyListQueryResult = NonNullable<Awaited<ReturnType<typeof getRetainedPropertyList>>>
export type GetRetainedPropertyListQueryError = ErrorType<void>


export function useGetRetainedPropertyList<TData = Awaited<ReturnType<typeof getRetainedPropertyList>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyList>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyList<TData = Awaited<ReturnType<typeof getRetainedPropertyList>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyList>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyList<TData = Awaited<ReturnType<typeof getRetainedPropertyList>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read an agency-local saved list without provider access
 */

export function useGetRetainedPropertyList<TData = Awaited<ReturnType<typeof getRetainedPropertyList>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetainedPropertyListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRetainedPropertyListMembersUrl = (id: string,
    params?: GetRetainedPropertyListMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/lists/${id}/members?${stringifiedParams}` : `/api/property-builder/lists/${id}/members`
}

/**
 * Agency administrator only, no View-As, local data only. Positions and total include missing members and duplicates in saved order; missing IDs are explicit. A supplied list version must match or returns 409.
 * @summary Read one bounded page of retained saved-list members
 */
export const getRetainedPropertyListMembers = async (id: string,
    params?: GetRetainedPropertyListMembersParams, options?: RequestInit): Promise<RetainedPropertyMemberPage> => {

  return customFetch<RetainedPropertyMemberPage>(getGetRetainedPropertyListMembersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetainedPropertyListMembersQueryKey = (id: string,
    params?: GetRetainedPropertyListMembersParams,) => {
    return [
    `/api/property-builder/lists/${id}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRetainedPropertyListMembersQueryOptions = <TData = Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError = ErrorType<void>>(id: string,
    params?: GetRetainedPropertyListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetainedPropertyListMembersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>> = ({ signal }) => getRetainedPropertyListMembers(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetainedPropertyListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>>
export type GetRetainedPropertyListMembersQueryError = ErrorType<void>


export function useGetRetainedPropertyListMembers<TData = Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetRetainedPropertyListMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyListMembers>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyListMembers<TData = Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: GetRetainedPropertyListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyListMembers>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyListMembers<TData = Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: GetRetainedPropertyListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one bounded page of retained saved-list members
 */

export function useGetRetainedPropertyListMembers<TData = Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: GetRetainedPropertyListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetainedPropertyListMembersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRetainedPropertyDetailUrl = (id: string,) => {




  return `/api/property-builder/properties/${id}`
}

/**
 * @summary Read a retained property under the bounded browsing quota
 */
export const getRetainedPropertyDetail = async (id: string, options?: RequestInit): Promise<GetRetainedPropertyDetail200> => {

  return customFetch<GetRetainedPropertyDetail200>(getGetRetainedPropertyDetailUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetainedPropertyDetailQueryKey = (id: string,) => {
    return [
    `/api/property-builder/properties/${id}`
    ] as const;
    }


export const getGetRetainedPropertyDetailQueryOptions = <TData = Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetainedPropertyDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetainedPropertyDetail>>> = ({ signal }) => getRetainedPropertyDetail(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetainedPropertyDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getRetainedPropertyDetail>>>
export type GetRetainedPropertyDetailQueryError = ErrorType<void>


export function useGetRetainedPropertyDetail<TData = Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyDetail>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyDetail<TData = Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedPropertyDetail>>,
          TError,
          Awaited<ReturnType<typeof getRetainedPropertyDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedPropertyDetail<TData = Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a retained property under the bounded browsing quota
 */

export function useGetRetainedPropertyDetail<TData = Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedPropertyDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetainedPropertyDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRepairAddressTaxpayerNamesUrl = (params: RepairAddressTaxpayerNamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/repair-taxpayer-names?${stringifiedParams}` : `/api/lob-mail/address-book/repair-taxpayer-names`
}

/**
 * Agency administrators only, selected client only, no View-As. Processes at most 100 recipients and 1000 retained transfers per request, keeping shared recipient references together, without provider calls or mail actions.
 * @summary Fill missing recipient names from retained taxpayer evidence
 */
export const repairAddressTaxpayerNames = async (taxpayerNameRepairInput: TaxpayerNameRepairInput,
    params: RepairAddressTaxpayerNamesParams, options?: RequestInit): Promise<TaxpayerNameRepairResult> => {

  return customFetch<TaxpayerNameRepairResult>(getRepairAddressTaxpayerNamesUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taxpayerNameRepairInput)
  }
);}




export const getRepairAddressTaxpayerNamesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairAddressTaxpayerNames>>, TError,{data: BodyType<TaxpayerNameRepairInput>;params: RepairAddressTaxpayerNamesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof repairAddressTaxpayerNames>>, TError,{data: BodyType<TaxpayerNameRepairInput>;params: RepairAddressTaxpayerNamesParams}, TContext> => {

const mutationKey = ['repairAddressTaxpayerNames'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof repairAddressTaxpayerNames>>, {data: BodyType<TaxpayerNameRepairInput>;params: RepairAddressTaxpayerNamesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  repairAddressTaxpayerNames(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RepairAddressTaxpayerNamesMutationResult = NonNullable<Awaited<ReturnType<typeof repairAddressTaxpayerNames>>>
    export type RepairAddressTaxpayerNamesMutationBody = BodyType<TaxpayerNameRepairInput>
    export type RepairAddressTaxpayerNamesMutationError = ErrorType<void>

    /**
 * @summary Fill missing recipient names from retained taxpayer evidence
 */
export const useRepairAddressTaxpayerNames = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairAddressTaxpayerNames>>, TError,{data: BodyType<TaxpayerNameRepairInput>;params: RepairAddressTaxpayerNamesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof repairAddressTaxpayerNames>>,
        TError,
        {data: BodyType<TaxpayerNameRepairInput>;params: RepairAddressTaxpayerNamesParams},
        TContext
      > => {
      return useMutation(getRepairAddressTaxpayerNamesMutationOptions(options), queryClient);
    }

export const getGetBlogAdminUrl = () => {




  return `/api/admin/blog`
}

/**
 * @summary Master-admin blog delivery state
 */
export const getBlogAdmin = async ( options?: RequestInit): Promise<BlogAdminState> => {

  return customFetch<BlogAdminState>(getGetBlogAdminUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBlogAdminQueryKey = () => {
    return [
    `/api/admin/blog`
    ] as const;
    }


export const getGetBlogAdminQueryOptions = <TData = Awaited<ReturnType<typeof getBlogAdmin>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlogAdminQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlogAdmin>>> = ({ signal }) => getBlogAdmin({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBlogAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getBlogAdmin>>>
export type GetBlogAdminQueryError = ErrorType<unknown>


export function useGetBlogAdmin<TData = Awaited<ReturnType<typeof getBlogAdmin>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlogAdmin>>,
          TError,
          Awaited<ReturnType<typeof getBlogAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlogAdmin<TData = Awaited<ReturnType<typeof getBlogAdmin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlogAdmin>>,
          TError,
          Awaited<ReturnType<typeof getBlogAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlogAdmin<TData = Awaited<ReturnType<typeof getBlogAdmin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Master-admin blog delivery state
 */

export function useGetBlogAdmin<TData = Awaited<ReturnType<typeof getBlogAdmin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlogAdmin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBlogAdminQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBlogSettingsUrl = () => {




  return `/api/admin/blog`
}

/**
 * @summary Pause or resume first publication
 */
export const updateBlogSettings = async (blogSettingsInput: BlogSettingsInput, options?: RequestInit): Promise<BlogAdminState> => {

  return customFetch<BlogAdminState>(getUpdateBlogSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blogSettingsInput)
  }
);}




export const getUpdateBlogSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBlogSettings>>, TError,{data: BodyType<BlogSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBlogSettings>>, TError,{data: BodyType<BlogSettingsInput>}, TContext> => {

const mutationKey = ['updateBlogSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBlogSettings>>, {data: BodyType<BlogSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateBlogSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBlogSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateBlogSettings>>>
    export type UpdateBlogSettingsMutationBody = BodyType<BlogSettingsInput>
    export type UpdateBlogSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Pause or resume first publication
 */
export const useUpdateBlogSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBlogSettings>>, TError,{data: BodyType<BlogSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBlogSettings>>,
        TError,
        {data: BodyType<BlogSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateBlogSettingsMutationOptions(options), queryClient);
    }

export const getRunBlogSyncUrl = () => {




  return `/api/admin/blog/sync`
}

/**
 * @summary Validate Notion or run an authorized publication batch
 */
export const runBlogSync = async (blogSyncInput: BlogSyncInput, options?: RequestInit): Promise<BlogSyncResult> => {

  return customFetch<BlogSyncResult>(getRunBlogSyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blogSyncInput)
  }
);}




export const getRunBlogSyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runBlogSync>>, TError,{data: BodyType<BlogSyncInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runBlogSync>>, TError,{data: BodyType<BlogSyncInput>}, TContext> => {

const mutationKey = ['runBlogSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runBlogSync>>, {data: BodyType<BlogSyncInput>}> = (props) => {
          const {data} = props ?? {};

          return  runBlogSync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunBlogSyncMutationResult = NonNullable<Awaited<ReturnType<typeof runBlogSync>>>
    export type RunBlogSyncMutationBody = BodyType<BlogSyncInput>
    export type RunBlogSyncMutationError = ErrorType<unknown>

    /**
 * @summary Validate Notion or run an authorized publication batch
 */
export const useRunBlogSync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runBlogSync>>, TError,{data: BodyType<BlogSyncInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runBlogSync>>,
        TError,
        {data: BodyType<BlogSyncInput>},
        TContext
      > => {
      return useMutation(getRunBlogSyncMutationOptions(options), queryClient);
    }

export const getControlBlogPostUrl = (sourceId: string,) => {




  return `/api/admin/blog/posts/${sourceId}`
}

/**
 * @summary Explicitly unpublish or restore a snapshot
 */
export const controlBlogPost = async (sourceId: string,
    blogPostControlInput: BlogPostControlInput, options?: RequestInit): Promise<BlogAdminState> => {

  return customFetch<BlogAdminState>(getControlBlogPostUrl(sourceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blogPostControlInput)
  }
);}




export const getControlBlogPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof controlBlogPost>>, TError,{sourceId: string;data: BodyType<BlogPostControlInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof controlBlogPost>>, TError,{sourceId: string;data: BodyType<BlogPostControlInput>}, TContext> => {

const mutationKey = ['controlBlogPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof controlBlogPost>>, {sourceId: string;data: BodyType<BlogPostControlInput>}> = (props) => {
          const {sourceId,data} = props ?? {};

          return  controlBlogPost(sourceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ControlBlogPostMutationResult = NonNullable<Awaited<ReturnType<typeof controlBlogPost>>>
    export type ControlBlogPostMutationBody = BodyType<BlogPostControlInput>
    export type ControlBlogPostMutationError = ErrorType<unknown>

    /**
 * @summary Explicitly unpublish or restore a snapshot
 */
export const useControlBlogPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof controlBlogPost>>, TError,{sourceId: string;data: BodyType<BlogPostControlInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof controlBlogPost>>,
        TError,
        {sourceId: string;data: BodyType<BlogPostControlInput>},
        TContext
      > => {
      return useMutation(getControlBlogPostMutationOptions(options), queryClient);
    }

export const getGetReferenceAddressListsUrl = (params: GetReferenceAddressListsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/reference-lists?${stringifiedParams}` : `/api/property-builder/reference-lists`
}

export const getReferenceAddressLists = async (params: GetReferenceAddressListsParams, options?: RequestInit): Promise<ReferenceListCollection> => {

  return customFetch<ReferenceListCollection>(getGetReferenceAddressListsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReferenceAddressListsQueryKey = (params?: GetReferenceAddressListsParams,) => {
    return [
    `/api/property-builder/reference-lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReferenceAddressListsQueryOptions = <TData = Awaited<ReturnType<typeof getReferenceAddressLists>>, TError = ErrorType<void>>(params: GetReferenceAddressListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferenceAddressListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceAddressLists>>> = ({ signal }) => getReferenceAddressLists(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferenceAddressListsQueryResult = NonNullable<Awaited<ReturnType<typeof getReferenceAddressLists>>>
export type GetReferenceAddressListsQueryError = ErrorType<void>


export function useGetReferenceAddressLists<TData = Awaited<ReturnType<typeof getReferenceAddressLists>>, TError = ErrorType<void>>(
 params: GetReferenceAddressListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceAddressLists>>,
          TError,
          Awaited<ReturnType<typeof getReferenceAddressLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceAddressLists<TData = Awaited<ReturnType<typeof getReferenceAddressLists>>, TError = ErrorType<void>>(
 params: GetReferenceAddressListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceAddressLists>>,
          TError,
          Awaited<ReturnType<typeof getReferenceAddressLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceAddressLists<TData = Awaited<ReturnType<typeof getReferenceAddressLists>>, TError = ErrorType<void>>(
 params: GetReferenceAddressListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReferenceAddressLists<TData = Awaited<ReturnType<typeof getReferenceAddressLists>>, TError = ErrorType<void>>(
 params: GetReferenceAddressListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAddressLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferenceAddressListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReferenceIntelligenceUrl = (params: GetReferenceIntelligenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/reference-intelligence?${stringifiedParams}` : `/api/property-builder/reference-intelligence`
}

export const getReferenceIntelligence = async (params: GetReferenceIntelligenceParams, options?: RequestInit): Promise<ReferenceRecordCollection> => {

  return customFetch<ReferenceRecordCollection>(getGetReferenceIntelligenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReferenceIntelligenceQueryKey = (params?: GetReferenceIntelligenceParams,) => {
    return [
    `/api/property-builder/reference-intelligence`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReferenceIntelligenceQueryOptions = <TData = Awaited<ReturnType<typeof getReferenceIntelligence>>, TError = ErrorType<unknown>>(params: GetReferenceIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferenceIntelligenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceIntelligence>>> = ({ signal }) => getReferenceIntelligence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferenceIntelligenceQueryResult = NonNullable<Awaited<ReturnType<typeof getReferenceIntelligence>>>
export type GetReferenceIntelligenceQueryError = ErrorType<unknown>


export function useGetReferenceIntelligence<TData = Awaited<ReturnType<typeof getReferenceIntelligence>>, TError = ErrorType<unknown>>(
 params: GetReferenceIntelligenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceIntelligence>>,
          TError,
          Awaited<ReturnType<typeof getReferenceIntelligence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceIntelligence<TData = Awaited<ReturnType<typeof getReferenceIntelligence>>, TError = ErrorType<unknown>>(
 params: GetReferenceIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceIntelligence>>,
          TError,
          Awaited<ReturnType<typeof getReferenceIntelligence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceIntelligence<TData = Awaited<ReturnType<typeof getReferenceIntelligence>>, TError = ErrorType<unknown>>(
 params: GetReferenceIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReferenceIntelligence<TData = Awaited<ReturnType<typeof getReferenceIntelligence>>, TError = ErrorType<unknown>>(
 params: GetReferenceIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferenceIntelligenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRemoveReferenceMemoryUrl = (id: string,) => {




  return `/api/property-builder/reference-intelligence/${id}`
}

export const removeReferenceMemory = async (id: string,
    referenceMemoryRemoval: ReferenceMemoryRemoval, options?: RequestInit): Promise<ReferenceMemoryResult> => {

  return customFetch<ReferenceMemoryResult>(getRemoveReferenceMemoryUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceMemoryRemoval)
  }
);}




export const getRemoveReferenceMemoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeReferenceMemory>>, TError,{id: string;data: BodyType<ReferenceMemoryRemoval>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeReferenceMemory>>, TError,{id: string;data: BodyType<ReferenceMemoryRemoval>}, TContext> => {

const mutationKey = ['removeReferenceMemory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeReferenceMemory>>, {id: string;data: BodyType<ReferenceMemoryRemoval>}> = (props) => {
          const {id,data} = props ?? {};

          return  removeReferenceMemory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveReferenceMemoryMutationResult = NonNullable<Awaited<ReturnType<typeof removeReferenceMemory>>>
    export type RemoveReferenceMemoryMutationBody = BodyType<ReferenceMemoryRemoval>
    export type RemoveReferenceMemoryMutationError = ErrorType<void>

    export const useRemoveReferenceMemory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeReferenceMemory>>, TError,{id: string;data: BodyType<ReferenceMemoryRemoval>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeReferenceMemory>>,
        TError,
        {id: string;data: BodyType<ReferenceMemoryRemoval>},
        TContext
      > => {
      return useMutation(getRemoveReferenceMemoryMutationOptions(options), queryClient);
    }

export const getGetContactCollectionSourcesUrl = () => {




  return `/api/property-builder/contact-collection-sources`
}

export const getContactCollectionSources = async ( options?: RequestInit): Promise<ContactSourceCatalog> => {

  return customFetch<ContactSourceCatalog>(getGetContactCollectionSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContactCollectionSourcesQueryKey = () => {
    return [
    `/api/property-builder/contact-collection-sources`
    ] as const;
    }


export const getGetContactCollectionSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getContactCollectionSources>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactCollectionSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactCollectionSources>>> = ({ signal }) => getContactCollectionSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactCollectionSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getContactCollectionSources>>>
export type GetContactCollectionSourcesQueryError = ErrorType<unknown>


export function useGetContactCollectionSources<TData = Awaited<ReturnType<typeof getContactCollectionSources>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactCollectionSources>>,
          TError,
          Awaited<ReturnType<typeof getContactCollectionSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactCollectionSources<TData = Awaited<ReturnType<typeof getContactCollectionSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactCollectionSources>>,
          TError,
          Awaited<ReturnType<typeof getContactCollectionSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactCollectionSources<TData = Awaited<ReturnType<typeof getContactCollectionSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContactCollectionSources<TData = Awaited<ReturnType<typeof getContactCollectionSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactCollectionSourcesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetContactCollectionReviewUrl = (id: string,) => {




  return `/api/property-builder/contact-collection-reviews/${id}`
}

export const getContactCollectionReview = async (id: string, options?: RequestInit): Promise<ContactReviewReceipt> => {

  return customFetch<ContactReviewReceipt>(getGetContactCollectionReviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContactCollectionReviewQueryKey = (id: string,) => {
    return [
    `/api/property-builder/contact-collection-reviews/${id}`
    ] as const;
    }


export const getGetContactCollectionReviewQueryOptions = <TData = Awaited<ReturnType<typeof getContactCollectionReview>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactCollectionReviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactCollectionReview>>> = ({ signal }) => getContactCollectionReview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactCollectionReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getContactCollectionReview>>>
export type GetContactCollectionReviewQueryError = ErrorType<void>


export function useGetContactCollectionReview<TData = Awaited<ReturnType<typeof getContactCollectionReview>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactCollectionReview>>,
          TError,
          Awaited<ReturnType<typeof getContactCollectionReview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactCollectionReview<TData = Awaited<ReturnType<typeof getContactCollectionReview>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactCollectionReview>>,
          TError,
          Awaited<ReturnType<typeof getContactCollectionReview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactCollectionReview<TData = Awaited<ReturnType<typeof getContactCollectionReview>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContactCollectionReview<TData = Awaited<ReturnType<typeof getContactCollectionReview>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactCollectionReview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactCollectionReviewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReferenceStudyCatalogUrl = () => {




  return `/api/property-builder/reference-study-catalog`
}

export const getReferenceStudyCatalog = async ( options?: RequestInit): Promise<ReferenceStudyCatalog> => {

  return customFetch<ReferenceStudyCatalog>(getGetReferenceStudyCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReferenceStudyCatalogQueryKey = () => {
    return [
    `/api/property-builder/reference-study-catalog`
    ] as const;
    }


export const getGetReferenceStudyCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferenceStudyCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceStudyCatalog>>> = ({ signal }) => getReferenceStudyCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferenceStudyCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getReferenceStudyCatalog>>>
export type GetReferenceStudyCatalogQueryError = ErrorType<unknown>


export function useGetReferenceStudyCatalog<TData = Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceStudyCatalog>>,
          TError,
          Awaited<ReturnType<typeof getReferenceStudyCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceStudyCatalog<TData = Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceStudyCatalog>>,
          TError,
          Awaited<ReturnType<typeof getReferenceStudyCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceStudyCatalog<TData = Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReferenceStudyCatalog<TData = Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceStudyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferenceStudyCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClearPropertyTrendSelectionUrl = (id: string,) => {




  return `/api/property-builder/workspaces/${id}/trend-selection`
}

export const clearPropertyTrendSelection = async (id: string,
    trendSelectionClearInput: TrendSelectionClearInput, options?: RequestInit): Promise<ClearPropertyTrendSelection200> => {

  return customFetch<ClearPropertyTrendSelection200>(getClearPropertyTrendSelectionUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trendSelectionClearInput)
  }
);}




export const getClearPropertyTrendSelectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearPropertyTrendSelection>>, TError,{id: string;data: BodyType<TrendSelectionClearInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearPropertyTrendSelection>>, TError,{id: string;data: BodyType<TrendSelectionClearInput>}, TContext> => {

const mutationKey = ['clearPropertyTrendSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearPropertyTrendSelection>>, {id: string;data: BodyType<TrendSelectionClearInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  clearPropertyTrendSelection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearPropertyTrendSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof clearPropertyTrendSelection>>>
    export type ClearPropertyTrendSelectionMutationBody = BodyType<TrendSelectionClearInput>
    export type ClearPropertyTrendSelectionMutationError = ErrorType<unknown>

    export const useClearPropertyTrendSelection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearPropertyTrendSelection>>, TError,{id: string;data: BodyType<TrendSelectionClearInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearPropertyTrendSelection>>,
        TError,
        {id: string;data: BodyType<TrendSelectionClearInput>},
        TContext
      > => {
      return useMutation(getClearPropertyTrendSelectionMutationOptions(options), queryClient);
    }

export const getReviewRetainedReferenceStudyUrl = () => {




  return `/api/property-builder/reference-studies/review`
}

export const reviewRetainedReferenceStudy = async (retainedStudyInput: RetainedStudyInput, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getReviewRetainedReferenceStudyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retainedStudyInput)
  }
);}




export const getReviewRetainedReferenceStudyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyInput>}, TContext> => {

const mutationKey = ['reviewRetainedReferenceStudy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>, {data: BodyType<RetainedStudyInput>}> = (props) => {
          const {data} = props ?? {};

          return  reviewRetainedReferenceStudy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewRetainedReferenceStudyMutationResult = NonNullable<Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>>
    export type ReviewRetainedReferenceStudyMutationBody = BodyType<RetainedStudyInput>
    export type ReviewRetainedReferenceStudyMutationError = ErrorType<unknown>

    export const useReviewRetainedReferenceStudy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewRetainedReferenceStudy>>,
        TError,
        {data: BodyType<RetainedStudyInput>},
        TContext
      > => {
      return useMutation(getReviewRetainedReferenceStudyMutationOptions(options), queryClient);
    }

export const getApproveRetainedReferenceStudyUrl = () => {




  return `/api/property-builder/reference-studies/approve`
}

export const approveRetainedReferenceStudy = async (retainedStudyConsent: RetainedStudyConsent, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getApproveRetainedReferenceStudyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retainedStudyConsent)
  }
);}




export const getApproveRetainedReferenceStudyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyConsent>}, TContext> => {

const mutationKey = ['approveRetainedReferenceStudy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveRetainedReferenceStudy>>, {data: BodyType<RetainedStudyConsent>}> = (props) => {
          const {data} = props ?? {};

          return  approveRetainedReferenceStudy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveRetainedReferenceStudyMutationResult = NonNullable<Awaited<ReturnType<typeof approveRetainedReferenceStudy>>>
    export type ApproveRetainedReferenceStudyMutationBody = BodyType<RetainedStudyConsent>
    export type ApproveRetainedReferenceStudyMutationError = ErrorType<void>

    export const useApproveRetainedReferenceStudy = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveRetainedReferenceStudy>>,
        TError,
        {data: BodyType<RetainedStudyConsent>},
        TContext
      > => {
      return useMutation(getApproveRetainedReferenceStudyMutationOptions(options), queryClient);
    }

export const getApproveRetainedStudyMatchingUrl = () => {




  return `/api/property-builder/reference-studies/approve-matching`
}

export const approveRetainedStudyMatching = async (retainedMatchingConsent: RetainedMatchingConsent, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getApproveRetainedStudyMatchingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retainedMatchingConsent)
  }
);}




export const getApproveRetainedStudyMatchingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRetainedStudyMatching>>, TError,{data: BodyType<RetainedMatchingConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveRetainedStudyMatching>>, TError,{data: BodyType<RetainedMatchingConsent>}, TContext> => {

const mutationKey = ['approveRetainedStudyMatching'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveRetainedStudyMatching>>, {data: BodyType<RetainedMatchingConsent>}> = (props) => {
          const {data} = props ?? {};

          return  approveRetainedStudyMatching(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveRetainedStudyMatchingMutationResult = NonNullable<Awaited<ReturnType<typeof approveRetainedStudyMatching>>>
    export type ApproveRetainedStudyMatchingMutationBody = BodyType<RetainedMatchingConsent>
    export type ApproveRetainedStudyMatchingMutationError = ErrorType<void>

    export const useApproveRetainedStudyMatching = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRetainedStudyMatching>>, TError,{data: BodyType<RetainedMatchingConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveRetainedStudyMatching>>,
        TError,
        {data: BodyType<RetainedMatchingConsent>},
        TContext
      > => {
      return useMutation(getApproveRetainedStudyMatchingMutationOptions(options), queryClient);
    }

export const getSelectRetainedReferencePropertiesUrl = () => {




  return `/api/property-builder/reference-studies/select`
}

export const selectRetainedReferenceProperties = async (retainedStudySelection: RetainedStudySelection, options?: RequestInit): Promise<RetainedSelectionResult> => {

  return customFetch<RetainedSelectionResult>(getSelectRetainedReferencePropertiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retainedStudySelection)
  }
);}




export const getSelectRetainedReferencePropertiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectRetainedReferenceProperties>>, TError,{data: BodyType<RetainedStudySelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectRetainedReferenceProperties>>, TError,{data: BodyType<RetainedStudySelection>}, TContext> => {

const mutationKey = ['selectRetainedReferenceProperties'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectRetainedReferenceProperties>>, {data: BodyType<RetainedStudySelection>}> = (props) => {
          const {data} = props ?? {};

          return  selectRetainedReferenceProperties(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectRetainedReferencePropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof selectRetainedReferenceProperties>>>
    export type SelectRetainedReferencePropertiesMutationBody = BodyType<RetainedStudySelection>
    export type SelectRetainedReferencePropertiesMutationError = ErrorType<unknown>

    export const useSelectRetainedReferenceProperties = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectRetainedReferenceProperties>>, TError,{data: BodyType<RetainedStudySelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selectRetainedReferenceProperties>>,
        TError,
        {data: BodyType<RetainedStudySelection>},
        TContext
      > => {
      return useMutation(getSelectRetainedReferencePropertiesMutationOptions(options), queryClient);
    }

export const getGetCurrentRetainedReferenceStudyUrl = (params: GetCurrentRetainedReferenceStudyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/reference-studies/current?${stringifiedParams}` : `/api/property-builder/reference-studies/current`
}

export const getCurrentRetainedReferenceStudy = async (params: GetCurrentRetainedReferenceStudyParams, options?: RequestInit): Promise<CurrentRetainedStudyResult> => {

  return customFetch<CurrentRetainedStudyResult>(getGetCurrentRetainedReferenceStudyUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentRetainedReferenceStudyQueryKey = (params?: GetCurrentRetainedReferenceStudyParams,) => {
    return [
    `/api/property-builder/reference-studies/current`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCurrentRetainedReferenceStudyQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError = ErrorType<void>>(params: GetCurrentRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentRetainedReferenceStudyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>> = ({ signal }) => getCurrentRetainedReferenceStudy(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentRetainedReferenceStudyQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>>
export type GetCurrentRetainedReferenceStudyQueryError = ErrorType<void>


export function useGetCurrentRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError = ErrorType<void>>(
 params: GetCurrentRetainedReferenceStudyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError = ErrorType<void>>(
 params: GetCurrentRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError = ErrorType<void>>(
 params: GetCurrentRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError = ErrorType<void>>(
 params: GetCurrentRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentRetainedReferenceStudyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecoverRetainedReferenceStudyUrl = () => {




  return `/api/property-builder/reference-studies/recover`
}

export const recoverRetainedReferenceStudy = async (retainedStudyRecoveryInput: RetainedStudyRecoveryInput, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getRecoverRetainedReferenceStudyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retainedStudyRecoveryInput)
  }
);}




export const getRecoverRetainedReferenceStudyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyRecoveryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyRecoveryInput>}, TContext> => {

const mutationKey = ['recoverRetainedReferenceStudy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>, {data: BodyType<RetainedStudyRecoveryInput>}> = (props) => {
          const {data} = props ?? {};

          return  recoverRetainedReferenceStudy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverRetainedReferenceStudyMutationResult = NonNullable<Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>>
    export type RecoverRetainedReferenceStudyMutationBody = BodyType<RetainedStudyRecoveryInput>
    export type RecoverRetainedReferenceStudyMutationError = ErrorType<void>

    export const useRecoverRetainedReferenceStudy = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>, TError,{data: BodyType<RetainedStudyRecoveryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recoverRetainedReferenceStudy>>,
        TError,
        {data: BodyType<RetainedStudyRecoveryInput>},
        TContext
      > => {
      return useMutation(getRecoverRetainedReferenceStudyMutationOptions(options), queryClient);
    }

export const getGetRetainedReferenceStudyUrl = (id: string,) => {




  return `/api/property-builder/reference-studies/${id}`
}

export const getRetainedReferenceStudy = async (id: string, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getGetRetainedReferenceStudyUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetainedReferenceStudyQueryKey = (id: string,) => {
    return [
    `/api/property-builder/reference-studies/${id}`
    ] as const;
    }


export const getGetRetainedReferenceStudyQueryOptions = <TData = Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetainedReferenceStudyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetainedReferenceStudy>>> = ({ signal }) => getRetainedReferenceStudy(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetainedReferenceStudyQueryResult = NonNullable<Awaited<ReturnType<typeof getRetainedReferenceStudy>>>
export type GetRetainedReferenceStudyQueryError = ErrorType<void>


export function useGetRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof getRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof getRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRetainedReferenceStudy<TData = Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetainedReferenceStudyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelRetainedReferenceStudyUrl = (id: string,) => {




  return `/api/property-builder/reference-studies/${id}`
}

export const cancelRetainedReferenceStudy = async (id: string,
    referenceVersionInput: ReferenceVersionInput, options?: RequestInit): Promise<RetainedStudyResult> => {

  return customFetch<RetainedStudyResult>(getCancelRetainedReferenceStudyUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceVersionInput)
  }
);}




export const getCancelRetainedReferenceStudyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext> => {

const mutationKey = ['cancelRetainedReferenceStudy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>, {id: string;data: BodyType<ReferenceVersionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelRetainedReferenceStudy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRetainedReferenceStudyMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>>
    export type CancelRetainedReferenceStudyMutationBody = BodyType<ReferenceVersionInput>
    export type CancelRetainedReferenceStudyMutationError = ErrorType<unknown>

    export const useCancelRetainedReferenceStudy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRetainedReferenceStudy>>,
        TError,
        {id: string;data: BodyType<ReferenceVersionInput>},
        TContext
      > => {
      return useMutation(getCancelRetainedReferenceStudyMutationOptions(options), queryClient);
    }

export const getDownloadRetainedReferenceStudyUrl = (id: string,
    params?: DownloadRetainedReferenceStudyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/reference-studies/${id}/download?${stringifiedParams}` : `/api/property-builder/reference-studies/${id}/download`
}

export const downloadRetainedReferenceStudy = async (id: string,
    params?: DownloadRetainedReferenceStudyParams, options?: RequestInit): Promise<DownloadRetainedReferenceStudy200One | string> => {

  return customFetch<DownloadRetainedReferenceStudy200One | string>(getDownloadRetainedReferenceStudyUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadRetainedReferenceStudyQueryKey = (id: string,
    params?: DownloadRetainedReferenceStudyParams,) => {
    return [
    `/api/property-builder/reference-studies/${id}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadRetainedReferenceStudyQueryOptions = <TData = Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError = ErrorType<void>>(id: string,
    params?: DownloadRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRetainedReferenceStudyQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>> = ({ signal }) => downloadRetainedReferenceStudy(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRetainedReferenceStudyQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>>
export type DownloadRetainedReferenceStudyQueryError = ErrorType<void>


export function useDownloadRetainedReferenceStudy<TData = Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  DownloadRetainedReferenceStudyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRetainedReferenceStudy<TData = Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string,
    params?: DownloadRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>,
          TError,
          Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRetainedReferenceStudy<TData = Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string,
    params?: DownloadRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadRetainedReferenceStudy<TData = Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError = ErrorType<void>>(
 id: string,
    params?: DownloadRetainedReferenceStudyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRetainedReferenceStudy>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadRetainedReferenceStudyQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewReferenceListCoverageUrl = () => {




  return `/api/property-builder/reference-coverage`
}

export const reviewReferenceListCoverage = async (referenceCoverageInput: ReferenceCoverageInput, options?: RequestInit): Promise<ReferenceCoverageResult> => {

  return customFetch<ReferenceCoverageResult>(getReviewReferenceListCoverageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceCoverageInput)
  }
);}




export const getReviewReferenceListCoverageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewReferenceListCoverage>>, TError,{data: BodyType<ReferenceCoverageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewReferenceListCoverage>>, TError,{data: BodyType<ReferenceCoverageInput>}, TContext> => {

const mutationKey = ['reviewReferenceListCoverage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewReferenceListCoverage>>, {data: BodyType<ReferenceCoverageInput>}> = (props) => {
          const {data} = props ?? {};

          return  reviewReferenceListCoverage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewReferenceListCoverageMutationResult = NonNullable<Awaited<ReturnType<typeof reviewReferenceListCoverage>>>
    export type ReviewReferenceListCoverageMutationBody = BodyType<ReferenceCoverageInput>
    export type ReviewReferenceListCoverageMutationError = ErrorType<unknown>

    export const useReviewReferenceListCoverage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewReferenceListCoverage>>, TError,{data: BodyType<ReferenceCoverageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewReferenceListCoverage>>,
        TError,
        {data: BodyType<ReferenceCoverageInput>},
        TContext
      > => {
      return useMutation(getReviewReferenceListCoverageMutationOptions(options), queryClient);
    }

export const getCancelReferenceListCoverageUrl = (id: string,) => {




  return `/api/property-builder/reference-coverage/${id}`
}

export const cancelReferenceListCoverage = async (id: string,
    referenceVersionInput: ReferenceVersionInput, options?: RequestInit): Promise<ReferenceCoverageResult> => {

  return customFetch<ReferenceCoverageResult>(getCancelReferenceListCoverageUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceVersionInput)
  }
);}




export const getCancelReferenceListCoverageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelReferenceListCoverage>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelReferenceListCoverage>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext> => {

const mutationKey = ['cancelReferenceListCoverage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelReferenceListCoverage>>, {id: string;data: BodyType<ReferenceVersionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelReferenceListCoverage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelReferenceListCoverageMutationResult = NonNullable<Awaited<ReturnType<typeof cancelReferenceListCoverage>>>
    export type CancelReferenceListCoverageMutationBody = BodyType<ReferenceVersionInput>
    export type CancelReferenceListCoverageMutationError = ErrorType<unknown>

    export const useCancelReferenceListCoverage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelReferenceListCoverage>>, TError,{id: string;data: BodyType<ReferenceVersionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelReferenceListCoverage>>,
        TError,
        {id: string;data: BodyType<ReferenceVersionInput>},
        TContext
      > => {
      return useMutation(getCancelReferenceListCoverageMutationOptions(options), queryClient);
    }

export const getAnalyzeReferenceListUrl = () => {




  return `/api/property-builder/reference-analysis`
}

export const analyzeReferenceList = async (referenceAnalysisConsent: ReferenceAnalysisConsent, options?: RequestInit): Promise<ReferenceAnalysisResult> => {

  return customFetch<ReferenceAnalysisResult>(getAnalyzeReferenceListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceAnalysisConsent)
  }
);}




export const getAnalyzeReferenceListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeReferenceList>>, TError,{data: BodyType<ReferenceAnalysisConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeReferenceList>>, TError,{data: BodyType<ReferenceAnalysisConsent>}, TContext> => {

const mutationKey = ['analyzeReferenceList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeReferenceList>>, {data: BodyType<ReferenceAnalysisConsent>}> = (props) => {
          const {data} = props ?? {};

          return  analyzeReferenceList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeReferenceListMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeReferenceList>>>
    export type AnalyzeReferenceListMutationBody = BodyType<ReferenceAnalysisConsent>
    export type AnalyzeReferenceListMutationError = ErrorType<void>

    export const useAnalyzeReferenceList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeReferenceList>>, TError,{data: BodyType<ReferenceAnalysisConsent>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analyzeReferenceList>>,
        TError,
        {data: BodyType<ReferenceAnalysisConsent>},
        TContext
      > => {
      return useMutation(getAnalyzeReferenceListMutationOptions(options), queryClient);
    }

export const getGetReferenceAnalysisJobUrl = (id: string,) => {




  return `/api/property-builder/reference-analysis-jobs/${id}`
}

export const getReferenceAnalysisJob = async (id: string, options?: RequestInit): Promise<ReferenceAnalysisResult> => {

  return customFetch<ReferenceAnalysisResult>(getGetReferenceAnalysisJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReferenceAnalysisJobQueryKey = (id: string,) => {
    return [
    `/api/property-builder/reference-analysis-jobs/${id}`
    ] as const;
    }


export const getGetReferenceAnalysisJobQueryOptions = <TData = Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferenceAnalysisJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceAnalysisJob>>> = ({ signal }) => getReferenceAnalysisJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferenceAnalysisJobQueryResult = NonNullable<Awaited<ReturnType<typeof getReferenceAnalysisJob>>>
export type GetReferenceAnalysisJobQueryError = ErrorType<void>


export function useGetReferenceAnalysisJob<TData = Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceAnalysisJob>>,
          TError,
          Awaited<ReturnType<typeof getReferenceAnalysisJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceAnalysisJob<TData = Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceAnalysisJob>>,
          TError,
          Awaited<ReturnType<typeof getReferenceAnalysisJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferenceAnalysisJob<TData = Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReferenceAnalysisJob<TData = Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceAnalysisJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferenceAnalysisJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolveReferenceIdentityUrl = () => {




  return `/api/property-builder/reference-identity`
}

export const resolveReferenceIdentity = async (referenceIdentityInput: ReferenceIdentityInput, options?: RequestInit): Promise<ReferenceMemoryResult> => {

  return customFetch<ReferenceMemoryResult>(getResolveReferenceIdentityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceIdentityInput)
  }
);}




export const getResolveReferenceIdentityMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveReferenceIdentity>>, TError,{data: BodyType<ReferenceIdentityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveReferenceIdentity>>, TError,{data: BodyType<ReferenceIdentityInput>}, TContext> => {

const mutationKey = ['resolveReferenceIdentity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveReferenceIdentity>>, {data: BodyType<ReferenceIdentityInput>}> = (props) => {
          const {data} = props ?? {};

          return  resolveReferenceIdentity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveReferenceIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof resolveReferenceIdentity>>>
    export type ResolveReferenceIdentityMutationBody = BodyType<ReferenceIdentityInput>
    export type ResolveReferenceIdentityMutationError = ErrorType<void>

    export const useResolveReferenceIdentity = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveReferenceIdentity>>, TError,{data: BodyType<ReferenceIdentityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveReferenceIdentity>>,
        TError,
        {data: BodyType<ReferenceIdentityInput>},
        TContext
      > => {
      return useMutation(getResolveReferenceIdentityMutationOptions(options), queryClient);
    }

export const getSaveReferencePlanUrl = () => {




  return `/api/property-builder/reference-plan`
}

export const saveReferencePlan = async (referencePlanInput: ReferencePlanInput, options?: RequestInit): Promise<ReferencePlanResult> => {

  return customFetch<ReferencePlanResult>(getSaveReferencePlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referencePlanInput)
  }
);}




export const getSaveReferencePlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReferencePlan>>, TError,{data: BodyType<ReferencePlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveReferencePlan>>, TError,{data: BodyType<ReferencePlanInput>}, TContext> => {

const mutationKey = ['saveReferencePlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveReferencePlan>>, {data: BodyType<ReferencePlanInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveReferencePlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveReferencePlanMutationResult = NonNullable<Awaited<ReturnType<typeof saveReferencePlan>>>
    export type SaveReferencePlanMutationBody = BodyType<ReferencePlanInput>
    export type SaveReferencePlanMutationError = ErrorType<void>

    export const useSaveReferencePlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReferencePlan>>, TError,{data: BodyType<ReferencePlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveReferencePlan>>,
        TError,
        {data: BodyType<ReferencePlanInput>},
        TContext
      > => {
      return useMutation(getSaveReferencePlanMutationOptions(options), queryClient);
    }

export const getRankReferencePropertiesUrl = () => {




  return `/api/property-builder/reference-ranking`
}

export const rankReferenceProperties = async (referenceRankingInput: ReferenceRankingInput, options?: RequestInit): Promise<ReferenceRankingResult> => {

  return customFetch<ReferenceRankingResult>(getRankReferencePropertiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenceRankingInput)
  }
);}




export const getRankReferencePropertiesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankReferenceProperties>>, TError,{data: BodyType<ReferenceRankingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankReferenceProperties>>, TError,{data: BodyType<ReferenceRankingInput>}, TContext> => {

const mutationKey = ['rankReferenceProperties'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankReferenceProperties>>, {data: BodyType<ReferenceRankingInput>}> = (props) => {
          const {data} = props ?? {};

          return  rankReferenceProperties(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankReferencePropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof rankReferenceProperties>>>
    export type RankReferencePropertiesMutationBody = BodyType<ReferenceRankingInput>
    export type RankReferencePropertiesMutationError = ErrorType<void>

    export const useRankReferenceProperties = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankReferenceProperties>>, TError,{data: BodyType<ReferenceRankingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankReferenceProperties>>,
        TError,
        {data: BodyType<ReferenceRankingInput>},
        TContext
      > => {
      return useMutation(getRankReferencePropertiesMutationOptions(options), queryClient);
    }

export const getEditAddressListMembershipsUrl = (params?: EditAddressListMembershipsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/list-memberships?${stringifiedParams}` : `/api/lob-mail/address-book/list-memberships`
}

export const editAddressListMemberships = async (addressMembershipInput: AddressMembershipInput,
    params?: EditAddressListMembershipsParams, options?: RequestInit): Promise<AddressMembershipResult> => {

  return customFetch<AddressMembershipResult>(getEditAddressListMembershipsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressMembershipInput)
  }
);}




export const getEditAddressListMembershipsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAddressListMemberships>>, TError,{data: BodyType<AddressMembershipInput>;params?: EditAddressListMembershipsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editAddressListMemberships>>, TError,{data: BodyType<AddressMembershipInput>;params?: EditAddressListMembershipsParams}, TContext> => {

const mutationKey = ['editAddressListMemberships'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editAddressListMemberships>>, {data: BodyType<AddressMembershipInput>;params?: EditAddressListMembershipsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  editAddressListMemberships(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditAddressListMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof editAddressListMemberships>>>
    export type EditAddressListMembershipsMutationBody = BodyType<AddressMembershipInput>
    export type EditAddressListMembershipsMutationError = ErrorType<void>

    export const useEditAddressListMemberships = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAddressListMemberships>>, TError,{data: BodyType<AddressMembershipInput>;params?: EditAddressListMembershipsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editAddressListMemberships>>,
        TError,
        {data: BodyType<AddressMembershipInput>;params?: EditAddressListMembershipsParams},
        TContext
      > => {
      return useMutation(getEditAddressListMembershipsMutationOptions(options), queryClient);
    }

export const getGetAddressMembershipReceiptUrl = (operationId: string,
    params?: GetAddressMembershipReceiptParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/list-memberships/${operationId}?${stringifiedParams}` : `/api/lob-mail/address-book/list-memberships/${operationId}`
}

/**
 * @summary Reconcile an uncertain membership response without repeating a write
 */
export const getAddressMembershipReceipt = async (operationId: string,
    params?: GetAddressMembershipReceiptParams, options?: RequestInit): Promise<AddressMembershipReceipt> => {

  return customFetch<AddressMembershipReceipt>(getGetAddressMembershipReceiptUrl(operationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddressMembershipReceiptQueryKey = (operationId: string,
    params?: GetAddressMembershipReceiptParams,) => {
    return [
    `/api/lob-mail/address-book/list-memberships/${operationId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAddressMembershipReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError = ErrorType<void>>(operationId: string,
    params?: GetAddressMembershipReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressMembershipReceiptQueryKey(operationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressMembershipReceipt>>> = ({ signal }) => getAddressMembershipReceipt(operationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressMembershipReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressMembershipReceipt>>>
export type GetAddressMembershipReceiptQueryError = ErrorType<void>


export function useGetAddressMembershipReceipt<TData = Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError = ErrorType<void>>(
 operationId: string,
    params: undefined |  GetAddressMembershipReceiptParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressMembershipReceipt>>,
          TError,
          Awaited<ReturnType<typeof getAddressMembershipReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressMembershipReceipt<TData = Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError = ErrorType<void>>(
 operationId: string,
    params?: GetAddressMembershipReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressMembershipReceipt>>,
          TError,
          Awaited<ReturnType<typeof getAddressMembershipReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressMembershipReceipt<TData = Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError = ErrorType<void>>(
 operationId: string,
    params?: GetAddressMembershipReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconcile an uncertain membership response without repeating a write
 */

export function useGetAddressMembershipReceipt<TData = Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError = ErrorType<void>>(
 operationId: string,
    params?: GetAddressMembershipReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressMembershipReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressMembershipReceiptQueryOptions(operationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSavedMailRankingUrl = (id: string,) => {




  return `/api/property-builder/workspaces/${id}/mail-ranking`
}

export const getSavedMailRanking = async (id: string, options?: RequestInit): Promise<GetSavedMailRanking200> => {

  return customFetch<GetSavedMailRanking200>(getGetSavedMailRankingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedMailRankingQueryKey = (id: string,) => {
    return [
    `/api/property-builder/workspaces/${id}/mail-ranking`
    ] as const;
    }


export const getGetSavedMailRankingQueryOptions = <TData = Awaited<ReturnType<typeof getSavedMailRanking>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedMailRankingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedMailRanking>>> = ({ signal }) => getSavedMailRanking(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedMailRankingQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedMailRanking>>>
export type GetSavedMailRankingQueryError = ErrorType<unknown>


export function useGetSavedMailRanking<TData = Awaited<ReturnType<typeof getSavedMailRanking>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedMailRanking>>,
          TError,
          Awaited<ReturnType<typeof getSavedMailRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedMailRanking<TData = Awaited<ReturnType<typeof getSavedMailRanking>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedMailRanking>>,
          TError,
          Awaited<ReturnType<typeof getSavedMailRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedMailRanking<TData = Awaited<ReturnType<typeof getSavedMailRanking>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSavedMailRanking<TData = Awaited<ReturnType<typeof getSavedMailRanking>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedMailRanking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedMailRankingQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewMailRankingUrl = () => {




  return `/api/property-builder/mail-ranking`
}

export const previewMailRanking = async (mailRankingInput: MailRankingInput, options?: RequestInit): Promise<PreviewMailRanking200> => {

  return customFetch<PreviewMailRanking200>(getPreviewMailRankingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailRankingInput)
  }
);}




export const getPreviewMailRankingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewMailRanking>>, TError,{data: BodyType<MailRankingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewMailRanking>>, TError,{data: BodyType<MailRankingInput>}, TContext> => {

const mutationKey = ['previewMailRanking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewMailRanking>>, {data: BodyType<MailRankingInput>}> = (props) => {
          const {data} = props ?? {};

          return  previewMailRanking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewMailRankingMutationResult = NonNullable<Awaited<ReturnType<typeof previewMailRanking>>>
    export type PreviewMailRankingMutationBody = BodyType<MailRankingInput>
    export type PreviewMailRankingMutationError = ErrorType<unknown>

    export const usePreviewMailRanking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewMailRanking>>, TError,{data: BodyType<MailRankingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewMailRanking>>,
        TError,
        {data: BodyType<MailRankingInput>},
        TContext
      > => {
      return useMutation(getPreviewMailRankingMutationOptions(options), queryClient);
    }

export const getSaveMailRankedListUrl = (id: string,) => {




  return `/api/property-builder/mail-ranking/${id}/list`
}

export const saveMailRankedList = async (id: string,
    mailRankSelectionInput: MailRankSelectionInput, options?: RequestInit): Promise<SaveMailRankedList200> => {

  return customFetch<SaveMailRankedList200>(getSaveMailRankedListUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailRankSelectionInput)
  }
);}




export const getSaveMailRankedListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMailRankedList>>, TError,{id: string;data: BodyType<MailRankSelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveMailRankedList>>, TError,{id: string;data: BodyType<MailRankSelectionInput>}, TContext> => {

const mutationKey = ['saveMailRankedList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveMailRankedList>>, {id: string;data: BodyType<MailRankSelectionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveMailRankedList(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveMailRankedListMutationResult = NonNullable<Awaited<ReturnType<typeof saveMailRankedList>>>
    export type SaveMailRankedListMutationBody = BodyType<MailRankSelectionInput>
    export type SaveMailRankedListMutationError = ErrorType<void>

    export const useSaveMailRankedList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMailRankedList>>, TError,{id: string;data: BodyType<MailRankSelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveMailRankedList>>,
        TError,
        {id: string;data: BodyType<MailRankSelectionInput>},
        TContext
      > => {
      return useMutation(getSaveMailRankedListMutationOptions(options), queryClient);
    }

export const getGetMailIntelligenceUrl = (params?: GetMailIntelligenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/intelligence?${stringifiedParams}` : `/api/lob-mail/mail-analytics/intelligence`
}

export const getMailIntelligence = async (params?: GetMailIntelligenceParams, options?: RequestInit): Promise<MailIntelligenceReport> => {

  return customFetch<MailIntelligenceReport>(getGetMailIntelligenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailIntelligenceQueryKey = (params?: GetMailIntelligenceParams,) => {
    return [
    `/api/lob-mail/mail-analytics/intelligence`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailIntelligenceQueryOptions = <TData = Awaited<ReturnType<typeof getMailIntelligence>>, TError = ErrorType<unknown>>(params?: GetMailIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailIntelligenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailIntelligence>>> = ({ signal }) => getMailIntelligence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailIntelligenceQueryResult = NonNullable<Awaited<ReturnType<typeof getMailIntelligence>>>
export type GetMailIntelligenceQueryError = ErrorType<unknown>


export function useGetMailIntelligence<TData = Awaited<ReturnType<typeof getMailIntelligence>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMailIntelligenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailIntelligence>>,
          TError,
          Awaited<ReturnType<typeof getMailIntelligence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailIntelligence<TData = Awaited<ReturnType<typeof getMailIntelligence>>, TError = ErrorType<unknown>>(
 params?: GetMailIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailIntelligence>>,
          TError,
          Awaited<ReturnType<typeof getMailIntelligence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailIntelligence<TData = Awaited<ReturnType<typeof getMailIntelligence>>, TError = ErrorType<unknown>>(
 params?: GetMailIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailIntelligence<TData = Awaited<ReturnType<typeof getMailIntelligence>>, TError = ErrorType<unknown>>(
 params?: GetMailIntelligenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailIntelligence>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailIntelligenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartMailIntelligenceAnalysisUrl = () => {




  return `/api/lob-mail/mail-analytics/intelligence/analyze`
}

export const startMailIntelligenceAnalysis = async (mailIntelligenceScope: MailIntelligenceScope, options?: RequestInit): Promise<StartMailIntelligenceAnalysis202> => {

  return customFetch<StartMailIntelligenceAnalysis202>(getStartMailIntelligenceAnalysisUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailIntelligenceScope)
  }
);}




export const getStartMailIntelligenceAnalysisMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>, TError,{data: BodyType<MailIntelligenceScope>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>, TError,{data: BodyType<MailIntelligenceScope>}, TContext> => {

const mutationKey = ['startMailIntelligenceAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>, {data: BodyType<MailIntelligenceScope>}> = (props) => {
          const {data} = props ?? {};

          return  startMailIntelligenceAnalysis(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMailIntelligenceAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>>
    export type StartMailIntelligenceAnalysisMutationBody = BodyType<MailIntelligenceScope>
    export type StartMailIntelligenceAnalysisMutationError = ErrorType<unknown>

    export const useStartMailIntelligenceAnalysis = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>, TError,{data: BodyType<MailIntelligenceScope>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startMailIntelligenceAnalysis>>,
        TError,
        {data: BodyType<MailIntelligenceScope>},
        TContext
      > => {
      return useMutation(getStartMailIntelligenceAnalysisMutationOptions(options), queryClient);
    }

export const getSaveMailIntelligenceOutcomeUrl = () => {




  return `/api/lob-mail/mail-analytics/intelligence/outcomes`
}

export const saveMailIntelligenceOutcome = async (mailOutcomeInput: MailOutcomeInput, options?: RequestInit): Promise<SaveMailIntelligenceOutcome200> => {

  return customFetch<SaveMailIntelligenceOutcome200>(getSaveMailIntelligenceOutcomeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailOutcomeInput)
  }
);}




export const getSaveMailIntelligenceOutcomeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>, TError,{data: BodyType<MailOutcomeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>, TError,{data: BodyType<MailOutcomeInput>}, TContext> => {

const mutationKey = ['saveMailIntelligenceOutcome'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>, {data: BodyType<MailOutcomeInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveMailIntelligenceOutcome(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveMailIntelligenceOutcomeMutationResult = NonNullable<Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>>
    export type SaveMailIntelligenceOutcomeMutationBody = BodyType<MailOutcomeInput>
    export type SaveMailIntelligenceOutcomeMutationError = ErrorType<void>

    export const useSaveMailIntelligenceOutcome = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>, TError,{data: BodyType<MailOutcomeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveMailIntelligenceOutcome>>,
        TError,
        {data: BodyType<MailOutcomeInput>},
        TContext
      > => {
      return useMutation(getSaveMailIntelligenceOutcomeMutationOptions(options), queryClient);
    }

export const getGetMailOutcomeSourcesUrl = () => {




  return `/api/lob-mail/mail-analytics/intelligence/sources`
}

export const getMailOutcomeSources = async ( options?: RequestInit): Promise<GetMailOutcomeSources200> => {

  return customFetch<GetMailOutcomeSources200>(getGetMailOutcomeSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailOutcomeSourcesQueryKey = () => {
    return [
    `/api/lob-mail/mail-analytics/intelligence/sources`
    ] as const;
    }


export const getGetMailOutcomeSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getMailOutcomeSources>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailOutcomeSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailOutcomeSources>>> = ({ signal }) => getMailOutcomeSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailOutcomeSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getMailOutcomeSources>>>
export type GetMailOutcomeSourcesQueryError = ErrorType<unknown>


export function useGetMailOutcomeSources<TData = Awaited<ReturnType<typeof getMailOutcomeSources>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailOutcomeSources>>,
          TError,
          Awaited<ReturnType<typeof getMailOutcomeSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailOutcomeSources<TData = Awaited<ReturnType<typeof getMailOutcomeSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailOutcomeSources>>,
          TError,
          Awaited<ReturnType<typeof getMailOutcomeSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailOutcomeSources<TData = Awaited<ReturnType<typeof getMailOutcomeSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailOutcomeSources<TData = Awaited<ReturnType<typeof getMailOutcomeSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailOutcomeSourcesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewMailOutcomeMappingUrl = () => {




  return `/api/lob-mail/mail-analytics/intelligence/mapping`
}

export const previewMailOutcomeMapping = async (mailOutcomeMappingInput: MailOutcomeMappingInput, options?: RequestInit): Promise<PreviewMailOutcomeMapping200> => {

  return customFetch<PreviewMailOutcomeMapping200>(getPreviewMailOutcomeMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailOutcomeMappingInput)
  }
);}




export const getPreviewMailOutcomeMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewMailOutcomeMapping>>, TError,{data: BodyType<MailOutcomeMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewMailOutcomeMapping>>, TError,{data: BodyType<MailOutcomeMappingInput>}, TContext> => {

const mutationKey = ['previewMailOutcomeMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewMailOutcomeMapping>>, {data: BodyType<MailOutcomeMappingInput>}> = (props) => {
          const {data} = props ?? {};

          return  previewMailOutcomeMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewMailOutcomeMappingMutationResult = NonNullable<Awaited<ReturnType<typeof previewMailOutcomeMapping>>>
    export type PreviewMailOutcomeMappingMutationBody = BodyType<MailOutcomeMappingInput>
    export type PreviewMailOutcomeMappingMutationError = ErrorType<unknown>

    export const usePreviewMailOutcomeMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewMailOutcomeMapping>>, TError,{data: BodyType<MailOutcomeMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewMailOutcomeMapping>>,
        TError,
        {data: BodyType<MailOutcomeMappingInput>},
        TContext
      > => {
      return useMutation(getPreviewMailOutcomeMappingMutationOptions(options), queryClient);
    }

export const getGetMailOutcomeMappingUrl = (id: string,
    params?: GetMailOutcomeMappingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/intelligence/mapping/${id}?${stringifiedParams}` : `/api/lob-mail/mail-analytics/intelligence/mapping/${id}`
}

export const getMailOutcomeMapping = async (id: string,
    params?: GetMailOutcomeMappingParams, options?: RequestInit): Promise<GetMailOutcomeMapping200> => {

  return customFetch<GetMailOutcomeMapping200>(getGetMailOutcomeMappingUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailOutcomeMappingQueryKey = (id: string,
    params?: GetMailOutcomeMappingParams,) => {
    return [
    `/api/lob-mail/mail-analytics/intelligence/mapping/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailOutcomeMappingQueryOptions = <TData = Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError = ErrorType<unknown>>(id: string,
    params?: GetMailOutcomeMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailOutcomeMappingQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailOutcomeMapping>>> = ({ signal }) => getMailOutcomeMapping(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailOutcomeMappingQueryResult = NonNullable<Awaited<ReturnType<typeof getMailOutcomeMapping>>>
export type GetMailOutcomeMappingQueryError = ErrorType<unknown>


export function useGetMailOutcomeMapping<TData = Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetMailOutcomeMappingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailOutcomeMapping>>,
          TError,
          Awaited<ReturnType<typeof getMailOutcomeMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailOutcomeMapping<TData = Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetMailOutcomeMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailOutcomeMapping>>,
          TError,
          Awaited<ReturnType<typeof getMailOutcomeMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailOutcomeMapping<TData = Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetMailOutcomeMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailOutcomeMapping<TData = Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetMailOutcomeMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailOutcomeMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailOutcomeMappingQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCompanyKnowledgeUrl = (params?: GetCompanyKnowledgeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge?${stringifiedParams}` : `/api/company-knowledge`
}

export const getCompanyKnowledge = async (params?: GetCompanyKnowledgeParams, options?: RequestInit): Promise<CompanyKnowledge> => {

  return customFetch<CompanyKnowledge>(getGetCompanyKnowledgeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyKnowledgeQueryKey = (params?: GetCompanyKnowledgeParams,) => {
    return [
    `/api/company-knowledge`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyKnowledgeQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKnowledge>>, TError = ErrorType<unknown>>(params?: GetCompanyKnowledgeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKnowledgeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKnowledge>>> = ({ signal }) => getCompanyKnowledge(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyKnowledgeQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKnowledge>>>
export type GetCompanyKnowledgeQueryError = ErrorType<unknown>


export function useGetCompanyKnowledge<TData = Awaited<ReturnType<typeof getCompanyKnowledge>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCompanyKnowledgeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledge>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledge<TData = Awaited<ReturnType<typeof getCompanyKnowledge>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledge>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledge<TData = Awaited<ReturnType<typeof getCompanyKnowledge>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCompanyKnowledge<TData = Awaited<ReturnType<typeof getCompanyKnowledge>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledge>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKnowledgeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveCompanyKnowledgeUrl = (params?: SaveCompanyKnowledgeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge?${stringifiedParams}` : `/api/company-knowledge`
}

export const saveCompanyKnowledge = async (companyKnowledgeInput: CompanyKnowledgeInput,
    params?: SaveCompanyKnowledgeParams, options?: RequestInit): Promise<CompanyKnowledge> => {

  return customFetch<CompanyKnowledge>(getSaveCompanyKnowledgeUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyKnowledgeInput)
  }
);}




export const getSaveCompanyKnowledgeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeInput>;params?: SaveCompanyKnowledgeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeInput>;params?: SaveCompanyKnowledgeParams}, TContext> => {

const mutationKey = ['saveCompanyKnowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveCompanyKnowledge>>, {data: BodyType<CompanyKnowledgeInput>;params?: SaveCompanyKnowledgeParams}> = (props) => {
          const {data,params} = props ?? {};

          return  saveCompanyKnowledge(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveCompanyKnowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof saveCompanyKnowledge>>>
    export type SaveCompanyKnowledgeMutationBody = BodyType<CompanyKnowledgeInput>
    export type SaveCompanyKnowledgeMutationError = ErrorType<void>

    export const useSaveCompanyKnowledge = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeInput>;params?: SaveCompanyKnowledgeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveCompanyKnowledge>>,
        TError,
        {data: BodyType<CompanyKnowledgeInput>;params?: SaveCompanyKnowledgeParams},
        TContext
      > => {
      return useMutation(getSaveCompanyKnowledgeMutationOptions(options), queryClient);
    }

export const getListKnowledgeDocumentsUrl = (params?: ListKnowledgeDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/documents?${stringifiedParams}` : `/api/company-knowledge/documents`
}

export const listKnowledgeDocuments = async (params?: ListKnowledgeDocumentsParams, options?: RequestInit): Promise<ListKnowledgeDocuments200> => {

  return customFetch<ListKnowledgeDocuments200>(getListKnowledgeDocumentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListKnowledgeDocumentsQueryKey = (params?: ListKnowledgeDocumentsParams,) => {
    return [
    `/api/company-knowledge/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListKnowledgeDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError = ErrorType<unknown>>(params?: ListKnowledgeDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListKnowledgeDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listKnowledgeDocuments>>> = ({ signal }) => listKnowledgeDocuments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListKnowledgeDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listKnowledgeDocuments>>>
export type ListKnowledgeDocumentsQueryError = ErrorType<unknown>


export function useListKnowledgeDocuments<TData = Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError = ErrorType<unknown>>(
 params: undefined |  ListKnowledgeDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKnowledgeDocuments>>,
          TError,
          Awaited<ReturnType<typeof listKnowledgeDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListKnowledgeDocuments<TData = Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError = ErrorType<unknown>>(
 params?: ListKnowledgeDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKnowledgeDocuments>>,
          TError,
          Awaited<ReturnType<typeof listKnowledgeDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListKnowledgeDocuments<TData = Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError = ErrorType<unknown>>(
 params?: ListKnowledgeDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListKnowledgeDocuments<TData = Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError = ErrorType<unknown>>(
 params?: ListKnowledgeDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKnowledgeDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListKnowledgeDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestKnowledgeDocumentUploadUrl = (params?: RequestKnowledgeDocumentUploadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/documents?${stringifiedParams}` : `/api/company-knowledge/documents`
}

export const requestKnowledgeDocumentUpload = async (requestKnowledgeDocumentUploadBody: RequestKnowledgeDocumentUploadBody,
    params?: RequestKnowledgeDocumentUploadParams, options?: RequestInit): Promise<RequestKnowledgeDocumentUpload201> => {

  return customFetch<RequestKnowledgeDocumentUpload201>(getRequestKnowledgeDocumentUploadUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestKnowledgeDocumentUploadBody)
  }
);}




export const getRequestKnowledgeDocumentUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>, TError,{data: BodyType<RequestKnowledgeDocumentUploadBody>;params?: RequestKnowledgeDocumentUploadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>, TError,{data: BodyType<RequestKnowledgeDocumentUploadBody>;params?: RequestKnowledgeDocumentUploadParams}, TContext> => {

const mutationKey = ['requestKnowledgeDocumentUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>, {data: BodyType<RequestKnowledgeDocumentUploadBody>;params?: RequestKnowledgeDocumentUploadParams}> = (props) => {
          const {data,params} = props ?? {};

          return  requestKnowledgeDocumentUpload(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestKnowledgeDocumentUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>>
    export type RequestKnowledgeDocumentUploadMutationBody = BodyType<RequestKnowledgeDocumentUploadBody>
    export type RequestKnowledgeDocumentUploadMutationError = ErrorType<unknown>

    export const useRequestKnowledgeDocumentUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>, TError,{data: BodyType<RequestKnowledgeDocumentUploadBody>;params?: RequestKnowledgeDocumentUploadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestKnowledgeDocumentUpload>>,
        TError,
        {data: BodyType<RequestKnowledgeDocumentUploadBody>;params?: RequestKnowledgeDocumentUploadParams},
        TContext
      > => {
      return useMutation(getRequestKnowledgeDocumentUploadMutationOptions(options), queryClient);
    }

export const getRemoveKnowledgeDocumentUrl = (documentId: string,
    params?: RemoveKnowledgeDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/documents/${documentId}?${stringifiedParams}` : `/api/company-knowledge/documents/${documentId}`
}

export const removeKnowledgeDocument = async (documentId: string,
    params?: RemoveKnowledgeDocumentParams, options?: RequestInit): Promise<RemoveKnowledgeDocument200> => {

  return customFetch<RemoveKnowledgeDocument200>(getRemoveKnowledgeDocumentUrl(documentId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveKnowledgeDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeKnowledgeDocument>>, TError,{documentId: string;params?: RemoveKnowledgeDocumentParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeKnowledgeDocument>>, TError,{documentId: string;params?: RemoveKnowledgeDocumentParams}, TContext> => {

const mutationKey = ['removeKnowledgeDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeKnowledgeDocument>>, {documentId: string;params?: RemoveKnowledgeDocumentParams}> = (props) => {
          const {documentId,params} = props ?? {};

          return  removeKnowledgeDocument(documentId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveKnowledgeDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof removeKnowledgeDocument>>>

    export type RemoveKnowledgeDocumentMutationError = ErrorType<unknown>

    export const useRemoveKnowledgeDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeKnowledgeDocument>>, TError,{documentId: string;params?: RemoveKnowledgeDocumentParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeKnowledgeDocument>>,
        TError,
        {documentId: string;params?: RemoveKnowledgeDocumentParams},
        TContext
      > => {
      return useMutation(getRemoveKnowledgeDocumentMutationOptions(options), queryClient);
    }

export const getGetCompanyKnowledgeResearchUrl = (params?: GetCompanyKnowledgeResearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/research?${stringifiedParams}` : `/api/company-knowledge/research`
}

export const getCompanyKnowledgeResearch = async (params?: GetCompanyKnowledgeResearchParams, options?: RequestInit): Promise<KnowledgeResearchStatus> => {

  return customFetch<KnowledgeResearchStatus>(getGetCompanyKnowledgeResearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyKnowledgeResearchQueryKey = (params?: GetCompanyKnowledgeResearchParams,) => {
    return [
    `/api/company-knowledge/research`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyKnowledgeResearchQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError = ErrorType<unknown>>(params?: GetCompanyKnowledgeResearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKnowledgeResearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>> = ({ signal }) => getCompanyKnowledgeResearch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyKnowledgeResearchQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>>
export type GetCompanyKnowledgeResearchQueryError = ErrorType<unknown>


export function useGetCompanyKnowledgeResearch<TData = Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCompanyKnowledgeResearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeResearch<TData = Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeResearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeResearch<TData = Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeResearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCompanyKnowledgeResearch<TData = Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeResearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeResearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKnowledgeResearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartCompanyKnowledgeResearchUrl = (params?: StartCompanyKnowledgeResearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/research?${stringifiedParams}` : `/api/company-knowledge/research`
}

export const startCompanyKnowledgeResearch = async (knowledgeResearchInput: KnowledgeResearchInput,
    params?: StartCompanyKnowledgeResearchParams, options?: RequestInit): Promise<KnowledgeResearchJob> => {

  return customFetch<KnowledgeResearchJob>(getStartCompanyKnowledgeResearchUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(knowledgeResearchInput)
  }
);}




export const getStartCompanyKnowledgeResearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>, TError,{data: BodyType<KnowledgeResearchInput>;params?: StartCompanyKnowledgeResearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>, TError,{data: BodyType<KnowledgeResearchInput>;params?: StartCompanyKnowledgeResearchParams}, TContext> => {

const mutationKey = ['startCompanyKnowledgeResearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>, {data: BodyType<KnowledgeResearchInput>;params?: StartCompanyKnowledgeResearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  startCompanyKnowledgeResearch(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartCompanyKnowledgeResearchMutationResult = NonNullable<Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>>
    export type StartCompanyKnowledgeResearchMutationBody = BodyType<KnowledgeResearchInput>
    export type StartCompanyKnowledgeResearchMutationError = ErrorType<unknown>

    export const useStartCompanyKnowledgeResearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>, TError,{data: BodyType<KnowledgeResearchInput>;params?: StartCompanyKnowledgeResearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startCompanyKnowledgeResearch>>,
        TError,
        {data: BodyType<KnowledgeResearchInput>;params?: StartCompanyKnowledgeResearchParams},
        TContext
      > => {
      return useMutation(getStartCompanyKnowledgeResearchMutationOptions(options), queryClient);
    }

export const getListCompanyKnowledgeResearchHistoryUrl = (params?: ListCompanyKnowledgeResearchHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/research/history?${stringifiedParams}` : `/api/company-knowledge/research/history`
}

export const listCompanyKnowledgeResearchHistory = async (params?: ListCompanyKnowledgeResearchHistoryParams, options?: RequestInit): Promise<KnowledgeResearchHistory> => {

  return customFetch<KnowledgeResearchHistory>(getListCompanyKnowledgeResearchHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyKnowledgeResearchHistoryQueryKey = (params?: ListCompanyKnowledgeResearchHistoryParams,) => {
    return [
    `/api/company-knowledge/research/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCompanyKnowledgeResearchHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError = ErrorType<unknown>>(params?: ListCompanyKnowledgeResearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompanyKnowledgeResearchHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>> = ({ signal }) => listCompanyKnowledgeResearchHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCompanyKnowledgeResearchHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>>
export type ListCompanyKnowledgeResearchHistoryQueryError = ErrorType<unknown>


export function useListCompanyKnowledgeResearchHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError = ErrorType<unknown>>(
 params: undefined |  ListCompanyKnowledgeResearchHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>,
          TError,
          Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompanyKnowledgeResearchHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeResearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>,
          TError,
          Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompanyKnowledgeResearchHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeResearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCompanyKnowledgeResearchHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeResearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeResearchHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanyKnowledgeResearchHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDownloadCompanyKnowledgeResearchErrorsUrl = (jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/research/${jobId}/errors?${stringifiedParams}` : `/api/company-knowledge/research/${jobId}/errors`
}

export const downloadCompanyKnowledgeResearchErrors = async (jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams, options?: RequestInit): Promise<KnowledgeResearchReport> => {

  return customFetch<KnowledgeResearchReport>(getDownloadCompanyKnowledgeResearchErrorsUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadCompanyKnowledgeResearchErrorsQueryKey = (jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams,) => {
    return [
    `/api/company-knowledge/research/${jobId}/errors`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadCompanyKnowledgeResearchErrorsQueryOptions = <TData = Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError = ErrorType<void>>(jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadCompanyKnowledgeResearchErrorsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>> = ({ signal }) => downloadCompanyKnowledgeResearchErrors(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadCompanyKnowledgeResearchErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>>
export type DownloadCompanyKnowledgeResearchErrorsQueryError = ErrorType<void>


export function useDownloadCompanyKnowledgeResearchErrors<TData = Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError = ErrorType<void>>(
 jobId: string,
    params: undefined |  DownloadCompanyKnowledgeResearchErrorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>,
          TError,
          Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCompanyKnowledgeResearchErrors<TData = Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError = ErrorType<void>>(
 jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>,
          TError,
          Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCompanyKnowledgeResearchErrors<TData = Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError = ErrorType<void>>(
 jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadCompanyKnowledgeResearchErrors<TData = Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError = ErrorType<void>>(
 jobId: string,
    params?: DownloadCompanyKnowledgeResearchErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyKnowledgeResearchErrors>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadCompanyKnowledgeResearchErrorsQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelCompanyKnowledgeResearchUrl = (jobId: string,
    params?: CancelCompanyKnowledgeResearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/research/${jobId}/cancel?${stringifiedParams}` : `/api/company-knowledge/research/${jobId}/cancel`
}

export const cancelCompanyKnowledgeResearch = async (jobId: string,
    params?: CancelCompanyKnowledgeResearchParams, options?: RequestInit): Promise<KnowledgeResearchJob> => {

  return customFetch<KnowledgeResearchJob>(getCancelCompanyKnowledgeResearchUrl(jobId,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelCompanyKnowledgeResearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>, TError,{jobId: string;params?: CancelCompanyKnowledgeResearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>, TError,{jobId: string;params?: CancelCompanyKnowledgeResearchParams}, TContext> => {

const mutationKey = ['cancelCompanyKnowledgeResearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>, {jobId: string;params?: CancelCompanyKnowledgeResearchParams}> = (props) => {
          const {jobId,params} = props ?? {};

          return  cancelCompanyKnowledgeResearch(jobId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelCompanyKnowledgeResearchMutationResult = NonNullable<Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>>

    export type CancelCompanyKnowledgeResearchMutationError = ErrorType<unknown>

    export const useCancelCompanyKnowledgeResearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>, TError,{jobId: string;params?: CancelCompanyKnowledgeResearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelCompanyKnowledgeResearch>>,
        TError,
        {jobId: string;params?: CancelCompanyKnowledgeResearchParams},
        TContext
      > => {
      return useMutation(getCancelCompanyKnowledgeResearchMutationOptions(options), queryClient);
    }

export const getListCompanyKnowledgeHistoryUrl = (params?: ListCompanyKnowledgeHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/history?${stringifiedParams}` : `/api/company-knowledge/history`
}

export const listCompanyKnowledgeHistory = async (params?: ListCompanyKnowledgeHistoryParams, options?: RequestInit): Promise<CompanyKnowledgeHistory> => {

  return customFetch<CompanyKnowledgeHistory>(getListCompanyKnowledgeHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyKnowledgeHistoryQueryKey = (params?: ListCompanyKnowledgeHistoryParams,) => {
    return [
    `/api/company-knowledge/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCompanyKnowledgeHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError = ErrorType<unknown>>(params?: ListCompanyKnowledgeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompanyKnowledgeHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>> = ({ signal }) => listCompanyKnowledgeHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCompanyKnowledgeHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>>
export type ListCompanyKnowledgeHistoryQueryError = ErrorType<unknown>


export function useListCompanyKnowledgeHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError = ErrorType<unknown>>(
 params: undefined |  ListCompanyKnowledgeHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>,
          TError,
          Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompanyKnowledgeHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>,
          TError,
          Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompanyKnowledgeHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCompanyKnowledgeHistory<TData = Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError = ErrorType<unknown>>(
 params?: ListCompanyKnowledgeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyKnowledgeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanyKnowledgeHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCompanyKnowledgeRevisionUrl = (revision: number,
    params?: GetCompanyKnowledgeRevisionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/history/${revision}?${stringifiedParams}` : `/api/company-knowledge/history/${revision}`
}

export const getCompanyKnowledgeRevision = async (revision: number,
    params?: GetCompanyKnowledgeRevisionParams, options?: RequestInit): Promise<CompanyKnowledgeRevision> => {

  return customFetch<CompanyKnowledgeRevision>(getGetCompanyKnowledgeRevisionUrl(revision,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyKnowledgeRevisionQueryKey = (revision: number,
    params?: GetCompanyKnowledgeRevisionParams,) => {
    return [
    `/api/company-knowledge/history/${revision}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyKnowledgeRevisionQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError = ErrorType<unknown>>(revision: number,
    params?: GetCompanyKnowledgeRevisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKnowledgeRevisionQueryKey(revision,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>> = ({ signal }) => getCompanyKnowledgeRevision(revision,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: revision !== null && revision !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyKnowledgeRevisionQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>>
export type GetCompanyKnowledgeRevisionQueryError = ErrorType<unknown>


export function useGetCompanyKnowledgeRevision<TData = Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError = ErrorType<unknown>>(
 revision: number,
    params: undefined |  GetCompanyKnowledgeRevisionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeRevision<TData = Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError = ErrorType<unknown>>(
 revision: number,
    params?: GetCompanyKnowledgeRevisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeRevision<TData = Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError = ErrorType<unknown>>(
 revision: number,
    params?: GetCompanyKnowledgeRevisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCompanyKnowledgeRevision<TData = Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError = ErrorType<unknown>>(
 revision: number,
    params?: GetCompanyKnowledgeRevisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeRevision>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKnowledgeRevisionQueryOptions(revision,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestoreCompanyKnowledgeUrl = (params?: RestoreCompanyKnowledgeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/restore?${stringifiedParams}` : `/api/company-knowledge/restore`
}

export const restoreCompanyKnowledge = async (companyKnowledgeRestoreInput: CompanyKnowledgeRestoreInput,
    params?: RestoreCompanyKnowledgeParams, options?: RequestInit): Promise<CompanyKnowledge> => {

  return customFetch<CompanyKnowledge>(getRestoreCompanyKnowledgeUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyKnowledgeRestoreInput)
  }
);}




export const getRestoreCompanyKnowledgeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeRestoreInput>;params?: RestoreCompanyKnowledgeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeRestoreInput>;params?: RestoreCompanyKnowledgeParams}, TContext> => {

const mutationKey = ['restoreCompanyKnowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreCompanyKnowledge>>, {data: BodyType<CompanyKnowledgeRestoreInput>;params?: RestoreCompanyKnowledgeParams}> = (props) => {
          const {data,params} = props ?? {};

          return  restoreCompanyKnowledge(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreCompanyKnowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof restoreCompanyKnowledge>>>
    export type RestoreCompanyKnowledgeMutationBody = BodyType<CompanyKnowledgeRestoreInput>
    export type RestoreCompanyKnowledgeMutationError = ErrorType<void>

    export const useRestoreCompanyKnowledge = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreCompanyKnowledge>>, TError,{data: BodyType<CompanyKnowledgeRestoreInput>;params?: RestoreCompanyKnowledgeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreCompanyKnowledge>>,
        TError,
        {data: BodyType<CompanyKnowledgeRestoreInput>;params?: RestoreCompanyKnowledgeParams},
        TContext
      > => {
      return useMutation(getRestoreCompanyKnowledgeMutationOptions(options), queryClient);
    }

export const getGetCompanyKnowledgeContextUrl = (params?: GetCompanyKnowledgeContextParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/company-knowledge/context?${stringifiedParams}` : `/api/company-knowledge/context`
}

export const getCompanyKnowledgeContext = async (params?: GetCompanyKnowledgeContextParams, options?: RequestInit): Promise<CompanyKnowledgeContext> => {

  return customFetch<CompanyKnowledgeContext>(getGetCompanyKnowledgeContextUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyKnowledgeContextQueryKey = (params?: GetCompanyKnowledgeContextParams,) => {
    return [
    `/api/company-knowledge/context`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyKnowledgeContextQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError = ErrorType<unknown>>(params?: GetCompanyKnowledgeContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKnowledgeContextQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>> = ({ signal }) => getCompanyKnowledgeContext(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyKnowledgeContextQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>>
export type GetCompanyKnowledgeContextQueryError = ErrorType<unknown>


export function useGetCompanyKnowledgeContext<TData = Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCompanyKnowledgeContextParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeContext>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeContext<TData = Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyKnowledgeContext>>,
          TError,
          Awaited<ReturnType<typeof getCompanyKnowledgeContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyKnowledgeContext<TData = Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCompanyKnowledgeContext<TData = Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError = ErrorType<unknown>>(
 params?: GetCompanyKnowledgeContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyKnowledgeContext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyKnowledgeContextQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClarityMetricsUrl = (params?: GetClarityMetricsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/clarity?${stringifiedParams}` : `/api/integrations/clarity`
}

export const getClarityMetrics = async (params?: GetClarityMetricsParams, options?: RequestInit): Promise<ClarityMetrics> => {

  return customFetch<ClarityMetrics>(getGetClarityMetricsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClarityMetricsQueryKey = (params?: GetClarityMetricsParams,) => {
    return [
    `/api/integrations/clarity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClarityMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getClarityMetrics>>, TError = ErrorType<unknown>>(params?: GetClarityMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClarityMetricsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClarityMetrics>>> = ({ signal }) => getClarityMetrics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClarityMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getClarityMetrics>>>
export type GetClarityMetricsQueryError = ErrorType<unknown>


export function useGetClarityMetrics<TData = Awaited<ReturnType<typeof getClarityMetrics>>, TError = ErrorType<unknown>>(
 params: undefined |  GetClarityMetricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClarityMetrics>>,
          TError,
          Awaited<ReturnType<typeof getClarityMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClarityMetrics<TData = Awaited<ReturnType<typeof getClarityMetrics>>, TError = ErrorType<unknown>>(
 params?: GetClarityMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClarityMetrics>>,
          TError,
          Awaited<ReturnType<typeof getClarityMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClarityMetrics<TData = Awaited<ReturnType<typeof getClarityMetrics>>, TError = ErrorType<unknown>>(
 params?: GetClarityMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClarityMetrics<TData = Awaited<ReturnType<typeof getClarityMetrics>>, TError = ErrorType<unknown>>(
 params?: GetClarityMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClarityMetrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClarityMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConnectClarityMetricsUrl = () => {




  return `/api/integrations/clarity`
}

export const connectClarityMetrics = async (clarityCredentialInput: ClarityCredentialInput, options?: RequestInit): Promise<ClarityMetrics> => {

  return customFetch<ClarityMetrics>(getConnectClarityMetricsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clarityCredentialInput)
  }
);}




export const getConnectClarityMetricsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectClarityMetrics>>, TError,{data: BodyType<ClarityCredentialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectClarityMetrics>>, TError,{data: BodyType<ClarityCredentialInput>}, TContext> => {

const mutationKey = ['connectClarityMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectClarityMetrics>>, {data: BodyType<ClarityCredentialInput>}> = (props) => {
          const {data} = props ?? {};

          return  connectClarityMetrics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectClarityMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof connectClarityMetrics>>>
    export type ConnectClarityMetricsMutationBody = BodyType<ClarityCredentialInput>
    export type ConnectClarityMetricsMutationError = ErrorType<unknown>

    export const useConnectClarityMetrics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectClarityMetrics>>, TError,{data: BodyType<ClarityCredentialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connectClarityMetrics>>,
        TError,
        {data: BodyType<ClarityCredentialInput>},
        TContext
      > => {
      return useMutation(getConnectClarityMetricsMutationOptions(options), queryClient);
    }

export const getDisconnectClarityMetricsUrl = () => {




  return `/api/integrations/clarity`
}

export const disconnectClarityMetrics = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDisconnectClarityMetricsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectClarityMetricsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectClarityMetrics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectClarityMetrics>>, TError,void, TContext> => {

const mutationKey = ['disconnectClarityMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectClarityMetrics>>, void> = () => {


          return  disconnectClarityMetrics(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectClarityMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectClarityMetrics>>>

    export type DisconnectClarityMetricsMutationError = ErrorType<unknown>

    export const useDisconnectClarityMetrics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectClarityMetrics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectClarityMetrics>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectClarityMetricsMutationOptions(options), queryClient);
    }

export const getRefreshClarityMetricsUrl = () => {




  return `/api/integrations/clarity/refresh`
}

export const refreshClarityMetrics = async (clarityWindowInput: ClarityWindowInput, options?: RequestInit): Promise<ClarityMetrics> => {

  return customFetch<ClarityMetrics>(getRefreshClarityMetricsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clarityWindowInput)
  }
);}




export const getRefreshClarityMetricsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshClarityMetrics>>, TError,{data: BodyType<ClarityWindowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshClarityMetrics>>, TError,{data: BodyType<ClarityWindowInput>}, TContext> => {

const mutationKey = ['refreshClarityMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshClarityMetrics>>, {data: BodyType<ClarityWindowInput>}> = (props) => {
          const {data} = props ?? {};

          return  refreshClarityMetrics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshClarityMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshClarityMetrics>>>
    export type RefreshClarityMetricsMutationBody = BodyType<ClarityWindowInput>
    export type RefreshClarityMetricsMutationError = ErrorType<unknown>

    export const useRefreshClarityMetrics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshClarityMetrics>>, TError,{data: BodyType<ClarityWindowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshClarityMetrics>>,
        TError,
        {data: BodyType<ClarityWindowInput>},
        TContext
      > => {
      return useMutation(getRefreshClarityMetricsMutationOptions(options), queryClient);
    }

export const getGetPublicRidConfigUrl = (key: string,) => {




  return `/api/rid/${key}/config`
}

export const getPublicRidConfig = async (key: string, options?: RequestInit): Promise<RidPublicConfig> => {

  return customFetch<RidPublicConfig>(getGetPublicRidConfigUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicRidConfigQueryKey = (key: string,) => {
    return [
    `/api/rid/${key}/config`
    ] as const;
    }


export const getGetPublicRidConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPublicRidConfig>>, TError = ErrorType<void>>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicRidConfigQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicRidConfig>>> = ({ signal }) => getPublicRidConfig(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicRidConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicRidConfig>>>
export type GetPublicRidConfigQueryError = ErrorType<void>


export function useGetPublicRidConfig<TData = Awaited<ReturnType<typeof getPublicRidConfig>>, TError = ErrorType<void>>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicRidConfig>>,
          TError,
          Awaited<ReturnType<typeof getPublicRidConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicRidConfig<TData = Awaited<ReturnType<typeof getPublicRidConfig>>, TError = ErrorType<void>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicRidConfig>>,
          TError,
          Awaited<ReturnType<typeof getPublicRidConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicRidConfig<TData = Awaited<ReturnType<typeof getPublicRidConfig>>, TError = ErrorType<void>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicRidConfig<TData = Awaited<ReturnType<typeof getPublicRidConfig>>, TError = ErrorType<void>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicRidConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicRidConfigQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReadPublicRidConfigUrl = (key: string,) => {




  return `/api/rid/${key}/config`
}

/**
 * Read-only configuration lookup. POST ensures browsers attach Origin even
 * when the website and collector share an origin. No body is consumed and
 * no configuration, diagnostic, or visit record is changed.
 */
export const readPublicRidConfig = async (key: string, options?: RequestInit): Promise<RidPublicConfig> => {

  return customFetch<RidPublicConfig>(getReadPublicRidConfigUrl(key),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReadPublicRidConfigMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readPublicRidConfig>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof readPublicRidConfig>>, TError,{key: string}, TContext> => {

const mutationKey = ['readPublicRidConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readPublicRidConfig>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  readPublicRidConfig(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadPublicRidConfigMutationResult = NonNullable<Awaited<ReturnType<typeof readPublicRidConfig>>>

    export type ReadPublicRidConfigMutationError = ErrorType<void>

    export const useReadPublicRidConfig = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readPublicRidConfig>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof readPublicRidConfig>>,
        TError,
        {key: string},
        TContext
      > => {
      return useMutation(getReadPublicRidConfigMutationOptions(options), queryClient);
    }

export const getCollectRidVisitUrl = (key: string,) => {




  return `/api/rid/${key}/events`
}

export const collectRidVisit = async (key: string,
    ridCollectorInput: RidCollectorInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCollectRidVisitUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ridCollectorInput)
  }
);}




export const getCollectRidVisitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof collectRidVisit>>, TError,{key: string;data: BodyType<RidCollectorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof collectRidVisit>>, TError,{key: string;data: BodyType<RidCollectorInput>}, TContext> => {

const mutationKey = ['collectRidVisit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof collectRidVisit>>, {key: string;data: BodyType<RidCollectorInput>}> = (props) => {
          const {key,data} = props ?? {};

          return  collectRidVisit(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CollectRidVisitMutationResult = NonNullable<Awaited<ReturnType<typeof collectRidVisit>>>
    export type CollectRidVisitMutationBody = BodyType<RidCollectorInput>
    export type CollectRidVisitMutationError = ErrorType<void>

    export const useCollectRidVisit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof collectRidVisit>>, TError,{key: string;data: BodyType<RidCollectorInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof collectRidVisit>>,
        TError,
        {key: string;data: BodyType<RidCollectorInput>},
        TContext
      > => {
      return useMutation(getCollectRidVisitMutationOptions(options), queryClient);
    }

export const getGetRidIntegrationUrl = () => {




  return `/api/integrations/rid`
}

export const getRidIntegration = async ( options?: RequestInit): Promise<RidIntegration> => {

  return customFetch<RidIntegration>(getGetRidIntegrationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRidIntegrationQueryKey = () => {
    return [
    `/api/integrations/rid`
    ] as const;
    }


export const getGetRidIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getRidIntegration>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRidIntegrationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRidIntegration>>> = ({ signal }) => getRidIntegration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRidIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getRidIntegration>>>
export type GetRidIntegrationQueryError = ErrorType<unknown>


export function useGetRidIntegration<TData = Awaited<ReturnType<typeof getRidIntegration>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRidIntegration>>,
          TError,
          Awaited<ReturnType<typeof getRidIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRidIntegration<TData = Awaited<ReturnType<typeof getRidIntegration>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRidIntegration>>,
          TError,
          Awaited<ReturnType<typeof getRidIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRidIntegration<TData = Awaited<ReturnType<typeof getRidIntegration>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRidIntegration<TData = Awaited<ReturnType<typeof getRidIntegration>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRidIntegration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRidIntegrationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveRidIntegrationUrl = () => {




  return `/api/integrations/rid`
}

export const saveRidIntegration = async (ridIntegrationInput: RidIntegrationInput, options?: RequestInit): Promise<RidIntegration> => {

  return customFetch<RidIntegration>(getSaveRidIntegrationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ridIntegrationInput)
  }
);}




export const getSaveRidIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRidIntegration>>, TError,{data: BodyType<RidIntegrationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRidIntegration>>, TError,{data: BodyType<RidIntegrationInput>}, TContext> => {

const mutationKey = ['saveRidIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRidIntegration>>, {data: BodyType<RidIntegrationInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveRidIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRidIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof saveRidIntegration>>>
    export type SaveRidIntegrationMutationBody = BodyType<RidIntegrationInput>
    export type SaveRidIntegrationMutationError = ErrorType<unknown>

    export const useSaveRidIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRidIntegration>>, TError,{data: BodyType<RidIntegrationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRidIntegration>>,
        TError,
        {data: BodyType<RidIntegrationInput>},
        TContext
      > => {
      return useMutation(getSaveRidIntegrationMutationOptions(options), queryClient);
    }

export const getTestRidIntegrationUrl = () => {




  return `/api/integrations/rid/test`
}

export const testRidIntegration = async ( options?: RequestInit): Promise<RidInstallationTest> => {

  return customFetch<RidInstallationTest>(getTestRidIntegrationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTestRidIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testRidIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testRidIntegration>>, TError,void, TContext> => {

const mutationKey = ['testRidIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testRidIntegration>>, void> = () => {


          return  testRidIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestRidIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof testRidIntegration>>>

    export type TestRidIntegrationMutationError = ErrorType<unknown>

    export const useTestRidIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testRidIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testRidIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestRidIntegrationMutationOptions(options), queryClient);
    }

export const getDeleteRidEventsUrl = () => {




  return `/api/integrations/rid/events`
}

export const deleteRidEvents = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteRidEventsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteRidEventsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRidEvents>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRidEvents>>, TError,void, TContext> => {

const mutationKey = ['deleteRidEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRidEvents>>, void> = () => {


          return  deleteRidEvents(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRidEventsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRidEvents>>>

    export type DeleteRidEventsMutationError = ErrorType<unknown>

    export const useDeleteRidEvents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRidEvents>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRidEvents>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteRidEventsMutationOptions(options), queryClient);
    }

export const getListRidRecipientsUrl = (params: ListRidRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/recipients?${stringifiedParams}` : `/api/lob-mail/mail-analytics/recipients`
}

export const listRidRecipients = async (params: ListRidRecipientsParams, options?: RequestInit): Promise<RidRecipientReport> => {

  return customFetch<RidRecipientReport>(getListRidRecipientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRidRecipientsQueryKey = (params?: ListRidRecipientsParams,) => {
    return [
    `/api/lob-mail/mail-analytics/recipients`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRidRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof listRidRecipients>>, TError = ErrorType<unknown>>(params: ListRidRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRidRecipientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRidRecipients>>> = ({ signal }) => listRidRecipients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRidRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof listRidRecipients>>>
export type ListRidRecipientsQueryError = ErrorType<unknown>


export function useListRidRecipients<TData = Awaited<ReturnType<typeof listRidRecipients>>, TError = ErrorType<unknown>>(
 params: ListRidRecipientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRidRecipients>>,
          TError,
          Awaited<ReturnType<typeof listRidRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRidRecipients<TData = Awaited<ReturnType<typeof listRidRecipients>>, TError = ErrorType<unknown>>(
 params: ListRidRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRidRecipients>>,
          TError,
          Awaited<ReturnType<typeof listRidRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRidRecipients<TData = Awaited<ReturnType<typeof listRidRecipients>>, TError = ErrorType<unknown>>(
 params: ListRidRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRidRecipients<TData = Awaited<ReturnType<typeof listRidRecipients>>, TError = ErrorType<unknown>>(
 params: ListRidRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRidRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRidRecipientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportRidRecipientsCsvUrl = (params: ExportRidRecipientsCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/recipients/export.csv?${stringifiedParams}` : `/api/lob-mail/mail-analytics/recipients/export.csv`
}

export const exportRidRecipientsCsv = async (params: ExportRidRecipientsCsvParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportRidRecipientsCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportRidRecipientsCsvQueryKey = (params?: ExportRidRecipientsCsvParams,) => {
    return [
    `/api/lob-mail/mail-analytics/recipients/export.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportRidRecipientsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError = ErrorType<unknown>>(params: ExportRidRecipientsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportRidRecipientsCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportRidRecipientsCsv>>> = ({ signal }) => exportRidRecipientsCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportRidRecipientsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportRidRecipientsCsv>>>
export type ExportRidRecipientsCsvQueryError = ErrorType<unknown>


export function useExportRidRecipientsCsv<TData = Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError = ErrorType<unknown>>(
 params: ExportRidRecipientsCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportRidRecipientsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportRidRecipientsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRidRecipientsCsv<TData = Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError = ErrorType<unknown>>(
 params: ExportRidRecipientsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportRidRecipientsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportRidRecipientsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRidRecipientsCsv<TData = Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError = ErrorType<unknown>>(
 params: ExportRidRecipientsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportRidRecipientsCsv<TData = Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError = ErrorType<unknown>>(
 params: ExportRidRecipientsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportRidRecipientsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportRidRecipientsCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRidEventLinkUrl = (id: string,) => {




  return `/api/lob-mail/mail-analytics/rid-events/${id}/link`
}

export const updateRidEventLink = async (id: string,
    ridLinkInput: RidLinkInput, options?: RequestInit): Promise<RidVisit> => {

  return customFetch<RidVisit>(getUpdateRidEventLinkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ridLinkInput)
  }
);}




export const getUpdateRidEventLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRidEventLink>>, TError,{id: string;data: BodyType<RidLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRidEventLink>>, TError,{id: string;data: BodyType<RidLinkInput>}, TContext> => {

const mutationKey = ['updateRidEventLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRidEventLink>>, {id: string;data: BodyType<RidLinkInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRidEventLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRidEventLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateRidEventLink>>>
    export type UpdateRidEventLinkMutationBody = BodyType<RidLinkInput>
    export type UpdateRidEventLinkMutationError = ErrorType<unknown>

    export const useUpdateRidEventLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRidEventLink>>, TError,{id: string;data: BodyType<RidLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRidEventLink>>,
        TError,
        {id: string;data: BodyType<RidLinkInput>},
        TContext
      > => {
      return useMutation(getUpdateRidEventLinkMutationOptions(options), queryClient);
    }

export const getGetPropertyUsageAllowancesUrl = () => {




  return `/api/property-builder/usage-allowances`
}

export const getPropertyUsageAllowances = async ( options?: RequestInit): Promise<PropertyUsageAllowances> => {

  return customFetch<PropertyUsageAllowances>(getGetPropertyUsageAllowancesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyUsageAllowancesQueryKey = () => {
    return [
    `/api/property-builder/usage-allowances`
    ] as const;
    }


export const getGetPropertyUsageAllowancesQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyUsageAllowancesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyUsageAllowances>>> = ({ signal }) => getPropertyUsageAllowances({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyUsageAllowancesQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyUsageAllowances>>>
export type GetPropertyUsageAllowancesQueryError = ErrorType<void>


export function useGetPropertyUsageAllowances<TData = Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyUsageAllowances>>,
          TError,
          Awaited<ReturnType<typeof getPropertyUsageAllowances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyUsageAllowances<TData = Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyUsageAllowances>>,
          TError,
          Awaited<ReturnType<typeof getPropertyUsageAllowances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyUsageAllowances<TData = Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyUsageAllowances<TData = Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyUsageAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyUsageAllowancesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdjustPropertyUsageTrackingUrl = () => {




  return `/api/property-builder/usage-allowances/tracking`
}

export const adjustPropertyUsageTracking = async (propertyUsageTrackingInput: PropertyUsageTrackingInput, options?: RequestInit): Promise<AdjustPropertyUsageTracking200> => {

  return customFetch<AdjustPropertyUsageTracking200>(getAdjustPropertyUsageTrackingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyUsageTrackingInput)
  }
);}




export const getAdjustPropertyUsageTrackingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustPropertyUsageTracking>>, TError,{data: BodyType<PropertyUsageTrackingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustPropertyUsageTracking>>, TError,{data: BodyType<PropertyUsageTrackingInput>}, TContext> => {

const mutationKey = ['adjustPropertyUsageTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustPropertyUsageTracking>>, {data: BodyType<PropertyUsageTrackingInput>}> = (props) => {
          const {data} = props ?? {};

          return  adjustPropertyUsageTracking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustPropertyUsageTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof adjustPropertyUsageTracking>>>
    export type AdjustPropertyUsageTrackingMutationBody = BodyType<PropertyUsageTrackingInput>
    export type AdjustPropertyUsageTrackingMutationError = ErrorType<void>

    export const useAdjustPropertyUsageTracking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustPropertyUsageTracking>>, TError,{data: BodyType<PropertyUsageTrackingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adjustPropertyUsageTracking>>,
        TError,
        {data: BodyType<PropertyUsageTrackingInput>},
        TContext
      > => {
      return useMutation(getAdjustPropertyUsageTrackingMutationOptions(options), queryClient);
    }

export const getGetPropertyBuilderUrl = () => {




  return `/api/property-builder`
}

export const getPropertyBuilder = async ( options?: RequestInit): Promise<GetPropertyBuilder200> => {

  return customFetch<GetPropertyBuilder200>(getGetPropertyBuilderUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderQueryKey = () => {
    return [
    `/api/property-builder`
    ] as const;
    }


export const getGetPropertyBuilderQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilder>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilder>>> = ({ signal }) => getPropertyBuilder({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilder>>>
export type GetPropertyBuilderQueryError = ErrorType<void>


export function useGetPropertyBuilder<TData = Awaited<ReturnType<typeof getPropertyBuilder>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilder>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilder<TData = Awaited<ReturnType<typeof getPropertyBuilder>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilder>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilder<TData = Awaited<ReturnType<typeof getPropertyBuilder>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilder<TData = Awaited<ReturnType<typeof getPropertyBuilder>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderImageLinksUrl = (params?: GetPropertyBuilderImageLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/image-links?${stringifiedParams}` : `/api/property-builder/image-links`
}

export const getPropertyBuilderImageLinks = async (params?: GetPropertyBuilderImageLinksParams, options?: RequestInit): Promise<GetPropertyBuilderImageLinks200> => {

  return customFetch<GetPropertyBuilderImageLinks200>(getGetPropertyBuilderImageLinksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderImageLinksQueryKey = (params?: GetPropertyBuilderImageLinksParams,) => {
    return [
    `/api/property-builder/image-links`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPropertyBuilderImageLinksQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError = ErrorType<unknown>>(params?: GetPropertyBuilderImageLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderImageLinksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>> = ({ signal }) => getPropertyBuilderImageLinks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderImageLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>>
export type GetPropertyBuilderImageLinksQueryError = ErrorType<unknown>


export function useGetPropertyBuilderImageLinks<TData = Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPropertyBuilderImageLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderImageLinks<TData = Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderImageLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderImageLinks<TData = Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderImageLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderImageLinks<TData = Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderImageLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderImageLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderImageLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobPropertyAudienceListsUrl = (params?: GetLobPropertyAudienceListsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/recipients/property-lists?${stringifiedParams}` : `/api/lob-mail/recipients/property-lists`
}

/**
 * @summary Agency-only retained Property Builder list catalog for the effective client
 */
export const getLobPropertyAudienceLists = async (params?: GetLobPropertyAudienceListsParams, options?: RequestInit): Promise<LobPropertyAudienceCatalog> => {

  return customFetch<LobPropertyAudienceCatalog>(getGetLobPropertyAudienceListsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobPropertyAudienceListsQueryKey = (params?: GetLobPropertyAudienceListsParams,) => {
    return [
    `/api/lob-mail/recipients/property-lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobPropertyAudienceListsQueryOptions = <TData = Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError = ErrorType<unknown>>(params?: GetLobPropertyAudienceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobPropertyAudienceListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>> = ({ signal }) => getLobPropertyAudienceLists(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobPropertyAudienceListsQueryResult = NonNullable<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>>
export type GetLobPropertyAudienceListsQueryError = ErrorType<unknown>


export function useGetLobPropertyAudienceLists<TData = Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobPropertyAudienceListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobPropertyAudienceLists>>,
          TError,
          Awaited<ReturnType<typeof getLobPropertyAudienceLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobPropertyAudienceLists<TData = Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError = ErrorType<unknown>>(
 params?: GetLobPropertyAudienceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobPropertyAudienceLists>>,
          TError,
          Awaited<ReturnType<typeof getLobPropertyAudienceLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobPropertyAudienceLists<TData = Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError = ErrorType<unknown>>(
 params?: GetLobPropertyAudienceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Agency-only retained Property Builder list catalog for the effective client
 */

export function useGetLobPropertyAudienceLists<TData = Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError = ErrorType<unknown>>(
 params?: GetLobPropertyAudienceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobPropertyAudienceLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobPropertyAudienceListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderPublishOperationUrl = (id: string,
    params?: GetPropertyBuilderPublishOperationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/publish-operations/${id}?${stringifiedParams}` : `/api/property-builder/publish-operations/${id}`
}

/**
 * Read a retained transfer operation or a 50-row review page. Pure review may resume; this never confirms or replays a save.
 */
export const getPropertyBuilderPublishOperation = async (id: string,
    params?: GetPropertyBuilderPublishOperationParams, options?: RequestInit): Promise<GetPropertyBuilderPublishOperation200> => {

  return customFetch<GetPropertyBuilderPublishOperation200>(getGetPropertyBuilderPublishOperationUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderPublishOperationQueryKey = (id: string,
    params?: GetPropertyBuilderPublishOperationParams,) => {
    return [
    `/api/property-builder/publish-operations/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPropertyBuilderPublishOperationQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError = ErrorType<void>>(id: string,
    params?: GetPropertyBuilderPublishOperationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderPublishOperationQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>> = ({ signal }) => getPropertyBuilderPublishOperation(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderPublishOperationQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>>
export type GetPropertyBuilderPublishOperationQueryError = ErrorType<void>


export function useGetPropertyBuilderPublishOperation<TData = Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetPropertyBuilderPublishOperationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderPublishOperation<TData = Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError = ErrorType<void>>(
 id: string,
    params?: GetPropertyBuilderPublishOperationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderPublishOperation<TData = Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError = ErrorType<void>>(
 id: string,
    params?: GetPropertyBuilderPublishOperationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderPublishOperation<TData = Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError = ErrorType<void>>(
 id: string,
    params?: GetPropertyBuilderPublishOperationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderPublishOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderPublishOperationQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderRecordsUrl = (params?: GetPropertyBuilderRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/records?${stringifiedParams}` : `/api/property-builder/records`
}

export const getPropertyBuilderRecords = async (params?: GetPropertyBuilderRecordsParams, options?: RequestInit): Promise<GetPropertyBuilderRecords200> => {

  return customFetch<GetPropertyBuilderRecords200>(getGetPropertyBuilderRecordsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderRecordsQueryKey = (params?: GetPropertyBuilderRecordsParams,) => {
    return [
    `/api/property-builder/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPropertyBuilderRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError = ErrorType<unknown>>(params?: GetPropertyBuilderRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderRecordsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderRecords>>> = ({ signal }) => getPropertyBuilderRecords(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderRecords>>>
export type GetPropertyBuilderRecordsQueryError = ErrorType<unknown>


export function useGetPropertyBuilderRecords<TData = Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPropertyBuilderRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderRecords>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderRecords<TData = Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderRecords>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderRecords<TData = Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderRecords<TData = Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError = ErrorType<unknown>>(
 params?: GetPropertyBuilderRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderRecordUrl = (id: string,) => {




  return `/api/property-builder/records/${id}`
}

export const getPropertyBuilderRecord = async (id: string, options?: RequestInit): Promise<GetPropertyBuilderRecord200> => {

  return customFetch<GetPropertyBuilderRecord200>(getGetPropertyBuilderRecordUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderRecordQueryKey = (id: string,) => {
    return [
    `/api/property-builder/records/${id}`
    ] as const;
    }


export const getGetPropertyBuilderRecordQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderRecordQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderRecord>>> = ({ signal }) => getPropertyBuilderRecord(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderRecordQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderRecord>>>
export type GetPropertyBuilderRecordQueryError = ErrorType<void>


export function useGetPropertyBuilderRecord<TData = Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderRecord>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderRecord<TData = Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderRecord>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderRecord<TData = Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderRecord<TData = Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderRecord>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderRecordQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSavedPropertyRefinementUrl = (id: string,) => {




  return `/api/property-builder/workspaces/${id}/refinement`
}

export const getSavedPropertyRefinement = async (id: string, options?: RequestInit): Promise<GetSavedPropertyRefinement200> => {

  return customFetch<GetSavedPropertyRefinement200>(getGetSavedPropertyRefinementUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedPropertyRefinementQueryKey = (id: string,) => {
    return [
    `/api/property-builder/workspaces/${id}/refinement`
    ] as const;
    }


export const getGetSavedPropertyRefinementQueryOptions = <TData = Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedPropertyRefinementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedPropertyRefinement>>> = ({ signal }) => getSavedPropertyRefinement(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedPropertyRefinementQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedPropertyRefinement>>>
export type GetSavedPropertyRefinementQueryError = ErrorType<void>


export function useGetSavedPropertyRefinement<TData = Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedPropertyRefinement>>,
          TError,
          Awaited<ReturnType<typeof getSavedPropertyRefinement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedPropertyRefinement<TData = Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedPropertyRefinement>>,
          TError,
          Awaited<ReturnType<typeof getSavedPropertyRefinement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedPropertyRefinement<TData = Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSavedPropertyRefinement<TData = Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPropertyRefinement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedPropertyRefinementQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderSavedCountUrl = (id: string,) => {




  return `/api/property-builder/workspaces/${id}/count`
}

/**
 * Read the existing workspace association and checkpoint only. Never creates runs, refreshes evidence, restores approval or calls the provider.
 */
export const getPropertyBuilderSavedCount = async (id: string, options?: RequestInit): Promise<GetPropertyBuilderSavedCount200> => {

  return customFetch<GetPropertyBuilderSavedCount200>(getGetPropertyBuilderSavedCountUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderSavedCountQueryKey = (id: string,) => {
    return [
    `/api/property-builder/workspaces/${id}/count`
    ] as const;
    }


export const getGetPropertyBuilderSavedCountQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError = ErrorType<void | GetPropertyBuilderSavedCount503>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderSavedCountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>> = ({ signal }) => getPropertyBuilderSavedCount(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderSavedCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>>
export type GetPropertyBuilderSavedCountQueryError = ErrorType<void | GetPropertyBuilderSavedCount503>


export function useGetPropertyBuilderSavedCount<TData = Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError = ErrorType<void | GetPropertyBuilderSavedCount503>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderSavedCount<TData = Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError = ErrorType<void | GetPropertyBuilderSavedCount503>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderSavedCount<TData = Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError = ErrorType<void | GetPropertyBuilderSavedCount503>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderSavedCount<TData = Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError = ErrorType<void | GetPropertyBuilderSavedCount503>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderSavedCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderSavedCountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPropertyBuilderActionUrl = () => {




  return `/api/property-builder/actions`
}

export const propertyBuilderAction = async (propertyBuilderActionInput: PropertyBuilderActionInput, options?: RequestInit): Promise<PropertyBuilderAction200> => {

  return customFetch<PropertyBuilderAction200>(getPropertyBuilderActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyBuilderActionInput)
  }
);}




export const getPropertyBuilderActionMutationOptions = <TError = ErrorType<void | PropertyBuilderAction429>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyBuilderAction>>, TError,{data: BodyType<PropertyBuilderActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyBuilderAction>>, TError,{data: BodyType<PropertyBuilderActionInput>}, TContext> => {

const mutationKey = ['propertyBuilderAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyBuilderAction>>, {data: BodyType<PropertyBuilderActionInput>}> = (props) => {
          const {data} = props ?? {};

          return  propertyBuilderAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PropertyBuilderActionMutationResult = NonNullable<Awaited<ReturnType<typeof propertyBuilderAction>>>
    export type PropertyBuilderActionMutationBody = BodyType<PropertyBuilderActionInput>
    export type PropertyBuilderActionMutationError = ErrorType<void | PropertyBuilderAction429>

    export const usePropertyBuilderAction = <TError = ErrorType<void | PropertyBuilderAction429>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyBuilderAction>>, TError,{data: BodyType<PropertyBuilderActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyBuilderAction>>,
        TError,
        {data: BodyType<PropertyBuilderActionInput>},
        TContext
      > => {
      return useMutation(getPropertyBuilderActionMutationOptions(options), queryClient);
    }

export const getExportPropertyBuilderUrl = (params?: ExportPropertyBuilderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-builder/export?${stringifiedParams}` : `/api/property-builder/export`
}

export const exportPropertyBuilder = async (params?: ExportPropertyBuilderParams, options?: RequestInit): Promise<string | ExportPropertyBuilder200Two> => {

  return customFetch<string | ExportPropertyBuilder200Two>(getExportPropertyBuilderUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportPropertyBuilderQueryKey = (params?: ExportPropertyBuilderParams,) => {
    return [
    `/api/property-builder/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportPropertyBuilderQueryOptions = <TData = Awaited<ReturnType<typeof exportPropertyBuilder>>, TError = ErrorType<unknown>>(params?: ExportPropertyBuilderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPropertyBuilderQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPropertyBuilder>>> = ({ signal }) => exportPropertyBuilder(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportPropertyBuilderQueryResult = NonNullable<Awaited<ReturnType<typeof exportPropertyBuilder>>>
export type ExportPropertyBuilderQueryError = ErrorType<unknown>


export function useExportPropertyBuilder<TData = Awaited<ReturnType<typeof exportPropertyBuilder>>, TError = ErrorType<unknown>>(
 params: undefined |  ExportPropertyBuilderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPropertyBuilder>>,
          TError,
          Awaited<ReturnType<typeof exportPropertyBuilder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPropertyBuilder<TData = Awaited<ReturnType<typeof exportPropertyBuilder>>, TError = ErrorType<unknown>>(
 params?: ExportPropertyBuilderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPropertyBuilder>>,
          TError,
          Awaited<ReturnType<typeof exportPropertyBuilder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPropertyBuilder<TData = Awaited<ReturnType<typeof exportPropertyBuilder>>, TError = ErrorType<unknown>>(
 params?: ExportPropertyBuilderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportPropertyBuilder<TData = Awaited<ReturnType<typeof exportPropertyBuilder>>, TError = ErrorType<unknown>>(
 params?: ExportPropertyBuilderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPropertyBuilder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportPropertyBuilderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPropertyBuilderGeojsonUrl = () => {




  return `/api/property-builder/geojson`
}

export const getPropertyBuilderGeojson = async ( options?: RequestInit): Promise<GetPropertyBuilderGeojson200> => {

  return customFetch<GetPropertyBuilderGeojson200>(getGetPropertyBuilderGeojsonUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyBuilderGeojsonQueryKey = () => {
    return [
    `/api/property-builder/geojson`
    ] as const;
    }


export const getGetPropertyBuilderGeojsonQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyBuilderGeojsonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>> = ({ signal }) => getPropertyBuilderGeojson({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyBuilderGeojsonQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>>
export type GetPropertyBuilderGeojsonQueryError = ErrorType<unknown>


export function useGetPropertyBuilderGeojson<TData = Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderGeojson>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderGeojson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderGeojson<TData = Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyBuilderGeojson>>,
          TError,
          Awaited<ReturnType<typeof getPropertyBuilderGeojson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyBuilderGeojson<TData = Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPropertyBuilderGeojson<TData = Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyBuilderGeojson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyBuilderGeojsonQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getQueryJobLocationsUrl = (params?: QueryJobLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-locations/query?${stringifiedParams}` : `/api/job-locations/query`
}

export const queryJobLocations = async (jobLocationQuery: JobLocationQuery,
    params?: QueryJobLocationsParams, options?: RequestInit): Promise<JobLocationPage> => {

  return customFetch<JobLocationPage>(getQueryJobLocationsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobLocationQuery)
  }
);}




export const getQueryJobLocationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: QueryJobLocationsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: QueryJobLocationsParams}, TContext> => {

const mutationKey = ['queryJobLocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryJobLocations>>, {data: BodyType<JobLocationQuery>;params?: QueryJobLocationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  queryJobLocations(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryJobLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof queryJobLocations>>>
    export type QueryJobLocationsMutationBody = BodyType<JobLocationQuery>
    export type QueryJobLocationsMutationError = ErrorType<unknown>

    export const useQueryJobLocations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: QueryJobLocationsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryJobLocations>>,
        TError,
        {data: BodyType<JobLocationQuery>;params?: QueryJobLocationsParams},
        TContext
      > => {
      return useMutation(getQueryJobLocationsMutationOptions(options), queryClient);
    }

export const getJobLocationDetailUrl = (params?: JobLocationDetailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-locations/detail?${stringifiedParams}` : `/api/job-locations/detail`
}

export const jobLocationDetail = async (jobLocationRecordInput: JobLocationRecordInput,
    params?: JobLocationDetailParams, options?: RequestInit): Promise<JobLocationDetail> => {

  return customFetch<JobLocationDetail>(getJobLocationDetailUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobLocationRecordInput)
  }
);}




export const getJobLocationDetailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobLocationDetail>>, TError,{data: BodyType<JobLocationRecordInput>;params?: JobLocationDetailParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobLocationDetail>>, TError,{data: BodyType<JobLocationRecordInput>;params?: JobLocationDetailParams}, TContext> => {

const mutationKey = ['jobLocationDetail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobLocationDetail>>, {data: BodyType<JobLocationRecordInput>;params?: JobLocationDetailParams}> = (props) => {
          const {data,params} = props ?? {};

          return  jobLocationDetail(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobLocationDetailMutationResult = NonNullable<Awaited<ReturnType<typeof jobLocationDetail>>>
    export type JobLocationDetailMutationBody = BodyType<JobLocationRecordInput>
    export type JobLocationDetailMutationError = ErrorType<unknown>

    export const useJobLocationDetail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobLocationDetail>>, TError,{data: BodyType<JobLocationRecordInput>;params?: JobLocationDetailParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobLocationDetail>>,
        TError,
        {data: BodyType<JobLocationRecordInput>;params?: JobLocationDetailParams},
        TContext
      > => {
      return useMutation(getJobLocationDetailMutationOptions(options), queryClient);
    }

export const getReviewJobLocationUrl = (params?: ReviewJobLocationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-locations/review?${stringifiedParams}` : `/api/job-locations/review`
}

export const reviewJobLocation = async (jobLocationReviewInput: JobLocationReviewInput,
    params?: ReviewJobLocationParams, options?: RequestInit): Promise<JobLocationDetail> => {

  return customFetch<JobLocationDetail>(getReviewJobLocationUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobLocationReviewInput)
  }
);}




export const getReviewJobLocationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewJobLocation>>, TError,{data: BodyType<JobLocationReviewInput>;params?: ReviewJobLocationParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewJobLocation>>, TError,{data: BodyType<JobLocationReviewInput>;params?: ReviewJobLocationParams}, TContext> => {

const mutationKey = ['reviewJobLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewJobLocation>>, {data: BodyType<JobLocationReviewInput>;params?: ReviewJobLocationParams}> = (props) => {
          const {data,params} = props ?? {};

          return  reviewJobLocation(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewJobLocationMutationResult = NonNullable<Awaited<ReturnType<typeof reviewJobLocation>>>
    export type ReviewJobLocationMutationBody = BodyType<JobLocationReviewInput>
    export type ReviewJobLocationMutationError = ErrorType<unknown>

    export const useReviewJobLocation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewJobLocation>>, TError,{data: BodyType<JobLocationReviewInput>;params?: ReviewJobLocationParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewJobLocation>>,
        TError,
        {data: BodyType<JobLocationReviewInput>;params?: ReviewJobLocationParams},
        TContext
      > => {
      return useMutation(getReviewJobLocationMutationOptions(options), queryClient);
    }

export const getRetryJobLocationsUrl = (params?: RetryJobLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-locations/retry?${stringifiedParams}` : `/api/job-locations/retry`
}

export const retryJobLocations = async (jobLocationQuery: JobLocationQuery,
    params?: RetryJobLocationsParams, options?: RequestInit): Promise<RetryJobLocations200> => {

  return customFetch<RetryJobLocations200>(getRetryJobLocationsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobLocationQuery)
  }
);}




export const getRetryJobLocationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: RetryJobLocationsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: RetryJobLocationsParams}, TContext> => {

const mutationKey = ['retryJobLocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryJobLocations>>, {data: BodyType<JobLocationQuery>;params?: RetryJobLocationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  retryJobLocations(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryJobLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof retryJobLocations>>>
    export type RetryJobLocationsMutationBody = BodyType<JobLocationQuery>
    export type RetryJobLocationsMutationError = ErrorType<unknown>

    export const useRetryJobLocations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryJobLocations>>, TError,{data: BodyType<JobLocationQuery>;params?: RetryJobLocationsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryJobLocations>>,
        TError,
        {data: BodyType<JobLocationQuery>;params?: RetryJobLocationsParams},
        TContext
      > => {
      return useMutation(getRetryJobLocationsMutationOptions(options), queryClient);
    }

export const getReadinessCheckUrl = () => {




  return `/api/readyz`
}

/**
 * @summary Check required API initialization without exposing database details
 */
export const readinessCheck = async ( options?: RequestInit): Promise<ReadinessCheck200> => {

  return customFetch<ReadinessCheck200>(getReadinessCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReadinessCheckQueryKey = () => {
    return [
    `/api/readyz`
    ] as const;
    }


export const getReadinessCheckQueryOptions = <TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<ReadinessCheck503>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadinessCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof readinessCheck>>> = ({ signal }) => readinessCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadinessCheckQueryResult = NonNullable<Awaited<ReturnType<typeof readinessCheck>>>
export type ReadinessCheckQueryError = ErrorType<ReadinessCheck503>


export function useReadinessCheck<TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<ReadinessCheck503>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadinessCheck<TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<ReadinessCheck503>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadinessCheck<TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<ReadinessCheck503>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check required API initialization without exposing database details
 */

export function useReadinessCheck<TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<ReadinessCheck503>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadinessCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCrmMailingListsUrl = (params?: ListCrmMailingListsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists`
}

/**
 * @summary List CRM mailing lists for the selected client tenant
 */
export const listCrmMailingLists = async (params?: ListCrmMailingListsParams, options?: RequestInit): Promise<ListCrmMailingLists200> => {

  return customFetch<ListCrmMailingLists200>(getListCrmMailingListsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmMailingListsQueryKey = (params?: ListCrmMailingListsParams,) => {
    return [
    `/api/lob-mail/crm/mailing-lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmMailingListsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmMailingLists>>, TError = ErrorType<void>>(params?: ListCrmMailingListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmMailingListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmMailingLists>>> = ({ signal }) => listCrmMailingLists(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCrmMailingListsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmMailingLists>>>
export type ListCrmMailingListsQueryError = ErrorType<void>


export function useListCrmMailingLists<TData = Awaited<ReturnType<typeof listCrmMailingLists>>, TError = ErrorType<void>>(
 params: undefined |  ListCrmMailingListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmMailingLists>>,
          TError,
          Awaited<ReturnType<typeof listCrmMailingLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmMailingLists<TData = Awaited<ReturnType<typeof listCrmMailingLists>>, TError = ErrorType<void>>(
 params?: ListCrmMailingListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmMailingLists>>,
          TError,
          Awaited<ReturnType<typeof listCrmMailingLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmMailingLists<TData = Awaited<ReturnType<typeof listCrmMailingLists>>, TError = ErrorType<void>>(
 params?: ListCrmMailingListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List CRM mailing lists for the selected client tenant
 */

export function useListCrmMailingLists<TData = Awaited<ReturnType<typeof listCrmMailingLists>>, TError = ErrorType<void>>(
 params?: ListCrmMailingListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCrmMailingListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCrmMailingListUrl = (params?: CreateCrmMailingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists`
}

/**
 * Manual lists preserve explicit membership; filtered lists derive membership from the saved live CRM filter. Creating or importing contacts never sends mail.
 * @summary Create a manual or live-filtered CRM mailing list
 */
export const createCrmMailingList = async (crmMailingListCreateInput: CrmMailingListCreateInput,
    params?: CreateCrmMailingListParams, options?: RequestInit): Promise<CrmMailingList> => {

  return customFetch<CrmMailingList>(getCreateCrmMailingListUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmMailingListCreateInput)
  }
);}




export const getCreateCrmMailingListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmMailingList>>, TError,{data: BodyType<CrmMailingListCreateInput>;params?: CreateCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmMailingList>>, TError,{data: BodyType<CrmMailingListCreateInput>;params?: CreateCrmMailingListParams}, TContext> => {

const mutationKey = ['createCrmMailingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmMailingList>>, {data: BodyType<CrmMailingListCreateInput>;params?: CreateCrmMailingListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createCrmMailingList(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmMailingListMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmMailingList>>>
    export type CreateCrmMailingListMutationBody = BodyType<CrmMailingListCreateInput>
    export type CreateCrmMailingListMutationError = ErrorType<void>

    /**
 * @summary Create a manual or live-filtered CRM mailing list
 */
export const useCreateCrmMailingList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmMailingList>>, TError,{data: BodyType<CrmMailingListCreateInput>;params?: CreateCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCrmMailingList>>,
        TError,
        {data: BodyType<CrmMailingListCreateInput>;params?: CreateCrmMailingListParams},
        TContext
      > => {
      return useMutation(getCreateCrmMailingListMutationOptions(options), queryClient);
    }

export const getGetCrmMailingListUrl = (id: string,
    params?: GetCrmMailingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}`
}

/**
 * Reading a filtered list synchronizes membership from its current saved CRM filter before returning its count.
 * @summary Read a tenant-owned CRM mailing list
 */
export const getCrmMailingList = async (id: string,
    params?: GetCrmMailingListParams, options?: RequestInit): Promise<CrmMailingList> => {

  return customFetch<CrmMailingList>(getGetCrmMailingListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmMailingListQueryKey = (id: string,
    params?: GetCrmMailingListParams,) => {
    return [
    `/api/lob-mail/crm/mailing-lists/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCrmMailingListQueryOptions = <TData = Awaited<ReturnType<typeof getCrmMailingList>>, TError = ErrorType<void>>(id: string,
    params?: GetCrmMailingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmMailingListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmMailingList>>> = ({ signal }) => getCrmMailingList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCrmMailingListQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmMailingList>>>
export type GetCrmMailingListQueryError = ErrorType<void>


export function useGetCrmMailingList<TData = Awaited<ReturnType<typeof getCrmMailingList>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetCrmMailingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmMailingList>>,
          TError,
          Awaited<ReturnType<typeof getCrmMailingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmMailingList<TData = Awaited<ReturnType<typeof getCrmMailingList>>, TError = ErrorType<void>>(
 id: string,
    params?: GetCrmMailingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmMailingList>>,
          TError,
          Awaited<ReturnType<typeof getCrmMailingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmMailingList<TData = Awaited<ReturnType<typeof getCrmMailingList>>, TError = ErrorType<void>>(
 id: string,
    params?: GetCrmMailingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a tenant-owned CRM mailing list
 */

export function useGetCrmMailingList<TData = Awaited<ReturnType<typeof getCrmMailingList>>, TError = ErrorType<void>>(
 id: string,
    params?: GetCrmMailingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCrmMailingListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCrmMailingListUrl = (id: string,
    params?: UpdateCrmMailingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}`
}

/**
 * @summary Rename a CRM list or update a filtered list's criteria
 */
export const updateCrmMailingList = async (id: string,
    crmMailingListUpdateInput: CrmMailingListUpdateInput,
    params?: UpdateCrmMailingListParams, options?: RequestInit): Promise<CrmMailingList> => {

  return customFetch<CrmMailingList>(getUpdateCrmMailingListUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmMailingListUpdateInput)
  }
);}




export const getUpdateCrmMailingListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmMailingList>>, TError,{id: string;data: BodyType<CrmMailingListUpdateInput>;params?: UpdateCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmMailingList>>, TError,{id: string;data: BodyType<CrmMailingListUpdateInput>;params?: UpdateCrmMailingListParams}, TContext> => {

const mutationKey = ['updateCrmMailingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmMailingList>>, {id: string;data: BodyType<CrmMailingListUpdateInput>;params?: UpdateCrmMailingListParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateCrmMailingList(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmMailingListMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmMailingList>>>
    export type UpdateCrmMailingListMutationBody = BodyType<CrmMailingListUpdateInput>
    export type UpdateCrmMailingListMutationError = ErrorType<void>

    /**
 * @summary Rename a CRM list or update a filtered list's criteria
 */
export const useUpdateCrmMailingList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmMailingList>>, TError,{id: string;data: BodyType<CrmMailingListUpdateInput>;params?: UpdateCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmMailingList>>,
        TError,
        {id: string;data: BodyType<CrmMailingListUpdateInput>;params?: UpdateCrmMailingListParams},
        TContext
      > => {
      return useMutation(getUpdateCrmMailingListMutationOptions(options), queryClient);
    }

export const getDeleteCrmMailingListUrl = (id: string,
    params?: DeleteCrmMailingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}`
}

/**
 * @summary Delete a tenant-owned CRM mailing list and its membership
 */
export const deleteCrmMailingList = async (id: string,
    params?: DeleteCrmMailingListParams, options?: RequestInit): Promise<DeleteCrmMailingList200> => {

  return customFetch<DeleteCrmMailingList200>(getDeleteCrmMailingListUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCrmMailingListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmMailingList>>, TError,{id: string;params?: DeleteCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCrmMailingList>>, TError,{id: string;params?: DeleteCrmMailingListParams}, TContext> => {

const mutationKey = ['deleteCrmMailingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCrmMailingList>>, {id: string;params?: DeleteCrmMailingListParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteCrmMailingList(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCrmMailingListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCrmMailingList>>>

    export type DeleteCrmMailingListMutationError = ErrorType<void>

    /**
 * @summary Delete a tenant-owned CRM mailing list and its membership
 */
export const useDeleteCrmMailingList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCrmMailingList>>, TError,{id: string;params?: DeleteCrmMailingListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCrmMailingList>>,
        TError,
        {id: string;params?: DeleteCrmMailingListParams},
        TContext
      > => {
      return useMutation(getDeleteCrmMailingListMutationOptions(options), queryClient);
    }

export const getSearchCrmContactsUrl = (params?: SearchCrmContactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/contacts/search?${stringifiedParams}` : `/api/lob-mail/crm/contacts/search`
}

/**
 * Filter and sort fields must be stable keys in this tenant's imported CRM field catalog; filtering always uses live CRM source values.
 * @summary Search and page tenant CRM contacts
 */
export const searchCrmContacts = async (params?: SearchCrmContactsParams, options?: RequestInit): Promise<CrmContactSearchResponse> => {

  return customFetch<CrmContactSearchResponse>(getSearchCrmContactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCrmContactsQueryKey = (params?: SearchCrmContactsParams,) => {
    return [
    `/api/lob-mail/crm/contacts/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCrmContactsQueryOptions = <TData = Awaited<ReturnType<typeof searchCrmContacts>>, TError = ErrorType<void>>(params?: SearchCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCrmContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCrmContacts>>> = ({ signal }) => searchCrmContacts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchCrmContactsQueryResult = NonNullable<Awaited<ReturnType<typeof searchCrmContacts>>>
export type SearchCrmContactsQueryError = ErrorType<void>


export function useSearchCrmContacts<TData = Awaited<ReturnType<typeof searchCrmContacts>>, TError = ErrorType<void>>(
 params: undefined |  SearchCrmContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCrmContacts>>,
          TError,
          Awaited<ReturnType<typeof searchCrmContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCrmContacts<TData = Awaited<ReturnType<typeof searchCrmContacts>>, TError = ErrorType<void>>(
 params?: SearchCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCrmContacts>>,
          TError,
          Awaited<ReturnType<typeof searchCrmContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCrmContacts<TData = Awaited<ReturnType<typeof searchCrmContacts>>, TError = ErrorType<void>>(
 params?: SearchCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search and page tenant CRM contacts
 */

export function useSearchCrmContacts<TData = Awaited<ReturnType<typeof searchCrmContacts>>, TError = ErrorType<void>>(
 params?: SearchCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCrmContactsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCrmMailingListMembersUrl = (id: string,
    params?: ListCrmMailingListMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members`
}

/**
 * Filtered membership is synchronized first. Member values resolve cell override, then locked column snapshot, then current CRM source.
 * @summary Page and filter a mailing list's members
 */
export const listCrmMailingListMembers = async (id: string,
    params?: ListCrmMailingListMembersParams, options?: RequestInit): Promise<CrmMailingListMembersResponse> => {

  return customFetch<CrmMailingListMembersResponse>(getListCrmMailingListMembersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmMailingListMembersQueryKey = (id: string,
    params?: ListCrmMailingListMembersParams,) => {
    return [
    `/api/lob-mail/crm/mailing-lists/${id}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmMailingListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError = ErrorType<void>>(id: string,
    params?: ListCrmMailingListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmMailingListMembersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmMailingListMembers>>> = ({ signal }) => listCrmMailingListMembers(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCrmMailingListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmMailingListMembers>>>
export type ListCrmMailingListMembersQueryError = ErrorType<void>


export function useListCrmMailingListMembers<TData = Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  ListCrmMailingListMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmMailingListMembers>>,
          TError,
          Awaited<ReturnType<typeof listCrmMailingListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmMailingListMembers<TData = Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: ListCrmMailingListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmMailingListMembers>>,
          TError,
          Awaited<ReturnType<typeof listCrmMailingListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmMailingListMembers<TData = Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: ListCrmMailingListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Page and filter a mailing list's members
 */

export function useListCrmMailingListMembers<TData = Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError = ErrorType<void>>(
 id: string,
    params?: ListCrmMailingListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmMailingListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCrmMailingListMembersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddCrmMailingListMembersUrl = (id: string,
    params?: AddCrmMailingListMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members`
}

/**
 * Selection operates across all matching records, not only the visible page. Filtered lists cannot be manually edited.
 * @summary Add explicit contacts or all contacts matching a filter to a manual list
 */
export const addCrmMailingListMembers = async (id: string,
    crmMailingListMemberAddInput: CrmMailingListMemberAddInput,
    params?: AddCrmMailingListMembersParams, options?: RequestInit): Promise<CrmMailingListMemberMutationResult> => {

  return customFetch<CrmMailingListMemberMutationResult>(getAddCrmMailingListMembersUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmMailingListMemberAddInput)
  }
);}




export const getAddCrmMailingListMembersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCrmMailingListMembers>>, TError,{id: string;data: BodyType<CrmMailingListMemberAddInput>;params?: AddCrmMailingListMembersParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCrmMailingListMembers>>, TError,{id: string;data: BodyType<CrmMailingListMemberAddInput>;params?: AddCrmMailingListMembersParams}, TContext> => {

const mutationKey = ['addCrmMailingListMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCrmMailingListMembers>>, {id: string;data: BodyType<CrmMailingListMemberAddInput>;params?: AddCrmMailingListMembersParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  addCrmMailingListMembers(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCrmMailingListMembersMutationResult = NonNullable<Awaited<ReturnType<typeof addCrmMailingListMembers>>>
    export type AddCrmMailingListMembersMutationBody = BodyType<CrmMailingListMemberAddInput>
    export type AddCrmMailingListMembersMutationError = ErrorType<void>

    /**
 * @summary Add explicit contacts or all contacts matching a filter to a manual list
 */
export const useAddCrmMailingListMembers = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCrmMailingListMembers>>, TError,{id: string;data: BodyType<CrmMailingListMemberAddInput>;params?: AddCrmMailingListMembersParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCrmMailingListMembers>>,
        TError,
        {id: string;data: BodyType<CrmMailingListMemberAddInput>;params?: AddCrmMailingListMembersParams},
        TContext
      > => {
      return useMutation(getAddCrmMailingListMembersMutationOptions(options), queryClient);
    }

export const getGetCrmMailingListPreviewMemberUrl = (id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/preview?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/preview`
}

/**
 * @summary Read one current member's effective values for a private template preview
 */
export const getCrmMailingListPreviewMember = async (id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams, options?: RequestInit): Promise<CrmMailingListMemberValue> => {

  return customFetch<CrmMailingListMemberValue>(getGetCrmMailingListPreviewMemberUrl(id,contactId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmMailingListPreviewMemberQueryKey = (id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams,) => {
    return [
    `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCrmMailingListPreviewMemberQueryOptions = <TData = Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError = ErrorType<void>>(id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmMailingListPreviewMemberQueryKey(id,contactId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>> = ({ signal }) => getCrmMailingListPreviewMember(id,contactId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && contactId !== null && contactId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCrmMailingListPreviewMemberQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>>
export type GetCrmMailingListPreviewMemberQueryError = ErrorType<void>


export function useGetCrmMailingListPreviewMember<TData = Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError = ErrorType<void>>(
 id: string,
    contactId: string,
    params: undefined |  GetCrmMailingListPreviewMemberParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>,
          TError,
          Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmMailingListPreviewMember<TData = Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError = ErrorType<void>>(
 id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>,
          TError,
          Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmMailingListPreviewMember<TData = Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError = ErrorType<void>>(
 id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one current member's effective values for a private template preview
 */

export function useGetCrmMailingListPreviewMember<TData = Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError = ErrorType<void>>(
 id: string,
    contactId: string,
    params?: GetCrmMailingListPreviewMemberParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmMailingListPreviewMember>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCrmMailingListPreviewMemberQueryOptions(id,contactId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRemoveCrmMailingListMemberUrl = (id: string,
    contactId: string,
    params?: RemoveCrmMailingListMemberParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}`
}

/**
 * @summary Remove a contact from a manual CRM mailing list
 */
export const removeCrmMailingListMember = async (id: string,
    contactId: string,
    params?: RemoveCrmMailingListMemberParams, options?: RequestInit): Promise<RemoveCrmMailingListMember200> => {

  return customFetch<RemoveCrmMailingListMember200>(getRemoveCrmMailingListMemberUrl(id,contactId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveCrmMailingListMemberMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCrmMailingListMember>>, TError,{id: string;contactId: string;params?: RemoveCrmMailingListMemberParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCrmMailingListMember>>, TError,{id: string;contactId: string;params?: RemoveCrmMailingListMemberParams}, TContext> => {

const mutationKey = ['removeCrmMailingListMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCrmMailingListMember>>, {id: string;contactId: string;params?: RemoveCrmMailingListMemberParams}> = (props) => {
          const {id,contactId,params} = props ?? {};

          return  removeCrmMailingListMember(id,contactId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCrmMailingListMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeCrmMailingListMember>>>

    export type RemoveCrmMailingListMemberMutationError = ErrorType<void>

    /**
 * @summary Remove a contact from a manual CRM mailing list
 */
export const useRemoveCrmMailingListMember = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCrmMailingListMember>>, TError,{id: string;contactId: string;params?: RemoveCrmMailingListMemberParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCrmMailingListMember>>,
        TError,
        {id: string;contactId: string;params?: RemoveCrmMailingListMemberParams},
        TContext
      > => {
      return useMutation(getRemoveCrmMailingListMemberMutationOptions(options), queryClient);
    }

export const getSetCrmMailingListColumnLockUrl = (id: string,
    fieldKey: string,
    params?: SetCrmMailingListColumnLockParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/locks/columns/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/locks/columns/${fieldKey}`
}

/**
 * Locking snapshots the currently effective non-null value; cell overrides take precedence over column snapshots.
 * @summary Lock or unlock one CRM column for every list member
 */
export const setCrmMailingListColumnLock = async (id: string,
    fieldKey: string,
    setCrmMailingListColumnLockBody: SetCrmMailingListColumnLockBody,
    params?: SetCrmMailingListColumnLockParams, options?: RequestInit): Promise<CrmMailingListColumnLockResult> => {

  return customFetch<CrmMailingListColumnLockResult>(getSetCrmMailingListColumnLockUrl(id,fieldKey,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCrmMailingListColumnLockBody)
  }
);}




export const getSetCrmMailingListColumnLockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListColumnLock>>, TError,{id: string;fieldKey: string;data: BodyType<SetCrmMailingListColumnLockBody>;params?: SetCrmMailingListColumnLockParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListColumnLock>>, TError,{id: string;fieldKey: string;data: BodyType<SetCrmMailingListColumnLockBody>;params?: SetCrmMailingListColumnLockParams}, TContext> => {

const mutationKey = ['setCrmMailingListColumnLock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCrmMailingListColumnLock>>, {id: string;fieldKey: string;data: BodyType<SetCrmMailingListColumnLockBody>;params?: SetCrmMailingListColumnLockParams}> = (props) => {
          const {id,fieldKey,data,params} = props ?? {};

          return  setCrmMailingListColumnLock(id,fieldKey,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCrmMailingListColumnLockMutationResult = NonNullable<Awaited<ReturnType<typeof setCrmMailingListColumnLock>>>
    export type SetCrmMailingListColumnLockMutationBody = BodyType<SetCrmMailingListColumnLockBody>
    export type SetCrmMailingListColumnLockMutationError = ErrorType<void>

    /**
 * @summary Lock or unlock one CRM column for every list member
 */
export const useSetCrmMailingListColumnLock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListColumnLock>>, TError,{id: string;fieldKey: string;data: BodyType<SetCrmMailingListColumnLockBody>;params?: SetCrmMailingListColumnLockParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCrmMailingListColumnLock>>,
        TError,
        {id: string;fieldKey: string;data: BodyType<SetCrmMailingListColumnLockBody>;params?: SetCrmMailingListColumnLockParams},
        TContext
      > => {
      return useMutation(getSetCrmMailingListColumnLockMutationOptions(options), queryClient);
    }

export const getSetCrmMailingListCellOverrideUrl = (id: string,
    contactId: string,
    fieldKey: string,
    params?: SetCrmMailingListCellOverrideParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/cells/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/cells/${fieldKey}`
}

/**
 * @summary Set one list-specific member cell value without changing CRM
 */
export const setCrmMailingListCellOverride = async (id: string,
    contactId: string,
    fieldKey: string,
    setCrmMailingListCellOverrideBody: SetCrmMailingListCellOverrideBody,
    params?: SetCrmMailingListCellOverrideParams, options?: RequestInit): Promise<CrmMailingListMemberValue> => {

  return customFetch<CrmMailingListMemberValue>(getSetCrmMailingListCellOverrideUrl(id,contactId,fieldKey,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCrmMailingListCellOverrideBody)
  }
);}




export const getSetCrmMailingListCellOverrideMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;data: BodyType<SetCrmMailingListCellOverrideBody>;params?: SetCrmMailingListCellOverrideParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;data: BodyType<SetCrmMailingListCellOverrideBody>;params?: SetCrmMailingListCellOverrideParams}, TContext> => {

const mutationKey = ['setCrmMailingListCellOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCrmMailingListCellOverride>>, {id: string;contactId: string;fieldKey: string;data: BodyType<SetCrmMailingListCellOverrideBody>;params?: SetCrmMailingListCellOverrideParams}> = (props) => {
          const {id,contactId,fieldKey,data,params} = props ?? {};

          return  setCrmMailingListCellOverride(id,contactId,fieldKey,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCrmMailingListCellOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setCrmMailingListCellOverride>>>
    export type SetCrmMailingListCellOverrideMutationBody = BodyType<SetCrmMailingListCellOverrideBody>
    export type SetCrmMailingListCellOverrideMutationError = ErrorType<void>

    /**
 * @summary Set one list-specific member cell value without changing CRM
 */
export const useSetCrmMailingListCellOverride = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;data: BodyType<SetCrmMailingListCellOverrideBody>;params?: SetCrmMailingListCellOverrideParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCrmMailingListCellOverride>>,
        TError,
        {id: string;contactId: string;fieldKey: string;data: BodyType<SetCrmMailingListCellOverrideBody>;params?: SetCrmMailingListCellOverrideParams},
        TContext
      > => {
      return useMutation(getSetCrmMailingListCellOverrideMutationOptions(options), queryClient);
    }

export const getClearCrmMailingListCellOverrideUrl = (id: string,
    contactId: string,
    fieldKey: string,
    params?: ClearCrmMailingListCellOverrideParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/cells/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/crm/mailing-lists/${id}/members/${contactId}/cells/${fieldKey}`
}

/**
 * @summary Remove a cell override and resume snapshot/live value resolution
 */
export const clearCrmMailingListCellOverride = async (id: string,
    contactId: string,
    fieldKey: string,
    params?: ClearCrmMailingListCellOverrideParams, options?: RequestInit): Promise<CrmMailingListMemberValue> => {

  return customFetch<CrmMailingListMemberValue>(getClearCrmMailingListCellOverrideUrl(id,contactId,fieldKey,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCrmMailingListCellOverrideMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;params?: ClearCrmMailingListCellOverrideParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;params?: ClearCrmMailingListCellOverrideParams}, TContext> => {

const mutationKey = ['clearCrmMailingListCellOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>, {id: string;contactId: string;fieldKey: string;params?: ClearCrmMailingListCellOverrideParams}> = (props) => {
          const {id,contactId,fieldKey,params} = props ?? {};

          return  clearCrmMailingListCellOverride(id,contactId,fieldKey,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCrmMailingListCellOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>>

    export type ClearCrmMailingListCellOverrideMutationError = ErrorType<void>

    /**
 * @summary Remove a cell override and resume snapshot/live value resolution
 */
export const useClearCrmMailingListCellOverride = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>, TError,{id: string;contactId: string;fieldKey: string;params?: ClearCrmMailingListCellOverrideParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCrmMailingListCellOverride>>,
        TError,
        {id: string;contactId: string;fieldKey: string;params?: ClearCrmMailingListCellOverrideParams},
        TContext
      > => {
      return useMutation(getClearCrmMailingListCellOverrideMutationOptions(options), queryClient);
    }

export const getImportCrmContactUrl = () => {




  return `/api/webhooks/crm-contacts`
}

/**
 * @summary Import or update a tenant-owned CRM contact
 */
export const importCrmContact = async (crmContactImportInput: CrmContactImportInput, options?: RequestInit): Promise<CrmContactImportResult> => {

  return customFetch<CrmContactImportResult>(getImportCrmContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmContactImportInput)
  }
);}




export const getImportCrmContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importCrmContact>>, TError,{data: BodyType<CrmContactImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importCrmContact>>, TError,{data: BodyType<CrmContactImportInput>}, TContext> => {

const mutationKey = ['importCrmContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importCrmContact>>, {data: BodyType<CrmContactImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  importCrmContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportCrmContactMutationResult = NonNullable<Awaited<ReturnType<typeof importCrmContact>>>
    export type ImportCrmContactMutationBody = BodyType<CrmContactImportInput>
    export type ImportCrmContactMutationError = ErrorType<void>

    /**
 * @summary Import or update a tenant-owned CRM contact
 */
export const useImportCrmContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importCrmContact>>, TError,{data: BodyType<CrmContactImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importCrmContact>>,
        TError,
        {data: BodyType<CrmContactImportInput>},
        TContext
      > => {
      return useMutation(getImportCrmContactMutationOptions(options), queryClient);
    }

export const getListCrmContactsUrl = (params?: ListCrmContactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/contacts?${stringifiedParams}` : `/api/lob-mail/crm/contacts`
}

/**
 * @summary List contacts scoped to the selected client tenant
 */
export const listCrmContacts = async (params?: ListCrmContactsParams, options?: RequestInit): Promise<CrmContactListResponse> => {

  return customFetch<CrmContactListResponse>(getListCrmContactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmContactsQueryKey = (params?: ListCrmContactsParams,) => {
    return [
    `/api/lob-mail/crm/contacts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmContactsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<void>>(params?: ListCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmContacts>>> = ({ signal }) => listCrmContacts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCrmContactsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmContacts>>>
export type ListCrmContactsQueryError = ErrorType<void>


export function useListCrmContacts<TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<void>>(
 params: undefined |  ListCrmContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmContacts>>,
          TError,
          Awaited<ReturnType<typeof listCrmContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmContacts<TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<void>>(
 params?: ListCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmContacts>>,
          TError,
          Awaited<ReturnType<typeof listCrmContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmContacts<TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<void>>(
 params?: ListCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List contacts scoped to the selected client tenant
 */

export function useListCrmContacts<TData = Awaited<ReturnType<typeof listCrmContacts>>, TError = ErrorType<void>>(
 params?: ListCrmContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContacts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCrmContactsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCrmContactUrl = (id: number,
    params?: UpdateCrmContactParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/contacts/${id}?${stringifiedParams}` : `/api/lob-mail/crm/contacts/${id}`
}

/**
 * @summary Update an existing CRM contact without importing or triggering mail
 */
export const updateCrmContact = async (id: number,
    crmContactUpdate: CrmContactUpdate,
    params?: UpdateCrmContactParams, options?: RequestInit): Promise<CrmContactUpdateResult> => {

  return customFetch<CrmContactUpdateResult>(getUpdateCrmContactUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmContactUpdate)
  }
);}




export const getUpdateCrmContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactUpdate>;params?: UpdateCrmContactParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactUpdate>;params?: UpdateCrmContactParams}, TContext> => {

const mutationKey = ['updateCrmContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrmContact>>, {id: number;data: BodyType<CrmContactUpdate>;params?: UpdateCrmContactParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateCrmContact(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrmContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrmContact>>>
    export type UpdateCrmContactMutationBody = BodyType<CrmContactUpdate>
    export type UpdateCrmContactMutationError = ErrorType<void>

    /**
 * @summary Update an existing CRM contact without importing or triggering mail
 */
export const useUpdateCrmContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrmContact>>, TError,{id: number;data: BodyType<CrmContactUpdate>;params?: UpdateCrmContactParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCrmContact>>,
        TError,
        {id: number;data: BodyType<CrmContactUpdate>;params?: UpdateCrmContactParams},
        TContext
      > => {
      return useMutation(getUpdateCrmContactMutationOptions(options), queryClient);
    }

export const getGetCrmContactUrl = (id: number,
    params?: GetCrmContactParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/contacts/${id}?${stringifiedParams}` : `/api/lob-mail/crm/contacts/${id}`
}

/**
 * @summary Read one contact within the selected client tenant
 */
export const getCrmContact = async (id: number,
    params?: GetCrmContactParams, options?: RequestInit): Promise<CrmContact> => {

  return customFetch<CrmContact>(getGetCrmContactUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmContactQueryKey = (id: number,
    params?: GetCrmContactParams,) => {
    return [
    `/api/lob-mail/crm/contacts/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCrmContactQueryOptions = <TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<void>>(id: number,
    params?: GetCrmContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmContactQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmContact>>> = ({ signal }) => getCrmContact(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCrmContactQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmContact>>>
export type GetCrmContactQueryError = ErrorType<void>


export function useGetCrmContact<TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<void>>(
 id: number,
    params: undefined |  GetCrmContactParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmContact>>,
          TError,
          Awaited<ReturnType<typeof getCrmContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmContact<TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<void>>(
 id: number,
    params?: GetCrmContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmContact>>,
          TError,
          Awaited<ReturnType<typeof getCrmContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmContact<TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<void>>(
 id: number,
    params?: GetCrmContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one contact within the selected client tenant
 */

export function useGetCrmContact<TData = Awaited<ReturnType<typeof getCrmContact>>, TError = ErrorType<void>>(
 id: number,
    params?: GetCrmContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCrmContactQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCrmArtworkFieldsUrl = (params?: ListCrmArtworkFieldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/fields?${stringifiedParams}` : `/api/lob-mail/crm/fields`
}

/**
 * @summary List only fields this client's Make contact import has supplied
 */
export const listCrmArtworkFields = async (params?: ListCrmArtworkFieldsParams, options?: RequestInit): Promise<CrmArtworkFields> => {

  return customFetch<CrmArtworkFields>(getListCrmArtworkFieldsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmArtworkFieldsQueryKey = (params?: ListCrmArtworkFieldsParams,) => {
    return [
    `/api/lob-mail/crm/fields`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmArtworkFieldsQueryOptions = <TData = Awaited<ReturnType<typeof listCrmArtworkFields>>, TError = ErrorType<unknown>>(params?: ListCrmArtworkFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmArtworkFieldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmArtworkFields>>> = ({ signal }) => listCrmArtworkFields(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCrmArtworkFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmArtworkFields>>>
export type ListCrmArtworkFieldsQueryError = ErrorType<unknown>


export function useListCrmArtworkFields<TData = Awaited<ReturnType<typeof listCrmArtworkFields>>, TError = ErrorType<unknown>>(
 params: undefined |  ListCrmArtworkFieldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmArtworkFields>>,
          TError,
          Awaited<ReturnType<typeof listCrmArtworkFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmArtworkFields<TData = Awaited<ReturnType<typeof listCrmArtworkFields>>, TError = ErrorType<unknown>>(
 params?: ListCrmArtworkFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmArtworkFields>>,
          TError,
          Awaited<ReturnType<typeof listCrmArtworkFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmArtworkFields<TData = Awaited<ReturnType<typeof listCrmArtworkFields>>, TError = ErrorType<unknown>>(
 params?: ListCrmArtworkFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List only fields this client's Make contact import has supplied
 */

export function useListCrmArtworkFields<TData = Awaited<ReturnType<typeof listCrmArtworkFields>>, TError = ErrorType<unknown>>(
 params?: ListCrmArtworkFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmArtworkFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCrmArtworkFieldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCrmContactSourcesUrl = (params?: ListCrmContactSourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/sources?${stringifiedParams}` : `/api/lob-mail/crm/sources`
}

/**
 * @summary List named CRM sources and the legacy source without exposing credentials
 */
export const listCrmContactSources = async (params?: ListCrmContactSourcesParams, options?: RequestInit): Promise<CrmContactSources> => {

  return customFetch<CrmContactSources>(getListCrmContactSourcesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCrmContactSourcesQueryKey = (params?: ListCrmContactSourcesParams,) => {
    return [
    `/api/lob-mail/crm/sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCrmContactSourcesQueryOptions = <TData = Awaited<ReturnType<typeof listCrmContactSources>>, TError = ErrorType<void>>(params?: ListCrmContactSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCrmContactSourcesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrmContactSources>>> = ({ signal }) => listCrmContactSources(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCrmContactSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listCrmContactSources>>>
export type ListCrmContactSourcesQueryError = ErrorType<void>


export function useListCrmContactSources<TData = Awaited<ReturnType<typeof listCrmContactSources>>, TError = ErrorType<void>>(
 params: undefined |  ListCrmContactSourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmContactSources>>,
          TError,
          Awaited<ReturnType<typeof listCrmContactSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmContactSources<TData = Awaited<ReturnType<typeof listCrmContactSources>>, TError = ErrorType<void>>(
 params?: ListCrmContactSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrmContactSources>>,
          TError,
          Awaited<ReturnType<typeof listCrmContactSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCrmContactSources<TData = Awaited<ReturnType<typeof listCrmContactSources>>, TError = ErrorType<void>>(
 params?: ListCrmContactSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List named CRM sources and the legacy source without exposing credentials
 */

export function useListCrmContactSources<TData = Awaited<ReturnType<typeof listCrmContactSources>>, TError = ErrorType<void>>(
 params?: ListCrmContactSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCrmContactSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCrmContactSourcesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCrmContactSourceUrl = (params: CreateCrmContactSourceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/sources?${stringifiedParams}` : `/api/lob-mail/crm/sources`
}

/**
 * @summary Create a named source for a client tenant
 */
export const createCrmContactSource = async (crmContactSourceInput: CrmContactSourceInput,
    params: CreateCrmContactSourceParams, options?: RequestInit): Promise<CrmContactSource> => {

  return customFetch<CrmContactSource>(getCreateCrmContactSourceUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmContactSourceInput)
  }
);}




export const getCreateCrmContactSourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmContactSource>>, TError,{data: BodyType<CrmContactSourceInput>;params: CreateCrmContactSourceParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrmContactSource>>, TError,{data: BodyType<CrmContactSourceInput>;params: CreateCrmContactSourceParams}, TContext> => {

const mutationKey = ['createCrmContactSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrmContactSource>>, {data: BodyType<CrmContactSourceInput>;params: CreateCrmContactSourceParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createCrmContactSource(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrmContactSourceMutationResult = NonNullable<Awaited<ReturnType<typeof createCrmContactSource>>>
    export type CreateCrmContactSourceMutationBody = BodyType<CrmContactSourceInput>
    export type CreateCrmContactSourceMutationError = ErrorType<void>

    /**
 * @summary Create a named source for a client tenant
 */
export const useCreateCrmContactSource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrmContactSource>>, TError,{data: BodyType<CrmContactSourceInput>;params: CreateCrmContactSourceParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCrmContactSource>>,
        TError,
        {data: BodyType<CrmContactSourceInput>;params: CreateCrmContactSourceParams},
        TContext
      > => {
      return useMutation(getCreateCrmContactSourceMutationOptions(options), queryClient);
    }

export const getRotateCrmContactSourceKeyUrl = (sourceId: number,
    params: RotateCrmContactSourceKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/sources/${sourceId}/key?${stringifiedParams}` : `/api/lob-mail/crm/sources/${sourceId}/key`
}

/**
 * @summary Rotate the selected source key and reveal it once
 */
export const rotateCrmContactSourceKey = async (sourceId: number,
    params: RotateCrmContactSourceKeyParams, options?: RequestInit): Promise<CrmContactImportKey> => {

  return customFetch<CrmContactImportKey>(getRotateCrmContactSourceKeyUrl(sourceId,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRotateCrmContactSourceKeyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactSourceKey>>, TError,{sourceId: number;params: RotateCrmContactSourceKeyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactSourceKey>>, TError,{sourceId: number;params: RotateCrmContactSourceKeyParams}, TContext> => {

const mutationKey = ['rotateCrmContactSourceKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateCrmContactSourceKey>>, {sourceId: number;params: RotateCrmContactSourceKeyParams}> = (props) => {
          const {sourceId,params} = props ?? {};

          return  rotateCrmContactSourceKey(sourceId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateCrmContactSourceKeyMutationResult = NonNullable<Awaited<ReturnType<typeof rotateCrmContactSourceKey>>>

    export type RotateCrmContactSourceKeyMutationError = ErrorType<void>

    /**
 * @summary Rotate the selected source key and reveal it once
 */
export const useRotateCrmContactSourceKey = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactSourceKey>>, TError,{sourceId: number;params: RotateCrmContactSourceKeyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rotateCrmContactSourceKey>>,
        TError,
        {sourceId: number;params: RotateCrmContactSourceKeyParams},
        TContext
      > => {
      return useMutation(getRotateCrmContactSourceKeyMutationOptions(options), queryClient);
    }

export const getAddCrmContactSourceFieldUrl = (sourceId: number,
    params: AddCrmContactSourceFieldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/sources/${sourceId}/fields?${stringifiedParams}` : `/api/lob-mail/crm/sources/${sourceId}/fields`
}

/**
 * @summary Add an artwork field to the selected source catalog
 */
export const addCrmContactSourceField = async (sourceId: number,
    crmContactSourceFieldInput: CrmContactSourceFieldInput,
    params: AddCrmContactSourceFieldParams, options?: RequestInit): Promise<CrmArtworkFields> => {

  return customFetch<CrmArtworkFields>(getAddCrmContactSourceFieldUrl(sourceId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmContactSourceFieldInput)
  }
);}




export const getAddCrmContactSourceFieldMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCrmContactSourceField>>, TError,{sourceId: number;data: BodyType<CrmContactSourceFieldInput>;params: AddCrmContactSourceFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCrmContactSourceField>>, TError,{sourceId: number;data: BodyType<CrmContactSourceFieldInput>;params: AddCrmContactSourceFieldParams}, TContext> => {

const mutationKey = ['addCrmContactSourceField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCrmContactSourceField>>, {sourceId: number;data: BodyType<CrmContactSourceFieldInput>;params: AddCrmContactSourceFieldParams}> = (props) => {
          const {sourceId,data,params} = props ?? {};

          return  addCrmContactSourceField(sourceId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCrmContactSourceFieldMutationResult = NonNullable<Awaited<ReturnType<typeof addCrmContactSourceField>>>
    export type AddCrmContactSourceFieldMutationBody = BodyType<CrmContactSourceFieldInput>
    export type AddCrmContactSourceFieldMutationError = ErrorType<void>

    /**
 * @summary Add an artwork field to the selected source catalog
 */
export const useAddCrmContactSourceField = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCrmContactSourceField>>, TError,{sourceId: number;data: BodyType<CrmContactSourceFieldInput>;params: AddCrmContactSourceFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCrmContactSourceField>>,
        TError,
        {sourceId: number;data: BodyType<CrmContactSourceFieldInput>;params: AddCrmContactSourceFieldParams},
        TContext
      > => {
      return useMutation(getAddCrmContactSourceFieldMutationOptions(options), queryClient);
    }

export const getGetCrmContactImportSettingsUrl = (params: GetCrmContactImportSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/import-settings?${stringifiedParams}` : `/api/lob-mail/crm/import-settings`
}

/**
 * @summary Read agency-only import credential configuration state
 */
export const getCrmContactImportSettings = async (params: GetCrmContactImportSettingsParams, options?: RequestInit): Promise<CrmContactImportSettings> => {

  return customFetch<CrmContactImportSettings>(getGetCrmContactImportSettingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCrmContactImportSettingsQueryKey = (params?: GetCrmContactImportSettingsParams,) => {
    return [
    `/api/lob-mail/crm/import-settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCrmContactImportSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError = ErrorType<void>>(params: GetCrmContactImportSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrmContactImportSettingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmContactImportSettings>>> = ({ signal }) => getCrmContactImportSettings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCrmContactImportSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCrmContactImportSettings>>>
export type GetCrmContactImportSettingsQueryError = ErrorType<void>


export function useGetCrmContactImportSettings<TData = Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError = ErrorType<void>>(
 params: GetCrmContactImportSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmContactImportSettings>>,
          TError,
          Awaited<ReturnType<typeof getCrmContactImportSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmContactImportSettings<TData = Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError = ErrorType<void>>(
 params: GetCrmContactImportSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmContactImportSettings>>,
          TError,
          Awaited<ReturnType<typeof getCrmContactImportSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCrmContactImportSettings<TData = Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError = ErrorType<void>>(
 params: GetCrmContactImportSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read agency-only import credential configuration state
 */

export function useGetCrmContactImportSettings<TData = Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError = ErrorType<void>>(
 params: GetCrmContactImportSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCrmContactImportSettings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCrmContactImportSettingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRotateCrmContactImportKeyUrl = (params: RotateCrmContactImportKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/crm/import-key?${stringifiedParams}` : `/api/lob-mail/crm/import-key`
}

/**
 * @summary Rotate and reveal a client-specific CRM import key once
 */
export const rotateCrmContactImportKey = async (params: RotateCrmContactImportKeyParams, options?: RequestInit): Promise<CrmContactImportKey> => {

  return customFetch<CrmContactImportKey>(getRotateCrmContactImportKeyUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRotateCrmContactImportKeyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactImportKey>>, TError,{params: RotateCrmContactImportKeyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactImportKey>>, TError,{params: RotateCrmContactImportKeyParams}, TContext> => {

const mutationKey = ['rotateCrmContactImportKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateCrmContactImportKey>>, {params: RotateCrmContactImportKeyParams}> = (props) => {
          const {params} = props ?? {};

          return  rotateCrmContactImportKey(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateCrmContactImportKeyMutationResult = NonNullable<Awaited<ReturnType<typeof rotateCrmContactImportKey>>>

    export type RotateCrmContactImportKeyMutationError = ErrorType<void>

    /**
 * @summary Rotate and reveal a client-specific CRM import key once
 */
export const useRotateCrmContactImportKey = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateCrmContactImportKey>>, TError,{params: RotateCrmContactImportKeyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rotateCrmContactImportKey>>,
        TError,
        {params: RotateCrmContactImportKeyParams},
        TContext
      > => {
      return useMutation(getRotateCrmContactImportKeyMutationOptions(options), queryClient);
    }

export const getGetLobMailStatusUrl = () => {




  return `/api/lob-mail/status`
}

/**
 * @summary Get Lob Custom Mail integration readiness
 */
export const getLobMailStatus = async ( options?: RequestInit): Promise<LobMailStatus> => {

  return customFetch<LobMailStatus>(getGetLobMailStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailStatusQueryKey = () => {
    return [
    `/api/lob-mail/status`
    ] as const;
    }


export const getGetLobMailStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailStatus>>> = ({ signal }) => getLobMailStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailStatus>>>
export type GetLobMailStatusQueryError = ErrorType<unknown>


export function useGetLobMailStatus<TData = Awaited<ReturnType<typeof getLobMailStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobMailStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailStatus<TData = Awaited<ReturnType<typeof getLobMailStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobMailStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailStatus<TData = Awaited<ReturnType<typeof getLobMailStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lob Custom Mail integration readiness
 */

export function useGetLobMailStatus<TData = Awaited<ReturnType<typeof getLobMailStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobMailCapabilitiesUrl = (params?: GetLobMailCapabilitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/capabilities?${stringifiedParams}` : `/api/lob-mail/capabilities`
}

/**
 * @summary Get Lob account capabilities
 */
export const getLobMailCapabilities = async (params?: GetLobMailCapabilitiesParams, options?: RequestInit): Promise<LobCapabilities> => {

  return customFetch<LobCapabilities>(getGetLobMailCapabilitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailCapabilitiesQueryKey = (params?: GetLobMailCapabilitiesParams,) => {
    return [
    `/api/lob-mail/capabilities`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailCapabilities>>, TError = ErrorType<unknown>>(params?: GetLobMailCapabilitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailCapabilitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailCapabilities>>> = ({ signal }) => getLobMailCapabilities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailCapabilities>>>
export type GetLobMailCapabilitiesQueryError = ErrorType<unknown>


export function useGetLobMailCapabilities<TData = Awaited<ReturnType<typeof getLobMailCapabilities>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobMailCapabilitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getLobMailCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailCapabilities<TData = Awaited<ReturnType<typeof getLobMailCapabilities>>, TError = ErrorType<unknown>>(
 params?: GetLobMailCapabilitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getLobMailCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailCapabilities<TData = Awaited<ReturnType<typeof getLobMailCapabilities>>, TError = ErrorType<unknown>>(
 params?: GetLobMailCapabilitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lob account capabilities
 */

export function useGetLobMailCapabilities<TData = Awaited<ReturnType<typeof getLobMailCapabilities>>, TError = ErrorType<unknown>>(
 params?: GetLobMailCapabilitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailCapabilitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressBookUrl = (params?: GetLobAddressBookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book?${stringifiedParams}` : `/api/lob-mail/address-book`
}

/**
 * One canonical client directory independent of mail simulation. Legacy mode inputs cannot select a test directory.
 */
export const getLobAddressBook = async (params?: GetLobAddressBookParams, options?: RequestInit): Promise<GetLobAddressBook200> => {

  return customFetch<GetLobAddressBook200>(getGetLobAddressBookUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressBookQueryKey = (params?: GetLobAddressBookParams,) => {
    return [
    `/api/lob-mail/address-book`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressBookQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressBook>>, TError = ErrorType<unknown>>(params?: GetLobAddressBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressBookQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressBook>>> = ({ signal }) => getLobAddressBook(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressBookQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressBook>>>
export type GetLobAddressBookQueryError = ErrorType<unknown>


export function useGetLobAddressBook<TData = Awaited<ReturnType<typeof getLobAddressBook>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobAddressBookParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBook>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBook<TData = Awaited<ReturnType<typeof getLobAddressBook>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBook>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBook<TData = Awaited<ReturnType<typeof getLobAddressBook>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddressBook<TData = Awaited<ReturnType<typeof getLobAddressBook>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressBookQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressBookPropertyDataUrl = (id: string,
    params?: GetLobAddressBookPropertyDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/${id}/property-data?${stringifiedParams}` : `/api/lob-mail/address-book/${id}/property-data`
}

/**
 * Agency-admin-only, selected-client-scoped lossless retained property snapshots. No provider calls or mail.
 */
export const getLobAddressBookPropertyData = async (id: string,
    params?: GetLobAddressBookPropertyDataParams, options?: RequestInit): Promise<GetLobAddressBookPropertyData200> => {

  return customFetch<GetLobAddressBookPropertyData200>(getGetLobAddressBookPropertyDataUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressBookPropertyDataQueryKey = (id: string,
    params?: GetLobAddressBookPropertyDataParams,) => {
    return [
    `/api/lob-mail/address-book/${id}/property-data`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressBookPropertyDataQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError = ErrorType<void>>(id: string,
    params?: GetLobAddressBookPropertyDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressBookPropertyDataQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>> = ({ signal }) => getLobAddressBookPropertyData(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressBookPropertyDataQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>>
export type GetLobAddressBookPropertyDataQueryError = ErrorType<void>


export function useGetLobAddressBookPropertyData<TData = Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetLobAddressBookPropertyDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookPropertyData>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookPropertyData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookPropertyData<TData = Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressBookPropertyDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookPropertyData>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookPropertyData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookPropertyData<TData = Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressBookPropertyDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddressBookPropertyData<TData = Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressBookPropertyDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookPropertyData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressBookPropertyDataQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressBookFieldsUrl = (params?: GetLobAddressBookFieldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/fields?${stringifiedParams}` : `/api/lob-mail/address-book/fields`
}

export const getLobAddressBookFields = async (params?: GetLobAddressBookFieldsParams, options?: RequestInit): Promise<GetLobAddressBookFields200> => {

  return customFetch<GetLobAddressBookFields200>(getGetLobAddressBookFieldsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressBookFieldsQueryKey = (params?: GetLobAddressBookFieldsParams,) => {
    return [
    `/api/lob-mail/address-book/fields`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressBookFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressBookFields>>, TError = ErrorType<unknown>>(params?: GetLobAddressBookFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressBookFieldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressBookFields>>> = ({ signal }) => getLobAddressBookFields(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressBookFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressBookFields>>>
export type GetLobAddressBookFieldsQueryError = ErrorType<unknown>


export function useGetLobAddressBookFields<TData = Awaited<ReturnType<typeof getLobAddressBookFields>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobAddressBookFieldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookFields>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookFields<TData = Awaited<ReturnType<typeof getLobAddressBookFields>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookFields>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookFields<TData = Awaited<ReturnType<typeof getLobAddressBookFields>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddressBookFields<TData = Awaited<ReturnType<typeof getLobAddressBookFields>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressBookFieldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobAddressBookFieldUrl = (params?: CreateLobAddressBookFieldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/fields?${stringifiedParams}` : `/api/lob-mail/address-book/fields`
}

export const createLobAddressBookField = async (createLobAddressBookFieldBody: CreateLobAddressBookFieldBody,
    params?: CreateLobAddressBookFieldParams, options?: RequestInit): Promise<LobAddressBookField> => {

  return customFetch<LobAddressBookField>(getCreateLobAddressBookFieldUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLobAddressBookFieldBody)
  }
);}




export const getCreateLobAddressBookFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookField>>, TError,{data: BodyType<CreateLobAddressBookFieldBody>;params?: CreateLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookField>>, TError,{data: BodyType<CreateLobAddressBookFieldBody>;params?: CreateLobAddressBookFieldParams}, TContext> => {

const mutationKey = ['createLobAddressBookField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobAddressBookField>>, {data: BodyType<CreateLobAddressBookFieldBody>;params?: CreateLobAddressBookFieldParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createLobAddressBookField(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobAddressBookFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createLobAddressBookField>>>
    export type CreateLobAddressBookFieldMutationBody = BodyType<CreateLobAddressBookFieldBody>
    export type CreateLobAddressBookFieldMutationError = ErrorType<unknown>

    export const useCreateLobAddressBookField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookField>>, TError,{data: BodyType<CreateLobAddressBookFieldBody>;params?: CreateLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobAddressBookField>>,
        TError,
        {data: BodyType<CreateLobAddressBookFieldBody>;params?: CreateLobAddressBookFieldParams},
        TContext
      > => {
      return useMutation(getCreateLobAddressBookFieldMutationOptions(options), queryClient);
    }

export const getRenameLobAddressBookFieldUrl = (id: number,
    params?: RenameLobAddressBookFieldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/fields/${id}?${stringifiedParams}` : `/api/lob-mail/address-book/fields/${id}`
}

export const renameLobAddressBookField = async (id: number,
    renameLobAddressBookFieldBody: RenameLobAddressBookFieldBody,
    params?: RenameLobAddressBookFieldParams, options?: RequestInit): Promise<LobAddressBookField> => {

  return customFetch<LobAddressBookField>(getRenameLobAddressBookFieldUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(renameLobAddressBookFieldBody)
  }
);}




export const getRenameLobAddressBookFieldMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameLobAddressBookField>>, TError,{id: number;data: BodyType<RenameLobAddressBookFieldBody>;params?: RenameLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameLobAddressBookField>>, TError,{id: number;data: BodyType<RenameLobAddressBookFieldBody>;params?: RenameLobAddressBookFieldParams}, TContext> => {

const mutationKey = ['renameLobAddressBookField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameLobAddressBookField>>, {id: number;data: BodyType<RenameLobAddressBookFieldBody>;params?: RenameLobAddressBookFieldParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  renameLobAddressBookField(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameLobAddressBookFieldMutationResult = NonNullable<Awaited<ReturnType<typeof renameLobAddressBookField>>>
    export type RenameLobAddressBookFieldMutationBody = BodyType<RenameLobAddressBookFieldBody>
    export type RenameLobAddressBookFieldMutationError = ErrorType<void>

    export const useRenameLobAddressBookField = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameLobAddressBookField>>, TError,{id: number;data: BodyType<RenameLobAddressBookFieldBody>;params?: RenameLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameLobAddressBookField>>,
        TError,
        {id: number;data: BodyType<RenameLobAddressBookFieldBody>;params?: RenameLobAddressBookFieldParams},
        TContext
      > => {
      return useMutation(getRenameLobAddressBookFieldMutationOptions(options), queryClient);
    }

export const getDeleteLobAddressBookFieldUrl = (id: number,
    params: DeleteLobAddressBookFieldParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/fields/${id}?${stringifiedParams}` : `/api/lob-mail/address-book/fields/${id}`
}

export const deleteLobAddressBookField = async (id: number,
    params: DeleteLobAddressBookFieldParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobAddressBookFieldUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobAddressBookFieldMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookField>>, TError,{id: number;params: DeleteLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookField>>, TError,{id: number;params: DeleteLobAddressBookFieldParams}, TContext> => {

const mutationKey = ['deleteLobAddressBookField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobAddressBookField>>, {id: number;params: DeleteLobAddressBookFieldParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteLobAddressBookField(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobAddressBookFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobAddressBookField>>>

    export type DeleteLobAddressBookFieldMutationError = ErrorType<void>

    export const useDeleteLobAddressBookField = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookField>>, TError,{id: number;params: DeleteLobAddressBookFieldParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobAddressBookField>>,
        TError,
        {id: number;params: DeleteLobAddressBookFieldParams},
        TContext
      > => {
      return useMutation(getDeleteLobAddressBookFieldMutationOptions(options), queryClient);
    }

export const getUpdateLobAddressBookValuesUrl = (id: string,
    params?: UpdateLobAddressBookValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/${id}/values?${stringifiedParams}` : `/api/lob-mail/address-book/${id}/values`
}

export const updateLobAddressBookValues = async (id: string,
    updateLobAddressBookValuesBody: UpdateLobAddressBookValuesBody,
    params?: UpdateLobAddressBookValuesParams, options?: RequestInit): Promise<UpdateLobAddressBookValues200> => {

  return customFetch<UpdateLobAddressBookValues200>(getUpdateLobAddressBookValuesUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLobAddressBookValuesBody)
  }
);}




export const getUpdateLobAddressBookValuesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookValues>>, TError,{id: string;data: BodyType<UpdateLobAddressBookValuesBody>;params?: UpdateLobAddressBookValuesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookValues>>, TError,{id: string;data: BodyType<UpdateLobAddressBookValuesBody>;params?: UpdateLobAddressBookValuesParams}, TContext> => {

const mutationKey = ['updateLobAddressBookValues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobAddressBookValues>>, {id: string;data: BodyType<UpdateLobAddressBookValuesBody>;params?: UpdateLobAddressBookValuesParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateLobAddressBookValues(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobAddressBookValuesMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobAddressBookValues>>>
    export type UpdateLobAddressBookValuesMutationBody = BodyType<UpdateLobAddressBookValuesBody>
    export type UpdateLobAddressBookValuesMutationError = ErrorType<void>

    export const useUpdateLobAddressBookValues = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookValues>>, TError,{id: string;data: BodyType<UpdateLobAddressBookValuesBody>;params?: UpdateLobAddressBookValuesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobAddressBookValues>>,
        TError,
        {id: string;data: BodyType<UpdateLobAddressBookValuesBody>;params?: UpdateLobAddressBookValuesParams},
        TContext
      > => {
      return useMutation(getUpdateLobAddressBookValuesMutationOptions(options), queryClient);
    }

export const getSearchLobRecipientsUrl = (params: SearchLobRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/recipients/search?${stringifiedParams}` : `/api/lob-mail/recipients/search`
}

export const searchLobRecipients = async (params: SearchLobRecipientsParams, options?: RequestInit): Promise<SearchLobRecipients200> => {

  return customFetch<SearchLobRecipients200>(getSearchLobRecipientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchLobRecipientsQueryKey = (params?: SearchLobRecipientsParams,) => {
    return [
    `/api/lob-mail/recipients/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchLobRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof searchLobRecipients>>, TError = ErrorType<unknown>>(params: SearchLobRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLobRecipientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLobRecipients>>> = ({ signal }) => searchLobRecipients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchLobRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof searchLobRecipients>>>
export type SearchLobRecipientsQueryError = ErrorType<unknown>


export function useSearchLobRecipients<TData = Awaited<ReturnType<typeof searchLobRecipients>>, TError = ErrorType<unknown>>(
 params: SearchLobRecipientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLobRecipients>>,
          TError,
          Awaited<ReturnType<typeof searchLobRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchLobRecipients<TData = Awaited<ReturnType<typeof searchLobRecipients>>, TError = ErrorType<unknown>>(
 params: SearchLobRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLobRecipients>>,
          TError,
          Awaited<ReturnType<typeof searchLobRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchLobRecipients<TData = Awaited<ReturnType<typeof searchLobRecipients>>, TError = ErrorType<unknown>>(
 params: SearchLobRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchLobRecipients<TData = Awaited<ReturnType<typeof searchLobRecipients>>, TError = ErrorType<unknown>>(
 params: SearchLobRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLobRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchLobRecipientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewLobRecipientsUrl = (params?: ReviewLobRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/recipients/review?${stringifiedParams}` : `/api/lob-mail/recipients/review`
}

export const reviewLobRecipients = async (reviewLobRecipientsBody: ReviewLobRecipientsBody,
    params?: ReviewLobRecipientsParams, options?: RequestInit): Promise<ReviewLobRecipients200> => {

  return customFetch<ReviewLobRecipients200>(getReviewLobRecipientsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewLobRecipientsBody)
  }
);}




export const getReviewLobRecipientsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewLobRecipients>>, TError,{data: BodyType<ReviewLobRecipientsBody>;params?: ReviewLobRecipientsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewLobRecipients>>, TError,{data: BodyType<ReviewLobRecipientsBody>;params?: ReviewLobRecipientsParams}, TContext> => {

const mutationKey = ['reviewLobRecipients'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewLobRecipients>>, {data: BodyType<ReviewLobRecipientsBody>;params?: ReviewLobRecipientsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  reviewLobRecipients(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewLobRecipientsMutationResult = NonNullable<Awaited<ReturnType<typeof reviewLobRecipients>>>
    export type ReviewLobRecipientsMutationBody = BodyType<ReviewLobRecipientsBody>
    export type ReviewLobRecipientsMutationError = ErrorType<unknown>

    export const useReviewLobRecipients = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewLobRecipients>>, TError,{data: BodyType<ReviewLobRecipientsBody>;params?: ReviewLobRecipientsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewLobRecipients>>,
        TError,
        {data: BodyType<ReviewLobRecipientsBody>;params?: ReviewLobRecipientsParams},
        TContext
      > => {
      return useMutation(getReviewLobRecipientsMutationOptions(options), queryClient);
    }

export const getListLobAddressesUrl = (params?: ListLobAddressesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/addresses?${stringifiedParams}` : `/api/lob-mail/addresses`
}

/**
 * @summary List the client's canonical Address Book
 */
export const listLobAddresses = async (params?: ListLobAddressesParams, options?: RequestInit): Promise<LobPage> => {

  return customFetch<LobPage>(getListLobAddressesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobAddressesQueryKey = (params?: ListLobAddressesParams,) => {
    return [
    `/api/lob-mail/addresses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobAddressesQueryOptions = <TData = Awaited<ReturnType<typeof listLobAddresses>>, TError = ErrorType<unknown>>(params?: ListLobAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobAddressesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobAddresses>>> = ({ signal }) => listLobAddresses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof listLobAddresses>>>
export type ListLobAddressesQueryError = ErrorType<unknown>


export function useListLobAddresses<TData = Awaited<ReturnType<typeof listLobAddresses>>, TError = ErrorType<unknown>>(
 params: undefined |  ListLobAddressesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddresses>>,
          TError,
          Awaited<ReturnType<typeof listLobAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddresses<TData = Awaited<ReturnType<typeof listLobAddresses>>, TError = ErrorType<unknown>>(
 params?: ListLobAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddresses>>,
          TError,
          Awaited<ReturnType<typeof listLobAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddresses<TData = Awaited<ReturnType<typeof listLobAddresses>>, TError = ErrorType<unknown>>(
 params?: ListLobAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the client's canonical Address Book
 */

export function useListLobAddresses<TData = Awaited<ReturnType<typeof listLobAddresses>>, TError = ErrorType<unknown>>(
 params?: ListLobAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddresses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobAddressUrl = () => {




  return `/api/lob-mail/addresses`
}

/**
 * @summary Create a local Address Book recipient without provider writes or mail
 */
export const createLobAddress = async (lobAddressInput: LobAddressInput, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getCreateLobAddressUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAddressInput)
  }
);}




export const getCreateLobAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddress>>, TError,{data: BodyType<LobAddressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobAddress>>, TError,{data: BodyType<LobAddressInput>}, TContext> => {

const mutationKey = ['createLobAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobAddress>>, {data: BodyType<LobAddressInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLobAddress(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobAddressMutationResult = NonNullable<Awaited<ReturnType<typeof createLobAddress>>>
    export type CreateLobAddressMutationBody = BodyType<LobAddressInput>
    export type CreateLobAddressMutationError = ErrorType<unknown>

    /**
 * @summary Create a local Address Book recipient without provider writes or mail
 */
export const useCreateLobAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddress>>, TError,{data: BodyType<LobAddressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobAddress>>,
        TError,
        {data: BodyType<LobAddressInput>},
        TContext
      > => {
      return useMutation(getCreateLobAddressMutationOptions(options), queryClient);
    }

export const getPreviewLobAddressImportUrl = () => {




  return `/api/lob-mail/address-imports/preview`
}

/**
 * @summary Inspect a bounded CSV, Excel, TXT or PDF address list without creating addresses
 */
export const previewLobAddressImport = async (previewLobAddressImportBody: Blob, options?: RequestInit): Promise<LobAddressImportPreview> => {

  return customFetch<LobAddressImportPreview>(getPreviewLobAddressImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/octet-stream', ...options?.headers },
    body: previewLobAddressImportBody
  }
);}




export const getPreviewLobAddressImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobAddressImport>>, TError,{data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobAddressImport>>, TError,{data: BodyType<Blob>}, TContext> => {

const mutationKey = ['previewLobAddressImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobAddressImport>>, {data: BodyType<Blob>}> = (props) => {
          const {data} = props ?? {};

          return  previewLobAddressImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobAddressImportMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobAddressImport>>>
    export type PreviewLobAddressImportMutationBody = BodyType<Blob>
    export type PreviewLobAddressImportMutationError = ErrorType<void>

    /**
 * @summary Inspect a bounded CSV, Excel, TXT or PDF address list without creating addresses
 */
export const usePreviewLobAddressImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobAddressImport>>, TError,{data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobAddressImport>>,
        TError,
        {data: BodyType<Blob>},
        TContext
      > => {
      return useMutation(getPreviewLobAddressImportMutationOptions(options), queryClient);
    }

export const getListLobAddressImportsUrl = () => {




  return `/api/lob-mail/address-imports`
}

/**
 * @summary Resume and list recent tenant-scoped address imports
 */
export const listLobAddressImports = async ( options?: RequestInit): Promise<ListLobAddressImports200> => {

  return customFetch<ListLobAddressImports200>(getListLobAddressImportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobAddressImportsQueryKey = () => {
    return [
    `/api/lob-mail/address-imports`
    ] as const;
    }


export const getListLobAddressImportsQueryOptions = <TData = Awaited<ReturnType<typeof listLobAddressImports>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobAddressImportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobAddressImports>>> = ({ signal }) => listLobAddressImports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobAddressImportsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobAddressImports>>>
export type ListLobAddressImportsQueryError = ErrorType<unknown>


export function useListLobAddressImports<TData = Awaited<ReturnType<typeof listLobAddressImports>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddressImports>>,
          TError,
          Awaited<ReturnType<typeof listLobAddressImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddressImports<TData = Awaited<ReturnType<typeof listLobAddressImports>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddressImports>>,
          TError,
          Awaited<ReturnType<typeof listLobAddressImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddressImports<TData = Awaited<ReturnType<typeof listLobAddressImports>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resume and list recent tenant-scoped address imports
 */

export function useListLobAddressImports<TData = Awaited<ReturnType<typeof listLobAddressImports>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobAddressImportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressImportUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}`
}

/**
 * @summary Get tenant- and mode-scoped import detail for review and resume
 */
export const getLobAddressImport = async (id: string, options?: RequestInit): Promise<LobAddressImportDetail> => {

  return customFetch<LobAddressImportDetail>(getGetLobAddressImportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressImportQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/address-imports/${id}`
    ] as const;
    }


export const getGetLobAddressImportQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressImport>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressImportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressImport>>> = ({ signal }) => getLobAddressImport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressImportQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressImport>>>
export type GetLobAddressImportQueryError = ErrorType<void>


export function useGetLobAddressImport<TData = Awaited<ReturnType<typeof getLobAddressImport>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImport>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImport<TData = Awaited<ReturnType<typeof getLobAddressImport>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImport>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImport<TData = Awaited<ReturnType<typeof getLobAddressImport>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tenant- and mode-scoped import detail for review and resume
 */

export function useGetLobAddressImport<TData = Awaited<ReturnType<typeof getLobAddressImport>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressImportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressImportValidationSummaryUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/validation-summary`
}

/**
 * @summary Count invalid and skipped rows using the saved selection before commit
 */
export const getLobAddressImportValidationSummary = async (id: string, options?: RequestInit): Promise<LobAddressImportValidationSummary> => {

  return customFetch<LobAddressImportValidationSummary>(getGetLobAddressImportValidationSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressImportValidationSummaryQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/address-imports/${id}/validation-summary`
    ] as const;
    }


export const getGetLobAddressImportValidationSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressImportValidationSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>> = ({ signal }) => getLobAddressImportValidationSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressImportValidationSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>>
export type GetLobAddressImportValidationSummaryQueryError = ErrorType<void>


export function useGetLobAddressImportValidationSummary<TData = Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportValidationSummary<TData = Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportValidationSummary<TData = Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Count invalid and skipped rows using the saved selection before commit
 */

export function useGetLobAddressImportValidationSummary<TData = Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportValidationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressImportValidationSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobAddressImportRowsUrl = (id: string,
    params?: ListLobAddressImportRowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-imports/${id}/rows?${stringifiedParams}` : `/api/lob-mail/address-imports/${id}/rows`
}

/**
 * @summary Read a paginated and searchable page of source rows for one sheet
 */
export const listLobAddressImportRows = async (id: string,
    params?: ListLobAddressImportRowsParams, options?: RequestInit): Promise<LobAddressImportRows> => {

  return customFetch<LobAddressImportRows>(getListLobAddressImportRowsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobAddressImportRowsQueryKey = (id: string,
    params?: ListLobAddressImportRowsParams,) => {
    return [
    `/api/lob-mail/address-imports/${id}/rows`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobAddressImportRowsQueryOptions = <TData = Awaited<ReturnType<typeof listLobAddressImportRows>>, TError = ErrorType<void>>(id: string,
    params?: ListLobAddressImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobAddressImportRowsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobAddressImportRows>>> = ({ signal }) => listLobAddressImportRows(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobAddressImportRowsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobAddressImportRows>>>
export type ListLobAddressImportRowsQueryError = ErrorType<void>


export function useListLobAddressImportRows<TData = Awaited<ReturnType<typeof listLobAddressImportRows>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  ListLobAddressImportRowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddressImportRows>>,
          TError,
          Awaited<ReturnType<typeof listLobAddressImportRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddressImportRows<TData = Awaited<ReturnType<typeof listLobAddressImportRows>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobAddressImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobAddressImportRows>>,
          TError,
          Awaited<ReturnType<typeof listLobAddressImportRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobAddressImportRows<TData = Awaited<ReturnType<typeof listLobAddressImportRows>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobAddressImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a paginated and searchable page of source rows for one sheet
 */

export function useListLobAddressImportRows<TData = Awaited<ReturnType<typeof listLobAddressImportRows>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobAddressImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobAddressImportRows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobAddressImportRowsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportLobAddressImportSourceUrl = (id: string,
    params?: ExportLobAddressImportSourceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-imports/${id}/source-csv?${stringifiedParams}` : `/api/lob-mail/address-imports/${id}/source-csv`
}

/**
 * Tenant-scoped agency administrator read. Current saved source cells override retained originals; blank and duplicate headings remain positional. Spreadsheet formula prefixes are escaped. Explicit 32 MiB output limit; missing evidence returns an error instead of a partial file. No provider calls.
 * @summary Export one retained source sheet with exact ordered original headings
 */
export const exportLobAddressImportSource = async (id: string,
    params?: ExportLobAddressImportSourceParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportLobAddressImportSourceUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportLobAddressImportSourceQueryKey = (id: string,
    params?: ExportLobAddressImportSourceParams,) => {
    return [
    `/api/lob-mail/address-imports/${id}/source-csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportLobAddressImportSourceQueryOptions = <TData = Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError = ErrorType<void>>(id: string,
    params?: ExportLobAddressImportSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLobAddressImportSourceQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportLobAddressImportSource>>> = ({ signal }) => exportLobAddressImportSource(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportLobAddressImportSourceQueryResult = NonNullable<Awaited<ReturnType<typeof exportLobAddressImportSource>>>
export type ExportLobAddressImportSourceQueryError = ErrorType<void>


export function useExportLobAddressImportSource<TData = Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  ExportLobAddressImportSourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobAddressImportSource>>,
          TError,
          Awaited<ReturnType<typeof exportLobAddressImportSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobAddressImportSource<TData = Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError = ErrorType<void>>(
 id: string,
    params?: ExportLobAddressImportSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobAddressImportSource>>,
          TError,
          Awaited<ReturnType<typeof exportLobAddressImportSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobAddressImportSource<TData = Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError = ErrorType<void>>(
 id: string,
    params?: ExportLobAddressImportSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export one retained source sheet with exact ordered original headings
 */

export function useExportLobAddressImportSource<TData = Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError = ErrorType<void>>(
 id: string,
    params?: ExportLobAddressImportSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobAddressImportSource>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportLobAddressImportSourceQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressImportSelectionUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/selection`
}

/**
 * @summary Resume a persisted per-sheet mapping and edit selection
 */
export const getLobAddressImportSelection = async (id: string, options?: RequestInit): Promise<GetLobAddressImportSelection200> => {

  return customFetch<GetLobAddressImportSelection200>(getGetLobAddressImportSelectionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressImportSelectionQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/address-imports/${id}/selection`
    ] as const;
    }


export const getGetLobAddressImportSelectionQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressImportSelectionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressImportSelection>>> = ({ signal }) => getLobAddressImportSelection(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressImportSelectionQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressImportSelection>>>
export type GetLobAddressImportSelectionQueryError = ErrorType<void>


export function useGetLobAddressImportSelection<TData = Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportSelection>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportSelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportSelection<TData = Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportSelection>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportSelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportSelection<TData = Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resume a persisted per-sheet mapping and edit selection
 */

export function useGetLobAddressImportSelection<TData = Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportSelection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressImportSelectionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveLobAddressImportSelectionUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/selection`
}

/**
 * @summary Persist per-sheet mapping, edits, and skipped rows before commit
 */
export const saveLobAddressImportSelection = async (id: string,
    lobAddressImportSelection: LobAddressImportSelection, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getSaveLobAddressImportSelectionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAddressImportSelection)
  }
);}




export const getSaveLobAddressImportSelectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobAddressImportSelection>>, TError,{id: string;data: BodyType<LobAddressImportSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveLobAddressImportSelection>>, TError,{id: string;data: BodyType<LobAddressImportSelection>}, TContext> => {

const mutationKey = ['saveLobAddressImportSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveLobAddressImportSelection>>, {id: string;data: BodyType<LobAddressImportSelection>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveLobAddressImportSelection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveLobAddressImportSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof saveLobAddressImportSelection>>>
    export type SaveLobAddressImportSelectionMutationBody = BodyType<LobAddressImportSelection>
    export type SaveLobAddressImportSelectionMutationError = ErrorType<void>

    /**
 * @summary Persist per-sheet mapping, edits, and skipped rows before commit
 */
export const useSaveLobAddressImportSelection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobAddressImportSelection>>, TError,{id: string;data: BodyType<LobAddressImportSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveLobAddressImportSelection>>,
        TError,
        {id: string;data: BodyType<LobAddressImportSelection>},
        TContext
      > => {
      return useMutation(getSaveLobAddressImportSelectionMutationOptions(options), queryClient);
    }

export const getCommitLobAddressImportUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/commit`
}

export const commitLobAddressImport = async (id: string, options?: RequestInit): Promise<LobAddressImportAccepted> => {

  return customFetch<LobAddressImportAccepted>(getCommitLobAddressImportUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCommitLobAddressImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commitLobAddressImport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof commitLobAddressImport>>, TError,{id: string}, TContext> => {

const mutationKey = ['commitLobAddressImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commitLobAddressImport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  commitLobAddressImport(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommitLobAddressImportMutationResult = NonNullable<Awaited<ReturnType<typeof commitLobAddressImport>>>

    export type CommitLobAddressImportMutationError = ErrorType<void>

    export const useCommitLobAddressImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commitLobAddressImport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commitLobAddressImport>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCommitLobAddressImportMutationOptions(options), queryClient);
    }

export const getDownloadLobCampaignCsvUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/campaign-csv`
}

/**
 * @summary Stream reviewed campaign CSV for all selected sheets
 */
export const downloadLobCampaignCsv = async (id: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getDownloadLobCampaignCsvUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadLobCampaignCsvQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/address-imports/${id}/campaign-csv`
    ] as const;
    }


export const getDownloadLobCampaignCsvQueryOptions = <TData = Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadLobCampaignCsvQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadLobCampaignCsv>>> = ({ signal }) => downloadLobCampaignCsv(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadLobCampaignCsvQueryResult = NonNullable<Awaited<ReturnType<typeof downloadLobCampaignCsv>>>
export type DownloadLobCampaignCsvQueryError = ErrorType<void>


export function useDownloadLobCampaignCsv<TData = Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadLobCampaignCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadLobCampaignCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadLobCampaignCsv<TData = Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadLobCampaignCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadLobCampaignCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadLobCampaignCsv<TData = Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream reviewed campaign CSV for all selected sheets
 */

export function useDownloadLobCampaignCsv<TData = Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLobCampaignCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadLobCampaignCsvQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAddressImportStatusUrl = (id: string,
    params?: GetLobAddressImportStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-imports/${id}/status?${stringifiedParams}` : `/api/lob-mail/address-imports/${id}/status`
}

/**
 * @summary Get durable progress and a paginated row-outcome page
 */
export const getLobAddressImportStatus = async (id: string,
    params?: GetLobAddressImportStatusParams, options?: RequestInit): Promise<LobAddressImportStatus> => {

  return customFetch<LobAddressImportStatus>(getGetLobAddressImportStatusUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressImportStatusQueryKey = (id: string,
    params?: GetLobAddressImportStatusParams,) => {
    return [
    `/api/lob-mail/address-imports/${id}/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressImportStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError = ErrorType<void>>(id: string,
    params?: GetLobAddressImportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressImportStatusQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressImportStatus>>> = ({ signal }) => getLobAddressImportStatus(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressImportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressImportStatus>>>
export type GetLobAddressImportStatusQueryError = ErrorType<void>


export function useGetLobAddressImportStatus<TData = Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetLobAddressImportStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportStatus<TData = Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressImportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressImportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressImportStatus<TData = Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressImportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get durable progress and a paginated row-outcome page
 */

export function useGetLobAddressImportStatus<TData = Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressImportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressImportStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressImportStatusQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getVerifyLobAddressImportUrl = (id: string,) => {




  return `/api/lob-mail/address-imports/${id}/verify`
}

/**
 * @summary Verify up to five reviewed rows per request with US address and/or identity checks, without creating addresses
 */
export const verifyLobAddressImport = async (id: string,
    lobAddressVerificationSelection: LobAddressVerificationSelection, options?: RequestInit): Promise<LobAddressVerificationResult> => {

  return customFetch<LobAddressVerificationResult>(getVerifyLobAddressImportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAddressVerificationSelection)
  }
);}




export const getVerifyLobAddressImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyLobAddressImport>>, TError,{id: string;data: BodyType<LobAddressVerificationSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyLobAddressImport>>, TError,{id: string;data: BodyType<LobAddressVerificationSelection>}, TContext> => {

const mutationKey = ['verifyLobAddressImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyLobAddressImport>>, {id: string;data: BodyType<LobAddressVerificationSelection>}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyLobAddressImport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyLobAddressImportMutationResult = NonNullable<Awaited<ReturnType<typeof verifyLobAddressImport>>>
    export type VerifyLobAddressImportMutationBody = BodyType<LobAddressVerificationSelection>
    export type VerifyLobAddressImportMutationError = ErrorType<void>

    /**
 * @summary Verify up to five reviewed rows per request with US address and/or identity checks, without creating addresses
 */
export const useVerifyLobAddressImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyLobAddressImport>>, TError,{id: string;data: BodyType<LobAddressVerificationSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyLobAddressImport>>,
        TError,
        {id: string;data: BodyType<LobAddressVerificationSelection>},
        TContext
      > => {
      return useMutation(getVerifyLobAddressImportMutationOptions(options), queryClient);
    }

export const getGetLobAddressUrl = (id: string,
    params?: GetLobAddressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/addresses/${id}?${stringifiedParams}` : `/api/lob-mail/addresses/${id}`
}

/**
 * Reads a local directory identity, not a provider resource in the selected send environment.
 */
export const getLobAddress = async (id: string,
    params?: GetLobAddressParams, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getGetLobAddressUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressQueryKey = (id: string,
    params?: GetLobAddressParams,) => {
    return [
    `/api/lob-mail/addresses/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddress>>, TError = ErrorType<void>>(id: string,
    params?: GetLobAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddress>>> = ({ signal }) => getLobAddress(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddress>>>
export type GetLobAddressQueryError = ErrorType<void>


export function useGetLobAddress<TData = Awaited<ReturnType<typeof getLobAddress>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetLobAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddress>>,
          TError,
          Awaited<ReturnType<typeof getLobAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddress<TData = Awaited<ReturnType<typeof getLobAddress>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddress>>,
          TError,
          Awaited<ReturnType<typeof getLobAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddress<TData = Awaited<ReturnType<typeof getLobAddress>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddress<TData = Awaited<ReturnType<typeof getLobAddress>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobAddressUrl = (id: string,
    params?: UpdateLobAddressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/addresses/${id}?${stringifiedParams}` : `/api/lob-mail/addresses/${id}`
}

export const updateLobAddress = async (id: string,
    lobAddressInput: LobAddressInput,
    params?: UpdateLobAddressParams, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getUpdateLobAddressUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAddressInput)
  }
);}




export const getUpdateLobAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddress>>, TError,{id: string;data: BodyType<LobAddressInput>;params?: UpdateLobAddressParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobAddress>>, TError,{id: string;data: BodyType<LobAddressInput>;params?: UpdateLobAddressParams}, TContext> => {

const mutationKey = ['updateLobAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobAddress>>, {id: string;data: BodyType<LobAddressInput>;params?: UpdateLobAddressParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateLobAddress(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobAddressMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobAddress>>>
    export type UpdateLobAddressMutationBody = BodyType<LobAddressInput>
    export type UpdateLobAddressMutationError = ErrorType<unknown>

    export const useUpdateLobAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddress>>, TError,{id: string;data: BodyType<LobAddressInput>;params?: UpdateLobAddressParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobAddress>>,
        TError,
        {id: string;data: BodyType<LobAddressInput>;params?: UpdateLobAddressParams},
        TContext
      > => {
      return useMutation(getUpdateLobAddressMutationOptions(options), queryClient);
    }

export const getDeleteLobAddressUrl = (id: string,
    params?: DeleteLobAddressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/addresses/${id}?${stringifiedParams}` : `/api/lob-mail/addresses/${id}`
}

export const deleteLobAddress = async (id: string,
    lobMutationControl: LobMutationControl,
    params?: DeleteLobAddressParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobAddressUrl(id,params),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMutationControl)
  }
);}




export const getDeleteLobAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddress>>, TError,{id: string;data: BodyType<LobMutationControl>;params?: DeleteLobAddressParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddress>>, TError,{id: string;data: BodyType<LobMutationControl>;params?: DeleteLobAddressParams}, TContext> => {

const mutationKey = ['deleteLobAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobAddress>>, {id: string;data: BodyType<LobMutationControl>;params?: DeleteLobAddressParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  deleteLobAddress(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobAddressMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobAddress>>>
    export type DeleteLobAddressMutationBody = BodyType<LobMutationControl>
    export type DeleteLobAddressMutationError = ErrorType<unknown>

    export const useDeleteLobAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddress>>, TError,{id: string;data: BodyType<LobMutationControl>;params?: DeleteLobAddressParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobAddress>>,
        TError,
        {id: string;data: BodyType<LobMutationControl>;params?: DeleteLobAddressParams},
        TContext
      > => {
      return useMutation(getDeleteLobAddressMutationOptions(options), queryClient);
    }

export const getListLobTemplatesUrl = (params?: ListLobTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/templates?${stringifiedParams}` : `/api/lob-mail/templates`
}

export const listLobTemplates = async (params?: ListLobTemplatesParams, options?: RequestInit): Promise<LobPage> => {

  return customFetch<LobPage>(getListLobTemplatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobTemplatesQueryKey = (params?: ListLobTemplatesParams,) => {
    return [
    `/api/lob-mail/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listLobTemplates>>, TError = ErrorType<unknown>>(params?: ListLobTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobTemplates>>> = ({ signal }) => listLobTemplates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listLobTemplates>>>
export type ListLobTemplatesQueryError = ErrorType<unknown>


export function useListLobTemplates<TData = Awaited<ReturnType<typeof listLobTemplates>>, TError = ErrorType<unknown>>(
 params: undefined |  ListLobTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobTemplates>>,
          TError,
          Awaited<ReturnType<typeof listLobTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobTemplates<TData = Awaited<ReturnType<typeof listLobTemplates>>, TError = ErrorType<unknown>>(
 params?: ListLobTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobTemplates>>,
          TError,
          Awaited<ReturnType<typeof listLobTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobTemplates<TData = Awaited<ReturnType<typeof listLobTemplates>>, TError = ErrorType<unknown>>(
 params?: ListLobTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLobTemplates<TData = Awaited<ReturnType<typeof listLobTemplates>>, TError = ErrorType<unknown>>(
 params?: ListLobTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobTemplateUrl = () => {




  return `/api/lob-mail/templates`
}

export const createLobTemplate = async (lobTemplateInput: LobTemplateInput, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getCreateLobTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobTemplateInput)
  }
);}




export const getCreateLobTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobTemplate>>, TError,{data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobTemplate>>, TError,{data: BodyType<LobTemplateInput>}, TContext> => {

const mutationKey = ['createLobTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobTemplate>>, {data: BodyType<LobTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLobTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createLobTemplate>>>
    export type CreateLobTemplateMutationBody = BodyType<LobTemplateInput>
    export type CreateLobTemplateMutationError = ErrorType<unknown>

    export const useCreateLobTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobTemplate>>, TError,{data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobTemplate>>,
        TError,
        {data: BodyType<LobTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateLobTemplateMutationOptions(options), queryClient);
    }

export const getGetLobTemplateUrl = (id: string,
    params?: GetLobTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/templates/${id}?${stringifiedParams}` : `/api/lob-mail/templates/${id}`
}

export const getLobTemplate = async (id: string,
    params?: GetLobTemplateParams, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getGetLobTemplateUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobTemplateQueryKey = (id: string,
    params?: GetLobTemplateParams,) => {
    return [
    `/api/lob-mail/templates/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getLobTemplate>>, TError = ErrorType<unknown>>(id: string,
    params?: GetLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobTemplateQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobTemplate>>> = ({ signal }) => getLobTemplate(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getLobTemplate>>>
export type GetLobTemplateQueryError = ErrorType<unknown>


export function useGetLobTemplate<TData = Awaited<ReturnType<typeof getLobTemplate>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetLobTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobTemplate>>,
          TError,
          Awaited<ReturnType<typeof getLobTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobTemplate<TData = Awaited<ReturnType<typeof getLobTemplate>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobTemplate>>,
          TError,
          Awaited<ReturnType<typeof getLobTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobTemplate<TData = Awaited<ReturnType<typeof getLobTemplate>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobTemplate<TData = Awaited<ReturnType<typeof getLobTemplate>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobTemplateQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobTemplateUrl = (id: string,) => {




  return `/api/lob-mail/templates/${id}`
}

export const updateLobTemplate = async (id: string,
    lobTemplateInput: LobTemplateInput, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getUpdateLobTemplateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobTemplateInput)
  }
);}




export const getUpdateLobTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplate>>, TError,{id: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplate>>, TError,{id: string;data: BodyType<LobTemplateInput>}, TContext> => {

const mutationKey = ['updateLobTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobTemplate>>, {id: string;data: BodyType<LobTemplateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLobTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobTemplate>>>
    export type UpdateLobTemplateMutationBody = BodyType<LobTemplateInput>
    export type UpdateLobTemplateMutationError = ErrorType<unknown>

    export const useUpdateLobTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplate>>, TError,{id: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobTemplate>>,
        TError,
        {id: string;data: BodyType<LobTemplateInput>},
        TContext
      > => {
      return useMutation(getUpdateLobTemplateMutationOptions(options), queryClient);
    }

export const getDeleteLobTemplateUrl = (id: string,) => {




  return `/api/lob-mail/templates/${id}`
}

export const deleteLobTemplate = async (id: string,
    lobMutationControl: LobMutationControl, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobTemplateUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMutationControl)
  }
);}




export const getDeleteLobTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplate>>, TError,{id: string;data: BodyType<LobMutationControl>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplate>>, TError,{id: string;data: BodyType<LobMutationControl>}, TContext> => {

const mutationKey = ['deleteLobTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobTemplate>>, {id: string;data: BodyType<LobMutationControl>}> = (props) => {
          const {id,data} = props ?? {};

          return  deleteLobTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobTemplate>>>
    export type DeleteLobTemplateMutationBody = BodyType<LobMutationControl>
    export type DeleteLobTemplateMutationError = ErrorType<unknown>

    export const useDeleteLobTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplate>>, TError,{id: string;data: BodyType<LobMutationControl>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobTemplate>>,
        TError,
        {id: string;data: BodyType<LobMutationControl>},
        TContext
      > => {
      return useMutation(getDeleteLobTemplateMutationOptions(options), queryClient);
    }

export const getListLobTemplateVersionsUrl = (templateId: string,
    params?: ListLobTemplateVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/templates/${templateId}/versions?${stringifiedParams}` : `/api/lob-mail/templates/${templateId}/versions`
}

export const listLobTemplateVersions = async (templateId: string,
    params?: ListLobTemplateVersionsParams, options?: RequestInit): Promise<LobPage> => {

  return customFetch<LobPage>(getListLobTemplateVersionsUrl(templateId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobTemplateVersionsQueryKey = (templateId: string,
    params?: ListLobTemplateVersionsParams,) => {
    return [
    `/api/lob-mail/templates/${templateId}/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobTemplateVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listLobTemplateVersions>>, TError = ErrorType<unknown>>(templateId: string,
    params?: ListLobTemplateVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobTemplateVersionsQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobTemplateVersions>>> = ({ signal }) => listLobTemplateVersions(templateId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobTemplateVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobTemplateVersions>>>
export type ListLobTemplateVersionsQueryError = ErrorType<unknown>


export function useListLobTemplateVersions<TData = Awaited<ReturnType<typeof listLobTemplateVersions>>, TError = ErrorType<unknown>>(
 templateId: string,
    params: undefined |  ListLobTemplateVersionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobTemplateVersions>>,
          TError,
          Awaited<ReturnType<typeof listLobTemplateVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobTemplateVersions<TData = Awaited<ReturnType<typeof listLobTemplateVersions>>, TError = ErrorType<unknown>>(
 templateId: string,
    params?: ListLobTemplateVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobTemplateVersions>>,
          TError,
          Awaited<ReturnType<typeof listLobTemplateVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobTemplateVersions<TData = Awaited<ReturnType<typeof listLobTemplateVersions>>, TError = ErrorType<unknown>>(
 templateId: string,
    params?: ListLobTemplateVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLobTemplateVersions<TData = Awaited<ReturnType<typeof listLobTemplateVersions>>, TError = ErrorType<unknown>>(
 templateId: string,
    params?: ListLobTemplateVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobTemplateVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobTemplateVersionsQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobTemplateVersionUrl = (templateId: string,) => {




  return `/api/lob-mail/templates/${templateId}/versions`
}

export const createLobTemplateVersion = async (templateId: string,
    lobTemplateInput: LobTemplateInput, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getCreateLobTemplateVersionUrl(templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobTemplateInput)
  }
);}




export const getCreateLobTemplateVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobTemplateVersion>>, TError,{templateId: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobTemplateVersion>>, TError,{templateId: string;data: BodyType<LobTemplateInput>}, TContext> => {

const mutationKey = ['createLobTemplateVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobTemplateVersion>>, {templateId: string;data: BodyType<LobTemplateInput>}> = (props) => {
          const {templateId,data} = props ?? {};

          return  createLobTemplateVersion(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobTemplateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createLobTemplateVersion>>>
    export type CreateLobTemplateVersionMutationBody = BodyType<LobTemplateInput>
    export type CreateLobTemplateVersionMutationError = ErrorType<unknown>

    export const useCreateLobTemplateVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobTemplateVersion>>, TError,{templateId: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobTemplateVersion>>,
        TError,
        {templateId: string;data: BodyType<LobTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateLobTemplateVersionMutationOptions(options), queryClient);
    }

export const getPreviewPublishedLobTemplateUrl = (templateId: string,
    params?: PreviewPublishedLobTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/templates/${templateId}/preview?${stringifiedParams}` : `/api/lob-mail/templates/${templateId}/preview`
}

/**
 * @summary Retrieve published HTML for a tenant-owned Lob template preview
 */
export const previewPublishedLobTemplate = async (templateId: string,
    params?: PreviewPublishedLobTemplateParams, options?: RequestInit): Promise<LobTemplatePreview> => {

  return customFetch<LobTemplatePreview>(getPreviewPublishedLobTemplateUrl(templateId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewPublishedLobTemplateQueryKey = (templateId: string,
    params?: PreviewPublishedLobTemplateParams,) => {
    return [
    `/api/lob-mail/templates/${templateId}/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewPublishedLobTemplateQueryOptions = <TData = Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError = ErrorType<void>>(templateId: string,
    params?: PreviewPublishedLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewPublishedLobTemplateQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewPublishedLobTemplate>>> = ({ signal }) => previewPublishedLobTemplate(templateId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewPublishedLobTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof previewPublishedLobTemplate>>>
export type PreviewPublishedLobTemplateQueryError = ErrorType<void>


export function usePreviewPublishedLobTemplate<TData = Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError = ErrorType<void>>(
 templateId: string,
    params: undefined |  PreviewPublishedLobTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPublishedLobTemplate>>,
          TError,
          Awaited<ReturnType<typeof previewPublishedLobTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewPublishedLobTemplate<TData = Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError = ErrorType<void>>(
 templateId: string,
    params?: PreviewPublishedLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPublishedLobTemplate>>,
          TError,
          Awaited<ReturnType<typeof previewPublishedLobTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewPublishedLobTemplate<TData = Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError = ErrorType<void>>(
 templateId: string,
    params?: PreviewPublishedLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve published HTML for a tenant-owned Lob template preview
 */

export function usePreviewPublishedLobTemplate<TData = Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError = ErrorType<void>>(
 templateId: string,
    params?: PreviewPublishedLobTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPublishedLobTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewPublishedLobTemplateQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobTemplateVersionUrl = (templateId: string,
    versionId: string,) => {




  return `/api/lob-mail/templates/${templateId}/versions/${versionId}`
}

export const getLobTemplateVersion = async (templateId: string,
    versionId: string, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getGetLobTemplateVersionUrl(templateId,versionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobTemplateVersionQueryKey = (templateId: string,
    versionId: string,) => {
    return [
    `/api/lob-mail/templates/${templateId}/versions/${versionId}`
    ] as const;
    }


export const getGetLobTemplateVersionQueryOptions = <TData = Awaited<ReturnType<typeof getLobTemplateVersion>>, TError = ErrorType<unknown>>(templateId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobTemplateVersionQueryKey(templateId,versionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobTemplateVersion>>> = ({ signal }) => getLobTemplateVersion(templateId,versionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined && versionId !== null && versionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobTemplateVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getLobTemplateVersion>>>
export type GetLobTemplateVersionQueryError = ErrorType<unknown>


export function useGetLobTemplateVersion<TData = Awaited<ReturnType<typeof getLobTemplateVersion>>, TError = ErrorType<unknown>>(
 templateId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobTemplateVersion>>,
          TError,
          Awaited<ReturnType<typeof getLobTemplateVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobTemplateVersion<TData = Awaited<ReturnType<typeof getLobTemplateVersion>>, TError = ErrorType<unknown>>(
 templateId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobTemplateVersion>>,
          TError,
          Awaited<ReturnType<typeof getLobTemplateVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobTemplateVersion<TData = Awaited<ReturnType<typeof getLobTemplateVersion>>, TError = ErrorType<unknown>>(
 templateId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobTemplateVersion<TData = Awaited<ReturnType<typeof getLobTemplateVersion>>, TError = ErrorType<unknown>>(
 templateId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobTemplateVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobTemplateVersionQueryOptions(templateId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobTemplateVersionUrl = (templateId: string,
    versionId: string,) => {




  return `/api/lob-mail/templates/${templateId}/versions/${versionId}`
}

export const updateLobTemplateVersion = async (templateId: string,
    versionId: string,
    lobTemplateInput: LobTemplateInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateLobTemplateVersionUrl(templateId,versionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobTemplateInput)
  }
);}




export const getUpdateLobTemplateVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobTemplateInput>}, TContext> => {

const mutationKey = ['updateLobTemplateVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobTemplateVersion>>, {templateId: string;versionId: string;data: BodyType<LobTemplateInput>}> = (props) => {
          const {templateId,versionId,data} = props ?? {};

          return  updateLobTemplateVersion(templateId,versionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobTemplateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobTemplateVersion>>>
    export type UpdateLobTemplateVersionMutationBody = BodyType<LobTemplateInput>
    export type UpdateLobTemplateVersionMutationError = ErrorType<unknown>

    export const useUpdateLobTemplateVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobTemplateVersion>>,
        TError,
        {templateId: string;versionId: string;data: BodyType<LobTemplateInput>},
        TContext
      > => {
      return useMutation(getUpdateLobTemplateVersionMutationOptions(options), queryClient);
    }

export const getDeleteLobTemplateVersionUrl = (templateId: string,
    versionId: string,) => {




  return `/api/lob-mail/templates/${templateId}/versions/${versionId}`
}

export const deleteLobTemplateVersion = async (templateId: string,
    versionId: string,
    lobMutationControl: LobMutationControl, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobTemplateVersionUrl(templateId,versionId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMutationControl)
  }
);}




export const getDeleteLobTemplateVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobMutationControl>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobMutationControl>}, TContext> => {

const mutationKey = ['deleteLobTemplateVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobTemplateVersion>>, {templateId: string;versionId: string;data: BodyType<LobMutationControl>}> = (props) => {
          const {templateId,versionId,data} = props ?? {};

          return  deleteLobTemplateVersion(templateId,versionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobTemplateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobTemplateVersion>>>
    export type DeleteLobTemplateVersionMutationBody = BodyType<LobMutationControl>
    export type DeleteLobTemplateVersionMutationError = ErrorType<unknown>

    export const useDeleteLobTemplateVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobTemplateVersion>>, TError,{templateId: string;versionId: string;data: BodyType<LobMutationControl>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobTemplateVersion>>,
        TError,
        {templateId: string;versionId: string;data: BodyType<LobMutationControl>},
        TContext
      > => {
      return useMutation(getDeleteLobTemplateVersionMutationOptions(options), queryClient);
    }

export const getListLobMailHistoryUrl = (params?: ListLobMailHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail?${stringifiedParams}` : `/api/lob-mail/mail`
}

export const listLobMailHistory = async (params?: ListLobMailHistoryParams, options?: RequestInit): Promise<LobPage> => {

  return customFetch<LobPage>(getListLobMailHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailHistoryQueryKey = (params?: ListLobMailHistoryParams,) => {
    return [
    `/api/lob-mail/mail`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listLobMailHistory>>, TError = ErrorType<unknown>>(params?: ListLobMailHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMailHistory>>> = ({ signal }) => listLobMailHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMailHistory>>>
export type ListLobMailHistoryQueryError = ErrorType<unknown>


export function useListLobMailHistory<TData = Awaited<ReturnType<typeof listLobMailHistory>>, TError = ErrorType<unknown>>(
 params: undefined |  ListLobMailHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailHistory>>,
          TError,
          Awaited<ReturnType<typeof listLobMailHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailHistory<TData = Awaited<ReturnType<typeof listLobMailHistory>>, TError = ErrorType<unknown>>(
 params?: ListLobMailHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailHistory>>,
          TError,
          Awaited<ReturnType<typeof listLobMailHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailHistory<TData = Awaited<ReturnType<typeof listLobMailHistory>>, TError = ErrorType<unknown>>(
 params?: ListLobMailHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLobMailHistory<TData = Awaited<ReturnType<typeof listLobMailHistory>>, TError = ErrorType<unknown>>(
 params?: ListLobMailHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportLobMailTrackingUrl = (params?: ExportLobMailTrackingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail/tracking.csv?${stringifiedParams}` : `/api/lob-mail/mail/tracking.csv`
}

/**
 * @summary Export all matching owned mailpiece tracking across all history
 */
export const exportLobMailTracking = async (params?: ExportLobMailTrackingParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportLobMailTrackingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportLobMailTrackingQueryKey = (params?: ExportLobMailTrackingParams,) => {
    return [
    `/api/lob-mail/mail/tracking.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportLobMailTrackingQueryOptions = <TData = Awaited<ReturnType<typeof exportLobMailTracking>>, TError = ErrorType<unknown>>(params?: ExportLobMailTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLobMailTrackingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportLobMailTracking>>> = ({ signal }) => exportLobMailTracking(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportLobMailTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof exportLobMailTracking>>>
export type ExportLobMailTrackingQueryError = ErrorType<unknown>


export function useExportLobMailTracking<TData = Awaited<ReturnType<typeof exportLobMailTracking>>, TError = ErrorType<unknown>>(
 params: undefined |  ExportLobMailTrackingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobMailTracking>>,
          TError,
          Awaited<ReturnType<typeof exportLobMailTracking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobMailTracking<TData = Awaited<ReturnType<typeof exportLobMailTracking>>, TError = ErrorType<unknown>>(
 params?: ExportLobMailTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobMailTracking>>,
          TError,
          Awaited<ReturnType<typeof exportLobMailTracking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobMailTracking<TData = Awaited<ReturnType<typeof exportLobMailTracking>>, TError = ErrorType<unknown>>(
 params?: ExportLobMailTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export all matching owned mailpiece tracking across all history
 */

export function useExportLobMailTracking<TData = Awaited<ReturnType<typeof exportLobMailTracking>>, TError = ErrorType<unknown>>(
 params?: ExportLobMailTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobMailTracking>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportLobMailTrackingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobMailUrl = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/${resourceType}?${stringifiedParams}` : `/api/lob-mail/${resourceType}`
}

export const listLobMail = async (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams, options?: RequestInit): Promise<LobPage> => {

  return customFetch<LobPage>(getListLobMailUrl(resourceType,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailQueryKey = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams,) => {
    return [
    `/api/lob-mail/${resourceType}`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailQueryOptions = <TData = Awaited<ReturnType<typeof listLobMail>>, TError = ErrorType<unknown>>(resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailQueryKey(resourceType,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMail>>> = ({ signal }) => listLobMail(resourceType,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: resourceType !== null && resourceType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMail>>>
export type ListLobMailQueryError = ErrorType<unknown>


export function useListLobMail<TData = Awaited<ReturnType<typeof listLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params: undefined |  ListLobMailParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMail>>,
          TError,
          Awaited<ReturnType<typeof listLobMail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMail<TData = Awaited<ReturnType<typeof listLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMail>>,
          TError,
          Awaited<ReturnType<typeof listLobMail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMail<TData = Awaited<ReturnType<typeof listLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLobMail<TData = Awaited<ReturnType<typeof listLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    params?: ListLobMailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailQueryOptions(resourceType,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobMailUrl = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',) => {




  return `/api/lob-mail/${resourceType}`
}

export const createLobMail = async (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    lobMailInput: LobMailInput, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getCreateLobMailUrl(resourceType),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailInput)
  }
);}




export const getCreateLobMailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';data: BodyType<LobMailInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';data: BodyType<LobMailInput>}, TContext> => {

const mutationKey = ['createLobMail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobMail>>, {resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';data: BodyType<LobMailInput>}> = (props) => {
          const {resourceType,data} = props ?? {};

          return  createLobMail(resourceType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobMailMutationResult = NonNullable<Awaited<ReturnType<typeof createLobMail>>>
    export type CreateLobMailMutationBody = BodyType<LobMailInput>
    export type CreateLobMailMutationError = ErrorType<unknown>

    export const useCreateLobMail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';data: BodyType<LobMailInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobMail>>,
        TError,
        {resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';data: BodyType<LobMailInput>},
        TContext
      > => {
      return useMutation(getCreateLobMailMutationOptions(options), queryClient);
    }

export const getGetLobMailUrl = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string,) => {




  return `/api/lob-mail/${resourceType}/${id}`
}

export const getLobMail = async (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options?: RequestInit): Promise<LobResource> => {

  return customFetch<LobResource>(getGetLobMailUrl(resourceType,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailQueryKey = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string,) => {
    return [
    `/api/lob-mail/${resourceType}/${id}`
    ] as const;
    }


export const getGetLobMailQueryOptions = <TData = Awaited<ReturnType<typeof getLobMail>>, TError = ErrorType<unknown>>(resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailQueryKey(resourceType,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMail>>> = ({ signal }) => getLobMail(resourceType,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: resourceType !== null && resourceType !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMail>>>
export type GetLobMailQueryError = ErrorType<unknown>


export function useGetLobMail<TData = Awaited<ReturnType<typeof getLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMail>>,
          TError,
          Awaited<ReturnType<typeof getLobMail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMail<TData = Awaited<ReturnType<typeof getLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMail>>,
          TError,
          Awaited<ReturnType<typeof getLobMail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMail<TData = Awaited<ReturnType<typeof getLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobMail<TData = Awaited<ReturnType<typeof getLobMail>>, TError = ErrorType<unknown>>(
 resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailQueryOptions(resourceType,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelLobMailUrl = (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string,) => {




  return `/api/lob-mail/${resourceType}/${id}`
}

export const cancelLobMail = async (resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks',
    id: string,
    cancelLobMailBody: CancelLobMailBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCancelLobMailUrl(resourceType,id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelLobMailBody)
  }
);}




export const getCancelLobMailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';id: string;data: BodyType<CancelLobMailBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';id: string;data: BodyType<CancelLobMailBody>}, TContext> => {

const mutationKey = ['cancelLobMail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelLobMail>>, {resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';id: string;data: BodyType<CancelLobMailBody>}> = (props) => {
          const {resourceType,id,data} = props ?? {};

          return  cancelLobMail(resourceType,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelLobMailMutationResult = NonNullable<Awaited<ReturnType<typeof cancelLobMail>>>
    export type CancelLobMailMutationBody = BodyType<CancelLobMailBody>
    export type CancelLobMailMutationError = ErrorType<void>

    export const useCancelLobMail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLobMail>>, TError,{resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';id: string;data: BodyType<CancelLobMailBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelLobMail>>,
        TError,
        {resourceType: 'postcards' | 'letters' | 'self_mailers' | 'checks';id: string;data: BodyType<CancelLobMailBody>},
        TContext
      > => {
      return useMutation(getCancelLobMailMutationOptions(options), queryClient);
    }

export const getReceiveLobWebhookUrl = () => {




  return `/api/webhooks/lob`
}

/**
 * @summary Receive a verified Lob webhook
 */
export const receiveLobWebhook = async (lobWebhookEvent: LobWebhookEvent, options?: RequestInit): Promise<ReceiveLobWebhook200> => {

  return customFetch<ReceiveLobWebhook200>(getReceiveLobWebhookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobWebhookEvent)
  }
);}




export const getReceiveLobWebhookMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveLobWebhook>>, TError,{data: BodyType<LobWebhookEvent>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveLobWebhook>>, TError,{data: BodyType<LobWebhookEvent>}, TContext> => {

const mutationKey = ['receiveLobWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveLobWebhook>>, {data: BodyType<LobWebhookEvent>}> = (props) => {
          const {data} = props ?? {};

          return  receiveLobWebhook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveLobWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof receiveLobWebhook>>>
    export type ReceiveLobWebhookMutationBody = BodyType<LobWebhookEvent>
    export type ReceiveLobWebhookMutationError = ErrorType<void>

    /**
 * @summary Receive a verified Lob webhook
 */
export const useReceiveLobWebhook = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveLobWebhook>>, TError,{data: BodyType<LobWebhookEvent>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receiveLobWebhook>>,
        TError,
        {data: BodyType<LobWebhookEvent>},
        TContext
      > => {
      return useMutation(getReceiveLobWebhookMutationOptions(options), queryClient);
    }

export const getGetMyProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Get current user profile
 */
export const getMyProfile = async ( options?: RequestInit): Promise<UserProfile> => {

  return customFetch<UserProfile>(getGetMyProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyProfileQueryKey = () => {
    return [
    `/api/me/profile`
    ] as const;
    }


export const getGetMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({ signal }) => getMyProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfile>>>
export type GetMyProfileQueryError = ErrorType<unknown>


export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user profile
 */

export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMyProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Update subscription tier
 */
export const updateMyProfile = async (userProfileUpdate: UserProfileUpdate, options?: RequestInit): Promise<UserProfile> => {

  return customFetch<UserProfile>(getUpdateMyProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userProfileUpdate)
  }
);}




export const getUpdateMyProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: BodyType<UserProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: BodyType<UserProfileUpdate>}, TContext> => {

const mutationKey = ['updateMyProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyProfile>>, {data: BodyType<UserProfileUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMyProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyProfile>>>
    export type UpdateMyProfileMutationBody = BodyType<UserProfileUpdate>
    export type UpdateMyProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update subscription tier
 */
export const useUpdateMyProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: BodyType<UserProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyProfile>>,
        TError,
        {data: BodyType<UserProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMyProfileMutationOptions(options), queryClient);
    }

export const getGetBillingContactUrl = () => {




  return `/api/billing-contact`
}

/**
 * @summary Get the account billing contact
 */
export const getBillingContact = async ( options?: RequestInit): Promise<BillingContact> => {

  return customFetch<BillingContact>(getGetBillingContactUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingContactQueryKey = () => {
    return [
    `/api/billing-contact`
    ] as const;
    }


export const getGetBillingContactQueryOptions = <TData = Awaited<ReturnType<typeof getBillingContact>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingContactQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingContact>>> = ({ signal }) => getBillingContact({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingContactQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingContact>>>
export type GetBillingContactQueryError = ErrorType<void>


export function useGetBillingContact<TData = Awaited<ReturnType<typeof getBillingContact>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingContact>>,
          TError,
          Awaited<ReturnType<typeof getBillingContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingContact<TData = Awaited<ReturnType<typeof getBillingContact>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingContact>>,
          TError,
          Awaited<ReturnType<typeof getBillingContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingContact<TData = Awaited<ReturnType<typeof getBillingContact>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the account billing contact
 */

export function useGetBillingContact<TData = Awaited<ReturnType<typeof getBillingContact>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingContact>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingContactQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBillingContactUrl = () => {




  return `/api/billing-contact`
}

/**
 * @summary Update the account billing contact
 */
export const updateBillingContact = async (billingContactUpdate: BillingContactUpdate, options?: RequestInit): Promise<BillingContact> => {

  return customFetch<BillingContact>(getUpdateBillingContactUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(billingContactUpdate)
  }
);}




export const getUpdateBillingContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingContact>>, TError,{data: BodyType<BillingContactUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBillingContact>>, TError,{data: BodyType<BillingContactUpdate>}, TContext> => {

const mutationKey = ['updateBillingContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBillingContact>>, {data: BodyType<BillingContactUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateBillingContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBillingContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateBillingContact>>>
    export type UpdateBillingContactMutationBody = BodyType<BillingContactUpdate>
    export type UpdateBillingContactMutationError = ErrorType<void>

    /**
 * @summary Update the account billing contact
 */
export const useUpdateBillingContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingContact>>, TError,{data: BodyType<BillingContactUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBillingContact>>,
        TError,
        {data: BodyType<BillingContactUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBillingContactMutationOptions(options), queryClient);
    }

export const getListMailingListsUrl = () => {




  return `/api/mailing-lists`
}

/**
 * @summary List user mailing lists
 */
export const listMailingLists = async ( options?: RequestInit): Promise<MailingList[]> => {

  return customFetch<MailingList[]>(getListMailingListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMailingListsQueryKey = () => {
    return [
    `/api/mailing-lists`
    ] as const;
    }


export const getListMailingListsQueryOptions = <TData = Awaited<ReturnType<typeof listMailingLists>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailingListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailingLists>>> = ({ signal }) => listMailingLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailingListsQueryResult = NonNullable<Awaited<ReturnType<typeof listMailingLists>>>
export type ListMailingListsQueryError = ErrorType<unknown>


export function useListMailingLists<TData = Awaited<ReturnType<typeof listMailingLists>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingLists>>,
          TError,
          Awaited<ReturnType<typeof listMailingLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingLists<TData = Awaited<ReturnType<typeof listMailingLists>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailingLists>>,
          TError,
          Awaited<ReturnType<typeof listMailingLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailingLists<TData = Awaited<ReturnType<typeof listMailingLists>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List user mailing lists
 */

export function useListMailingLists<TData = Awaited<ReturnType<typeof listMailingLists>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailingLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailingListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateMailingListUrl = () => {




  return `/api/mailing-lists`
}

/**
 * @summary Upload a new mailing list
 */
export const createMailingList = async (mailingListInput: MailingListInput, options?: RequestInit): Promise<MailingList> => {

  return customFetch<MailingList>(getCreateMailingListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailingListInput)
  }
);}




export const getCreateMailingListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingList>>, TError,{data: BodyType<MailingListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMailingList>>, TError,{data: BodyType<MailingListInput>}, TContext> => {

const mutationKey = ['createMailingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMailingList>>, {data: BodyType<MailingListInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMailingList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMailingListMutationResult = NonNullable<Awaited<ReturnType<typeof createMailingList>>>
    export type CreateMailingListMutationBody = BodyType<MailingListInput>
    export type CreateMailingListMutationError = ErrorType<unknown>

    /**
 * @summary Upload a new mailing list
 */
export const useCreateMailingList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailingList>>, TError,{data: BodyType<MailingListInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMailingList>>,
        TError,
        {data: BodyType<MailingListInput>},
        TContext
      > => {
      return useMutation(getCreateMailingListMutationOptions(options), queryClient);
    }

export const getDeleteMailingListUrl = (id: number,) => {




  return `/api/mailing-lists/${id}`
}

/**
 * @summary Delete a mailing list
 */
export const deleteMailingList = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMailingListUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMailingListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMailingList>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMailingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMailingList>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMailingList(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMailingListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMailingList>>>

    export type DeleteMailingListMutationError = ErrorType<unknown>

    /**
 * @summary Delete a mailing list
 */
export const useDeleteMailingList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailingList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMailingList>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMailingListMutationOptions(options), queryClient);
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options), queryClient);
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorageObject>>,
          TError,
          Awaited<ReturnType<typeof getStorageObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorageObject>>,
          TError,
          Awaited<ReturnType<typeof getStorageObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSavedDesignsUrl = () => {




  return `/api/saved-designs`
}

/**
 * @summary List user's saved designs
 */
export const listSavedDesigns = async ( options?: RequestInit): Promise<SavedDesign[]> => {

  return customFetch<SavedDesign[]>(getListSavedDesignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedDesignsQueryKey = () => {
    return [
    `/api/saved-designs`
    ] as const;
    }


export const getListSavedDesignsQueryOptions = <TData = Awaited<ReturnType<typeof listSavedDesigns>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedDesignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedDesigns>>> = ({ signal }) => listSavedDesigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedDesignsQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedDesigns>>>
export type ListSavedDesignsQueryError = ErrorType<unknown>


export function useListSavedDesigns<TData = Awaited<ReturnType<typeof listSavedDesigns>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedDesigns>>,
          TError,
          Awaited<ReturnType<typeof listSavedDesigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedDesigns<TData = Awaited<ReturnType<typeof listSavedDesigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedDesigns>>,
          TError,
          Awaited<ReturnType<typeof listSavedDesigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedDesigns<TData = Awaited<ReturnType<typeof listSavedDesigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List user's saved designs
 */

export function useListSavedDesigns<TData = Awaited<ReturnType<typeof listSavedDesigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedDesigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedDesignsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSavedDesignUrl = () => {




  return `/api/saved-designs`
}

/**
 * @summary Save a new design
 */
export const createSavedDesign = async (savedDesignInput: SavedDesignInput, options?: RequestInit): Promise<SavedDesign> => {

  return customFetch<SavedDesign>(getCreateSavedDesignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedDesignInput)
  }
);}




export const getCreateSavedDesignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedDesign>>, TError,{data: BodyType<SavedDesignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSavedDesign>>, TError,{data: BodyType<SavedDesignInput>}, TContext> => {

const mutationKey = ['createSavedDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSavedDesign>>, {data: BodyType<SavedDesignInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSavedDesign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSavedDesignMutationResult = NonNullable<Awaited<ReturnType<typeof createSavedDesign>>>
    export type CreateSavedDesignMutationBody = BodyType<SavedDesignInput>
    export type CreateSavedDesignMutationError = ErrorType<unknown>

    /**
 * @summary Save a new design
 */
export const useCreateSavedDesign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedDesign>>, TError,{data: BodyType<SavedDesignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSavedDesign>>,
        TError,
        {data: BodyType<SavedDesignInput>},
        TContext
      > => {
      return useMutation(getCreateSavedDesignMutationOptions(options), queryClient);
    }

export const getPatchSavedDesignUrl = (id: number,) => {




  return `/api/saved-designs/${id}`
}

/**
 * @summary Update positioning and thumbnail of a saved design
 */
export const patchSavedDesign = async (id: number,
    savedDesignPatch: SavedDesignPatch, options?: RequestInit): Promise<SavedDesign> => {

  return customFetch<SavedDesign>(getPatchSavedDesignUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedDesignPatch)
  }
);}




export const getPatchSavedDesignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSavedDesign>>, TError,{id: number;data: BodyType<SavedDesignPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSavedDesign>>, TError,{id: number;data: BodyType<SavedDesignPatch>}, TContext> => {

const mutationKey = ['patchSavedDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSavedDesign>>, {id: number;data: BodyType<SavedDesignPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSavedDesign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSavedDesignMutationResult = NonNullable<Awaited<ReturnType<typeof patchSavedDesign>>>
    export type PatchSavedDesignMutationBody = BodyType<SavedDesignPatch>
    export type PatchSavedDesignMutationError = ErrorType<void>

    /**
 * @summary Update positioning and thumbnail of a saved design
 */
export const usePatchSavedDesign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSavedDesign>>, TError,{id: number;data: BodyType<SavedDesignPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSavedDesign>>,
        TError,
        {id: number;data: BodyType<SavedDesignPatch>},
        TContext
      > => {
      return useMutation(getPatchSavedDesignMutationOptions(options), queryClient);
    }

export const getDeleteSavedDesignUrl = (id: number,) => {




  return `/api/saved-designs/${id}`
}

/**
 * @summary Delete a saved design
 */
export const deleteSavedDesign = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSavedDesignUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSavedDesignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedDesign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedDesign>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSavedDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedDesign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSavedDesign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedDesignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedDesign>>>

    export type DeleteSavedDesignMutationError = ErrorType<unknown>

    /**
 * @summary Delete a saved design
 */
export const useDeleteSavedDesign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedDesign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedDesign>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSavedDesignMutationOptions(options), queryClient);
    }

export const getListTenantsUrl = () => {




  return `/api/tenants`
}

/**
 * @summary List all tenants (agency_admin only)
 */
export const listTenants = async ( options?: RequestInit): Promise<Tenant[]> => {

  return customFetch<Tenant[]>(getListTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantsQueryKey = () => {
    return [
    `/api/tenants`
    ] as const;
    }


export const getListTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenants>>> = ({ signal }) => listTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>
export type ListTenantsQueryError = ErrorType<unknown>


export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all tenants (agency_admin only)
 */

export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTenantUrl = () => {




  return `/api/tenants`
}

/**
 * @summary Create a new tenant (agency_admin only)
 */
export const createTenant = async (tenantInput: TenantInput, options?: RequestInit): Promise<Tenant> => {

  return customFetch<Tenant>(getCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantInput)
  }
);}




export const getCreateTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: BodyType<TenantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: BodyType<TenantInput>}, TContext> => {

const mutationKey = ['createTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenant>>, {data: BodyType<TenantInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createTenant>>>
    export type CreateTenantMutationBody = BodyType<TenantInput>
    export type CreateTenantMutationError = ErrorType<unknown>

    /**
 * @summary Create a new tenant (agency_admin only)
 */
export const useCreateTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: BodyType<TenantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTenant>>,
        TError,
        {data: BodyType<TenantInput>},
        TContext
      > => {
      return useMutation(getCreateTenantMutationOptions(options), queryClient);
    }

export const getGetTenantUrl = (id: number,) => {




  return `/api/tenants/${id}`
}

/**
 * @summary Get a single tenant
 */
export const getTenant = async (id: number, options?: RequestInit): Promise<Tenant> => {

  return customFetch<Tenant>(getGetTenantUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantQueryKey = (id: number,) => {
    return [
    `/api/tenants/${id}`
    ] as const;
    }


export const getGetTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenant>>> = ({ signal }) => getTenant(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTenant>>>
export type GetTenantQueryError = ErrorType<ErrorResponse>


export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single tenant
 */

export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTenantUrl = (id: number,) => {




  return `/api/tenants/${id}`
}

/**
 * @summary Update a tenant
 */
export const updateTenant = async (id: number,
    tenantUpdate: TenantUpdate, options?: RequestInit): Promise<Tenant> => {

  return customFetch<Tenant>(getUpdateTenantUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantUpdate)
  }
);}




export const getUpdateTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: number;data: BodyType<TenantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: number;data: BodyType<TenantUpdate>}, TContext> => {

const mutationKey = ['updateTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenant>>, {id: number;data: BodyType<TenantUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTenant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenant>>>
    export type UpdateTenantMutationBody = BodyType<TenantUpdate>
    export type UpdateTenantMutationError = ErrorType<unknown>

    /**
 * @summary Update a tenant
 */
export const useUpdateTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{id: number;data: BodyType<TenantUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTenant>>,
        TError,
        {id: number;data: BodyType<TenantUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTenantMutationOptions(options), queryClient);
    }

export const getGetMailReportingAccessUrl = () => {




  return `/api/lob-mail/reporting-access`
}

export const getMailReportingAccess = async ( options?: RequestInit): Promise<GetMailReportingAccess200> => {

  return customFetch<GetMailReportingAccess200>(getGetMailReportingAccessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailReportingAccessQueryKey = () => {
    return [
    `/api/lob-mail/reporting-access`
    ] as const;
    }


export const getGetMailReportingAccessQueryOptions = <TData = Awaited<ReturnType<typeof getMailReportingAccess>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailReportingAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailReportingAccess>>> = ({ signal }) => getMailReportingAccess({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailReportingAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getMailReportingAccess>>>
export type GetMailReportingAccessQueryError = ErrorType<void>


export function useGetMailReportingAccess<TData = Awaited<ReturnType<typeof getMailReportingAccess>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailReportingAccess>>,
          TError,
          Awaited<ReturnType<typeof getMailReportingAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailReportingAccess<TData = Awaited<ReturnType<typeof getMailReportingAccess>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailReportingAccess>>,
          TError,
          Awaited<ReturnType<typeof getMailReportingAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailReportingAccess<TData = Awaited<ReturnType<typeof getMailReportingAccess>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMailReportingAccess<TData = Awaited<ReturnType<typeof getMailReportingAccess>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailReportingAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailReportingAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignMailReportingUrl = (id: number,) => {




  return `/api/campaigns/${id}/mail-reporting`
}

export const getCampaignMailReporting = async (id: number, options?: RequestInit): Promise<CampaignMailReporting> => {

  return customFetch<CampaignMailReporting>(getGetCampaignMailReportingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignMailReportingQueryKey = (id: number,) => {
    return [
    `/api/campaigns/${id}/mail-reporting`
    ] as const;
    }


export const getGetCampaignMailReportingQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignMailReporting>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignMailReportingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignMailReporting>>> = ({ signal }) => getCampaignMailReporting(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignMailReportingQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignMailReporting>>>
export type GetCampaignMailReportingQueryError = ErrorType<void>


export function useGetCampaignMailReporting<TData = Awaited<ReturnType<typeof getCampaignMailReporting>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignMailReporting>>,
          TError,
          Awaited<ReturnType<typeof getCampaignMailReporting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignMailReporting<TData = Awaited<ReturnType<typeof getCampaignMailReporting>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignMailReporting>>,
          TError,
          Awaited<ReturnType<typeof getCampaignMailReporting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignMailReporting<TData = Awaited<ReturnType<typeof getCampaignMailReporting>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignMailReporting<TData = Awaited<ReturnType<typeof getCampaignMailReporting>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMailReporting>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignMailReportingQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetCampaignMailAssociationsUrl = (id: number,) => {




  return `/api/campaigns/${id}/mail-reporting`
}

export const setCampaignMailAssociations = async (id: number,
    campaignMailAssociationInput: CampaignMailAssociationInput, options?: RequestInit): Promise<CampaignMailAssociationInput> => {

  return customFetch<CampaignMailAssociationInput>(getSetCampaignMailAssociationsUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(campaignMailAssociationInput)
  }
);}




export const getSetCampaignMailAssociationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCampaignMailAssociations>>, TError,{id: number;data: BodyType<CampaignMailAssociationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCampaignMailAssociations>>, TError,{id: number;data: BodyType<CampaignMailAssociationInput>}, TContext> => {

const mutationKey = ['setCampaignMailAssociations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCampaignMailAssociations>>, {id: number;data: BodyType<CampaignMailAssociationInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setCampaignMailAssociations(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCampaignMailAssociationsMutationResult = NonNullable<Awaited<ReturnType<typeof setCampaignMailAssociations>>>
    export type SetCampaignMailAssociationsMutationBody = BodyType<CampaignMailAssociationInput>
    export type SetCampaignMailAssociationsMutationError = ErrorType<void>

    export const useSetCampaignMailAssociations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCampaignMailAssociations>>, TError,{id: number;data: BodyType<CampaignMailAssociationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCampaignMailAssociations>>,
        TError,
        {id: number;data: BodyType<CampaignMailAssociationInput>},
        TContext
      > => {
      return useMutation(getSetCampaignMailAssociationsMutationOptions(options), queryClient);
    }

export const getListCampaignsUrl = () => {




  return `/api/campaigns`
}

/**
 * @summary List campaigns for current tenant
 */
export const listCampaigns = async ( options?: RequestInit): Promise<Campaign[]> => {

  return customFetch<Campaign[]>(getListCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignsQueryKey = () => {
    return [
    `/api/campaigns`
    ] as const;
    }


export const getListCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaigns>>> = ({ signal }) => listCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaigns>>>
export type ListCampaignsQueryError = ErrorType<unknown>


export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List campaigns for current tenant
 */

export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCampaignUrl = () => {




  return `/api/campaigns`
}

/**
 * @summary Create a new campaign
 */
export const createCampaign = async (campaignInput: CampaignInput, options?: RequestInit): Promise<Campaign> => {

  return customFetch<Campaign>(getCreateCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(campaignInput)
  }
);}




export const getCreateCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CampaignInput>}, TContext> => {

const mutationKey = ['createCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCampaign>>, {data: BodyType<CampaignInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createCampaign>>>
    export type CreateCampaignMutationBody = BodyType<CampaignInput>
    export type CreateCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Create a new campaign
 */
export const useCreateCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCampaign>>,
        TError,
        {data: BodyType<CampaignInput>},
        TContext
      > => {
      return useMutation(getCreateCampaignMutationOptions(options), queryClient);
    }

export const getListCampaignsPagedUrl = (params?: ListCampaignsPagedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/campaigns/paged?${stringifiedParams}` : `/api/campaigns/paged`
}

/**
 * @summary List a tenant's campaigns with an accurate total and full-dataset summary
 */
export const listCampaignsPaged = async (params?: ListCampaignsPagedParams, options?: RequestInit): Promise<CampaignPage> => {

  return customFetch<CampaignPage>(getListCampaignsPagedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignsPagedQueryKey = (params?: ListCampaignsPagedParams,) => {
    return [
    `/api/campaigns/paged`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCampaignsPagedQueryOptions = <TData = Awaited<ReturnType<typeof listCampaignsPaged>>, TError = ErrorType<unknown>>(params?: ListCampaignsPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignsPagedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignsPaged>>> = ({ signal }) => listCampaignsPaged(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignsPagedQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignsPaged>>>
export type ListCampaignsPagedQueryError = ErrorType<unknown>


export function useListCampaignsPaged<TData = Awaited<ReturnType<typeof listCampaignsPaged>>, TError = ErrorType<unknown>>(
 params: undefined |  ListCampaignsPagedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignsPaged>>,
          TError,
          Awaited<ReturnType<typeof listCampaignsPaged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignsPaged<TData = Awaited<ReturnType<typeof listCampaignsPaged>>, TError = ErrorType<unknown>>(
 params?: ListCampaignsPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignsPaged>>,
          TError,
          Awaited<ReturnType<typeof listCampaignsPaged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignsPaged<TData = Awaited<ReturnType<typeof listCampaignsPaged>>, TError = ErrorType<unknown>>(
 params?: ListCampaignsPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a tenant's campaigns with an accurate total and full-dataset summary
 */

export function useListCampaignsPaged<TData = Awaited<ReturnType<typeof listCampaignsPaged>>, TError = ErrorType<unknown>>(
 params?: ListCampaignsPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignsPaged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignsPagedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignUrl = (id: number,) => {




  return `/api/campaigns/${id}`
}

/**
 * @summary Get a campaign by ID
 */
export const getCampaign = async (id: number, options?: RequestInit): Promise<Campaign> => {

  return customFetch<Campaign>(getGetCampaignUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignQueryKey = (id: number,) => {
    return [
    `/api/campaigns/${id}`
    ] as const;
    }


export const getGetCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaign>>> = ({ signal }) => getCampaign(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaign>>>
export type GetCampaignQueryError = ErrorType<unknown>


export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a campaign by ID
 */

export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCampaignUrl = (id: number,) => {




  return `/api/campaigns/${id}`
}

/**
 * @summary Update a campaign
 */
export const updateCampaign = async (id: number,
    campaignUpdate: CampaignUpdate, options?: RequestInit): Promise<Campaign> => {

  return customFetch<Campaign>(getUpdateCampaignUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(campaignUpdate)
  }
);}




export const getUpdateCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: number;data: BodyType<CampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: number;data: BodyType<CampaignUpdate>}, TContext> => {

const mutationKey = ['updateCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampaign>>, {id: number;data: BodyType<CampaignUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCampaign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaign>>>
    export type UpdateCampaignMutationBody = BodyType<CampaignUpdate>
    export type UpdateCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Update a campaign
 */
export const useUpdateCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: number;data: BodyType<CampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCampaign>>,
        TError,
        {id: number;data: BodyType<CampaignUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCampaignMutationOptions(options), queryClient);
    }

export const getDeleteCampaignUrl = (id: number,) => {




  return `/api/campaigns/${id}`
}

/**
 * @summary Delete a campaign
 */
export const deleteCampaign = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCampaignUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaign>>>

    export type DeleteCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Delete a campaign
 */
export const useDeleteCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaign>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCampaignMutationOptions(options), queryClient);
    }

export const getListAudiencesUrl = () => {




  return `/api/audiences`
}

/**
 * @summary List saved audiences for current tenant
 */
export const listAudiences = async ( options?: RequestInit): Promise<Audience[]> => {

  return customFetch<Audience[]>(getListAudiencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAudiencesQueryKey = () => {
    return [
    `/api/audiences`
    ] as const;
    }


export const getListAudiencesQueryOptions = <TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAudiencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAudiences>>> = ({ signal }) => listAudiences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAudiencesQueryResult = NonNullable<Awaited<ReturnType<typeof listAudiences>>>
export type ListAudiencesQueryError = ErrorType<unknown>


export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAudiences>>,
          TError,
          Awaited<ReturnType<typeof listAudiences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAudiences>>,
          TError,
          Awaited<ReturnType<typeof listAudiences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved audiences for current tenant
 */

export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAudiencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAudienceUrl = () => {




  return `/api/audiences`
}

/**
 * @summary Save a new audience (selected EDDM routes)
 */
export const createAudience = async (audienceInput: AudienceInput, options?: RequestInit): Promise<Audience> => {

  return customFetch<Audience>(getCreateAudienceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(audienceInput)
  }
);}




export const getCreateAudienceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{data: BodyType<AudienceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{data: BodyType<AudienceInput>}, TContext> => {

const mutationKey = ['createAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAudience>>, {data: BodyType<AudienceInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAudience(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof createAudience>>>
    export type CreateAudienceMutationBody = BodyType<AudienceInput>
    export type CreateAudienceMutationError = ErrorType<unknown>

    /**
 * @summary Save a new audience (selected EDDM routes)
 */
export const useCreateAudience = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{data: BodyType<AudienceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAudience>>,
        TError,
        {data: BodyType<AudienceInput>},
        TContext
      > => {
      return useMutation(getCreateAudienceMutationOptions(options), queryClient);
    }

export const getDeleteAudienceUrl = (id: number,) => {




  return `/api/audiences/${id}`
}

/**
 * @summary Delete a saved audience
 */
export const deleteAudience = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAudienceUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAudienceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAudience>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAudience(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAudience>>>

    export type DeleteAudienceMutationError = ErrorType<unknown>

    /**
 * @summary Delete a saved audience
 */
export const useDeleteAudience = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAudience>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAudienceMutationOptions(options), queryClient);
    }

export const getSendInvitationUrl = () => {




  return `/api/invitations`
}

/**
 * @summary Invite a user to join a tenant
 */
export const sendInvitation = async (invitationInput: InvitationInput, options?: RequestInit): Promise<Invitation> => {

  return customFetch<Invitation>(getSendInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invitationInput)
  }
);}




export const getSendInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext> => {

const mutationKey = ['sendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInvitation>>, {data: BodyType<InvitationInput>}> = (props) => {
          const {data} = props ?? {};

          return  sendInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof sendInvitation>>>
    export type SendInvitationMutationBody = BodyType<InvitationInput>
    export type SendInvitationMutationError = ErrorType<unknown>

    /**
 * @summary Invite a user to join a tenant
 */
export const useSendInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInvitation>>,
        TError,
        {data: BodyType<InvitationInput>},
        TContext
      > => {
      return useMutation(getSendInvitationMutationOptions(options), queryClient);
    }

export const getListInvitationsUrl = () => {




  return `/api/invitations`
}

/**
 * @summary List pending invitations for current tenant
 */
export const listInvitations = async ( options?: RequestInit): Promise<Invitation[]> => {

  return customFetch<Invitation[]>(getListInvitationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitationsQueryKey = () => {
    return [
    `/api/invitations`
    ] as const;
    }


export const getListInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({ signal }) => listInvitations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvitations>>>
export type ListInvitationsQueryError = ErrorType<unknown>


export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pending invitations for current tenant
 */

export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvitationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAcceptInvitationUrl = (token: string,) => {




  return `/api/invitations/${token}/accept`
}

/**
 * @summary Accept an invitation by token
 */
export const acceptInvitation = async (token: string, options?: RequestInit): Promise<Invitation> => {

  return customFetch<Invitation>(getAcceptInvitationUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext> => {

const mutationKey = ['acceptInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitation>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  acceptInvitation(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitation>>>

    export type AcceptInvitationMutationError = ErrorType<unknown>

    /**
 * @summary Accept an invitation by token
 */
export const useAcceptInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitation>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getAcceptInvitationMutationOptions(options), queryClient);
    }

export const getListTenantMembersUrl = (id: number,) => {




  return `/api/tenants/${id}/members`
}

/**
 * @summary List members of a tenant
 */
export const listTenantMembers = async (id: number, options?: RequestInit): Promise<TenantMember[]> => {

  return customFetch<TenantMember[]>(getListTenantMembersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantMembersQueryKey = (id: number,) => {
    return [
    `/api/tenants/${id}/members`
    ] as const;
    }


export const getListTenantMembersQueryOptions = <TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantMembersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantMembers>>> = ({ signal }) => listTenantMembers(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantMembers>>>
export type ListTenantMembersQueryError = ErrorType<unknown>


export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantMembers>>,
          TError,
          Awaited<ReturnType<typeof listTenantMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantMembers>>,
          TError,
          Awaited<ReturnType<typeof listTenantMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List members of a tenant
 */

export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantMembersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEddmRoutesUrl = (params: GetEddmRoutesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/eddm/routes?${stringifiedParams}` : `/api/eddm/routes`
}

/**
 * @summary Get EDDM carrier routes for a ZIP code
 */
export const getEddmRoutes = async (params: GetEddmRoutesParams, options?: RequestInit): Promise<EddmRoute[]> => {

  return customFetch<EddmRoute[]>(getGetEddmRoutesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEddmRoutesQueryKey = (params?: GetEddmRoutesParams,) => {
    return [
    `/api/eddm/routes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEddmRoutesQueryOptions = <TData = Awaited<ReturnType<typeof getEddmRoutes>>, TError = ErrorType<unknown>>(params: GetEddmRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEddmRoutesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEddmRoutes>>> = ({ signal }) => getEddmRoutes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEddmRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof getEddmRoutes>>>
export type GetEddmRoutesQueryError = ErrorType<unknown>


export function useGetEddmRoutes<TData = Awaited<ReturnType<typeof getEddmRoutes>>, TError = ErrorType<unknown>>(
 params: GetEddmRoutesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEddmRoutes>>,
          TError,
          Awaited<ReturnType<typeof getEddmRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEddmRoutes<TData = Awaited<ReturnType<typeof getEddmRoutes>>, TError = ErrorType<unknown>>(
 params: GetEddmRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEddmRoutes>>,
          TError,
          Awaited<ReturnType<typeof getEddmRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEddmRoutes<TData = Awaited<ReturnType<typeof getEddmRoutes>>, TError = ErrorType<unknown>>(
 params: GetEddmRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get EDDM carrier routes for a ZIP code
 */

export function useGetEddmRoutes<TData = Awaited<ReturnType<typeof getEddmRoutes>>, TError = ErrorType<unknown>>(
 params: GetEddmRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEddmRoutesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEddmRouteGeometryUrl = (params: GetEddmRouteGeometryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/eddm/routes/geometry?${stringifiedParams}` : `/api/eddm/routes/geometry`
}

/**
 * @summary Get GeoJSON polygon geometry for EDDM routes in a ZIP
 */
export const getEddmRouteGeometry = async (params: GetEddmRouteGeometryParams, options?: RequestInit): Promise<GetEddmRouteGeometry200> => {

  return customFetch<GetEddmRouteGeometry200>(getGetEddmRouteGeometryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEddmRouteGeometryQueryKey = (params?: GetEddmRouteGeometryParams,) => {
    return [
    `/api/eddm/routes/geometry`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEddmRouteGeometryQueryOptions = <TData = Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError = ErrorType<unknown>>(params: GetEddmRouteGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEddmRouteGeometryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEddmRouteGeometry>>> = ({ signal }) => getEddmRouteGeometry(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEddmRouteGeometryQueryResult = NonNullable<Awaited<ReturnType<typeof getEddmRouteGeometry>>>
export type GetEddmRouteGeometryQueryError = ErrorType<unknown>


export function useGetEddmRouteGeometry<TData = Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError = ErrorType<unknown>>(
 params: GetEddmRouteGeometryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEddmRouteGeometry>>,
          TError,
          Awaited<ReturnType<typeof getEddmRouteGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEddmRouteGeometry<TData = Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError = ErrorType<unknown>>(
 params: GetEddmRouteGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEddmRouteGeometry>>,
          TError,
          Awaited<ReturnType<typeof getEddmRouteGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEddmRouteGeometry<TData = Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError = ErrorType<unknown>>(
 params: GetEddmRouteGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get GeoJSON polygon geometry for EDDM routes in a ZIP
 */

export function useGetEddmRouteGeometry<TData = Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError = ErrorType<unknown>>(
 params: GetEddmRouteGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEddmRouteGeometry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEddmRouteGeometryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEddmRecommendationsUrl = () => {




  return `/api/eddm/recommend`
}

/**
 * @summary Get AI-recommended EDDM routes based on business profile
 */
export const getEddmRecommendations = async (eddmRecommendInput: EddmRecommendInput, options?: RequestInit): Promise<EddmRouteScored[]> => {

  return customFetch<EddmRouteScored[]>(getGetEddmRecommendationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eddmRecommendInput)
  }
);}




export const getGetEddmRecommendationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEddmRecommendations>>, TError,{data: BodyType<EddmRecommendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getEddmRecommendations>>, TError,{data: BodyType<EddmRecommendInput>}, TContext> => {

const mutationKey = ['getEddmRecommendations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEddmRecommendations>>, {data: BodyType<EddmRecommendInput>}> = (props) => {
          const {data} = props ?? {};

          return  getEddmRecommendations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetEddmRecommendationsMutationResult = NonNullable<Awaited<ReturnType<typeof getEddmRecommendations>>>
    export type GetEddmRecommendationsMutationBody = BodyType<EddmRecommendInput>
    export type GetEddmRecommendationsMutationError = ErrorType<unknown>

    /**
 * @summary Get AI-recommended EDDM routes based on business profile
 */
export const useGetEddmRecommendations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEddmRecommendations>>, TError,{data: BodyType<EddmRecommendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEddmRecommendations>>,
        TError,
        {data: BodyType<EddmRecommendInput>},
        TContext
      > => {
      return useMutation(getGetEddmRecommendationsMutationOptions(options), queryClient);
    }

export const getGetAppDashboardUrl = () => {




  return `/api/app/dashboard`
}

/**
 * @summary Get dashboard summary for current user
 */
export const getAppDashboard = async ( options?: RequestInit): Promise<AppDashboard> => {

  return customFetch<AppDashboard>(getGetAppDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppDashboardQueryKey = () => {
    return [
    `/api/app/dashboard`
    ] as const;
    }


export const getGetAppDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAppDashboard>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppDashboard>>> = ({ signal }) => getAppDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAppDashboard>>>
export type GetAppDashboardQueryError = ErrorType<unknown>


export function useGetAppDashboard<TData = Awaited<ReturnType<typeof getAppDashboard>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAppDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppDashboard<TData = Awaited<ReturnType<typeof getAppDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAppDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppDashboard<TData = Awaited<ReturnType<typeof getAppDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get dashboard summary for current user
 */

export function useGetAppDashboard<TData = Awaited<ReturnType<typeof getAppDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppDashboard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppDashboardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProductsUrl = () => {




  return `/api/products`
}

/**
 * @summary List all print products
 */
export const listProducts = async ( options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = () => {
    return [
    `/api/products`
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all print products
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Get a single product
 */
export const getProduct = async (id: number, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/api/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<ErrorResponse>


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCartUrl = () => {




  return `/api/cart`
}

/**
 * @summary Get current user's cart
 */
export const getCart = async ( options?: RequestInit): Promise<Cart> => {

  return customFetch<Cart>(getGetCartUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCartQueryKey = () => {
    return [
    `/api/cart`
    ] as const;
    }


export const getGetCartQueryOptions = <TData = Awaited<ReturnType<typeof getCart>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCartQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCart>>> = ({ signal }) => getCart({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCartQueryResult = NonNullable<Awaited<ReturnType<typeof getCart>>>
export type GetCartQueryError = ErrorType<unknown>


export function useGetCart<TData = Awaited<ReturnType<typeof getCart>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCart>>,
          TError,
          Awaited<ReturnType<typeof getCart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCart<TData = Awaited<ReturnType<typeof getCart>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCart>>,
          TError,
          Awaited<ReturnType<typeof getCart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCart<TData = Awaited<ReturnType<typeof getCart>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's cart
 */

export function useGetCart<TData = Awaited<ReturnType<typeof getCart>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCartQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClearCartUrl = () => {




  return `/api/cart`
}

/**
 * @summary Clear the cart
 */
export const clearCart = async ( options?: RequestInit): Promise<Cart> => {

  return customFetch<Cart>(getClearCartUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext> => {

const mutationKey = ['clearCart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCart>>, void> = () => {


          return  clearCart(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCartMutationResult = NonNullable<Awaited<ReturnType<typeof clearCart>>>

    export type ClearCartMutationError = ErrorType<unknown>

    /**
 * @summary Clear the cart
 */
export const useClearCart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCart>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearCartMutationOptions(options), queryClient);
    }

export const getAddCartItemUrl = () => {




  return `/api/cart/items`
}

/**
 * @summary Add item to cart
 */
export const addCartItem = async (cartItemInput: CartItemInput, options?: RequestInit): Promise<Cart> => {

  return customFetch<Cart>(getAddCartItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cartItemInput)
  }
);}




export const getAddCartItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,{data: BodyType<CartItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,{data: BodyType<CartItemInput>}, TContext> => {

const mutationKey = ['addCartItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCartItem>>, {data: BodyType<CartItemInput>}> = (props) => {
          const {data} = props ?? {};

          return  addCartItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof addCartItem>>>
    export type AddCartItemMutationBody = BodyType<CartItemInput>
    export type AddCartItemMutationError = ErrorType<unknown>

    /**
 * @summary Add item to cart
 */
export const useAddCartItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,{data: BodyType<CartItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCartItem>>,
        TError,
        {data: BodyType<CartItemInput>},
        TContext
      > => {
      return useMutation(getAddCartItemMutationOptions(options), queryClient);
    }

export const getUpdateCartItemUrl = (itemId: number,) => {




  return `/api/cart/items/${itemId}`
}

/**
 * @summary Update cart item quantity
 */
export const updateCartItem = async (itemId: number,
    cartItemUpdate: CartItemUpdate, options?: RequestInit): Promise<Cart> => {

  return customFetch<Cart>(getUpdateCartItemUrl(itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cartItemUpdate)
  }
);}




export const getUpdateCartItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,{itemId: number;data: BodyType<CartItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,{itemId: number;data: BodyType<CartItemUpdate>}, TContext> => {

const mutationKey = ['updateCartItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCartItem>>, {itemId: number;data: BodyType<CartItemUpdate>}> = (props) => {
          const {itemId,data} = props ?? {};

          return  updateCartItem(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateCartItem>>>
    export type UpdateCartItemMutationBody = BodyType<CartItemUpdate>
    export type UpdateCartItemMutationError = ErrorType<unknown>

    /**
 * @summary Update cart item quantity
 */
export const useUpdateCartItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,{itemId: number;data: BodyType<CartItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCartItem>>,
        TError,
        {itemId: number;data: BodyType<CartItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCartItemMutationOptions(options), queryClient);
    }

export const getRemoveCartItemUrl = (itemId: number,) => {




  return `/api/cart/items/${itemId}`
}

/**
 * @summary Remove item from cart
 */
export const removeCartItem = async (itemId: number, options?: RequestInit): Promise<Cart> => {

  return customFetch<Cart>(getRemoveCartItemUrl(itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveCartItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,{itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,{itemId: number}, TContext> => {

const mutationKey = ['removeCartItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCartItem>>, {itemId: number}> = (props) => {
          const {itemId} = props ?? {};

          return  removeCartItem(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof removeCartItem>>>

    export type RemoveCartItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove item from cart
 */
export const useRemoveCartItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,{itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCartItem>>,
        TError,
        {itemId: number},
        TContext
      > => {
      return useMutation(getRemoveCartItemMutationOptions(options), queryClient);
    }

export const getListOrdersUrl = () => {




  return `/api/orders`
}

/**
 * @summary List current user's orders
 */
export const listOrders = async ( options?: RequestInit): Promise<Order[]> => {

  return customFetch<Order[]>(getListOrdersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrdersQueryKey = () => {
    return [
    `/api/orders`
    ] as const;
    }


export const getListOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrdersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({ signal }) => listOrders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrders>>>
export type ListOrdersQueryError = ErrorType<unknown>


export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrders>>,
          TError,
          Awaited<ReturnType<typeof listOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrders>>,
          TError,
          Awaited<ReturnType<typeof listOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List current user's orders
 */

export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrdersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOrderUrl = () => {




  return `/api/orders`
}

/**
 * @summary Place an order (checkout)
 */
export const createOrder = async (orderInput: OrderInput, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getCreateOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderInput)
  }
);}




export const getCreateOrderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext> => {

const mutationKey = ['createOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrder>>, {data: BodyType<OrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createOrder>>>
    export type CreateOrderMutationBody = BodyType<OrderInput>
    export type CreateOrderMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Place an order (checkout)
 */
export const useCreateOrder = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrder>>,
        TError,
        {data: BodyType<OrderInput>},
        TContext
      > => {
      return useMutation(getCreateOrderMutationOptions(options), queryClient);
    }

export const getGetOrderUrl = (id: number,) => {




  return `/api/orders/${id}`
}

/**
 * @summary Get a single order
 */
export const getOrder = async (id: number, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getGetOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderQueryKey = (id: number,) => {
    return [
    `/api/orders/${id}`
    ] as const;
    }


export const getGetOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({ signal }) => getOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOrder>>>
export type GetOrderQueryError = ErrorType<ErrorResponse>


export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single order
 */

export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrderUrl = (id: number,) => {




  return `/api/orders/${id}`
}

/**
 * @summary Update an order (e.g. link/unlink a campaign)
 */
export const updateOrder = async (id: number,
    orderUpdateInput: OrderUpdateInput, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getUpdateOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderUpdateInput)
  }
);}




export const getUpdateOrderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdateInput>}, TContext> => {

const mutationKey = ['updateOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrder>>, {id: number;data: BodyType<OrderUpdateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrder>>>
    export type UpdateOrderMutationBody = BodyType<OrderUpdateInput>
    export type UpdateOrderMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update an order (e.g. link/unlink a campaign)
 */
export const useUpdateOrder = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrder>>,
        TError,
        {id: number;data: BodyType<OrderUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdateOrderMutationOptions(options), queryClient);
    }

export const getGetOrderSummaryUrl = () => {




  return `/api/orders/summary`
}

/**
 * @summary Get order stats summary for the current user
 */
export const getOrderSummary = async ( options?: RequestInit): Promise<OrderSummary> => {

  return customFetch<OrderSummary>(getGetOrderSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderSummaryQueryKey = () => {
    return [
    `/api/orders/summary`
    ] as const;
    }


export const getGetOrderSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getOrderSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderSummary>>> = ({ signal }) => getOrderSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderSummary>>>
export type GetOrderSummaryQueryError = ErrorType<unknown>


export function useGetOrderSummary<TData = Awaited<ReturnType<typeof getOrderSummary>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderSummary>>,
          TError,
          Awaited<ReturnType<typeof getOrderSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderSummary<TData = Awaited<ReturnType<typeof getOrderSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderSummary>>,
          TError,
          Awaited<ReturnType<typeof getOrderSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderSummary<TData = Awaited<ReturnType<typeof getOrderSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get order stats summary for the current user
 */

export function useGetOrderSummary<TData = Awaited<ReturnType<typeof getOrderSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitContactUrl = () => {




  return `/api/contact`
}

/**
 * @summary Submit a contact inquiry
 */
export const submitContact = async (contactInput: ContactInput, options?: RequestInit): Promise<ContactConfirmation> => {

  return customFetch<ContactConfirmation>(getSubmitContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactInput)
  }
);}




export const getSubmitContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext> => {

const mutationKey = ['submitContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContact>>, {data: BodyType<ContactInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactMutationResult = NonNullable<Awaited<ReturnType<typeof submitContact>>>
    export type SubmitContactMutationBody = BodyType<ContactInput>
    export type SubmitContactMutationError = ErrorType<unknown>

    /**
 * @summary Submit a contact inquiry
 */
export const useSubmitContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitContact>>,
        TError,
        {data: BodyType<ContactInput>},
        TContext
      > => {
      return useMutation(getSubmitContactMutationOptions(options), queryClient);
    }

export const getRequestQuoteUrl = () => {




  return `/api/quote`
}

/**
 * @summary Request a custom quote
 */
export const requestQuote = async (quoteInput: QuoteInput, options?: RequestInit): Promise<ContactConfirmation> => {

  return customFetch<ContactConfirmation>(getRequestQuoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quoteInput)
  }
);}




export const getRequestQuoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestQuote>>, TError,{data: BodyType<QuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestQuote>>, TError,{data: BodyType<QuoteInput>}, TContext> => {

const mutationKey = ['requestQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestQuote>>, {data: BodyType<QuoteInput>}> = (props) => {
          const {data} = props ?? {};

          return  requestQuote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof requestQuote>>>
    export type RequestQuoteMutationBody = BodyType<QuoteInput>
    export type RequestQuoteMutationError = ErrorType<unknown>

    /**
 * @summary Request a custom quote
 */
export const useRequestQuote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestQuote>>, TError,{data: BodyType<QuoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestQuote>>,
        TError,
        {data: BodyType<QuoteInput>},
        TContext
      > => {
      return useMutation(getRequestQuoteMutationOptions(options), queryClient);
    }

export const getValidateCouponUrl = (code: string,) => {




  return `/api/public/coupons/validate/${code}`
}

/**
 * @summary Validate a coupon code (public)
 */
export const validateCoupon = async (code: string, options?: RequestInit): Promise<CouponValidationResult> => {

  return customFetch<CouponValidationResult>(getValidateCouponUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getValidateCouponQueryKey = (code: string,) => {
    return [
    `/api/public/coupons/validate/${code}`
    ] as const;
    }


export const getValidateCouponQueryOptions = <TData = Awaited<ReturnType<typeof validateCoupon>>, TError = ErrorType<unknown>>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateCouponQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateCoupon>>> = ({ signal }) => validateCoupon(code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ValidateCouponQueryResult = NonNullable<Awaited<ReturnType<typeof validateCoupon>>>
export type ValidateCouponQueryError = ErrorType<unknown>


export function useValidateCoupon<TData = Awaited<ReturnType<typeof validateCoupon>>, TError = ErrorType<unknown>>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateCoupon>>,
          TError,
          Awaited<ReturnType<typeof validateCoupon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateCoupon<TData = Awaited<ReturnType<typeof validateCoupon>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateCoupon>>,
          TError,
          Awaited<ReturnType<typeof validateCoupon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateCoupon<TData = Awaited<ReturnType<typeof validateCoupon>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Validate a coupon code (public)
 */

export function useValidateCoupon<TData = Awaited<ReturnType<typeof validateCoupon>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCoupon>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateCouponQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRedeemCouponUrl = () => {




  return `/api/public/coupons/redeem`
}

/**
 * @summary Record coupon use (public)
 */
export const redeemCoupon = async (redeemCouponRequest: RedeemCouponRequest, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getRedeemCouponUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(redeemCouponRequest)
  }
);}




export const getRedeemCouponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{data: BodyType<RedeemCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{data: BodyType<RedeemCouponRequest>}, TContext> => {

const mutationKey = ['redeemCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemCoupon>>, {data: BodyType<RedeemCouponRequest>}> = (props) => {
          const {data} = props ?? {};

          return  redeemCoupon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemCouponMutationResult = NonNullable<Awaited<ReturnType<typeof redeemCoupon>>>
    export type RedeemCouponMutationBody = BodyType<RedeemCouponRequest>
    export type RedeemCouponMutationError = ErrorType<unknown>

    /**
 * @summary Record coupon use (public)
 */
export const useRedeemCoupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemCoupon>>, TError,{data: BodyType<RedeemCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemCoupon>>,
        TError,
        {data: BodyType<RedeemCouponRequest>},
        TContext
      > => {
      return useMutation(getRedeemCouponMutationOptions(options), queryClient);
    }

export const getListCouponsUrl = () => {




  return `/api/admin/coupons`
}

/**
 * @summary List all coupons (admin)
 */
export const listCoupons = async ( options?: RequestInit): Promise<Coupon[]> => {

  return customFetch<Coupon[]>(getListCouponsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCouponsQueryKey = () => {
    return [
    `/api/admin/coupons`
    ] as const;
    }


export const getListCouponsQueryOptions = <TData = Awaited<ReturnType<typeof listCoupons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCouponsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoupons>>> = ({ signal }) => listCoupons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof listCoupons>>>
export type ListCouponsQueryError = ErrorType<unknown>


export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all coupons (admin)
 */

export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCouponsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCouponUrl = () => {




  return `/api/admin/coupons`
}

/**
 * @summary Create a coupon (admin)
 */
export const createCoupon = async (createCouponRequest: CreateCouponRequest, options?: RequestInit): Promise<Coupon> => {

  return customFetch<Coupon>(getCreateCouponUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCouponRequest)
  }
);}




export const getCreateCouponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: BodyType<CreateCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: BodyType<CreateCouponRequest>}, TContext> => {

const mutationKey = ['createCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCoupon>>, {data: BodyType<CreateCouponRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCoupon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof createCoupon>>>
    export type CreateCouponMutationBody = BodyType<CreateCouponRequest>
    export type CreateCouponMutationError = ErrorType<unknown>

    /**
 * @summary Create a coupon (admin)
 */
export const useCreateCoupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: BodyType<CreateCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCoupon>>,
        TError,
        {data: BodyType<CreateCouponRequest>},
        TContext
      > => {
      return useMutation(getCreateCouponMutationOptions(options), queryClient);
    }

export const getUpdateCouponUrl = (id: string,) => {




  return `/api/admin/coupons/${id}`
}

/**
 * @summary Update a coupon (admin)
 */
export const updateCoupon = async (id: string,
    updateCouponRequest: UpdateCouponRequest, options?: RequestInit): Promise<Coupon> => {

  return customFetch<Coupon>(getUpdateCouponUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCouponRequest)
  }
);}




export const getUpdateCouponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: string;data: BodyType<UpdateCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: string;data: BodyType<UpdateCouponRequest>}, TContext> => {

const mutationKey = ['updateCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCoupon>>, {id: string;data: BodyType<UpdateCouponRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCoupon(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoupon>>>
    export type UpdateCouponMutationBody = BodyType<UpdateCouponRequest>
    export type UpdateCouponMutationError = ErrorType<unknown>

    /**
 * @summary Update a coupon (admin)
 */
export const useUpdateCoupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: string;data: BodyType<UpdateCouponRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCoupon>>,
        TError,
        {id: string;data: BodyType<UpdateCouponRequest>},
        TContext
      > => {
      return useMutation(getUpdateCouponMutationOptions(options), queryClient);
    }

export const getDeleteCouponUrl = (id: string,) => {




  return `/api/admin/coupons/${id}`
}

/**
 * @summary Deactivate a coupon (admin)
 */
export const deleteCoupon = async (id: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteCouponUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCouponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoupon>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCoupon(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCouponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoupon>>>

    export type DeleteCouponMutationError = ErrorType<unknown>

    /**
 * @summary Deactivate a coupon (admin)
 */
export const useDeleteCoupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoupon>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCouponMutationOptions(options), queryClient);
    }

export const getListGaPropertiesUrl = () => {




  return `/api/integrations/google-analytics/properties`
}

/**
 * @summary List all GA4 properties accessible to the connected Google account
 */
export const listGaProperties = async ( options?: RequestInit): Promise<GaPropertiesResponse> => {

  return customFetch<GaPropertiesResponse>(getListGaPropertiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGaPropertiesQueryKey = () => {
    return [
    `/api/integrations/google-analytics/properties`
    ] as const;
    }


export const getListGaPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof listGaProperties>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGaPropertiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGaProperties>>> = ({ signal }) => listGaProperties({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGaPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof listGaProperties>>>
export type ListGaPropertiesQueryError = ErrorType<void>


export function useListGaProperties<TData = Awaited<ReturnType<typeof listGaProperties>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGaProperties>>,
          TError,
          Awaited<ReturnType<typeof listGaProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGaProperties<TData = Awaited<ReturnType<typeof listGaProperties>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGaProperties>>,
          TError,
          Awaited<ReturnType<typeof listGaProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGaProperties<TData = Awaited<ReturnType<typeof listGaProperties>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all GA4 properties accessible to the connected Google account
 */

export function useListGaProperties<TData = Awaited<ReturnType<typeof listGaProperties>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGaProperties>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGaPropertiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetGaPropertyUrl = () => {




  return `/api/integrations/google-analytics/property`
}

/**
 * @summary Save the selected GA4 property for the current user
 */
export const setGaProperty = async (gaPropertySelection: GaPropertySelection, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getSetGaPropertyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(gaPropertySelection)
  }
);}




export const getSetGaPropertyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGaProperty>>, TError,{data: BodyType<GaPropertySelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setGaProperty>>, TError,{data: BodyType<GaPropertySelection>}, TContext> => {

const mutationKey = ['setGaProperty'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setGaProperty>>, {data: BodyType<GaPropertySelection>}> = (props) => {
          const {data} = props ?? {};

          return  setGaProperty(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetGaPropertyMutationResult = NonNullable<Awaited<ReturnType<typeof setGaProperty>>>
    export type SetGaPropertyMutationBody = BodyType<GaPropertySelection>
    export type SetGaPropertyMutationError = ErrorType<void>

    /**
 * @summary Save the selected GA4 property for the current user
 */
export const useSetGaProperty = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGaProperty>>, TError,{data: BodyType<GaPropertySelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setGaProperty>>,
        TError,
        {data: BodyType<GaPropertySelection>},
        TContext
      > => {
      return useMutation(getSetGaPropertyMutationOptions(options), queryClient);
    }

export const getListScSitesUrl = () => {




  return `/api/integrations/search-console/sites`
}

/**
 * @summary List all Search Console sites accessible to the connected Google account
 */
export const listScSites = async ( options?: RequestInit): Promise<ScSitesResponse> => {

  return customFetch<ScSitesResponse>(getListScSitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScSitesQueryKey = () => {
    return [
    `/api/integrations/search-console/sites`
    ] as const;
    }


export const getListScSitesQueryOptions = <TData = Awaited<ReturnType<typeof listScSites>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScSitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScSites>>> = ({ signal }) => listScSites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScSitesQueryResult = NonNullable<Awaited<ReturnType<typeof listScSites>>>
export type ListScSitesQueryError = ErrorType<void>


export function useListScSites<TData = Awaited<ReturnType<typeof listScSites>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScSites>>,
          TError,
          Awaited<ReturnType<typeof listScSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScSites<TData = Awaited<ReturnType<typeof listScSites>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScSites>>,
          TError,
          Awaited<ReturnType<typeof listScSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScSites<TData = Awaited<ReturnType<typeof listScSites>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all Search Console sites accessible to the connected Google account
 */

export function useListScSites<TData = Awaited<ReturnType<typeof listScSites>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScSitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetScSiteUrl = () => {




  return `/api/integrations/search-console/site`
}

/**
 * @summary Save the selected Search Console site for the current user
 */
export const setScSite = async (scSiteSelection: ScSiteSelection, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getSetScSiteUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scSiteSelection)
  }
);}




export const getSetScSiteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScSite>>, TError,{data: BodyType<ScSiteSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setScSite>>, TError,{data: BodyType<ScSiteSelection>}, TContext> => {

const mutationKey = ['setScSite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setScSite>>, {data: BodyType<ScSiteSelection>}> = (props) => {
          const {data} = props ?? {};

          return  setScSite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetScSiteMutationResult = NonNullable<Awaited<ReturnType<typeof setScSite>>>
    export type SetScSiteMutationBody = BodyType<ScSiteSelection>
    export type SetScSiteMutationError = ErrorType<void>

    /**
 * @summary Save the selected Search Console site for the current user
 */
export const useSetScSite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScSite>>, TError,{data: BodyType<ScSiteSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setScSite>>,
        TError,
        {data: BodyType<ScSiteSelection>},
        TContext
      > => {
      return useMutation(getSetScSiteMutationOptions(options), queryClient);
    }

export const getGetGaIntegrationStatusUrl = () => {




  return `/api/integrations/google-analytics/status`
}

/**
 * @summary Get Google Analytics integration status for the current user
 */
export const getGaIntegrationStatus = async ( options?: RequestInit): Promise<GaIntegrationStatus> => {

  return customFetch<GaIntegrationStatus>(getGetGaIntegrationStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGaIntegrationStatusQueryKey = () => {
    return [
    `/api/integrations/google-analytics/status`
    ] as const;
    }


export const getGetGaIntegrationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGaIntegrationStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGaIntegrationStatus>>> = ({ signal }) => getGaIntegrationStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGaIntegrationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGaIntegrationStatus>>>
export type GetGaIntegrationStatusQueryError = ErrorType<void>


export function useGetGaIntegrationStatus<TData = Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGaIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getGaIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGaIntegrationStatus<TData = Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGaIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getGaIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGaIntegrationStatus<TData = Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Google Analytics integration status for the current user
 */

export function useGetGaIntegrationStatus<TData = Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGaIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGaIntegrationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetScIntegrationStatusUrl = () => {




  return `/api/integrations/search-console/status`
}

/**
 * @summary Get Google Search Console integration status for the current user
 */
export const getScIntegrationStatus = async ( options?: RequestInit): Promise<ScIntegrationStatus> => {

  return customFetch<ScIntegrationStatus>(getGetScIntegrationStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScIntegrationStatusQueryKey = () => {
    return [
    `/api/integrations/search-console/status`
    ] as const;
    }


export const getGetScIntegrationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getScIntegrationStatus>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScIntegrationStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScIntegrationStatus>>> = ({ signal }) => getScIntegrationStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScIntegrationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getScIntegrationStatus>>>
export type GetScIntegrationStatusQueryError = ErrorType<void>


export function useGetScIntegrationStatus<TData = Awaited<ReturnType<typeof getScIntegrationStatus>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getScIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScIntegrationStatus<TData = Awaited<ReturnType<typeof getScIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getScIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScIntegrationStatus<TData = Awaited<ReturnType<typeof getScIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Google Search Console integration status for the current user
 */

export function useGetScIntegrationStatus<TData = Awaited<ReturnType<typeof getScIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScIntegrationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDisconnectScIntegrationUrl = () => {




  return `/api/integrations/search-console/disconnect`
}

/**
 * @summary Revoke and delete the Search Console integration
 */
export const disconnectScIntegration = async ( options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDisconnectScIntegrationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectScIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectScIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectScIntegration>>, TError,void, TContext> => {

const mutationKey = ['disconnectScIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectScIntegration>>, void> = () => {


          return  disconnectScIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectScIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectScIntegration>>>

    export type DisconnectScIntegrationMutationError = ErrorType<void>

    /**
 * @summary Revoke and delete the Search Console integration
 */
export const useDisconnectScIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectScIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectScIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectScIntegrationMutationOptions(options), queryClient);
    }

export const getDisconnectGaIntegrationUrl = () => {




  return `/api/integrations/google-analytics/disconnect`
}

/**
 * @summary Revoke and delete the Google Analytics integration
 */
export const disconnectGaIntegration = async ( options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDisconnectGaIntegrationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectGaIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGaIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectGaIntegration>>, TError,void, TContext> => {

const mutationKey = ['disconnectGaIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectGaIntegration>>, void> = () => {


          return  disconnectGaIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectGaIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectGaIntegration>>>

    export type DisconnectGaIntegrationMutationError = ErrorType<void>

    /**
 * @summary Revoke and delete the Google Analytics integration
 */
export const useDisconnectGaIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGaIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectGaIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectGaIntegrationMutationOptions(options), queryClient);
    }

export const getGetAdsIntegrationStatusUrl = () => {




  return `/api/integrations/google-ads/status`
}

/**
 * @summary Get Google Ads integration status for the current user
 */
export const getAdsIntegrationStatus = async ( options?: RequestInit): Promise<AdsIntegrationStatus> => {

  return customFetch<AdsIntegrationStatus>(getGetAdsIntegrationStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdsIntegrationStatusQueryKey = () => {
    return [
    `/api/integrations/google-ads/status`
    ] as const;
    }


export const getGetAdsIntegrationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdsIntegrationStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdsIntegrationStatus>>> = ({ signal }) => getAdsIntegrationStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdsIntegrationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAdsIntegrationStatus>>>
export type GetAdsIntegrationStatusQueryError = ErrorType<void>


export function useGetAdsIntegrationStatus<TData = Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdsIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdsIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdsIntegrationStatus<TData = Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdsIntegrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdsIntegrationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdsIntegrationStatus<TData = Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Google Ads integration status for the current user
 */

export function useGetAdsIntegrationStatus<TData = Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsIntegrationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdsIntegrationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdsCustomersUrl = () => {




  return `/api/integrations/google-ads/customers`
}

/**
 * @summary List accessible Google Ads customer accounts
 */
export const listAdsCustomers = async ( options?: RequestInit): Promise<AdsCustomersResponse> => {

  return customFetch<AdsCustomersResponse>(getListAdsCustomersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdsCustomersQueryKey = () => {
    return [
    `/api/integrations/google-ads/customers`
    ] as const;
    }


export const getListAdsCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listAdsCustomers>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdsCustomersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdsCustomers>>> = ({ signal }) => listAdsCustomers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdsCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdsCustomers>>>
export type ListAdsCustomersQueryError = ErrorType<void>


export function useListAdsCustomers<TData = Awaited<ReturnType<typeof listAdsCustomers>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdsCustomers>>,
          TError,
          Awaited<ReturnType<typeof listAdsCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdsCustomers<TData = Awaited<ReturnType<typeof listAdsCustomers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdsCustomers>>,
          TError,
          Awaited<ReturnType<typeof listAdsCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdsCustomers<TData = Awaited<ReturnType<typeof listAdsCustomers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List accessible Google Ads customer accounts
 */

export function useListAdsCustomers<TData = Awaited<ReturnType<typeof listAdsCustomers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdsCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdsCustomersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetAdsCustomerUrl = () => {




  return `/api/integrations/google-ads/customer`
}

/**
 * @summary Save the selected Google Ads customer account
 */
export const setAdsCustomer = async (adsCustomerSelection: AdsCustomerSelection, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getSetAdsCustomerUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adsCustomerSelection)
  }
);}




export const getSetAdsCustomerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdsCustomer>>, TError,{data: BodyType<AdsCustomerSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdsCustomer>>, TError,{data: BodyType<AdsCustomerSelection>}, TContext> => {

const mutationKey = ['setAdsCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdsCustomer>>, {data: BodyType<AdsCustomerSelection>}> = (props) => {
          const {data} = props ?? {};

          return  setAdsCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdsCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof setAdsCustomer>>>
    export type SetAdsCustomerMutationBody = BodyType<AdsCustomerSelection>
    export type SetAdsCustomerMutationError = ErrorType<void>

    /**
 * @summary Save the selected Google Ads customer account
 */
export const useSetAdsCustomer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdsCustomer>>, TError,{data: BodyType<AdsCustomerSelection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAdsCustomer>>,
        TError,
        {data: BodyType<AdsCustomerSelection>},
        TContext
      > => {
      return useMutation(getSetAdsCustomerMutationOptions(options), queryClient);
    }

export const getDisconnectAdsIntegrationUrl = () => {




  return `/api/integrations/google-ads/disconnect`
}

/**
 * @summary Revoke and delete the Google Ads integration
 */
export const disconnectAdsIntegration = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDisconnectAdsIntegrationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectAdsIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdsIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectAdsIntegration>>, TError,void, TContext> => {

const mutationKey = ['disconnectAdsIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectAdsIntegration>>, void> = () => {


          return  disconnectAdsIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectAdsIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectAdsIntegration>>>

    export type DisconnectAdsIntegrationMutationError = ErrorType<void>

    /**
 * @summary Revoke and delete the Google Ads integration
 */
export const useDisconnectAdsIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdsIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectAdsIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectAdsIntegrationMutationOptions(options), queryClient);
    }

export const getGetReportsOverviewUrl = (params?: GetReportsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/overview?${stringifiedParams}` : `/api/reports/overview`
}

/**
 * @summary Get normalized GA4 + Search Console overview data
 */
export const getReportsOverview = async (params?: GetReportsOverviewParams, options?: RequestInit): Promise<ReportsOverview> => {

  return customFetch<ReportsOverview>(getGetReportsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsOverviewQueryKey = (params?: GetReportsOverviewParams,) => {
    return [
    `/api/reports/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getReportsOverview>>, TError = ErrorType<void>>(params?: GetReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsOverview>>> = ({ signal }) => getReportsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsOverview>>>
export type GetReportsOverviewQueryError = ErrorType<void>


export function useGetReportsOverview<TData = Awaited<ReturnType<typeof getReportsOverview>>, TError = ErrorType<void>>(
 params: undefined |  GetReportsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsOverview<TData = Awaited<ReturnType<typeof getReportsOverview>>, TError = ErrorType<void>>(
 params?: GetReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsOverview<TData = Awaited<ReturnType<typeof getReportsOverview>>, TError = ErrorType<void>>(
 params?: GetReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get normalized GA4 + Search Console overview data
 */

export function useGetReportsOverview<TData = Awaited<ReturnType<typeof getReportsOverview>>, TError = ErrorType<void>>(
 params?: GetReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReportsTrafficSourcesUrl = (params: GetReportsTrafficSourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/traffic-sources?${stringifiedParams}` : `/api/reports/traffic-sources`
}

/**
 * @summary Get a tenant-scoped page of aggregated traffic-source results
 */
export const getReportsTrafficSources = async (params: GetReportsTrafficSourcesParams, options?: RequestInit): Promise<ReportsTrafficSourcesResponse> => {

  return customFetch<ReportsTrafficSourcesResponse>(getGetReportsTrafficSourcesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsTrafficSourcesQueryKey = (params?: GetReportsTrafficSourcesParams,) => {
    return [
    `/api/reports/traffic-sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportsTrafficSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getReportsTrafficSources>>, TError = ErrorType<void>>(params: GetReportsTrafficSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsTrafficSourcesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTrafficSources>>> = ({ signal }) => getReportsTrafficSources(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsTrafficSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsTrafficSources>>>
export type GetReportsTrafficSourcesQueryError = ErrorType<void>


export function useGetReportsTrafficSources<TData = Awaited<ReturnType<typeof getReportsTrafficSources>>, TError = ErrorType<void>>(
 params: GetReportsTrafficSourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTrafficSources>>,
          TError,
          Awaited<ReturnType<typeof getReportsTrafficSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsTrafficSources<TData = Awaited<ReturnType<typeof getReportsTrafficSources>>, TError = ErrorType<void>>(
 params: GetReportsTrafficSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTrafficSources>>,
          TError,
          Awaited<ReturnType<typeof getReportsTrafficSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsTrafficSources<TData = Awaited<ReturnType<typeof getReportsTrafficSources>>, TError = ErrorType<void>>(
 params: GetReportsTrafficSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a tenant-scoped page of aggregated traffic-source results
 */

export function useGetReportsTrafficSources<TData = Awaited<ReturnType<typeof getReportsTrafficSources>>, TError = ErrorType<void>>(
 params: GetReportsTrafficSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTrafficSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsTrafficSourcesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReportsSearchQueriesUrl = (params: GetReportsSearchQueriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeQueries[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/search-queries?${stringifiedParams}` : `/api/reports/search-queries`
}

/**
 * @summary Get a tenant-scoped page of aggregated Search Console queries
 */
export const getReportsSearchQueries = async (params: GetReportsSearchQueriesParams, options?: RequestInit): Promise<ReportsSearchQueriesResponse> => {

  return customFetch<ReportsSearchQueriesResponse>(getGetReportsSearchQueriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsSearchQueriesQueryKey = (params?: GetReportsSearchQueriesParams,) => {
    return [
    `/api/reports/search-queries`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportsSearchQueriesQueryOptions = <TData = Awaited<ReturnType<typeof getReportsSearchQueries>>, TError = ErrorType<void>>(params: GetReportsSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsSearchQueriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSearchQueries>>> = ({ signal }) => getReportsSearchQueries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsSearchQueriesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsSearchQueries>>>
export type GetReportsSearchQueriesQueryError = ErrorType<void>


export function useGetReportsSearchQueries<TData = Awaited<ReturnType<typeof getReportsSearchQueries>>, TError = ErrorType<void>>(
 params: GetReportsSearchQueriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSearchQueries>>,
          TError,
          Awaited<ReturnType<typeof getReportsSearchQueries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsSearchQueries<TData = Awaited<ReturnType<typeof getReportsSearchQueries>>, TError = ErrorType<void>>(
 params: GetReportsSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSearchQueries>>,
          TError,
          Awaited<ReturnType<typeof getReportsSearchQueries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsSearchQueries<TData = Awaited<ReturnType<typeof getReportsSearchQueries>>, TError = ErrorType<void>>(
 params: GetReportsSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a tenant-scoped page of aggregated Search Console queries
 */

export function useGetReportsSearchQueries<TData = Awaited<ReturnType<typeof getReportsSearchQueries>>, TError = ErrorType<void>>(
 params: GetReportsSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsSearchQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReportsDailySeriesUrl = (params: GetReportsDailySeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sources","queries"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/daily-series?${stringifiedParams}` : `/api/reports/daily-series`
}

/**
 * @summary Get daily time-series data for specific traffic sources and/or search queries
 */
export const getReportsDailySeries = async (params: GetReportsDailySeriesParams, options?: RequestInit): Promise<DailySeriesResponse> => {

  return customFetch<DailySeriesResponse>(getGetReportsDailySeriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsDailySeriesQueryKey = (params?: GetReportsDailySeriesParams,) => {
    return [
    `/api/reports/daily-series`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportsDailySeriesQueryOptions = <TData = Awaited<ReturnType<typeof getReportsDailySeries>>, TError = ErrorType<void>>(params: GetReportsDailySeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsDailySeriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsDailySeries>>> = ({ signal }) => getReportsDailySeries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsDailySeriesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsDailySeries>>>
export type GetReportsDailySeriesQueryError = ErrorType<void>


export function useGetReportsDailySeries<TData = Awaited<ReturnType<typeof getReportsDailySeries>>, TError = ErrorType<void>>(
 params: GetReportsDailySeriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsDailySeries>>,
          TError,
          Awaited<ReturnType<typeof getReportsDailySeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsDailySeries<TData = Awaited<ReturnType<typeof getReportsDailySeries>>, TError = ErrorType<void>>(
 params: GetReportsDailySeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsDailySeries>>,
          TError,
          Awaited<ReturnType<typeof getReportsDailySeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsDailySeries<TData = Awaited<ReturnType<typeof getReportsDailySeries>>, TError = ErrorType<void>>(
 params: GetReportsDailySeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get daily time-series data for specific traffic sources and/or search queries
 */

export function useGetReportsDailySeries<TData = Awaited<ReturnType<typeof getReportsDailySeries>>, TError = ErrorType<void>>(
 params: GetReportsDailySeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsDailySeries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsDailySeriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignAttributionUrl = (id: number,) => {




  return `/api/reports/campaigns/${id}/attribution`
}

/**
 * @summary Get GA4 attribution data for a specific campaign
 */
export const getCampaignAttribution = async (id: number, options?: RequestInit): Promise<CampaignAttribution> => {

  return customFetch<CampaignAttribution>(getGetCampaignAttributionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignAttributionQueryKey = (id: number,) => {
    return [
    `/api/reports/campaigns/${id}/attribution`
    ] as const;
    }


export const getGetCampaignAttributionQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignAttribution>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignAttributionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignAttribution>>> = ({ signal }) => getCampaignAttribution(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignAttributionQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignAttribution>>>
export type GetCampaignAttributionQueryError = ErrorType<void>


export function useGetCampaignAttribution<TData = Awaited<ReturnType<typeof getCampaignAttribution>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignAttribution>>,
          TError,
          Awaited<ReturnType<typeof getCampaignAttribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignAttribution<TData = Awaited<ReturnType<typeof getCampaignAttribution>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignAttribution>>,
          TError,
          Awaited<ReturnType<typeof getCampaignAttribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignAttribution<TData = Awaited<ReturnType<typeof getCampaignAttribution>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get GA4 attribution data for a specific campaign
 */

export function useGetCampaignAttribution<TData = Awaited<ReturnType<typeof getCampaignAttribution>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignAttributionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUnifiedAttributionUrl = (params?: GetUnifiedAttributionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/unified-attribution?${stringifiedParams}` : `/api/reports/unified-attribution`
}

/**
 * @summary Unified cross-channel causal attribution — fetches all channel data in one request and calls the unified causal model.

 */
export const getUnifiedAttribution = async (params?: GetUnifiedAttributionParams, options?: RequestInit): Promise<UnifiedAttributionResponse> => {

  return customFetch<UnifiedAttributionResponse>(getGetUnifiedAttributionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnifiedAttributionQueryKey = (params?: GetUnifiedAttributionParams,) => {
    return [
    `/api/reports/unified-attribution`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUnifiedAttributionQueryOptions = <TData = Awaited<ReturnType<typeof getUnifiedAttribution>>, TError = ErrorType<void>>(params?: GetUnifiedAttributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnifiedAttributionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnifiedAttribution>>> = ({ signal }) => getUnifiedAttribution(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnifiedAttributionQueryResult = NonNullable<Awaited<ReturnType<typeof getUnifiedAttribution>>>
export type GetUnifiedAttributionQueryError = ErrorType<void>


export function useGetUnifiedAttribution<TData = Awaited<ReturnType<typeof getUnifiedAttribution>>, TError = ErrorType<void>>(
 params: undefined |  GetUnifiedAttributionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnifiedAttribution>>,
          TError,
          Awaited<ReturnType<typeof getUnifiedAttribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnifiedAttribution<TData = Awaited<ReturnType<typeof getUnifiedAttribution>>, TError = ErrorType<void>>(
 params?: GetUnifiedAttributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnifiedAttribution>>,
          TError,
          Awaited<ReturnType<typeof getUnifiedAttribution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnifiedAttribution<TData = Awaited<ReturnType<typeof getUnifiedAttribution>>, TError = ErrorType<void>>(
 params?: GetUnifiedAttributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Unified cross-channel causal attribution — fetches all channel data in one request and calls the unified causal model.

 */

export function useGetUnifiedAttribution<TData = Awaited<ReturnType<typeof getUnifiedAttribution>>, TError = ErrorType<void>>(
 params?: GetUnifiedAttributionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnifiedAttribution>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnifiedAttributionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTriggerAnalyticsSyncUrl = () => {




  return `/api/reports/sync`
}

/**
 * @summary Manually trigger analytics sync for the current user
 */
export const triggerAnalyticsSync = async ( options?: RequestInit): Promise<SyncResult> => {

  return customFetch<SyncResult>(getTriggerAnalyticsSyncUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTriggerAnalyticsSyncMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerAnalyticsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerAnalyticsSync>>, TError,void, TContext> => {

const mutationKey = ['triggerAnalyticsSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerAnalyticsSync>>, void> = () => {


          return  triggerAnalyticsSync(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerAnalyticsSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerAnalyticsSync>>>

    export type TriggerAnalyticsSyncMutationError = ErrorType<void>

    /**
 * @summary Manually trigger analytics sync for the current user
 */
export const useTriggerAnalyticsSync = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerAnalyticsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerAnalyticsSync>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTriggerAnalyticsSyncMutationOptions(options), queryClient);
    }

export const getGetCampaignAttributionAnalysisUrl = (id: number,) => {




  return `/api/campaigns/${id}/attribution-analysis`
}

/**
 * @summary Synthetic-control attribution analysis for a campaign
 */
export const getCampaignAttributionAnalysis = async (id: number, options?: RequestInit): Promise<CampaignAttributionAnalysis> => {

  return customFetch<CampaignAttributionAnalysis>(getGetCampaignAttributionAnalysisUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignAttributionAnalysisQueryKey = (id: number,) => {
    return [
    `/api/campaigns/${id}/attribution-analysis`
    ] as const;
    }


export const getGetCampaignAttributionAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignAttributionAnalysisQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>> = ({ signal }) => getCampaignAttributionAnalysis(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignAttributionAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>>
export type GetCampaignAttributionAnalysisQueryError = ErrorType<void>


export function useGetCampaignAttributionAnalysis<TData = Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignAttributionAnalysis<TData = Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignAttributionAnalysis<TData = Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Synthetic-control attribution analysis for a campaign
 */

export function useGetCampaignAttributionAnalysis<TData = Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignAttributionAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignAttributionAnalysisQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSubscriptionPlansUrl = () => {




  return `/api/subscriptions/plans`
}

/**
 * @summary List available subscription plans with Stripe price IDs
 */
export const getSubscriptionPlans = async ( options?: RequestInit): Promise<SubscriptionPlan[]> => {

  return customFetch<SubscriptionPlan[]>(getGetSubscriptionPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionPlansQueryKey = () => {
    return [
    `/api/subscriptions/plans`
    ] as const;
    }


export const getGetSubscriptionPlansQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionPlans>>> = ({ signal }) => getSubscriptionPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionPlans>>>
export type GetSubscriptionPlansQueryError = ErrorType<unknown>


export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionPlans>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionPlans>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available subscription plans with Stripe price IDs
 */

export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSubscriptionCheckoutUrl = () => {




  return `/api/subscriptions/checkout`
}

/**
 * @summary Create a Stripe Checkout Session for a subscription
 */
export const createSubscriptionCheckout = async (subscriptionCheckoutRequest: SubscriptionCheckoutRequest, options?: RequestInit): Promise<SubscriptionCheckoutResponse> => {

  return customFetch<SubscriptionCheckoutResponse>(getCreateSubscriptionCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscriptionCheckoutRequest)
  }
);}




export const getCreateSubscriptionCheckoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionCheckout>>, TError,{data: BodyType<SubscriptionCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionCheckout>>, TError,{data: BodyType<SubscriptionCheckoutRequest>}, TContext> => {

const mutationKey = ['createSubscriptionCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionCheckout>>, {data: BodyType<SubscriptionCheckoutRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createSubscriptionCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionCheckout>>>
    export type CreateSubscriptionCheckoutMutationBody = BodyType<SubscriptionCheckoutRequest>
    export type CreateSubscriptionCheckoutMutationError = ErrorType<unknown>

    /**
 * @summary Create a Stripe Checkout Session for a subscription
 */
export const useCreateSubscriptionCheckout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionCheckout>>, TError,{data: BodyType<SubscriptionCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionCheckout>>,
        TError,
        {data: BodyType<SubscriptionCheckoutRequest>},
        TContext
      > => {
      return useMutation(getCreateSubscriptionCheckoutMutationOptions(options), queryClient);
    }

export const getCreateSubscriptionPortalUrl = () => {




  return `/api/subscriptions/portal`
}

/**
 * @summary Create a Stripe Billing Portal session
 */
export const createSubscriptionPortal = async ( options?: RequestInit): Promise<SubscriptionPortalResponse> => {

  return customFetch<SubscriptionPortalResponse>(getCreateSubscriptionPortalUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateSubscriptionPortalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionPortal>>, TError,void, TContext> => {

const mutationKey = ['createSubscriptionPortal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionPortal>>, void> = () => {


          return  createSubscriptionPortal(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionPortalMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionPortal>>>

    export type CreateSubscriptionPortalMutationError = ErrorType<unknown>

    /**
 * @summary Create a Stripe Billing Portal session
 */
export const useCreateSubscriptionPortal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionPortal>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateSubscriptionPortalMutationOptions(options), queryClient);
    }

export const getGetSubscriptionCurrentUrl = () => {




  return `/api/subscriptions/current`
}

/**
 * @summary Get current user subscription status
 */
export const getSubscriptionCurrent = async ( options?: RequestInit): Promise<SubscriptionStatus> => {

  return customFetch<SubscriptionStatus>(getGetSubscriptionCurrentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionCurrentQueryKey = () => {
    return [
    `/api/subscriptions/current`
    ] as const;
    }


export const getGetSubscriptionCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionCurrentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionCurrent>>> = ({ signal }) => getSubscriptionCurrent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionCurrent>>>
export type GetSubscriptionCurrentQueryError = ErrorType<unknown>


export function useGetSubscriptionCurrent<TData = Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionCurrent<TData = Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionCurrent<TData = Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user subscription status
 */

export function useGetSubscriptionCurrent<TData = Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionCurrentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSubscriptionInvoicesUrl = () => {




  return `/api/subscriptions/invoices`
}

/**
 * @summary List subscription invoice history with receipt paths
 */
export const listSubscriptionInvoices = async ( options?: RequestInit): Promise<SubscriptionInvoice[]> => {

  return customFetch<SubscriptionInvoice[]>(getListSubscriptionInvoicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubscriptionInvoicesQueryKey = () => {
    return [
    `/api/subscriptions/invoices`
    ] as const;
    }


export const getListSubscriptionInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubscriptionInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubscriptionInvoices>>> = ({ signal }) => listSubscriptionInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSubscriptionInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listSubscriptionInvoices>>>
export type ListSubscriptionInvoicesQueryError = ErrorType<unknown>


export function useListSubscriptionInvoices<TData = Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubscriptionInvoices>>,
          TError,
          Awaited<ReturnType<typeof listSubscriptionInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubscriptionInvoices<TData = Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubscriptionInvoices>>,
          TError,
          Awaited<ReturnType<typeof listSubscriptionInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubscriptionInvoices<TData = Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List subscription invoice history with receipt paths
 */

export function useListSubscriptionInvoices<TData = Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionInvoices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSubscriptionInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePaymentMethodSetupIntentUrl = () => {




  return `/api/payment-methods/setup-intent`
}

/**
 * @summary Create a Stripe SetupIntent to collect and save a card
 */
export const createPaymentMethodSetupIntent = async ( options?: RequestInit): Promise<SetupIntentResponse> => {

  return customFetch<SetupIntentResponse>(getCreatePaymentMethodSetupIntentUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreatePaymentMethodSetupIntentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>, TError,void, TContext> => {

const mutationKey = ['createPaymentMethodSetupIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>, void> = () => {


          return  createPaymentMethodSetupIntent(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentMethodSetupIntentMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>>

    export type CreatePaymentMethodSetupIntentMutationError = ErrorType<void>

    /**
 * @summary Create a Stripe SetupIntent to collect and save a card
 */
export const useCreatePaymentMethodSetupIntent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentMethodSetupIntent>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreatePaymentMethodSetupIntentMutationOptions(options), queryClient);
    }

export const getListPaymentMethodsUrl = () => {




  return `/api/payment-methods`
}

/**
 * @summary List saved payment methods for the authenticated customer
 */
export const listPaymentMethods = async ( options?: RequestInit): Promise<PaymentMethodsResponse> => {

  return customFetch<PaymentMethodsResponse>(getListPaymentMethodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentMethodsQueryKey = () => {
    return [
    `/api/payment-methods`
    ] as const;
    }


export const getListPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethods>>> = ({ signal }) => listPaymentMethods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethods>>>
export type ListPaymentMethodsQueryError = ErrorType<void>


export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved payment methods for the authenticated customer
 */

export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetDefaultPaymentMethodUrl = (id: string,) => {




  return `/api/payment-methods/${id}/set-default`
}

/**
 * @summary Set a saved payment method as the default
 */
export const setDefaultPaymentMethod = async (id: string, options?: RequestInit): Promise<OkResponse> => {

  return customFetch<OkResponse>(getSetDefaultPaymentMethodUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSetDefaultPaymentMethodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,{id: string}, TContext> => {

const mutationKey = ['setDefaultPaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  setDefaultPaymentMethod(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultPaymentMethod>>>

    export type SetDefaultPaymentMethodMutationError = ErrorType<void>

    /**
 * @summary Set a saved payment method as the default
 */
export const useSetDefaultPaymentMethod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultPaymentMethod>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSetDefaultPaymentMethodMutationOptions(options), queryClient);
    }

export const getDeletePaymentMethodUrl = (id: string,) => {




  return `/api/payment-methods/${id}`
}

/**
 * @summary Detach a saved payment method
 */
export const deletePaymentMethod = async (id: string, options?: RequestInit): Promise<OkResponse> => {

  return customFetch<OkResponse>(getDeletePaymentMethodUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePaymentMethodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentMethod>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePaymentMethod(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentMethod>>>

    export type DeletePaymentMethodMutationError = ErrorType<void>

    /**
 * @summary Detach a saved payment method
 */
export const useDeletePaymentMethod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePaymentMethodMutationOptions(options), queryClient);
    }

export const getTriggerSeoCrawlUrl = (clientId: number,) => {




  return `/api/seo/crawl/${clientId}`
}

/**
 * @summary Trigger an on-demand SEO crawl for a tenant
 */
export const triggerSeoCrawl = async (clientId: number, options?: RequestInit): Promise<OkResponse> => {

  return customFetch<OkResponse>(getTriggerSeoCrawlUrl(clientId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTriggerSeoCrawlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSeoCrawl>>, TError,{clientId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerSeoCrawl>>, TError,{clientId: number}, TContext> => {

const mutationKey = ['triggerSeoCrawl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerSeoCrawl>>, {clientId: number}> = (props) => {
          const {clientId} = props ?? {};

          return  triggerSeoCrawl(clientId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerSeoCrawlMutationResult = NonNullable<Awaited<ReturnType<typeof triggerSeoCrawl>>>

    export type TriggerSeoCrawlMutationError = ErrorType<void>

    /**
 * @summary Trigger an on-demand SEO crawl for a tenant
 */
export const useTriggerSeoCrawl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSeoCrawl>>, TError,{clientId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerSeoCrawl>>,
        TError,
        {clientId: number},
        TContext
      > => {
      return useMutation(getTriggerSeoCrawlMutationOptions(options), queryClient);
    }

export const getGetSeoChangesUrl = (params?: GetSeoChangesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/seo/changes?${stringifiedParams}` : `/api/seo/changes`
}

/**
 * @summary List paginated SEO change events for the calling tenant
 */
export const getSeoChanges = async (params?: GetSeoChangesParams, options?: RequestInit): Promise<SeoChangesResponse> => {

  return customFetch<SeoChangesResponse>(getGetSeoChangesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoChangesQueryKey = (params?: GetSeoChangesParams,) => {
    return [
    `/api/seo/changes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSeoChangesQueryOptions = <TData = Awaited<ReturnType<typeof getSeoChanges>>, TError = ErrorType<void>>(params?: GetSeoChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoChangesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoChanges>>> = ({ signal }) => getSeoChanges(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeoChangesQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoChanges>>>
export type GetSeoChangesQueryError = ErrorType<void>


export function useGetSeoChanges<TData = Awaited<ReturnType<typeof getSeoChanges>>, TError = ErrorType<void>>(
 params: undefined |  GetSeoChangesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoChanges>>,
          TError,
          Awaited<ReturnType<typeof getSeoChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoChanges<TData = Awaited<ReturnType<typeof getSeoChanges>>, TError = ErrorType<void>>(
 params?: GetSeoChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoChanges>>,
          TError,
          Awaited<ReturnType<typeof getSeoChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoChanges<TData = Awaited<ReturnType<typeof getSeoChanges>>, TError = ErrorType<void>>(
 params?: GetSeoChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List paginated SEO change events for the calling tenant
 */

export function useGetSeoChanges<TData = Awaited<ReturnType<typeof getSeoChanges>>, TError = ErrorType<void>>(
 params?: GetSeoChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoChanges>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeoChangesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchSeoChangeEventUrl = (eventId: number,) => {




  return `/api/seo/changes/${eventId}`
}

/**
 * @summary Toggle the isPreExisting flag on a single change event
 */
export const patchSeoChangeEvent = async (eventId: number,
    patchSeoChangeEventBody: PatchSeoChangeEventBody, options?: RequestInit): Promise<SeoChangeEvent> => {

  return customFetch<SeoChangeEvent>(getPatchSeoChangeEventUrl(eventId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSeoChangeEventBody)
  }
);}




export const getPatchSeoChangeEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSeoChangeEvent>>, TError,{eventId: number;data: BodyType<PatchSeoChangeEventBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSeoChangeEvent>>, TError,{eventId: number;data: BodyType<PatchSeoChangeEventBody>}, TContext> => {

const mutationKey = ['patchSeoChangeEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSeoChangeEvent>>, {eventId: number;data: BodyType<PatchSeoChangeEventBody>}> = (props) => {
          const {eventId,data} = props ?? {};

          return  patchSeoChangeEvent(eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSeoChangeEventMutationResult = NonNullable<Awaited<ReturnType<typeof patchSeoChangeEvent>>>
    export type PatchSeoChangeEventMutationBody = BodyType<PatchSeoChangeEventBody>
    export type PatchSeoChangeEventMutationError = ErrorType<void>

    /**
 * @summary Toggle the isPreExisting flag on a single change event
 */
export const usePatchSeoChangeEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSeoChangeEvent>>, TError,{eventId: number;data: BodyType<PatchSeoChangeEventBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSeoChangeEvent>>,
        TError,
        {eventId: number;data: BodyType<PatchSeoChangeEventBody>},
        TContext
      > => {
      return useMutation(getPatchSeoChangeEventMutationOptions(options), queryClient);
    }

export const getBulkMarkSeoChangesPreExistingUrl = () => {




  return `/api/seo/changes/mark-pre-existing`
}

/**
 * @summary Bulk-flag multiple change events as pre-existing (or unmark)
 */
export const bulkMarkSeoChangesPreExisting = async (bulkMarkSeoChangesPreExistingBody: BulkMarkSeoChangesPreExistingBody, options?: RequestInit): Promise<BulkMarkSeoChangesPreExisting200> => {

  return customFetch<BulkMarkSeoChangesPreExisting200>(getBulkMarkSeoChangesPreExistingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkMarkSeoChangesPreExistingBody)
  }
);}




export const getBulkMarkSeoChangesPreExistingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>, TError,{data: BodyType<BulkMarkSeoChangesPreExistingBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>, TError,{data: BodyType<BulkMarkSeoChangesPreExistingBody>}, TContext> => {

const mutationKey = ['bulkMarkSeoChangesPreExisting'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>, {data: BodyType<BulkMarkSeoChangesPreExistingBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkMarkSeoChangesPreExisting(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMarkSeoChangesPreExistingMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>>
    export type BulkMarkSeoChangesPreExistingMutationBody = BodyType<BulkMarkSeoChangesPreExistingBody>
    export type BulkMarkSeoChangesPreExistingMutationError = ErrorType<void>

    /**
 * @summary Bulk-flag multiple change events as pre-existing (or unmark)
 */
export const useBulkMarkSeoChangesPreExisting = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>, TError,{data: BodyType<BulkMarkSeoChangesPreExistingBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMarkSeoChangesPreExisting>>,
        TError,
        {data: BodyType<BulkMarkSeoChangesPreExistingBody>},
        TContext
      > => {
      return useMutation(getBulkMarkSeoChangesPreExistingMutationOptions(options), queryClient);
    }

export const getGetSeoStatusUrl = () => {




  return `/api/seo/status`
}

/**
 * @summary Last crawl status for the calling tenant
 */
export const getSeoStatus = async ( options?: RequestInit): Promise<SeoStatusResponse> => {

  return customFetch<SeoStatusResponse>(getGetSeoStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoStatusQueryKey = () => {
    return [
    `/api/seo/status`
    ] as const;
    }


export const getGetSeoStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSeoStatus>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoStatus>>> = ({ signal }) => getSeoStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeoStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoStatus>>>
export type GetSeoStatusQueryError = ErrorType<void>


export function useGetSeoStatus<TData = Awaited<ReturnType<typeof getSeoStatus>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoStatus>>,
          TError,
          Awaited<ReturnType<typeof getSeoStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoStatus<TData = Awaited<ReturnType<typeof getSeoStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoStatus>>,
          TError,
          Awaited<ReturnType<typeof getSeoStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoStatus<TData = Awaited<ReturnType<typeof getSeoStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Last crawl status for the calling tenant
 */

export function useGetSeoStatus<TData = Awaited<ReturnType<typeof getSeoStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeoStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshSeoSourceUrl = () => {




  return `/api/seo/refresh`
}

/**
 * @summary Refresh current website content and verified Search Console data
 */
export const refreshSeoSource = async ( options?: RequestInit): Promise<OkResponse> => {

  return customFetch<OkResponse>(getRefreshSeoSourceUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshSeoSourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshSeoSource>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshSeoSource>>, TError,void, TContext> => {

const mutationKey = ['refreshSeoSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshSeoSource>>, void> = () => {


          return  refreshSeoSource(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshSeoSourceMutationResult = NonNullable<Awaited<ReturnType<typeof refreshSeoSource>>>

    export type RefreshSeoSourceMutationError = ErrorType<void>

    /**
 * @summary Refresh current website content and verified Search Console data
 */
export const useRefreshSeoSource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshSeoSource>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshSeoSource>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshSeoSourceMutationOptions(options), queryClient);
    }

export const getGetSeoSiteAnalysisUrl = () => {




  return `/api/seo/site-analysis`
}

/**
 * @summary Get the latest precomputed site-wide SEO causal analysis
 */
export const getSeoSiteAnalysis = async ( options?: RequestInit): Promise<SeoSiteAnalysisResponse> => {

  return customFetch<SeoSiteAnalysisResponse>(getGetSeoSiteAnalysisUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoSiteAnalysisQueryKey = () => {
    return [
    `/api/seo/site-analysis`
    ] as const;
    }


export const getGetSeoSiteAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoSiteAnalysisQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoSiteAnalysis>>> = ({ signal }) => getSeoSiteAnalysis({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeoSiteAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoSiteAnalysis>>>
export type GetSeoSiteAnalysisQueryError = ErrorType<void>


export function useGetSeoSiteAnalysis<TData = Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoSiteAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getSeoSiteAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoSiteAnalysis<TData = Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoSiteAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getSeoSiteAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoSiteAnalysis<TData = Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the latest precomputed site-wide SEO causal analysis
 */

export function useGetSeoSiteAnalysis<TData = Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSiteAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeoSiteAnalysisQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunSeoSiteAnalysisUrl = () => {




  return `/api/seo/site-analysis/run`
}

/**
 * @summary Manually re-trigger site-wide SEO causal analysis (admin only)
 */
export const runSeoSiteAnalysis = async ( options?: RequestInit): Promise<OkResponse> => {

  return customFetch<OkResponse>(getRunSeoSiteAnalysisUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRunSeoSiteAnalysisMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSeoSiteAnalysis>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runSeoSiteAnalysis>>, TError,void, TContext> => {

const mutationKey = ['runSeoSiteAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runSeoSiteAnalysis>>, void> = () => {


          return  runSeoSiteAnalysis(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunSeoSiteAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof runSeoSiteAnalysis>>>

    export type RunSeoSiteAnalysisMutationError = ErrorType<void>

    /**
 * @summary Manually re-trigger site-wide SEO causal analysis (admin only)
 */
export const useRunSeoSiteAnalysis = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSeoSiteAnalysis>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runSeoSiteAnalysis>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunSeoSiteAnalysisMutationOptions(options), queryClient);
    }

export const getListGoogleAdsReportCampaignsUrl = (params?: ListGoogleAdsReportCampaignsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google-ads/campaigns?${stringifiedParams}` : `/api/google-ads/campaigns`
}

/**
 * @summary Paginated tenant-scoped Google Ads campaign aggregates
 */
export const listGoogleAdsReportCampaigns = async (params?: ListGoogleAdsReportCampaignsParams, options?: RequestInit): Promise<GoogleAdsCampaignPage> => {

  return customFetch<GoogleAdsCampaignPage>(getListGoogleAdsReportCampaignsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAdsReportCampaignsQueryKey = (params?: ListGoogleAdsReportCampaignsParams,) => {
    return [
    `/api/google-ads/campaigns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGoogleAdsReportCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError = ErrorType<unknown>>(params?: ListGoogleAdsReportCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAdsReportCampaignsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>> = ({ signal }) => listGoogleAdsReportCampaigns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGoogleAdsReportCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>>
export type ListGoogleAdsReportCampaignsQueryError = ErrorType<unknown>


export function useListGoogleAdsReportCampaigns<TData = Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError = ErrorType<unknown>>(
 params: undefined |  ListGoogleAdsReportCampaignsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsReportCampaigns<TData = Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsReportCampaigns<TData = Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated tenant-scoped Google Ads campaign aggregates
 */

export function useListGoogleAdsReportCampaigns<TData = Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGoogleAdsReportCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleAdsCampaignOptionsUrl = (params?: ListGoogleAdsCampaignOptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google-ads/campaign-options?${stringifiedParams}` : `/api/google-ads/campaign-options`
}

/**
 * @summary Search tenant-scoped campaign filter options without loading all campaigns
 */
export const listGoogleAdsCampaignOptions = async (params?: ListGoogleAdsCampaignOptionsParams, options?: RequestInit): Promise<GoogleAdsCampaignOptionsPage> => {

  return customFetch<GoogleAdsCampaignOptionsPage>(getListGoogleAdsCampaignOptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAdsCampaignOptionsQueryKey = (params?: ListGoogleAdsCampaignOptionsParams,) => {
    return [
    `/api/google-ads/campaign-options`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGoogleAdsCampaignOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError = ErrorType<unknown>>(params?: ListGoogleAdsCampaignOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAdsCampaignOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>> = ({ signal }) => listGoogleAdsCampaignOptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGoogleAdsCampaignOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>>
export type ListGoogleAdsCampaignOptionsQueryError = ErrorType<unknown>


export function useListGoogleAdsCampaignOptions<TData = Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError = ErrorType<unknown>>(
 params: undefined |  ListGoogleAdsCampaignOptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsCampaignOptions<TData = Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsCampaignOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsCampaignOptions<TData = Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsCampaignOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search tenant-scoped campaign filter options without loading all campaigns
 */

export function useListGoogleAdsCampaignOptions<TData = Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsCampaignOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsCampaignOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGoogleAdsCampaignOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleAdsReportKeywordsUrl = (params?: ListGoogleAdsReportKeywordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google-ads/keywords?${stringifiedParams}` : `/api/google-ads/keywords`
}

/**
 * @summary Paginated tenant-scoped paid keywords with branded tags
 */
export const listGoogleAdsReportKeywords = async (params?: ListGoogleAdsReportKeywordsParams, options?: RequestInit): Promise<GoogleAdsKeywordPage> => {

  return customFetch<GoogleAdsKeywordPage>(getListGoogleAdsReportKeywordsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAdsReportKeywordsQueryKey = (params?: ListGoogleAdsReportKeywordsParams,) => {
    return [
    `/api/google-ads/keywords`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGoogleAdsReportKeywordsQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError = ErrorType<unknown>>(params?: ListGoogleAdsReportKeywordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAdsReportKeywordsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>> = ({ signal }) => listGoogleAdsReportKeywords(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGoogleAdsReportKeywordsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>>
export type ListGoogleAdsReportKeywordsQueryError = ErrorType<unknown>


export function useListGoogleAdsReportKeywords<TData = Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError = ErrorType<unknown>>(
 params: undefined |  ListGoogleAdsReportKeywordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsReportKeywords<TData = Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportKeywordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsReportKeywords<TData = Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportKeywordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated tenant-scoped paid keywords with branded tags
 */

export function useListGoogleAdsReportKeywords<TData = Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsReportKeywordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsReportKeywords>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGoogleAdsReportKeywordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleAdsKeywordOverlapUrl = (params?: ListGoogleAdsKeywordOverlapParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google-ads/keyword-overlap?${stringifiedParams}` : `/api/google-ads/keyword-overlap`
}

/**
 * @summary Paginated paid/organic keyword overlap buckets
 */
export const listGoogleAdsKeywordOverlap = async (params?: ListGoogleAdsKeywordOverlapParams, options?: RequestInit): Promise<GoogleAdsOverlapPage> => {

  return customFetch<GoogleAdsOverlapPage>(getListGoogleAdsKeywordOverlapUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAdsKeywordOverlapQueryKey = (params?: ListGoogleAdsKeywordOverlapParams,) => {
    return [
    `/api/google-ads/keyword-overlap`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGoogleAdsKeywordOverlapQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError = ErrorType<unknown>>(params?: ListGoogleAdsKeywordOverlapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAdsKeywordOverlapQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>> = ({ signal }) => listGoogleAdsKeywordOverlap(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGoogleAdsKeywordOverlapQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>>
export type ListGoogleAdsKeywordOverlapQueryError = ErrorType<unknown>


export function useListGoogleAdsKeywordOverlap<TData = Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError = ErrorType<unknown>>(
 params: undefined |  ListGoogleAdsKeywordOverlapParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsKeywordOverlap<TData = Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsKeywordOverlapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsKeywordOverlap<TData = Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsKeywordOverlapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated paid/organic keyword overlap buckets
 */

export function useListGoogleAdsKeywordOverlap<TData = Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsKeywordOverlapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsKeywordOverlap>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGoogleAdsKeywordOverlapQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleAdsSearchTermsUrl = (params?: ListGoogleAdsSearchTermsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google-ads/search-terms?${stringifiedParams}` : `/api/google-ads/search-terms`
}

/**
 * @summary Paginated wasted-spend search terms
 */
export const listGoogleAdsSearchTerms = async (params?: ListGoogleAdsSearchTermsParams, options?: RequestInit): Promise<GoogleAdsSearchTermPage> => {

  return customFetch<GoogleAdsSearchTermPage>(getListGoogleAdsSearchTermsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAdsSearchTermsQueryKey = (params?: ListGoogleAdsSearchTermsParams,) => {
    return [
    `/api/google-ads/search-terms`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGoogleAdsSearchTermsQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError = ErrorType<unknown>>(params?: ListGoogleAdsSearchTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAdsSearchTermsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>> = ({ signal }) => listGoogleAdsSearchTerms(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGoogleAdsSearchTermsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>>
export type ListGoogleAdsSearchTermsQueryError = ErrorType<unknown>


export function useListGoogleAdsSearchTerms<TData = Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError = ErrorType<unknown>>(
 params: undefined |  ListGoogleAdsSearchTermsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsSearchTerms<TData = Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsSearchTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>,
          TError,
          Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGoogleAdsSearchTerms<TData = Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsSearchTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated wasted-spend search terms
 */

export function useListGoogleAdsSearchTerms<TData = Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError = ErrorType<unknown>>(
 params?: ListGoogleAdsSearchTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoogleAdsSearchTerms>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGoogleAdsSearchTermsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSeoSourcesUrl = (params?: GetSeoSourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/seo/sources?${stringifiedParams}` : `/api/seo/sources`
}

/**
 * @summary GA4 sessions grouped by source/medium for the past 30 days
 */
export const getSeoSources = async (params?: GetSeoSourcesParams, options?: RequestInit): Promise<SeoSourcesResponse> => {

  return customFetch<SeoSourcesResponse>(getGetSeoSourcesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoSourcesQueryKey = (params?: GetSeoSourcesParams,) => {
    return [
    `/api/seo/sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSeoSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getSeoSources>>, TError = ErrorType<void>>(params?: GetSeoSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoSourcesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoSources>>> = ({ signal }) => getSeoSources(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeoSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoSources>>>
export type GetSeoSourcesQueryError = ErrorType<void>


export function useGetSeoSources<TData = Awaited<ReturnType<typeof getSeoSources>>, TError = ErrorType<void>>(
 params: undefined |  GetSeoSourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoSources>>,
          TError,
          Awaited<ReturnType<typeof getSeoSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoSources<TData = Awaited<ReturnType<typeof getSeoSources>>, TError = ErrorType<void>>(
 params?: GetSeoSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoSources>>,
          TError,
          Awaited<ReturnType<typeof getSeoSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoSources<TData = Awaited<ReturnType<typeof getSeoSources>>, TError = ErrorType<void>>(
 params?: GetSeoSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary GA4 sessions grouped by source/medium for the past 30 days
 */

export function useGetSeoSources<TData = Awaited<ReturnType<typeof getSeoSources>>, TError = ErrorType<void>>(
 params?: GetSeoSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeoSourcesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSeoPageVisitsUrl = (params?: GetSeoPageVisitsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/seo/page-visits?${stringifiedParams}` : `/api/seo/page-visits`
}

/**
 * @summary GA4 sessions grouped by landing page for the past 30 days
 */
export const getSeoPageVisits = async (params?: GetSeoPageVisitsParams, options?: RequestInit): Promise<SeoPageVisitsResponse> => {

  return customFetch<SeoPageVisitsResponse>(getGetSeoPageVisitsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoPageVisitsQueryKey = (params?: GetSeoPageVisitsParams,) => {
    return [
    `/api/seo/page-visits`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSeoPageVisitsQueryOptions = <TData = Awaited<ReturnType<typeof getSeoPageVisits>>, TError = ErrorType<void>>(params?: GetSeoPageVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoPageVisitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoPageVisits>>> = ({ signal }) => getSeoPageVisits(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeoPageVisitsQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoPageVisits>>>
export type GetSeoPageVisitsQueryError = ErrorType<void>


export function useGetSeoPageVisits<TData = Awaited<ReturnType<typeof getSeoPageVisits>>, TError = ErrorType<void>>(
 params: undefined |  GetSeoPageVisitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoPageVisits>>,
          TError,
          Awaited<ReturnType<typeof getSeoPageVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoPageVisits<TData = Awaited<ReturnType<typeof getSeoPageVisits>>, TError = ErrorType<void>>(
 params?: GetSeoPageVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeoPageVisits>>,
          TError,
          Awaited<ReturnType<typeof getSeoPageVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeoPageVisits<TData = Awaited<ReturnType<typeof getSeoPageVisits>>, TError = ErrorType<void>>(
 params?: GetSeoPageVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary GA4 sessions grouped by landing page for the past 30 days
 */

export function useGetSeoPageVisits<TData = Awaited<ReturnType<typeof getSeoPageVisits>>, TError = ErrorType<void>>(
 params?: GetSeoPageVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeoPageVisits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeoPageVisitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTriggerMetaSyncUrl = () => {




  return `/api/meta/sync`
}

/**
 * @summary Trigger historical Meta backfill + incremental update (admin only)
 */
export const triggerMetaSync = async ( options?: RequestInit): Promise<MetaSyncResult> => {

  return customFetch<MetaSyncResult>(getTriggerMetaSyncUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTriggerMetaSyncQueryKey = () => {
    return [
    `/api/meta/sync`
    ] as const;
    }


export const getTriggerMetaSyncQueryOptions = <TData = Awaited<ReturnType<typeof triggerMetaSync>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTriggerMetaSyncQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof triggerMetaSync>>> = ({ signal }) => triggerMetaSync({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TriggerMetaSyncQueryResult = NonNullable<Awaited<ReturnType<typeof triggerMetaSync>>>
export type TriggerMetaSyncQueryError = ErrorType<void>


export function useTriggerMetaSync<TData = Awaited<ReturnType<typeof triggerMetaSync>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggerMetaSync>>,
          TError,
          Awaited<ReturnType<typeof triggerMetaSync>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTriggerMetaSync<TData = Awaited<ReturnType<typeof triggerMetaSync>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggerMetaSync>>,
          TError,
          Awaited<ReturnType<typeof triggerMetaSync>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTriggerMetaSync<TData = Awaited<ReturnType<typeof triggerMetaSync>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Trigger historical Meta backfill + incremental update (admin only)
 */

export function useTriggerMetaSync<TData = Awaited<ReturnType<typeof triggerMetaSync>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerMetaSync>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTriggerMetaSyncQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMetaPostsUrl = (params?: ListMetaPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/posts?${stringifiedParams}` : `/api/meta/posts`
}

/**
 * @summary Paginated post list with engagement metrics
 */
export const listMetaPosts = async (params?: ListMetaPostsParams, options?: RequestInit): Promise<MetaPostsResponse> => {

  return customFetch<MetaPostsResponse>(getListMetaPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetaPostsQueryKey = (params?: ListMetaPostsParams,) => {
    return [
    `/api/meta/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMetaPostsQueryOptions = <TData = Awaited<ReturnType<typeof listMetaPosts>>, TError = ErrorType<void>>(params?: ListMetaPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetaPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetaPosts>>> = ({ signal }) => listMetaPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetaPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetaPosts>>>
export type ListMetaPostsQueryError = ErrorType<void>


export function useListMetaPosts<TData = Awaited<ReturnType<typeof listMetaPosts>>, TError = ErrorType<void>>(
 params: undefined |  ListMetaPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPosts>>,
          TError,
          Awaited<ReturnType<typeof listMetaPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPosts<TData = Awaited<ReturnType<typeof listMetaPosts>>, TError = ErrorType<void>>(
 params?: ListMetaPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPosts>>,
          TError,
          Awaited<ReturnType<typeof listMetaPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPosts<TData = Awaited<ReturnType<typeof listMetaPosts>>, TError = ErrorType<void>>(
 params?: ListMetaPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated post list with engagement metrics
 */

export function useListMetaPosts<TData = Awaited<ReturnType<typeof listMetaPosts>>, TError = ErrorType<void>>(
 params?: ListMetaPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPosts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetaPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMetaPostHistoryUrl = (postId: string,) => {




  return `/api/meta/post-history/${postId}`
}

/**
 * @summary Get stored snapshots and adjacent-day metric changes for a post
 */
export const getMetaPostHistory = async (postId: string, options?: RequestInit): Promise<MetaPostHistoryResponse> => {

  return customFetch<MetaPostHistoryResponse>(getGetMetaPostHistoryUrl(postId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMetaPostHistoryQueryKey = (postId: string,) => {
    return [
    `/api/meta/post-history/${postId}`
    ] as const;
    }


export const getGetMetaPostHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getMetaPostHistory>>, TError = ErrorType<void>>(postId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaPostHistoryQueryKey(postId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaPostHistory>>> = ({ signal }) => getMetaPostHistory(postId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: postId !== null && postId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMetaPostHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaPostHistory>>>
export type GetMetaPostHistoryQueryError = ErrorType<void>


export function useGetMetaPostHistory<TData = Awaited<ReturnType<typeof getMetaPostHistory>>, TError = ErrorType<void>>(
 postId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaPostHistory>>,
          TError,
          Awaited<ReturnType<typeof getMetaPostHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaPostHistory<TData = Awaited<ReturnType<typeof getMetaPostHistory>>, TError = ErrorType<void>>(
 postId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaPostHistory>>,
          TError,
          Awaited<ReturnType<typeof getMetaPostHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaPostHistory<TData = Awaited<ReturnType<typeof getMetaPostHistory>>, TError = ErrorType<void>>(
 postId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get stored snapshots and adjacent-day metric changes for a post
 */

export function useGetMetaPostHistory<TData = Awaited<ReturnType<typeof getMetaPostHistory>>, TError = ErrorType<void>>(
 postId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMetaPostHistoryQueryOptions(postId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMetaPostActivitySummaryUrl = (params: GetMetaPostActivitySummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/post-activity-summary?${stringifiedParams}` : `/api/meta/post-activity-summary`
}

/**
 * @summary Date-scoped daily post activity across every tenant post, independent of the post table's page
 */
export const getMetaPostActivitySummary = async (params: GetMetaPostActivitySummaryParams, options?: RequestInit): Promise<MetaPostActivitySummary> => {

  return customFetch<MetaPostActivitySummary>(getGetMetaPostActivitySummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMetaPostActivitySummaryQueryKey = (params?: GetMetaPostActivitySummaryParams,) => {
    return [
    `/api/meta/post-activity-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMetaPostActivitySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError = ErrorType<void>>(params: GetMetaPostActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaPostActivitySummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaPostActivitySummary>>> = ({ signal }) => getMetaPostActivitySummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMetaPostActivitySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaPostActivitySummary>>>
export type GetMetaPostActivitySummaryQueryError = ErrorType<void>


export function useGetMetaPostActivitySummary<TData = Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError = ErrorType<void>>(
 params: GetMetaPostActivitySummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaPostActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof getMetaPostActivitySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaPostActivitySummary<TData = Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError = ErrorType<void>>(
 params: GetMetaPostActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaPostActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof getMetaPostActivitySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaPostActivitySummary<TData = Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError = ErrorType<void>>(
 params: GetMetaPostActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Date-scoped daily post activity across every tenant post, independent of the post table's page
 */

export function useGetMetaPostActivitySummary<TData = Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError = ErrorType<void>>(
 params: GetMetaPostActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaPostActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMetaPostActivitySummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMetaPostActivityUrl = (params?: ListMetaPostActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/post-activity?${stringifiedParams}` : `/api/meta/post-activity`
}

/**
 * @summary Paginated latest posts with stored range activity by date
 */
export const listMetaPostActivity = async (params?: ListMetaPostActivityParams, options?: RequestInit): Promise<MetaPostActivityResponse> => {

  return customFetch<MetaPostActivityResponse>(getListMetaPostActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetaPostActivityQueryKey = (params?: ListMetaPostActivityParams,) => {
    return [
    `/api/meta/post-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMetaPostActivityQueryOptions = <TData = Awaited<ReturnType<typeof listMetaPostActivity>>, TError = ErrorType<void>>(params?: ListMetaPostActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetaPostActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetaPostActivity>>> = ({ signal }) => listMetaPostActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetaPostActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listMetaPostActivity>>>
export type ListMetaPostActivityQueryError = ErrorType<void>


export function useListMetaPostActivity<TData = Awaited<ReturnType<typeof listMetaPostActivity>>, TError = ErrorType<void>>(
 params: undefined |  ListMetaPostActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPostActivity>>,
          TError,
          Awaited<ReturnType<typeof listMetaPostActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPostActivity<TData = Awaited<ReturnType<typeof listMetaPostActivity>>, TError = ErrorType<void>>(
 params?: ListMetaPostActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPostActivity>>,
          TError,
          Awaited<ReturnType<typeof listMetaPostActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPostActivity<TData = Awaited<ReturnType<typeof listMetaPostActivity>>, TError = ErrorType<void>>(
 params?: ListMetaPostActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated latest posts with stored range activity by date
 */

export function useListMetaPostActivity<TData = Awaited<ReturnType<typeof listMetaPostActivity>>, TError = ErrorType<void>>(
 params?: ListMetaPostActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostActivity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetaPostActivityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMetaPostCommentsUrl = (postId: string,
    params?: ListMetaPostCommentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/posts/${postId}/comments?${stringifiedParams}` : `/api/meta/posts/${postId}/comments`
}

/**
 * @summary List stored comments for a Meta post
 */
export const listMetaPostComments = async (postId: string,
    params?: ListMetaPostCommentsParams, options?: RequestInit): Promise<MetaCommentsResponse> => {

  return customFetch<MetaCommentsResponse>(getListMetaPostCommentsUrl(postId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetaPostCommentsQueryKey = (postId: string,
    params?: ListMetaPostCommentsParams,) => {
    return [
    `/api/meta/posts/${postId}/comments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMetaPostCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listMetaPostComments>>, TError = ErrorType<void>>(postId: string,
    params?: ListMetaPostCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetaPostCommentsQueryKey(postId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetaPostComments>>> = ({ signal }) => listMetaPostComments(postId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: postId !== null && postId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetaPostCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetaPostComments>>>
export type ListMetaPostCommentsQueryError = ErrorType<void>


export function useListMetaPostComments<TData = Awaited<ReturnType<typeof listMetaPostComments>>, TError = ErrorType<void>>(
 postId: string,
    params: undefined |  ListMetaPostCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPostComments>>,
          TError,
          Awaited<ReturnType<typeof listMetaPostComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPostComments<TData = Awaited<ReturnType<typeof listMetaPostComments>>, TError = ErrorType<void>>(
 postId: string,
    params?: ListMetaPostCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPostComments>>,
          TError,
          Awaited<ReturnType<typeof listMetaPostComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPostComments<TData = Awaited<ReturnType<typeof listMetaPostComments>>, TError = ErrorType<void>>(
 postId: string,
    params?: ListMetaPostCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List stored comments for a Meta post
 */

export function useListMetaPostComments<TData = Awaited<ReturnType<typeof listMetaPostComments>>, TError = ErrorType<void>>(
 postId: string,
    params?: ListMetaPostCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPostComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetaPostCommentsQueryOptions(postId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMetaCommentsOverviewUrl = (params?: GetMetaCommentsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/comments/overview?${stringifiedParams}` : `/api/meta/comments/overview`
}

/**
 * @summary Count stored Meta comments by platform
 */
export const getMetaCommentsOverview = async (params?: GetMetaCommentsOverviewParams, options?: RequestInit): Promise<MetaCommentsOverview> => {

  return customFetch<MetaCommentsOverview>(getGetMetaCommentsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMetaCommentsOverviewQueryKey = (params?: GetMetaCommentsOverviewParams,) => {
    return [
    `/api/meta/comments/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMetaCommentsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError = ErrorType<void>>(params?: GetMetaCommentsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaCommentsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaCommentsOverview>>> = ({ signal }) => getMetaCommentsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMetaCommentsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaCommentsOverview>>>
export type GetMetaCommentsOverviewQueryError = ErrorType<void>


export function useGetMetaCommentsOverview<TData = Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError = ErrorType<void>>(
 params: undefined |  GetMetaCommentsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaCommentsOverview>>,
          TError,
          Awaited<ReturnType<typeof getMetaCommentsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaCommentsOverview<TData = Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError = ErrorType<void>>(
 params?: GetMetaCommentsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaCommentsOverview>>,
          TError,
          Awaited<ReturnType<typeof getMetaCommentsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaCommentsOverview<TData = Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError = ErrorType<void>>(
 params?: GetMetaCommentsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Count stored Meta comments by platform
 */

export function useGetMetaCommentsOverview<TData = Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError = ErrorType<void>>(
 params?: GetMetaCommentsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaCommentsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMetaCommentsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSummarizeMetaCommentsUrl = () => {




  return `/api/meta/comments/summary`
}

/**
 * @summary Generate an AI summary of stored Meta comments
 */
export const summarizeMetaComments = async (metaCommentsSummaryRequest: MetaCommentsSummaryRequest, options?: RequestInit): Promise<MetaCommentsSummaryResponse> => {

  return customFetch<MetaCommentsSummaryResponse>(getSummarizeMetaCommentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(metaCommentsSummaryRequest)
  }
);}




export const getSummarizeMetaCommentsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeMetaComments>>, TError,{data: BodyType<MetaCommentsSummaryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof summarizeMetaComments>>, TError,{data: BodyType<MetaCommentsSummaryRequest>}, TContext> => {

const mutationKey = ['summarizeMetaComments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof summarizeMetaComments>>, {data: BodyType<MetaCommentsSummaryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  summarizeMetaComments(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SummarizeMetaCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof summarizeMetaComments>>>
    export type SummarizeMetaCommentsMutationBody = BodyType<MetaCommentsSummaryRequest>
    export type SummarizeMetaCommentsMutationError = ErrorType<void>

    /**
 * @summary Generate an AI summary of stored Meta comments
 */
export const useSummarizeMetaComments = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeMetaComments>>, TError,{data: BodyType<MetaCommentsSummaryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof summarizeMetaComments>>,
        TError,
        {data: BodyType<MetaCommentsSummaryRequest>},
        TContext
      > => {
      return useMutation(getSummarizeMetaCommentsMutationOptions(options), queryClient);
    }

export const getListMetaDailyInsightsUrl = (params?: ListMetaDailyInsightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meta/daily-insights?${stringifiedParams}` : `/api/meta/daily-insights`
}

/**
 * @summary Daily rolled-up page/account metrics time series
 */
export const listMetaDailyInsights = async (params?: ListMetaDailyInsightsParams, options?: RequestInit): Promise<MetaDailyInsightsResponse> => {

  return customFetch<MetaDailyInsightsResponse>(getListMetaDailyInsightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetaDailyInsightsQueryKey = (params?: ListMetaDailyInsightsParams,) => {
    return [
    `/api/meta/daily-insights`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMetaDailyInsightsQueryOptions = <TData = Awaited<ReturnType<typeof listMetaDailyInsights>>, TError = ErrorType<void>>(params?: ListMetaDailyInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetaDailyInsightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetaDailyInsights>>> = ({ signal }) => listMetaDailyInsights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetaDailyInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetaDailyInsights>>>
export type ListMetaDailyInsightsQueryError = ErrorType<void>


export function useListMetaDailyInsights<TData = Awaited<ReturnType<typeof listMetaDailyInsights>>, TError = ErrorType<void>>(
 params: undefined |  ListMetaDailyInsightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaDailyInsights>>,
          TError,
          Awaited<ReturnType<typeof listMetaDailyInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaDailyInsights<TData = Awaited<ReturnType<typeof listMetaDailyInsights>>, TError = ErrorType<void>>(
 params?: ListMetaDailyInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaDailyInsights>>,
          TError,
          Awaited<ReturnType<typeof listMetaDailyInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaDailyInsights<TData = Awaited<ReturnType<typeof listMetaDailyInsights>>, TError = ErrorType<void>>(
 params?: ListMetaDailyInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Daily rolled-up page/account metrics time series
 */

export function useListMetaDailyInsights<TData = Awaited<ReturnType<typeof listMetaDailyInsights>>, TError = ErrorType<void>>(
 params?: ListMetaDailyInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaDailyInsights>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetaDailyInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMetaStatusUrl = () => {




  return `/api/meta/status`
}

/**
 * @summary Last sync timestamp, total posts, and date range covered
 */
export const getMetaStatus = async ( options?: RequestInit): Promise<MetaStatusResponse> => {

  return customFetch<MetaStatusResponse>(getGetMetaStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMetaStatusQueryKey = () => {
    return [
    `/api/meta/status`
    ] as const;
    }


export const getGetMetaStatusQueryOptions = <TData = Awaited<ReturnType<typeof getMetaStatus>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaStatus>>> = ({ signal }) => getMetaStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMetaStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaStatus>>>
export type GetMetaStatusQueryError = ErrorType<void>


export function useGetMetaStatus<TData = Awaited<ReturnType<typeof getMetaStatus>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaStatus>>,
          TError,
          Awaited<ReturnType<typeof getMetaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaStatus<TData = Awaited<ReturnType<typeof getMetaStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaStatus>>,
          TError,
          Awaited<ReturnType<typeof getMetaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMetaStatus<TData = Awaited<ReturnType<typeof getMetaStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Last sync timestamp, total posts, and date range covered
 */

export function useGetMetaStatus<TData = Awaited<ReturnType<typeof getMetaStatus>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMetaStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomOrdersUrl = () => {




  return `/api/custom-orders`
}

/**
 * @summary List Custom Orders and successful subscription charges for the current tenant
 */
export const listCustomOrders = async ( options?: RequestInit): Promise<CustomOrderItem[]> => {

  return customFetch<CustomOrderItem[]>(getListCustomOrdersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomOrdersQueryKey = () => {
    return [
    `/api/custom-orders`
    ] as const;
    }


export const getListCustomOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomOrders>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomOrdersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomOrders>>> = ({ signal }) => listCustomOrders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomOrders>>>
export type ListCustomOrdersQueryError = ErrorType<void>


export function useListCustomOrders<TData = Awaited<ReturnType<typeof listCustomOrders>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomOrders>>,
          TError,
          Awaited<ReturnType<typeof listCustomOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomOrders<TData = Awaited<ReturnType<typeof listCustomOrders>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomOrders>>,
          TError,
          Awaited<ReturnType<typeof listCustomOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomOrders<TData = Awaited<ReturnType<typeof listCustomOrders>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Custom Orders and successful subscription charges for the current tenant
 */

export function useListCustomOrders<TData = Awaited<ReturnType<typeof listCustomOrders>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomOrdersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResumeCheckoutBankVerificationUrl = (token: string,) => {




  return `/api/checkout-link/${token}/verify-bank`
}

/**
 * Same-origin browser form only. The unguessable checkout token authorizes the read. Retrieves Stripe state afresh; never accepts a destination or payment reference from the payer, and never creates or confirms a payment. Capability URLs are no-store redirects, not JSON or email content.
 * @summary Redirect the existing checkout obligation to Stripe bank verification
 */
export const resumeCheckoutBankVerification = async (token: string, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getResumeCheckoutBankVerificationUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResumeCheckoutBankVerificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCheckoutBankVerification>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeCheckoutBankVerification>>, TError,{token: string}, TContext> => {

const mutationKey = ['resumeCheckoutBankVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeCheckoutBankVerification>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  resumeCheckoutBankVerification(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeCheckoutBankVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resumeCheckoutBankVerification>>>

    export type ResumeCheckoutBankVerificationMutationError = ErrorType<void>

    /**
 * @summary Redirect the existing checkout obligation to Stripe bank verification
 */
export const useResumeCheckoutBankVerification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCheckoutBankVerification>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeCheckoutBankVerification>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getResumeCheckoutBankVerificationMutationOptions(options), queryClient);
    }

export const getListCheckoutPaymentEmailDeliveriesUrl = () => {




  return `/api/checkout-payment-email-deliveries`
}

/**
 * @summary Agency-only admin payment email delivery diagnostics
 */
export const listCheckoutPaymentEmailDeliveries = async ( options?: RequestInit): Promise<ListCheckoutPaymentEmailDeliveries200Item[]> => {

  return customFetch<ListCheckoutPaymentEmailDeliveries200Item[]>(getListCheckoutPaymentEmailDeliveriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCheckoutPaymentEmailDeliveriesQueryKey = () => {
    return [
    `/api/checkout-payment-email-deliveries`
    ] as const;
    }


export const getListCheckoutPaymentEmailDeliveriesQueryOptions = <TData = Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCheckoutPaymentEmailDeliveriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>> = ({ signal }) => listCheckoutPaymentEmailDeliveries({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCheckoutPaymentEmailDeliveriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>>
export type ListCheckoutPaymentEmailDeliveriesQueryError = ErrorType<void>


export function useListCheckoutPaymentEmailDeliveries<TData = Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCheckoutPaymentEmailDeliveries<TData = Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCheckoutPaymentEmailDeliveries<TData = Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Agency-only admin payment email delivery diagnostics
 */

export function useListCheckoutPaymentEmailDeliveries<TData = Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutPaymentEmailDeliveries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCheckoutPaymentEmailDeliveriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteCheckoutLinkUrl = (id: number,) => {




  return `/api/checkout-links/${id}`
}

/**
 * @summary Hard-delete a checkout link (agency admin only)
 */
export const deleteCheckoutLink = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCheckoutLinkUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCheckoutLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCheckoutLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCheckoutLink>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCheckoutLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCheckoutLink>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCheckoutLink(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCheckoutLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCheckoutLink>>>

    export type DeleteCheckoutLinkMutationError = ErrorType<void>

    /**
 * @summary Hard-delete a checkout link (agency admin only)
 */
export const useDeleteCheckoutLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCheckoutLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCheckoutLink>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCheckoutLinkMutationOptions(options), queryClient);
    }

export const getListCheckoutLinksUrl = (params?: ListCheckoutLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/checkout-links?${stringifiedParams}` : `/api/checkout-links`
}

/**
 * @summary List checkout links for the current tenant (admin can pass tenantId to list a client's links)
 */
export const listCheckoutLinks = async (params?: ListCheckoutLinksParams, options?: RequestInit): Promise<CheckoutLinkItem[]> => {

  return customFetch<CheckoutLinkItem[]>(getListCheckoutLinksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCheckoutLinksQueryKey = (params?: ListCheckoutLinksParams,) => {
    return [
    `/api/checkout-links`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCheckoutLinksQueryOptions = <TData = Awaited<ReturnType<typeof listCheckoutLinks>>, TError = ErrorType<void>>(params?: ListCheckoutLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCheckoutLinksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCheckoutLinks>>> = ({ signal }) => listCheckoutLinks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCheckoutLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listCheckoutLinks>>>
export type ListCheckoutLinksQueryError = ErrorType<void>


export function useListCheckoutLinks<TData = Awaited<ReturnType<typeof listCheckoutLinks>>, TError = ErrorType<void>>(
 params: undefined |  ListCheckoutLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCheckoutLinks>>,
          TError,
          Awaited<ReturnType<typeof listCheckoutLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCheckoutLinks<TData = Awaited<ReturnType<typeof listCheckoutLinks>>, TError = ErrorType<void>>(
 params?: ListCheckoutLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCheckoutLinks>>,
          TError,
          Awaited<ReturnType<typeof listCheckoutLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCheckoutLinks<TData = Awaited<ReturnType<typeof listCheckoutLinks>>, TError = ErrorType<void>>(
 params?: ListCheckoutLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List checkout links for the current tenant (admin can pass tenantId to list a client's links)
 */

export function useListCheckoutLinks<TData = Awaited<ReturnType<typeof listCheckoutLinks>>, TError = ErrorType<void>>(
 params?: ListCheckoutLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCheckoutLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCheckoutLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCheckoutLinkUrl = () => {




  return `/api/checkout-links`
}

/**
 * @summary Create a new checkout link (admin only)
 */
export const createCheckoutLink = async (checkoutLinkCreate: CheckoutLinkCreate, options?: RequestInit): Promise<CreateCheckoutLink201> => {

  return customFetch<CreateCheckoutLink201>(getCreateCheckoutLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkoutLinkCreate)
  }
);}




export const getCreateCheckoutLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutLink>>, TError,{data: BodyType<CheckoutLinkCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCheckoutLink>>, TError,{data: BodyType<CheckoutLinkCreate>}, TContext> => {

const mutationKey = ['createCheckoutLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCheckoutLink>>, {data: BodyType<CheckoutLinkCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createCheckoutLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCheckoutLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckoutLink>>>
    export type CreateCheckoutLinkMutationBody = BodyType<CheckoutLinkCreate>
    export type CreateCheckoutLinkMutationError = ErrorType<void>

    /**
 * @summary Create a new checkout link (admin only)
 */
export const useCreateCheckoutLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutLink>>, TError,{data: BodyType<CheckoutLinkCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCheckoutLink>>,
        TError,
        {data: BodyType<CheckoutLinkCreate>},
        TContext
      > => {
      return useMutation(getCreateCheckoutLinkMutationOptions(options), queryClient);
    }

export const getListLobCampaignsUrl = () => {




  return `/api/lob-mail/campaigns`
}

/**
 * @summary List tenant-owned Lob campaigns
 */
export const listLobCampaigns = async ( options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getListLobCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobCampaignsQueryKey = () => {
    return [
    `/api/lob-mail/campaigns`
    ] as const;
    }


export const getListLobCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listLobCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobCampaigns>>> = ({ signal }) => listLobCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobCampaigns>>>
export type ListLobCampaignsQueryError = ErrorType<unknown>


export function useListLobCampaigns<TData = Awaited<ReturnType<typeof listLobCampaigns>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaigns<TData = Awaited<ReturnType<typeof listLobCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaigns<TData = Awaited<ReturnType<typeof listLobCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-owned Lob campaigns
 */

export function useListLobCampaigns<TData = Awaited<ReturnType<typeof listLobCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaigns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobCampaignsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobCampaignUrl = () => {




  return `/api/lob-mail/campaigns`
}

/**
 * Creates the provider campaign and stores mailpiece format/size/postage configuration locally; Lob applies those fields only to a separately-created creative. The current published Lob campaign schedule enum supports immediate only; "now" is accepted as a UI compatibility alias and normalized to immediate. Live setup mutations require live operations to be enabled, while dispatch requires explicit confirmation.
 * @summary Create a tenant-owned Lob campaign
 */
export const createLobCampaign = async (lobCampaignCreateInput: LobCampaignCreateInput, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getCreateLobCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignCreateInput)
  }
);}




export const getCreateLobCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaign>>, TError,{data: BodyType<LobCampaignCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobCampaign>>, TError,{data: BodyType<LobCampaignCreateInput>}, TContext> => {

const mutationKey = ['createLobCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobCampaign>>, {data: BodyType<LobCampaignCreateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLobCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createLobCampaign>>>
    export type CreateLobCampaignMutationBody = BodyType<LobCampaignCreateInput>
    export type CreateLobCampaignMutationError = ErrorType<void>

    /**
 * @summary Create a tenant-owned Lob campaign
 */
export const useCreateLobCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaign>>, TError,{data: BodyType<LobCampaignCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobCampaign>>,
        TError,
        {data: BodyType<LobCampaignCreateInput>},
        TContext
      > => {
      return useMutation(getCreateLobCampaignMutationOptions(options), queryClient);
    }

export const getListLobCampaignDraftsUrl = () => {




  return `/api/lob-mail/campaign-drafts`
}

/**
 * @summary List tenant-owned campaign configuration drafts
 */
export const listLobCampaignDrafts = async ( options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getListLobCampaignDraftsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobCampaignDraftsQueryKey = () => {
    return [
    `/api/lob-mail/campaign-drafts`
    ] as const;
    }


export const getListLobCampaignDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobCampaignDraftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobCampaignDrafts>>> = ({ signal }) => listLobCampaignDrafts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobCampaignDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobCampaignDrafts>>>
export type ListLobCampaignDraftsQueryError = ErrorType<unknown>


export function useListLobCampaignDrafts<TData = Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaignDrafts>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaignDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaignDrafts<TData = Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaignDrafts>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaignDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaignDrafts<TData = Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-owned campaign configuration drafts
 */

export function useListLobCampaignDrafts<TData = Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobCampaignDraftsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobCampaignDraftUrl = () => {




  return `/api/lob-mail/campaign-drafts`
}

/**
 * @summary Save a campaign configuration draft
 */
export const createLobCampaignDraft = async (lobCampaignDraftRequest: LobCampaignDraftRequest, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getCreateLobCampaignDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignDraftRequest)
  }
);}




export const getCreateLobCampaignDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignDraft>>, TError,{data: BodyType<LobCampaignDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignDraft>>, TError,{data: BodyType<LobCampaignDraftRequest>}, TContext> => {

const mutationKey = ['createLobCampaignDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobCampaignDraft>>, {data: BodyType<LobCampaignDraftRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createLobCampaignDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobCampaignDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createLobCampaignDraft>>>
    export type CreateLobCampaignDraftMutationBody = BodyType<LobCampaignDraftRequest>
    export type CreateLobCampaignDraftMutationError = ErrorType<unknown>

    /**
 * @summary Save a campaign configuration draft
 */
export const useCreateLobCampaignDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignDraft>>, TError,{data: BodyType<LobCampaignDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobCampaignDraft>>,
        TError,
        {data: BodyType<LobCampaignDraftRequest>},
        TContext
      > => {
      return useMutation(getCreateLobCampaignDraftMutationOptions(options), queryClient);
    }

export const getGetLobCampaignDraftUrl = (id: string,) => {




  return `/api/lob-mail/campaign-drafts/${id}`
}

/**
 * @summary Get a campaign configuration draft
 */
export const getLobCampaignDraft = async (id: string, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getGetLobCampaignDraftUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobCampaignDraftQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/campaign-drafts/${id}`
    ] as const;
    }


export const getGetLobCampaignDraftQueryOptions = <TData = Awaited<ReturnType<typeof getLobCampaignDraft>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobCampaignDraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobCampaignDraft>>> = ({ signal }) => getLobCampaignDraft(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobCampaignDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getLobCampaignDraft>>>
export type GetLobCampaignDraftQueryError = ErrorType<unknown>


export function useGetLobCampaignDraft<TData = Awaited<ReturnType<typeof getLobCampaignDraft>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignDraft>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignDraft<TData = Awaited<ReturnType<typeof getLobCampaignDraft>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignDraft>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignDraft<TData = Awaited<ReturnType<typeof getLobCampaignDraft>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a campaign configuration draft
 */

export function useGetLobCampaignDraft<TData = Awaited<ReturnType<typeof getLobCampaignDraft>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobCampaignDraftQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobCampaignDraftUrl = (id: string,) => {




  return `/api/lob-mail/campaign-drafts/${id}`
}

/**
 * @summary Update a campaign configuration draft
 */
export const updateLobCampaignDraft = async (id: string,
    lobCampaignDraftRequest: LobCampaignDraftRequest, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateLobCampaignDraftUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignDraftRequest)
  }
);}




export const getUpdateLobCampaignDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignDraftRequest>}, TContext> => {

const mutationKey = ['updateLobCampaignDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobCampaignDraft>>, {id: string;data: BodyType<LobCampaignDraftRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLobCampaignDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobCampaignDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobCampaignDraft>>>
    export type UpdateLobCampaignDraftMutationBody = BodyType<LobCampaignDraftRequest>
    export type UpdateLobCampaignDraftMutationError = ErrorType<unknown>

    /**
 * @summary Update a campaign configuration draft
 */
export const useUpdateLobCampaignDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobCampaignDraft>>,
        TError,
        {id: string;data: BodyType<LobCampaignDraftRequest>},
        TContext
      > => {
      return useMutation(getUpdateLobCampaignDraftMutationOptions(options), queryClient);
    }

export const getContinueLobCampaignDraftUrl = (id: string,) => {




  return `/api/lob-mail/campaign-drafts/${id}/continue`
}

/**
 * @summary Continue a draft by creating a provider campaign
 */
export const continueLobCampaignDraft = async (id: string,
    lobCampaignContinueInput: LobCampaignContinueInput, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getContinueLobCampaignDraftUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignContinueInput)
  }
);}




export const getContinueLobCampaignDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignContinueInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof continueLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignContinueInput>}, TContext> => {

const mutationKey = ['continueLobCampaignDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof continueLobCampaignDraft>>, {id: string;data: BodyType<LobCampaignContinueInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  continueLobCampaignDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ContinueLobCampaignDraftMutationResult = NonNullable<Awaited<ReturnType<typeof continueLobCampaignDraft>>>
    export type ContinueLobCampaignDraftMutationBody = BodyType<LobCampaignContinueInput>
    export type ContinueLobCampaignDraftMutationError = ErrorType<unknown>

    /**
 * @summary Continue a draft by creating a provider campaign
 */
export const useContinueLobCampaignDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueLobCampaignDraft>>, TError,{id: string;data: BodyType<LobCampaignContinueInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof continueLobCampaignDraft>>,
        TError,
        {id: string;data: BodyType<LobCampaignContinueInput>},
        TContext
      > => {
      return useMutation(getContinueLobCampaignDraftMutationOptions(options), queryClient);
    }

export const getGetLobCampaignUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}`
}

/**
 * @summary Get campaign
 */
export const getLobCampaign = async (id: string, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getGetLobCampaignUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobCampaignQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/campaigns/${id}`
    ] as const;
    }


export const getGetLobCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getLobCampaign>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobCampaignQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobCampaign>>> = ({ signal }) => getLobCampaign(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getLobCampaign>>>
export type GetLobCampaignQueryError = ErrorType<unknown>


export function useGetLobCampaign<TData = Awaited<ReturnType<typeof getLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaign>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaign<TData = Awaited<ReturnType<typeof getLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaign>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaign<TData = Awaited<ReturnType<typeof getLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get campaign
 */

export function useGetLobCampaign<TData = Awaited<ReturnType<typeof getLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobCampaignUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}`
}

/**
 * Updates provider campaign fields and locally stored creative configuration. Lob only supports immediate scheduling; now is accepted as a UI compatibility alias and normalized to immediate.
 * @summary Update campaign
 */
export const updateLobCampaign = async (id: string,
    lobCampaignPatchInput: LobCampaignPatchInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateLobCampaignUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignPatchInput)
  }
);}




export const getUpdateLobCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignPatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignPatchInput>}, TContext> => {

const mutationKey = ['updateLobCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobCampaign>>, {id: string;data: BodyType<LobCampaignPatchInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLobCampaign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobCampaign>>>
    export type UpdateLobCampaignMutationBody = BodyType<LobCampaignPatchInput>
    export type UpdateLobCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Update campaign
 */
export const useUpdateLobCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignPatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobCampaign>>,
        TError,
        {id: string;data: BodyType<LobCampaignPatchInput>},
        TContext
      > => {
      return useMutation(getUpdateLobCampaignMutationOptions(options), queryClient);
    }

export const getDeleteLobCampaignUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}`
}

/**
 * @summary Delete campaign
 */
export const deleteLobCampaign = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobCampaignUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobCampaign>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLobCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLobCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobCampaign>>>

    export type DeleteLobCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Delete campaign
 */
export const useDeleteLobCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobCampaign>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLobCampaignMutationOptions(options), queryClient);
    }

export const getGetLobCampaignAudienceDraftUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/audience-draft`
}

/**
 * @summary Read the local campaign audience selection draft
 */
export const getLobCampaignAudienceDraft = async (id: string, options?: RequestInit): Promise<LobCampaignAudienceDraft> => {

  return customFetch<LobCampaignAudienceDraft>(getGetLobCampaignAudienceDraftUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobCampaignAudienceDraftQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/campaigns/${id}/audience-draft`
    ] as const;
    }


export const getGetLobCampaignAudienceDraftQueryOptions = <TData = Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobCampaignAudienceDraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>> = ({ signal }) => getLobCampaignAudienceDraft(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobCampaignAudienceDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>>
export type GetLobCampaignAudienceDraftQueryError = ErrorType<void>


export function useGetLobCampaignAudienceDraft<TData = Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignAudienceDraft<TData = Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignAudienceDraft<TData = Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the local campaign audience selection draft
 */

export function useGetLobCampaignAudienceDraft<TData = Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobCampaignAudienceDraftQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveLobCampaignAudienceDraftUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/audience-draft`
}

/**
 * @summary Save a version-fenced local selection without uploading, approving or sending
 */
export const saveLobCampaignAudienceDraft = async (id: string,
    lobCampaignAudienceDraft: LobCampaignAudienceDraft, options?: RequestInit): Promise<LobCampaignAudienceDraft> => {

  return customFetch<LobCampaignAudienceDraft>(getSaveLobCampaignAudienceDraftUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignAudienceDraft)
  }
);}




export const getSaveLobCampaignAudienceDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>, TError,{id: string;data: BodyType<LobCampaignAudienceDraft>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>, TError,{id: string;data: BodyType<LobCampaignAudienceDraft>}, TContext> => {

const mutationKey = ['saveLobCampaignAudienceDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>, {id: string;data: BodyType<LobCampaignAudienceDraft>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveLobCampaignAudienceDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveLobCampaignAudienceDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>>
    export type SaveLobCampaignAudienceDraftMutationBody = BodyType<LobCampaignAudienceDraft>
    export type SaveLobCampaignAudienceDraftMutationError = ErrorType<void>

    /**
 * @summary Save a version-fenced local selection without uploading, approving or sending
 */
export const useSaveLobCampaignAudienceDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>, TError,{id: string;data: BodyType<LobCampaignAudienceDraft>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveLobCampaignAudienceDraft>>,
        TError,
        {id: string;data: BodyType<LobCampaignAudienceDraft>},
        TContext
      > => {
      return useMutation(getSaveLobCampaignAudienceDraftMutationOptions(options), queryClient);
    }

export const getCreateLobCampaignCreativeUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/creative`
}

/**
 * Creates the Lob creative associated with a tenant-owned campaign, then retrieves it from Lob and proves the provider association, sender, format, and details before recording it as verified. Live setup mutations require live operations to be enabled; no send is performed.
 * @summary Create and verify campaign creative
 */
export const createLobCampaignCreative = async (id: string,
    lobCampaignCreativeInput: LobCampaignCreativeInput, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getCreateLobCampaignCreativeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignCreativeInput)
  }
);}




export const getCreateLobCampaignCreativeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignCreative>>, TError,{id: string;data: BodyType<LobCampaignCreativeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignCreative>>, TError,{id: string;data: BodyType<LobCampaignCreativeInput>}, TContext> => {

const mutationKey = ['createLobCampaignCreative'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobCampaignCreative>>, {id: string;data: BodyType<LobCampaignCreativeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createLobCampaignCreative(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobCampaignCreativeMutationResult = NonNullable<Awaited<ReturnType<typeof createLobCampaignCreative>>>
    export type CreateLobCampaignCreativeMutationBody = BodyType<LobCampaignCreativeInput>
    export type CreateLobCampaignCreativeMutationError = ErrorType<void>

    /**
 * @summary Create and verify campaign creative
 */
export const useCreateLobCampaignCreative = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobCampaignCreative>>, TError,{id: string;data: BodyType<LobCampaignCreativeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobCampaignCreative>>,
        TError,
        {id: string;data: BodyType<LobCampaignCreativeInput>},
        TContext
      > => {
      return useMutation(getCreateLobCampaignCreativeMutationOptions(options), queryClient);
    }

export const getUploadLobCampaignAudienceUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/audience`
}

/**
 * Accepts tenant-owned address IDs as JSON, a registered tenant-private fileId, or text/csv bytes. May be uploaded before creative creation. Live uploads require live operations to be enabled; this creates/transfers the audience only and does not send the campaign.
 * @summary Upload audience to a Lob campaign
 */
export const uploadLobCampaignAudience = async (id: string,
    uploadLobCampaignAudienceBody: LobCampaignAudienceInput | LobCampaignAudienceCsvInput, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getUploadLobCampaignAudienceUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(uploadLobCampaignAudienceBody)
  }
);}




export const getUploadLobCampaignAudienceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLobCampaignAudience>>, TError,{id: string;data: BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadLobCampaignAudience>>, TError,{id: string;data: BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>}, TContext> => {

const mutationKey = ['uploadLobCampaignAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLobCampaignAudience>>, {id: string;data: BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadLobCampaignAudience(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadLobCampaignAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLobCampaignAudience>>>
    export type UploadLobCampaignAudienceMutationBody = BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>
    export type UploadLobCampaignAudienceMutationError = ErrorType<void>

    /**
 * @summary Upload audience to a Lob campaign
 */
export const useUploadLobCampaignAudience = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLobCampaignAudience>>, TError,{id: string;data: BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadLobCampaignAudience>>,
        TError,
        {id: string;data: BodyType<LobCampaignAudienceInput | LobCampaignAudienceCsvInput>},
        TContext
      > => {
      return useMutation(getUploadLobCampaignAudienceMutationOptions(options), queryClient);
    }

export const getReviewLobCampaignUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/review`
}

/**
 * Retrieves the campaign, associated creatives, and upload from Lob. Returns campaign, creative, upload, count, ready, reasons, and proof alongside compatibility fields. Reports readiness without dispatching.
 * @summary Refresh provider-backed campaign readiness
 */
export const reviewLobCampaign = async (id: string, options?: RequestInit): Promise<LobCampaignReviewEnvelope> => {

  return customFetch<LobCampaignReviewEnvelope>(getReviewLobCampaignUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReviewLobCampaignQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/campaigns/${id}/review`
    ] as const;
    }


export const getReviewLobCampaignQueryOptions = <TData = Awaited<ReturnType<typeof reviewLobCampaign>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReviewLobCampaignQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reviewLobCampaign>>> = ({ signal }) => reviewLobCampaign(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReviewLobCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof reviewLobCampaign>>>
export type ReviewLobCampaignQueryError = ErrorType<unknown>


export function useReviewLobCampaign<TData = Awaited<ReturnType<typeof reviewLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewLobCampaign>>,
          TError,
          Awaited<ReturnType<typeof reviewLobCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewLobCampaign<TData = Awaited<ReturnType<typeof reviewLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewLobCampaign>>,
          TError,
          Awaited<ReturnType<typeof reviewLobCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewLobCampaign<TData = Awaited<ReturnType<typeof reviewLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Refresh provider-backed campaign readiness
 */

export function useReviewLobCampaign<TData = Awaited<ReturnType<typeof reviewLobCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewLobCampaign>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReviewLobCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobCampaignAudienceSampleUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/audience-sample`
}

/**
 * Returns only the first three rows of the exact audience CSV transferred to Lob, bound to this tenant, mode, campaign and upload. No creative or mail is created.
 * @summary Read the first three submitted recipients for browser artwork preview
 */
export const getLobCampaignAudienceSample = async (id: string, options?: RequestInit): Promise<GetLobCampaignAudienceSample200> => {

  return customFetch<GetLobCampaignAudienceSample200>(getGetLobCampaignAudienceSampleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobCampaignAudienceSampleQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/campaigns/${id}/audience-sample`
    ] as const;
    }


export const getGetLobCampaignAudienceSampleQueryOptions = <TData = Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobCampaignAudienceSampleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>> = ({ signal }) => getLobCampaignAudienceSample(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobCampaignAudienceSampleQueryResult = NonNullable<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>>
export type GetLobCampaignAudienceSampleQueryError = ErrorType<void>


export function useGetLobCampaignAudienceSample<TData = Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignAudienceSample>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignAudienceSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignAudienceSample<TData = Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignAudienceSample>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignAudienceSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignAudienceSample<TData = Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the first three submitted recipients for browser artwork preview
 */

export function useGetLobCampaignAudienceSample<TData = Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignAudienceSample>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobCampaignAudienceSampleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendLobCampaignUrl = (id: string,) => {




  return `/api/lob-mail/campaigns/${id}/send`
}

/**
 * @summary Send campaign
 */
export const sendLobCampaign = async (id: string,
    lobCampaignSendInput: LobCampaignSendInput, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getSendLobCampaignUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobCampaignSendInput)
  }
);}




export const getSendLobCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignSendInput>}, TContext> => {

const mutationKey = ['sendLobCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendLobCampaign>>, {id: string;data: BodyType<LobCampaignSendInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendLobCampaign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendLobCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof sendLobCampaign>>>
    export type SendLobCampaignMutationBody = BodyType<LobCampaignSendInput>
    export type SendLobCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Send campaign
 */
export const useSendLobCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendLobCampaign>>, TError,{id: string;data: BodyType<LobCampaignSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendLobCampaign>>,
        TError,
        {id: string;data: BodyType<LobCampaignSendInput>},
        TContext
      > => {
      return useMutation(getSendLobCampaignMutationOptions(options), queryClient);
    }

export const getListLobUploadsUrl = () => {




  return `/api/lob-mail/uploads`
}

/**
 * @summary List tenant-owned Lob uploads
 */
export const listLobUploads = async ( options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getListLobUploadsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobUploadsQueryKey = () => {
    return [
    `/api/lob-mail/uploads`
    ] as const;
    }


export const getListLobUploadsQueryOptions = <TData = Awaited<ReturnType<typeof listLobUploads>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobUploadsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobUploads>>> = ({ signal }) => listLobUploads({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobUploadsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobUploads>>>
export type ListLobUploadsQueryError = ErrorType<unknown>


export function useListLobUploads<TData = Awaited<ReturnType<typeof listLobUploads>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobUploads>>,
          TError,
          Awaited<ReturnType<typeof listLobUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobUploads<TData = Awaited<ReturnType<typeof listLobUploads>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobUploads>>,
          TError,
          Awaited<ReturnType<typeof listLobUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobUploads<TData = Awaited<ReturnType<typeof listLobUploads>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-owned Lob uploads
 */

export function useListLobUploads<TData = Awaited<ReturnType<typeof listLobUploads>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobUploadsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobUploadUrl = () => {




  return `/api/lob-mail/uploads`
}

/**
 * @summary Create and submit a private CSV upload
 */
export const createLobUpload = async (createLobUploadBody: CreateLobUploadBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateLobUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLobUploadBody)
  }
);}




export const getCreateLobUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobUpload>>, TError,{data: BodyType<CreateLobUploadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobUpload>>, TError,{data: BodyType<CreateLobUploadBody>}, TContext> => {

const mutationKey = ['createLobUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobUpload>>, {data: BodyType<CreateLobUploadBody>}> = (props) => {
          const {data} = props ?? {};

          return  createLobUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createLobUpload>>>
    export type CreateLobUploadMutationBody = BodyType<CreateLobUploadBody>
    export type CreateLobUploadMutationError = ErrorType<unknown>

    /**
 * @summary Create and submit a private CSV upload
 */
export const useCreateLobUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobUpload>>, TError,{data: BodyType<CreateLobUploadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobUpload>>,
        TError,
        {data: BodyType<CreateLobUploadBody>},
        TContext
      > => {
      return useMutation(getCreateLobUploadMutationOptions(options), queryClient);
    }

export const getRegisterLobPrivateFileUrl = () => {




  return `/api/lob-mail/files`
}

/**
 * @summary Issue a tenant-bound private CSV upload URL for Lob audience import
 */
export const registerLobPrivateFile = async (registerLobPrivateFileBody: RegisterLobPrivateFileBody, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getRegisterLobPrivateFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registerLobPrivateFileBody)
  }
);}




export const getRegisterLobPrivateFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobPrivateFile>>, TError,{data: BodyType<RegisterLobPrivateFileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerLobPrivateFile>>, TError,{data: BodyType<RegisterLobPrivateFileBody>}, TContext> => {

const mutationKey = ['registerLobPrivateFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerLobPrivateFile>>, {data: BodyType<RegisterLobPrivateFileBody>}> = (props) => {
          const {data} = props ?? {};

          return  registerLobPrivateFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterLobPrivateFileMutationResult = NonNullable<Awaited<ReturnType<typeof registerLobPrivateFile>>>
    export type RegisterLobPrivateFileMutationBody = BodyType<RegisterLobPrivateFileBody>
    export type RegisterLobPrivateFileMutationError = ErrorType<void>

    /**
 * @summary Issue a tenant-bound private CSV upload URL for Lob audience import
 */
export const useRegisterLobPrivateFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobPrivateFile>>, TError,{data: BodyType<RegisterLobPrivateFileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerLobPrivateFile>>,
        TError,
        {data: BodyType<RegisterLobPrivateFileBody>},
        TContext
      > => {
      return useMutation(getRegisterLobPrivateFileMutationOptions(options), queryClient);
    }

export const getGetLobUploadUrl = (id: string,) => {




  return `/api/lob-mail/uploads/${id}`
}

/**
 * @summary Get upload
 */
export const getLobUpload = async (id: string, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getGetLobUploadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobUploadQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/uploads/${id}`
    ] as const;
    }


export const getGetLobUploadQueryOptions = <TData = Awaited<ReturnType<typeof getLobUpload>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobUploadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobUpload>>> = ({ signal }) => getLobUpload(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobUploadQueryResult = NonNullable<Awaited<ReturnType<typeof getLobUpload>>>
export type GetLobUploadQueryError = ErrorType<unknown>


export function useGetLobUpload<TData = Awaited<ReturnType<typeof getLobUpload>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUpload>>,
          TError,
          Awaited<ReturnType<typeof getLobUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUpload<TData = Awaited<ReturnType<typeof getLobUpload>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUpload>>,
          TError,
          Awaited<ReturnType<typeof getLobUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUpload<TData = Awaited<ReturnType<typeof getLobUpload>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get upload
 */

export function useGetLobUpload<TData = Awaited<ReturnType<typeof getLobUpload>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobUploadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobUploadUrl = (id: string,) => {




  return `/api/lob-mail/uploads/${id}`
}

/**
 * @summary Update upload metadata
 */
export const updateLobUpload = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateLobUploadUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getUpdateLobUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobUpload>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobUpload>>, TError,{id: string}, TContext> => {

const mutationKey = ['updateLobUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobUpload>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  updateLobUpload(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobUploadMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobUpload>>>

    export type UpdateLobUploadMutationError = ErrorType<unknown>

    /**
 * @summary Update upload metadata
 */
export const useUpdateLobUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobUpload>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobUpload>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUpdateLobUploadMutationOptions(options), queryClient);
    }

export const getDeleteLobUploadUrl = (id: string,) => {




  return `/api/lob-mail/uploads/${id}`
}

/**
 * @summary Delete upload
 */
export const deleteLobUpload = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobUploadUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobUpload>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobUpload>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLobUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobUpload>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLobUpload(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobUploadMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobUpload>>>

    export type DeleteLobUploadMutationError = ErrorType<unknown>

    /**
 * @summary Delete upload
 */
export const useDeleteLobUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobUpload>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobUpload>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLobUploadMutationOptions(options), queryClient);
    }

export const getGetLobUploadReportUrl = (id: string,) => {




  return `/api/lob-mail/uploads/${id}/report`
}

/**
 * @summary Get upload row report
 */
export const getLobUploadReport = async (id: string, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getGetLobUploadReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobUploadReportQueryKey = (id: string,) => {
    return [
    `/api/lob-mail/uploads/${id}/report`
    ] as const;
    }


export const getGetLobUploadReportQueryOptions = <TData = Awaited<ReturnType<typeof getLobUploadReport>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobUploadReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobUploadReport>>> = ({ signal }) => getLobUploadReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobUploadReportQueryResult = NonNullable<Awaited<ReturnType<typeof getLobUploadReport>>>
export type GetLobUploadReportQueryError = ErrorType<unknown>


export function useGetLobUploadReport<TData = Awaited<ReturnType<typeof getLobUploadReport>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUploadReport>>,
          TError,
          Awaited<ReturnType<typeof getLobUploadReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUploadReport<TData = Awaited<ReturnType<typeof getLobUploadReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUploadReport>>,
          TError,
          Awaited<ReturnType<typeof getLobUploadReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUploadReport<TData = Awaited<ReturnType<typeof getLobUploadReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get upload row report
 */

export function useGetLobUploadReport<TData = Awaited<ReturnType<typeof getLobUploadReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobUploadReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobUploadExportUrl = (id: string,) => {




  return `/api/lob-mail/uploads/${id}/exports`
}

/**
 * @summary Create upload export
 */
export const createLobUploadExport = async (id: string,
    createLobUploadExportBody: CreateLobUploadExportBody, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getCreateLobUploadExportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLobUploadExportBody)
  }
);}




export const getCreateLobUploadExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobUploadExport>>, TError,{id: string;data: BodyType<CreateLobUploadExportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobUploadExport>>, TError,{id: string;data: BodyType<CreateLobUploadExportBody>}, TContext> => {

const mutationKey = ['createLobUploadExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobUploadExport>>, {id: string;data: BodyType<CreateLobUploadExportBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  createLobUploadExport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobUploadExportMutationResult = NonNullable<Awaited<ReturnType<typeof createLobUploadExport>>>
    export type CreateLobUploadExportMutationBody = BodyType<CreateLobUploadExportBody>
    export type CreateLobUploadExportMutationError = ErrorType<unknown>

    /**
 * @summary Create upload export
 */
export const useCreateLobUploadExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobUploadExport>>, TError,{id: string;data: BodyType<CreateLobUploadExportBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobUploadExport>>,
        TError,
        {id: string;data: BodyType<CreateLobUploadExportBody>},
        TContext
      > => {
      return useMutation(getCreateLobUploadExportMutationOptions(options), queryClient);
    }

export const getGetLobUploadExportUrl = (id: string,
    exportId: string,) => {




  return `/api/lob-mail/uploads/${id}/exports/${exportId}`
}

/**
 * @summary Get upload export
 */
export const getLobUploadExport = async (id: string,
    exportId: string, options?: RequestInit): Promise<LobBulkEnvelope> => {

  return customFetch<LobBulkEnvelope>(getGetLobUploadExportUrl(id,exportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobUploadExportQueryKey = (id: string,
    exportId: string,) => {
    return [
    `/api/lob-mail/uploads/${id}/exports/${exportId}`
    ] as const;
    }


export const getGetLobUploadExportQueryOptions = <TData = Awaited<ReturnType<typeof getLobUploadExport>>, TError = ErrorType<unknown>>(id: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobUploadExportQueryKey(id,exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobUploadExport>>> = ({ signal }) => getLobUploadExport(id,exportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && exportId !== null && exportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobUploadExportQueryResult = NonNullable<Awaited<ReturnType<typeof getLobUploadExport>>>
export type GetLobUploadExportQueryError = ErrorType<unknown>


export function useGetLobUploadExport<TData = Awaited<ReturnType<typeof getLobUploadExport>>, TError = ErrorType<unknown>>(
 id: string,
    exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUploadExport>>,
          TError,
          Awaited<ReturnType<typeof getLobUploadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUploadExport<TData = Awaited<ReturnType<typeof getLobUploadExport>>, TError = ErrorType<unknown>>(
 id: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobUploadExport>>,
          TError,
          Awaited<ReturnType<typeof getLobUploadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobUploadExport<TData = Awaited<ReturnType<typeof getLobUploadExport>>, TError = ErrorType<unknown>>(
 id: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get upload export
 */

export function useGetLobUploadExport<TData = Awaited<ReturnType<typeof getLobUploadExport>>, TError = ErrorType<unknown>>(
 id: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobUploadExport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobUploadExportQueryOptions(id,exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunLobVerificationUrl = (tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity',) => {




  return `/api/lob-mail/verification/${tool}`
}

/**
 * @summary Run an enabled Lob verification tool
 */
export const runLobVerification = async (tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity',
    lobVerificationInput: LobVerificationInput, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getRunLobVerificationUrl(tool),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobVerificationInput)
  }
);}




export const getRunLobVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runLobVerification>>, TError,{tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity';data: BodyType<LobVerificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runLobVerification>>, TError,{tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity';data: BodyType<LobVerificationInput>}, TContext> => {

const mutationKey = ['runLobVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runLobVerification>>, {tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity';data: BodyType<LobVerificationInput>}> = (props) => {
          const {tool,data} = props ?? {};

          return  runLobVerification(tool,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunLobVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof runLobVerification>>>
    export type RunLobVerificationMutationBody = BodyType<LobVerificationInput>
    export type RunLobVerificationMutationError = ErrorType<unknown>

    /**
 * @summary Run an enabled Lob verification tool
 */
export const useRunLobVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runLobVerification>>, TError,{tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity';data: BodyType<LobVerificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runLobVerification>>,
        TError,
        {tool: 'us' | 'bulk-us' | 'autocomplete' | 'zip' | 'reverse-geocode' | 'international' | 'identity';data: BodyType<LobVerificationInput>},
        TContext
      > => {
      return useMutation(getRunLobVerificationMutationOptions(options), queryClient);
    }

export const getListLobReportEventsUrl = (params?: ListLobReportEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/reports/events?${stringifiedParams}` : `/api/lob-mail/reports/events`
}

/**
 * @summary List tenant-scoped Lob operational events with filtered total in meta.count
 */
export const listLobReportEvents = async (params?: ListLobReportEventsParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getListLobReportEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobReportEventsQueryKey = (params?: ListLobReportEventsParams,) => {
    return [
    `/api/lob-mail/reports/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobReportEventsQueryOptions = <TData = Awaited<ReturnType<typeof listLobReportEvents>>, TError = ErrorType<unknown>>(params?: ListLobReportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobReportEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobReportEvents>>> = ({ signal }) => listLobReportEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobReportEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobReportEvents>>>
export type ListLobReportEventsQueryError = ErrorType<unknown>


export function useListLobReportEvents<TData = Awaited<ReturnType<typeof listLobReportEvents>>, TError = ErrorType<unknown>>(
 params: undefined |  ListLobReportEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobReportEvents>>,
          TError,
          Awaited<ReturnType<typeof listLobReportEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobReportEvents<TData = Awaited<ReturnType<typeof listLobReportEvents>>, TError = ErrorType<unknown>>(
 params?: ListLobReportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobReportEvents>>,
          TError,
          Awaited<ReturnType<typeof listLobReportEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobReportEvents<TData = Awaited<ReturnType<typeof listLobReportEvents>>, TError = ErrorType<unknown>>(
 params?: ListLobReportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-scoped Lob operational events with filtered total in meta.count
 */

export function useListLobReportEvents<TData = Awaited<ReturnType<typeof listLobReportEvents>>, TError = ErrorType<unknown>>(
 params?: ListLobReportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobReportEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobReportEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobReportSummaryUrl = (params?: GetLobReportSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/reports/summary?${stringifiedParams}` : `/api/lob-mail/reports/summary`
}

/**
 * @summary Summarize tenant-scoped provider statuses and webhook events
 */
export const getLobReportSummary = async (params?: GetLobReportSummaryParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getGetLobReportSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobReportSummaryQueryKey = (params?: GetLobReportSummaryParams,) => {
    return [
    `/api/lob-mail/reports/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobReportSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLobReportSummary>>, TError = ErrorType<unknown>>(params?: GetLobReportSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobReportSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobReportSummary>>> = ({ signal }) => getLobReportSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobReportSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLobReportSummary>>>
export type GetLobReportSummaryQueryError = ErrorType<unknown>


export function useGetLobReportSummary<TData = Awaited<ReturnType<typeof getLobReportSummary>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobReportSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobReportSummary>>,
          TError,
          Awaited<ReturnType<typeof getLobReportSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobReportSummary<TData = Awaited<ReturnType<typeof getLobReportSummary>>, TError = ErrorType<unknown>>(
 params?: GetLobReportSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobReportSummary>>,
          TError,
          Awaited<ReturnType<typeof getLobReportSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobReportSummary<TData = Awaited<ReturnType<typeof getLobReportSummary>>, TError = ErrorType<unknown>>(
 params?: GetLobReportSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Summarize tenant-scoped provider statuses and webhook events
 */

export function useGetLobReportSummary<TData = Awaited<ReturnType<typeof getLobReportSummary>>, TError = ErrorType<unknown>>(
 params?: GetLobReportSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobReportSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobReportSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportLobReportEventsCsvUrl = (params?: ExportLobReportEventsCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/reports/events.csv?${stringifiedParams}` : `/api/lob-mail/reports/events.csv`
}

/**
 * @summary Export tenant-scoped Lob operational events
 */
export const exportLobReportEventsCsv = async (params?: ExportLobReportEventsCsvParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportLobReportEventsCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportLobReportEventsCsvQueryKey = (params?: ExportLobReportEventsCsvParams,) => {
    return [
    `/api/lob-mail/reports/events.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportLobReportEventsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError = ErrorType<unknown>>(params?: ExportLobReportEventsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLobReportEventsCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportLobReportEventsCsv>>> = ({ signal }) => exportLobReportEventsCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportLobReportEventsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportLobReportEventsCsv>>>
export type ExportLobReportEventsCsvQueryError = ErrorType<unknown>


export function useExportLobReportEventsCsv<TData = Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError = ErrorType<unknown>>(
 params: undefined |  ExportLobReportEventsCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobReportEventsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportLobReportEventsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobReportEventsCsv<TData = Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError = ErrorType<unknown>>(
 params?: ExportLobReportEventsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLobReportEventsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportLobReportEventsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLobReportEventsCsv<TData = Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError = ErrorType<unknown>>(
 params?: ExportLobReportEventsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export tenant-scoped Lob operational events
 */

export function useExportLobReportEventsCsv<TData = Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError = ErrorType<unknown>>(
 params?: ExportLobReportEventsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLobReportEventsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportLobReportEventsCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMailClientIdentityUrl = (params?: GetMailClientIdentityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tenants/mail-identity?${stringifiedParams}` : `/api/tenants/mail-identity`
}

/**
 * @summary Get the stable mail identity for the authorized client
 */
export const getMailClientIdentity = async (params?: GetMailClientIdentityParams, options?: RequestInit): Promise<MailClientIdentity> => {

  return customFetch<MailClientIdentity>(getGetMailClientIdentityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailClientIdentityQueryKey = (params?: GetMailClientIdentityParams,) => {
    return [
    `/api/tenants/mail-identity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailClientIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getMailClientIdentity>>, TError = ErrorType<void>>(params?: GetMailClientIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailClientIdentityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailClientIdentity>>> = ({ signal }) => getMailClientIdentity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailClientIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getMailClientIdentity>>>
export type GetMailClientIdentityQueryError = ErrorType<void>


export function useGetMailClientIdentity<TData = Awaited<ReturnType<typeof getMailClientIdentity>>, TError = ErrorType<void>>(
 params: undefined |  GetMailClientIdentityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailClientIdentity>>,
          TError,
          Awaited<ReturnType<typeof getMailClientIdentity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailClientIdentity<TData = Awaited<ReturnType<typeof getMailClientIdentity>>, TError = ErrorType<void>>(
 params?: GetMailClientIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailClientIdentity>>,
          TError,
          Awaited<ReturnType<typeof getMailClientIdentity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailClientIdentity<TData = Awaited<ReturnType<typeof getMailClientIdentity>>, TError = ErrorType<void>>(
 params?: GetMailClientIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the stable mail identity for the authorized client
 */

export function useGetMailClientIdentity<TData = Awaited<ReturnType<typeof getMailClientIdentity>>, TError = ErrorType<void>>(
 params?: GetMailClientIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailClientIdentity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailClientIdentityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMailedDesignAssetUrl = (id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/pieces/${id}/design/${assetKey}?${stringifiedParams}` : `/api/lob-mail/mail-analytics/pieces/${id}/design/${assetKey}`
}

/**
 * @summary Read an immutable exact mailed-design asset for an authorized client piece
 */
export const getMailedDesignAsset = async (id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetMailedDesignAssetUrl(id,assetKey,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailedDesignAssetQueryKey = (id: string,
    assetKey: string,
    params?: GetMailedDesignAssetParams,) => {
    return [
    `/api/lob-mail/mail-analytics/pieces/${id}/design/${assetKey}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailedDesignAssetQueryOptions = <TData = Awaited<ReturnType<typeof getMailedDesignAsset>>, TError = ErrorType<void>>(id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailedDesignAssetQueryKey(id,assetKey,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailedDesignAsset>>> = ({ signal }) => getMailedDesignAsset(id,assetKey,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && assetKey !== null && assetKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailedDesignAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getMailedDesignAsset>>>
export type GetMailedDesignAssetQueryError = ErrorType<void>


export function useGetMailedDesignAsset<TData = Awaited<ReturnType<typeof getMailedDesignAsset>>, TError = ErrorType<void>>(
 id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailedDesignAsset>>,
          TError,
          Awaited<ReturnType<typeof getMailedDesignAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailedDesignAsset<TData = Awaited<ReturnType<typeof getMailedDesignAsset>>, TError = ErrorType<void>>(
 id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailedDesignAsset>>,
          TError,
          Awaited<ReturnType<typeof getMailedDesignAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailedDesignAsset<TData = Awaited<ReturnType<typeof getMailedDesignAsset>>, TError = ErrorType<void>>(
 id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read an immutable exact mailed-design asset for an authorized client piece
 */

export function useGetMailedDesignAsset<TData = Awaited<ReturnType<typeof getMailedDesignAsset>>, TError = ErrorType<void>>(
 id: string,
    assetKey: string,
    params: GetMailedDesignAssetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailedDesignAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailedDesignAssetQueryOptions(id,assetKey,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMailAnalyticsReportUrl = (params: GetMailAnalyticsReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics?${stringifiedParams}` : `/api/lob-mail/mail-analytics`
}

/**
 * Returns aggregate activity across the entire filtered mailpiece set. from is inclusive and to is exclusive; dateBasis is UTC occurrence time. Milestone rates use distinct eligible sent pieces with a known sent/creation time strictly before to as their denominator, including pieces sent before from. Tenant scope is derived from the authenticated member or trusted View-As context.
 * @summary Get tenant-scoped, activity-time Lob mail analytics
 */
export const getMailAnalyticsReport = async (params: GetMailAnalyticsReportParams, options?: RequestInit): Promise<MailAnalyticsReportResponse> => {

  return customFetch<MailAnalyticsReportResponse>(getGetMailAnalyticsReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailAnalyticsReportQueryKey = (params?: GetMailAnalyticsReportParams,) => {
    return [
    `/api/lob-mail/mail-analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailAnalyticsReportQueryOptions = <TData = Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError = ErrorType<ErrorResponse>>(params: GetMailAnalyticsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailAnalyticsReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailAnalyticsReport>>> = ({ signal }) => getMailAnalyticsReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailAnalyticsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getMailAnalyticsReport>>>
export type GetMailAnalyticsReportQueryError = ErrorType<ErrorResponse>


export function useGetMailAnalyticsReport<TData = Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError = ErrorType<ErrorResponse>>(
 params: GetMailAnalyticsReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailAnalyticsReport>>,
          TError,
          Awaited<ReturnType<typeof getMailAnalyticsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailAnalyticsReport<TData = Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError = ErrorType<ErrorResponse>>(
 params: GetMailAnalyticsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailAnalyticsReport>>,
          TError,
          Awaited<ReturnType<typeof getMailAnalyticsReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailAnalyticsReport<TData = Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError = ErrorType<ErrorResponse>>(
 params: GetMailAnalyticsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tenant-scoped, activity-time Lob mail analytics
 */

export function useGetMailAnalyticsReport<TData = Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError = ErrorType<ErrorResponse>>(
 params: GetMailAnalyticsReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailAnalyticsReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMailAnalyticsPiecesUrl = (params: ListMailAnalyticsPiecesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/pieces?${stringifiedParams}` : `/api/lob-mail/mail-analytics/pieces`
}

/**
 * Uses the same activity interval and ownership scope as the report. Authorized recipient and exact mailed-design information is returned; raw webhook payloads, credentials and QR IP addresses are excluded.
 * @summary Search and page tenant-owned mailpieces and activity
 */
export const listMailAnalyticsPieces = async (params: ListMailAnalyticsPiecesParams, options?: RequestInit): Promise<MailAnalyticsPiecesResponse> => {

  return customFetch<MailAnalyticsPiecesResponse>(getListMailAnalyticsPiecesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMailAnalyticsPiecesQueryKey = (params?: ListMailAnalyticsPiecesParams,) => {
    return [
    `/api/lob-mail/mail-analytics/pieces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMailAnalyticsPiecesQueryOptions = <TData = Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError = ErrorType<ErrorResponse>>(params: ListMailAnalyticsPiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailAnalyticsPiecesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailAnalyticsPieces>>> = ({ signal }) => listMailAnalyticsPieces(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailAnalyticsPiecesQueryResult = NonNullable<Awaited<ReturnType<typeof listMailAnalyticsPieces>>>
export type ListMailAnalyticsPiecesQueryError = ErrorType<ErrorResponse>


export function useListMailAnalyticsPieces<TData = Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError = ErrorType<ErrorResponse>>(
 params: ListMailAnalyticsPiecesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailAnalyticsPieces>>,
          TError,
          Awaited<ReturnType<typeof listMailAnalyticsPieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailAnalyticsPieces<TData = Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError = ErrorType<ErrorResponse>>(
 params: ListMailAnalyticsPiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailAnalyticsPieces>>,
          TError,
          Awaited<ReturnType<typeof listMailAnalyticsPieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailAnalyticsPieces<TData = Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError = ErrorType<ErrorResponse>>(
 params: ListMailAnalyticsPiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search and page tenant-owned mailpieces and activity
 */

export function useListMailAnalyticsPieces<TData = Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError = ErrorType<ErrorResponse>>(
 params: ListMailAnalyticsPiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailAnalyticsPieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailAnalyticsPiecesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMailAnalyticsPieceUrl = (id: string,
    params: GetMailAnalyticsPieceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/pieces/${id}?${stringifiedParams}` : `/api/lob-mail/mail-analytics/pieces/${id}`
}

/**
 * expectedDeliveryDate is a provider estimate, not an observed delivery. Only coarse provider scan geography is returned; IP addresses and raw provider responses are excluded.
 * @summary Get observed delivery timeline and scan history for one owned mailpiece
 */
export const getMailAnalyticsPiece = async (id: string,
    params: GetMailAnalyticsPieceParams, options?: RequestInit): Promise<MailAnalyticsPieceResponse> => {

  return customFetch<MailAnalyticsPieceResponse>(getGetMailAnalyticsPieceUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMailAnalyticsPieceQueryKey = (id: string,
    params?: GetMailAnalyticsPieceParams,) => {
    return [
    `/api/lob-mail/mail-analytics/pieces/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMailAnalyticsPieceQueryOptions = <TData = Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError = ErrorType<ErrorResponse>>(id: string,
    params: GetMailAnalyticsPieceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMailAnalyticsPieceQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailAnalyticsPiece>>> = ({ signal }) => getMailAnalyticsPiece(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMailAnalyticsPieceQueryResult = NonNullable<Awaited<ReturnType<typeof getMailAnalyticsPiece>>>
export type GetMailAnalyticsPieceQueryError = ErrorType<ErrorResponse>


export function useGetMailAnalyticsPiece<TData = Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError = ErrorType<ErrorResponse>>(
 id: string,
    params: GetMailAnalyticsPieceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailAnalyticsPiece>>,
          TError,
          Awaited<ReturnType<typeof getMailAnalyticsPiece>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailAnalyticsPiece<TData = Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError = ErrorType<ErrorResponse>>(
 id: string,
    params: GetMailAnalyticsPieceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMailAnalyticsPiece>>,
          TError,
          Awaited<ReturnType<typeof getMailAnalyticsPiece>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMailAnalyticsPiece<TData = Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError = ErrorType<ErrorResponse>>(
 id: string,
    params: GetMailAnalyticsPieceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get observed delivery timeline and scan history for one owned mailpiece
 */

export function useGetMailAnalyticsPiece<TData = Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError = ErrorType<ErrorResponse>>(
 id: string,
    params: GetMailAnalyticsPieceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMailAnalyticsPiece>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMailAnalyticsPieceQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshMailAnalyticsUrl = () => {




  return `/api/lob-mail/mail-analytics/refresh`
}

/**
 * Explicit, read-only QR refresh for at most 500 tenant-owned pieces within an overall 28-second deadline, using up to five bounded provider calls of no more than 100 resource IDs each. Confirmed-sent tenant-owned campaigns are eligible for bounded line-item discovery. Persisted filter-scoped resource and campaign cursors permit subsequent calls to continue larger scopes. Provider failures preserve prior observations and report partial or unavailable coverage.
 * @summary Refresh QR observations for tenant-owned mailpieces
 */
export const refreshMailAnalytics = async (mailAnalyticsRefreshInput: MailAnalyticsRefreshInput, options?: RequestInit): Promise<MailAnalyticsRefreshResponse> => {

  return customFetch<MailAnalyticsRefreshResponse>(getRefreshMailAnalyticsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailAnalyticsRefreshInput)
  }
);}




export const getRefreshMailAnalyticsMutationOptions = <TError = ErrorType<ErrorResponse | MailAnalyticsRefreshResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshMailAnalytics>>, TError,{data: BodyType<MailAnalyticsRefreshInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshMailAnalytics>>, TError,{data: BodyType<MailAnalyticsRefreshInput>}, TContext> => {

const mutationKey = ['refreshMailAnalytics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshMailAnalytics>>, {data: BodyType<MailAnalyticsRefreshInput>}> = (props) => {
          const {data} = props ?? {};

          return  refreshMailAnalytics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshMailAnalyticsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshMailAnalytics>>>
    export type RefreshMailAnalyticsMutationBody = BodyType<MailAnalyticsRefreshInput>
    export type RefreshMailAnalyticsMutationError = ErrorType<ErrorResponse | MailAnalyticsRefreshResponse>

    /**
 * @summary Refresh QR observations for tenant-owned mailpieces
 */
export const useRefreshMailAnalytics = <TError = ErrorType<ErrorResponse | MailAnalyticsRefreshResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshMailAnalytics>>, TError,{data: BodyType<MailAnalyticsRefreshInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshMailAnalytics>>,
        TError,
        {data: BodyType<MailAnalyticsRefreshInput>},
        TContext
      > => {
      return useMutation(getRefreshMailAnalyticsMutationOptions(options), queryClient);
    }

export const getExportMailAnalyticsCsvUrl = (params: ExportMailAnalyticsCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/mail-analytics/export.csv?${stringifiedParams}` : `/api/lob-mail/mail-analytics/export.csv`
}

/**
 * Uses the report filters and UTC activity interval. Exports are capped at 10,000 rows, formula-leading cells are escaped, and raw addresses, webhook payloads, QR IP addresses, and account-wide provider resources are excluded.
 * @summary Export filtered tenant-owned mailpiece activity as CSV
 */
export const exportMailAnalyticsCsv = async (params: ExportMailAnalyticsCsvParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportMailAnalyticsCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportMailAnalyticsCsvQueryKey = (params?: ExportMailAnalyticsCsvParams,) => {
    return [
    `/api/lob-mail/mail-analytics/export.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportMailAnalyticsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError = ErrorType<ErrorResponse>>(params: ExportMailAnalyticsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportMailAnalyticsCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>> = ({ signal }) => exportMailAnalyticsCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportMailAnalyticsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>>
export type ExportMailAnalyticsCsvQueryError = ErrorType<ErrorResponse>


export function useExportMailAnalyticsCsv<TData = Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError = ErrorType<ErrorResponse>>(
 params: ExportMailAnalyticsCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportMailAnalyticsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportMailAnalyticsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMailAnalyticsCsv<TData = Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError = ErrorType<ErrorResponse>>(
 params: ExportMailAnalyticsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportMailAnalyticsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportMailAnalyticsCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMailAnalyticsCsv<TData = Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError = ErrorType<ErrorResponse>>(
 params: ExportMailAnalyticsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export filtered tenant-owned mailpiece activity as CSV
 */

export function useExportMailAnalyticsCsv<TData = Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError = ErrorType<ErrorResponse>>(
 params: ExportMailAnalyticsCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMailAnalyticsCsv>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportMailAnalyticsCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobQrAnalyticsUrl = (params: GetLobQrAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/analytics/qr?${stringifiedParams}` : `/api/lob-mail/analytics/qr`
}

/**
 * @summary Get QR analytics for a tenant-owned Lob resource
 */
export const getLobQrAnalytics = async (params: GetLobQrAnalyticsParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getGetLobQrAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobQrAnalyticsQueryKey = (params?: GetLobQrAnalyticsParams,) => {
    return [
    `/api/lob-mail/analytics/qr`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobQrAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getLobQrAnalytics>>, TError = ErrorType<unknown>>(params: GetLobQrAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobQrAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobQrAnalytics>>> = ({ signal }) => getLobQrAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobQrAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getLobQrAnalytics>>>
export type GetLobQrAnalyticsQueryError = ErrorType<unknown>


export function useGetLobQrAnalytics<TData = Awaited<ReturnType<typeof getLobQrAnalytics>>, TError = ErrorType<unknown>>(
 params: GetLobQrAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getLobQrAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrAnalytics<TData = Awaited<ReturnType<typeof getLobQrAnalytics>>, TError = ErrorType<unknown>>(
 params: GetLobQrAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getLobQrAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrAnalytics<TData = Awaited<ReturnType<typeof getLobQrAnalytics>>, TError = ErrorType<unknown>>(
 params: GetLobQrAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get QR analytics for a tenant-owned Lob resource
 */

export function useGetLobQrAnalytics<TData = Awaited<ReturnType<typeof getLobQrAnalytics>>, TError = ErrorType<unknown>>(
 params: GetLobQrAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobQrAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobCampaignQrMailpiecesUrl = (id: string,
    params?: ListLobCampaignQrMailpiecesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/campaigns/${id}/qr-mailpieces?${stringifiedParams}` : `/api/lob-mail/campaigns/${id}/qr-mailpieces`
}

/**
 * Read-only, bounded Lob line-item report and QR analytics lookup. Lob must enable upload line-item report access. No account-wide resource listing or automatic export is performed.
 * @summary Get individually tracked mailpieces from a tenant-owned campaign upload
 */
export const listLobCampaignQrMailpieces = async (id: string,
    params?: ListLobCampaignQrMailpiecesParams, options?: RequestInit): Promise<LobCampaignQrMailpieces> => {

  return customFetch<LobCampaignQrMailpieces>(getListLobCampaignQrMailpiecesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobCampaignQrMailpiecesQueryKey = (id: string,
    params?: ListLobCampaignQrMailpiecesParams,) => {
    return [
    `/api/lob-mail/campaigns/${id}/qr-mailpieces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobCampaignQrMailpiecesQueryOptions = <TData = Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError = ErrorType<void>>(id: string,
    params?: ListLobCampaignQrMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobCampaignQrMailpiecesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>> = ({ signal }) => listLobCampaignQrMailpieces(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobCampaignQrMailpiecesQueryResult = NonNullable<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>>
export type ListLobCampaignQrMailpiecesQueryError = ErrorType<void>


export function useListLobCampaignQrMailpieces<TData = Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  ListLobCampaignQrMailpiecesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaignQrMailpieces<TData = Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobCampaignQrMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>,
          TError,
          Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobCampaignQrMailpieces<TData = Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobCampaignQrMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get individually tracked mailpieces from a tenant-owned campaign upload
 */

export function useListLobCampaignQrMailpieces<TData = Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError = ErrorType<void>>(
 id: string,
    params?: ListLobCampaignQrMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobCampaignQrMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobCampaignQrMailpiecesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobResourceProofUrl = (resourceId: string,
    params?: GetLobResourceProofParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/proofs/${resourceId}?${stringifiedParams}` : `/api/lob-mail/proofs/${resourceId}`
}

/**
 * @summary Get a proof for a tenant-owned Lob resource
 */
export const getLobResourceProof = async (resourceId: string,
    params?: GetLobResourceProofParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getGetLobResourceProofUrl(resourceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobResourceProofQueryKey = (resourceId: string,
    params?: GetLobResourceProofParams,) => {
    return [
    `/api/lob-mail/proofs/${resourceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobResourceProofQueryOptions = <TData = Awaited<ReturnType<typeof getLobResourceProof>>, TError = ErrorType<unknown>>(resourceId: string,
    params?: GetLobResourceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobResourceProofQueryKey(resourceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobResourceProof>>> = ({ signal }) => getLobResourceProof(resourceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: resourceId !== null && resourceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobResourceProofQueryResult = NonNullable<Awaited<ReturnType<typeof getLobResourceProof>>>
export type GetLobResourceProofQueryError = ErrorType<unknown>


export function useGetLobResourceProof<TData = Awaited<ReturnType<typeof getLobResourceProof>>, TError = ErrorType<unknown>>(
 resourceId: string,
    params: undefined |  GetLobResourceProofParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobResourceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobResourceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobResourceProof<TData = Awaited<ReturnType<typeof getLobResourceProof>>, TError = ErrorType<unknown>>(
 resourceId: string,
    params?: GetLobResourceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobResourceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobResourceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobResourceProof<TData = Awaited<ReturnType<typeof getLobResourceProof>>, TError = ErrorType<unknown>>(
 resourceId: string,
    params?: GetLobResourceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a proof for a tenant-owned Lob resource
 */

export function useGetLobResourceProof<TData = Awaited<ReturnType<typeof getLobResourceProof>>, TError = ErrorType<unknown>>(
 resourceId: string,
    params?: GetLobResourceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobResourceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobResourceProofQueryOptions(resourceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobManagedResourcesUrl = (type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/managed/${type}?${stringifiedParams}` : `/api/lob-mail/managed/${type}`
}

/**
 * @summary List tenant-owned Lob domains, links, or proofs
 */
export const listLobManagedResources = async (type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getListLobManagedResourcesUrl(type,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobManagedResourcesQueryKey = (type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams,) => {
    return [
    `/api/lob-mail/managed/${type}`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobManagedResourcesQueryOptions = <TData = Awaited<ReturnType<typeof listLobManagedResources>>, TError = ErrorType<unknown>>(type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobManagedResourcesQueryKey(type,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobManagedResources>>> = ({ signal }) => listLobManagedResources(type,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobManagedResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listLobManagedResources>>>
export type ListLobManagedResourcesQueryError = ErrorType<unknown>


export function useListLobManagedResources<TData = Awaited<ReturnType<typeof listLobManagedResources>>, TError = ErrorType<unknown>>(
 type: 'domains' | 'links' | 'resource_proofs',
    params: undefined |  ListLobManagedResourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobManagedResources>>,
          TError,
          Awaited<ReturnType<typeof listLobManagedResources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobManagedResources<TData = Awaited<ReturnType<typeof listLobManagedResources>>, TError = ErrorType<unknown>>(
 type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobManagedResources>>,
          TError,
          Awaited<ReturnType<typeof listLobManagedResources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobManagedResources<TData = Awaited<ReturnType<typeof listLobManagedResources>>, TError = ErrorType<unknown>>(
 type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-owned Lob domains, links, or proofs
 */

export function useListLobManagedResources<TData = Awaited<ReturnType<typeof listLobManagedResources>>, TError = ErrorType<unknown>>(
 type: 'domains' | 'links' | 'resource_proofs',
    params?: ListLobManagedResourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobManagedResources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobManagedResourcesQueryOptions(type,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobManagedResourceUrl = (type: 'domains' | 'links' | 'resource_proofs',) => {




  return `/api/lob-mail/managed/${type}`
}

/**
 * @summary Create a tenant-owned Lob domain, link, or resource proof
 */
export const createLobManagedResource = async (type: 'domains' | 'links' | 'resource_proofs',
    lobManagedInput: LobManagedInput, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getCreateLobManagedResourceUrl(type),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobManagedInput)
  }
);}




export const getCreateLobManagedResourceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobManagedResource>>, TError,{type: 'domains' | 'links' | 'resource_proofs';data: BodyType<LobManagedInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobManagedResource>>, TError,{type: 'domains' | 'links' | 'resource_proofs';data: BodyType<LobManagedInput>}, TContext> => {

const mutationKey = ['createLobManagedResource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobManagedResource>>, {type: 'domains' | 'links' | 'resource_proofs';data: BodyType<LobManagedInput>}> = (props) => {
          const {type,data} = props ?? {};

          return  createLobManagedResource(type,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobManagedResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createLobManagedResource>>>
    export type CreateLobManagedResourceMutationBody = BodyType<LobManagedInput>
    export type CreateLobManagedResourceMutationError = ErrorType<unknown>

    /**
 * @summary Create a tenant-owned Lob domain, link, or resource proof
 */
export const useCreateLobManagedResource = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobManagedResource>>, TError,{type: 'domains' | 'links' | 'resource_proofs';data: BodyType<LobManagedInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobManagedResource>>,
        TError,
        {type: 'domains' | 'links' | 'resource_proofs';data: BodyType<LobManagedInput>},
        TContext
      > => {
      return useMutation(getCreateLobManagedResourceMutationOptions(options), queryClient);
    }

export const getListLobInsertsUrl = (type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/inventory/${type}?${stringifiedParams}` : `/api/lob-mail/inventory/${type}`
}

/**
 * @summary List tenant-owned Lob cards or buckslips
 */
export const listLobInserts = async (type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getListLobInsertsUrl(type,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobInsertsQueryKey = (type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams,) => {
    return [
    `/api/lob-mail/inventory/${type}`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobInsertsQueryOptions = <TData = Awaited<ReturnType<typeof listLobInserts>>, TError = ErrorType<unknown>>(type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobInsertsQueryKey(type,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobInserts>>> = ({ signal }) => listLobInserts(type,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobInsertsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobInserts>>>
export type ListLobInsertsQueryError = ErrorType<unknown>


export function useListLobInserts<TData = Awaited<ReturnType<typeof listLobInserts>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    params: undefined |  ListLobInsertsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobInserts>>,
          TError,
          Awaited<ReturnType<typeof listLobInserts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobInserts<TData = Awaited<ReturnType<typeof listLobInserts>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobInserts>>,
          TError,
          Awaited<ReturnType<typeof listLobInserts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobInserts<TData = Awaited<ReturnType<typeof listLobInserts>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant-owned Lob cards or buckslips
 */

export function useListLobInserts<TData = Awaited<ReturnType<typeof listLobInserts>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    params?: ListLobInsertsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInserts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobInsertsQueryOptions(type,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobInsertUrl = (type: 'cards' | 'buckslips',) => {




  return `/api/lob-mail/inventory/${type}`
}

/**
 * @summary Create a card or buckslip
 */
export const createLobInsert = async (type: 'cards' | 'buckslips',
    lobInsertInput: LobInsertInput, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getCreateLobInsertUrl(type),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobInsertInput)
  }
);}




export const getCreateLobInsertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobInsert>>, TError,{type: 'cards' | 'buckslips';data: BodyType<LobInsertInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobInsert>>, TError,{type: 'cards' | 'buckslips';data: BodyType<LobInsertInput>}, TContext> => {

const mutationKey = ['createLobInsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobInsert>>, {type: 'cards' | 'buckslips';data: BodyType<LobInsertInput>}> = (props) => {
          const {type,data} = props ?? {};

          return  createLobInsert(type,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobInsertMutationResult = NonNullable<Awaited<ReturnType<typeof createLobInsert>>>
    export type CreateLobInsertMutationBody = BodyType<LobInsertInput>
    export type CreateLobInsertMutationError = ErrorType<unknown>

    /**
 * @summary Create a card or buckslip
 */
export const useCreateLobInsert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobInsert>>, TError,{type: 'cards' | 'buckslips';data: BodyType<LobInsertInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobInsert>>,
        TError,
        {type: 'cards' | 'buckslips';data: BodyType<LobInsertInput>},
        TContext
      > => {
      return useMutation(getCreateLobInsertMutationOptions(options), queryClient);
    }

export const getUpdateLobInsertUrl = (type: 'cards' | 'buckslips',
    id: string,) => {




  return `/api/lob-mail/inventory/${type}/${id}`
}

/**
 * @summary Update a tenant-owned card or buckslip
 */
export const updateLobInsert = async (type: 'cards' | 'buckslips',
    id: string,
    lobInsertUpdate: LobInsertUpdate, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getUpdateLobInsertUrl(type,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobInsertUpdate)
  }
);}




export const getUpdateLobInsertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInsertUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInsertUpdate>}, TContext> => {

const mutationKey = ['updateLobInsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobInsert>>, {type: 'cards' | 'buckslips';id: string;data: BodyType<LobInsertUpdate>}> = (props) => {
          const {type,id,data} = props ?? {};

          return  updateLobInsert(type,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobInsertMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobInsert>>>
    export type UpdateLobInsertMutationBody = BodyType<LobInsertUpdate>
    export type UpdateLobInsertMutationError = ErrorType<unknown>

    /**
 * @summary Update a tenant-owned card or buckslip
 */
export const useUpdateLobInsert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInsertUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobInsert>>,
        TError,
        {type: 'cards' | 'buckslips';id: string;data: BodyType<LobInsertUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLobInsertMutationOptions(options), queryClient);
    }

export const getDeleteLobInsertUrl = (type: 'cards' | 'buckslips',
    id: string,) => {




  return `/api/lob-mail/inventory/${type}/${id}`
}

/**
 * @summary Delete a tenant-owned card or buckslip
 */
export const deleteLobInsert = async (type: 'cards' | 'buckslips',
    id: string,
    lobActionConfirmation: LobActionConfirmation, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getDeleteLobInsertUrl(type,id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobActionConfirmation)
  }
);}




export const getDeleteLobInsertMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobActionConfirmation>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobActionConfirmation>}, TContext> => {

const mutationKey = ['deleteLobInsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobInsert>>, {type: 'cards' | 'buckslips';id: string;data: BodyType<LobActionConfirmation>}> = (props) => {
          const {type,id,data} = props ?? {};

          return  deleteLobInsert(type,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobInsertMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobInsert>>>
    export type DeleteLobInsertMutationBody = BodyType<LobActionConfirmation>
    export type DeleteLobInsertMutationError = ErrorType<unknown>

    /**
 * @summary Delete a tenant-owned card or buckslip
 */
export const useDeleteLobInsert = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobInsert>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobActionConfirmation>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobInsert>>,
        TError,
        {type: 'cards' | 'buckslips';id: string;data: BodyType<LobActionConfirmation>},
        TContext
      > => {
      return useMutation(getDeleteLobInsertMutationOptions(options), queryClient);
    }

export const getListLobInsertOrdersUrl = (type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/inventory/${type}/${id}/orders?${stringifiedParams}` : `/api/lob-mail/inventory/${type}/${id}/orders`
}

/**
 * @summary Track locally registered inventory orders
 */
export const listLobInsertOrders = async (type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getListLobInsertOrdersUrl(type,id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobInsertOrdersQueryKey = (type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams,) => {
    return [
    `/api/lob-mail/inventory/${type}/${id}/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobInsertOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listLobInsertOrders>>, TError = ErrorType<unknown>>(type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobInsertOrdersQueryKey(type,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobInsertOrders>>> = ({ signal }) => listLobInsertOrders(type,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobInsertOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listLobInsertOrders>>>
export type ListLobInsertOrdersQueryError = ErrorType<unknown>


export function useListLobInsertOrders<TData = Awaited<ReturnType<typeof listLobInsertOrders>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    id: string,
    params: undefined |  ListLobInsertOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobInsertOrders>>,
          TError,
          Awaited<ReturnType<typeof listLobInsertOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobInsertOrders<TData = Awaited<ReturnType<typeof listLobInsertOrders>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobInsertOrders>>,
          TError,
          Awaited<ReturnType<typeof listLobInsertOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobInsertOrders<TData = Awaited<ReturnType<typeof listLobInsertOrders>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Track locally registered inventory orders
 */

export function useListLobInsertOrders<TData = Awaited<ReturnType<typeof listLobInsertOrders>>, TError = ErrorType<unknown>>(
 type: 'cards' | 'buckslips',
    id: string,
    params?: ListLobInsertOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobInsertOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobInsertOrdersQueryOptions(type,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobInsertOrderUrl = (type: 'cards' | 'buckslips',
    id: string,) => {




  return `/api/lob-mail/inventory/${type}/${id}/orders`
}

/**
 * @summary Order inventory for a tenant-owned insert
 */
export const createLobInsertOrder = async (type: 'cards' | 'buckslips',
    id: string,
    lobInventoryOrderInput: LobInventoryOrderInput, options?: RequestInit): Promise<LobOperationalEnvelope> => {

  return customFetch<LobOperationalEnvelope>(getCreateLobInsertOrderUrl(type,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobInventoryOrderInput)
  }
);}




export const getCreateLobInsertOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobInsertOrder>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInventoryOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobInsertOrder>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInventoryOrderInput>}, TContext> => {

const mutationKey = ['createLobInsertOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobInsertOrder>>, {type: 'cards' | 'buckslips';id: string;data: BodyType<LobInventoryOrderInput>}> = (props) => {
          const {type,id,data} = props ?? {};

          return  createLobInsertOrder(type,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobInsertOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createLobInsertOrder>>>
    export type CreateLobInsertOrderMutationBody = BodyType<LobInventoryOrderInput>
    export type CreateLobInsertOrderMutationError = ErrorType<unknown>

    /**
 * @summary Order inventory for a tenant-owned insert
 */
export const useCreateLobInsertOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobInsertOrder>>, TError,{type: 'cards' | 'buckslips';id: string;data: BodyType<LobInventoryOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobInsertOrder>>,
        TError,
        {type: 'cards' | 'buckslips';id: string;data: BodyType<LobInventoryOrderInput>},
        TContext
      > => {
      return useMutation(getCreateLobInsertOrderMutationOptions(options), queryClient);
    }

export const getGetLobMailAutomationSenderAddressUrl = (addressId: string,
    params: GetLobMailAutomationSenderAddressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/sender-addresses/${addressId}?${stringifiedParams}` : `/api/lob-mail/automation/sender-addresses/${addressId}`
}

/**
 * @summary Read structured sender correction details from an owned snapshot
 */
export const getLobMailAutomationSenderAddress = async (addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options?: RequestInit): Promise<GetLobMailAutomationSenderAddress200> => {

  return customFetch<GetLobMailAutomationSenderAddress200>(getGetLobMailAutomationSenderAddressUrl(addressId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailAutomationSenderAddressQueryKey = (addressId: string,
    params?: GetLobMailAutomationSenderAddressParams,) => {
    return [
    `/api/lob-mail/automation/sender-addresses/${addressId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailAutomationSenderAddressQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError = ErrorType<void>>(addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailAutomationSenderAddressQueryKey(addressId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>> = ({ signal }) => getLobMailAutomationSenderAddress(addressId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: addressId !== null && addressId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailAutomationSenderAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>>
export type GetLobMailAutomationSenderAddressQueryError = ErrorType<void>


export function useGetLobMailAutomationSenderAddress<TData = Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError = ErrorType<void>>(
 addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationSenderAddress<TData = Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError = ErrorType<void>>(
 addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationSenderAddress<TData = Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError = ErrorType<void>>(
 addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read structured sender correction details from an owned snapshot
 */

export function useGetLobMailAutomationSenderAddress<TData = Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError = ErrorType<void>>(
 addressId: string,
    params: GetLobMailAutomationSenderAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationSenderAddress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailAutomationSenderAddressQueryOptions(addressId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobMailAutomationSendersUrl = (params?: ListLobMailAutomationSendersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/senders?${stringifiedParams}` : `/api/lob-mail/automation/senders`
}

/**
 * @summary List registered sender addresses for one Lob environment
 */
export const listLobMailAutomationSenders = async (params?: ListLobMailAutomationSendersParams, options?: RequestInit): Promise<ListLobMailAutomationSenders200> => {

  return customFetch<ListLobMailAutomationSenders200>(getListLobMailAutomationSendersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailAutomationSendersQueryKey = (params?: ListLobMailAutomationSendersParams,) => {
    return [
    `/api/lob-mail/automation/senders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailAutomationSendersQueryOptions = <TData = Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError = ErrorType<void>>(params?: ListLobMailAutomationSendersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailAutomationSendersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMailAutomationSenders>>> = ({ signal }) => listLobMailAutomationSenders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailAutomationSendersQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMailAutomationSenders>>>
export type ListLobMailAutomationSendersQueryError = ErrorType<void>


export function useListLobMailAutomationSenders<TData = Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError = ErrorType<void>>(
 params: undefined |  ListLobMailAutomationSendersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationSenders>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationSenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationSenders<TData = Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationSendersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationSenders>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationSenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationSenders<TData = Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationSendersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List registered sender addresses for one Lob environment
 */

export function useListLobMailAutomationSenders<TData = Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationSendersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationSenders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailAutomationSendersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterLobMailAutomationSenderUrl = (params?: RegisterLobMailAutomationSenderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/senders?${stringifiedParams}` : `/api/lob-mail/automation/senders`
}

/**
 * The address is manually supplied, not derived from CRM columns. Existing addresses must already belong to this tenant and environment. Verification must report deliverable before registration.
 * @summary Register a verified US Lob sender or create and verify one
 */
export const registerLobMailAutomationSender = async (lobAutomationSenderInput: LobAutomationSenderInput,
    params?: RegisterLobMailAutomationSenderParams, options?: RequestInit): Promise<LobAutomationSender> => {

  return customFetch<LobAutomationSender>(getRegisterLobMailAutomationSenderUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAutomationSenderInput)
  }
);}




export const getRegisterLobMailAutomationSenderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobMailAutomationSender>>, TError,{data: BodyType<LobAutomationSenderInput>;params?: RegisterLobMailAutomationSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerLobMailAutomationSender>>, TError,{data: BodyType<LobAutomationSenderInput>;params?: RegisterLobMailAutomationSenderParams}, TContext> => {

const mutationKey = ['registerLobMailAutomationSender'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerLobMailAutomationSender>>, {data: BodyType<LobAutomationSenderInput>;params?: RegisterLobMailAutomationSenderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  registerLobMailAutomationSender(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterLobMailAutomationSenderMutationResult = NonNullable<Awaited<ReturnType<typeof registerLobMailAutomationSender>>>
    export type RegisterLobMailAutomationSenderMutationBody = BodyType<LobAutomationSenderInput>
    export type RegisterLobMailAutomationSenderMutationError = ErrorType<void>

    /**
 * @summary Register a verified US Lob sender or create and verify one
 */
export const useRegisterLobMailAutomationSender = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobMailAutomationSender>>, TError,{data: BodyType<LobAutomationSenderInput>;params?: RegisterLobMailAutomationSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerLobMailAutomationSender>>,
        TError,
        {data: BodyType<LobAutomationSenderInput>;params?: RegisterLobMailAutomationSenderParams},
        TContext
      > => {
      return useMutation(getRegisterLobMailAutomationSenderMutationOptions(options), queryClient);
    }

export const getDeleteLobMailAutomationSenderUrl = (senderId: number,
    params: DeleteLobMailAutomationSenderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/senders/${senderId}?${stringifiedParams}` : `/api/lob-mail/automation/senders/${senderId}`
}

/**
 * @summary Remove a saved sender without deleting provider or historical address records
 */
export const deleteLobMailAutomationSender = async (senderId: number,
    params: DeleteLobMailAutomationSenderParams, options?: RequestInit): Promise<DeleteLobMailAutomationSender200> => {

  return customFetch<DeleteLobMailAutomationSender200>(getDeleteLobMailAutomationSenderUrl(senderId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobMailAutomationSenderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationSender>>, TError,{senderId: number;params: DeleteLobMailAutomationSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationSender>>, TError,{senderId: number;params: DeleteLobMailAutomationSenderParams}, TContext> => {

const mutationKey = ['deleteLobMailAutomationSender'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobMailAutomationSender>>, {senderId: number;params: DeleteLobMailAutomationSenderParams}> = (props) => {
          const {senderId,params} = props ?? {};

          return  deleteLobMailAutomationSender(senderId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobMailAutomationSenderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobMailAutomationSender>>>

    export type DeleteLobMailAutomationSenderMutationError = ErrorType<void>

    /**
 * @summary Remove a saved sender without deleting provider or historical address records
 */
export const useDeleteLobMailAutomationSender = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationSender>>, TError,{senderId: number;params: DeleteLobMailAutomationSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobMailAutomationSender>>,
        TError,
        {senderId: number;params: DeleteLobMailAutomationSenderParams},
        TContext
      > => {
      return useMutation(getDeleteLobMailAutomationSenderMutationOptions(options), queryClient);
    }

export const getSetLobMailAutomationDefaultSenderUrl = (params?: SetLobMailAutomationDefaultSenderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/senders/default?${stringifiedParams}` : `/api/lob-mail/automation/senders/default`
}

/**
 * @summary Reverify and set the default sender for an environment
 */
export const setLobMailAutomationDefaultSender = async (setLobMailAutomationDefaultSenderBody: SetLobMailAutomationDefaultSenderBody,
    params?: SetLobMailAutomationDefaultSenderParams, options?: RequestInit): Promise<LobAutomationSender> => {

  return customFetch<LobAutomationSender>(getSetLobMailAutomationDefaultSenderUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setLobMailAutomationDefaultSenderBody)
  }
);}




export const getSetLobMailAutomationDefaultSenderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>, TError,{data: BodyType<SetLobMailAutomationDefaultSenderBody>;params?: SetLobMailAutomationDefaultSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>, TError,{data: BodyType<SetLobMailAutomationDefaultSenderBody>;params?: SetLobMailAutomationDefaultSenderParams}, TContext> => {

const mutationKey = ['setLobMailAutomationDefaultSender'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>, {data: BodyType<SetLobMailAutomationDefaultSenderBody>;params?: SetLobMailAutomationDefaultSenderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  setLobMailAutomationDefaultSender(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLobMailAutomationDefaultSenderMutationResult = NonNullable<Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>>
    export type SetLobMailAutomationDefaultSenderMutationBody = BodyType<SetLobMailAutomationDefaultSenderBody>
    export type SetLobMailAutomationDefaultSenderMutationError = ErrorType<void>

    /**
 * @summary Reverify and set the default sender for an environment
 */
export const useSetLobMailAutomationDefaultSender = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>, TError,{data: BodyType<SetLobMailAutomationDefaultSenderBody>;params?: SetLobMailAutomationDefaultSenderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLobMailAutomationDefaultSender>>,
        TError,
        {data: BodyType<SetLobMailAutomationDefaultSenderBody>;params?: SetLobMailAutomationDefaultSenderParams},
        TContext
      > => {
      return useMutation(getSetLobMailAutomationDefaultSenderMutationOptions(options), queryClient);
    }

export const getListLobMailAutomationDraftsUrl = (params?: ListLobMailAutomationDraftsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/drafts?${stringifiedParams}` : `/api/lob-mail/automation/drafts`
}

/**
 * @summary List incomplete automation drafts for the selected client
 */
export const listLobMailAutomationDrafts = async (params?: ListLobMailAutomationDraftsParams, options?: RequestInit): Promise<ListLobMailAutomationDrafts200> => {

  return customFetch<ListLobMailAutomationDrafts200>(getListLobMailAutomationDraftsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailAutomationDraftsQueryKey = (params?: ListLobMailAutomationDraftsParams,) => {
    return [
    `/api/lob-mail/automation/drafts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailAutomationDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError = ErrorType<unknown>>(params?: ListLobMailAutomationDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailAutomationDraftsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>> = ({ signal }) => listLobMailAutomationDrafts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailAutomationDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>>
export type ListLobMailAutomationDraftsQueryError = ErrorType<unknown>


export function useListLobMailAutomationDrafts<TData = Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError = ErrorType<unknown>>(
 params: undefined |  ListLobMailAutomationDraftsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationDrafts>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationDrafts<TData = Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError = ErrorType<unknown>>(
 params?: ListLobMailAutomationDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationDrafts>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationDrafts<TData = Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError = ErrorType<unknown>>(
 params?: ListLobMailAutomationDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List incomplete automation drafts for the selected client
 */

export function useListLobMailAutomationDrafts<TData = Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError = ErrorType<unknown>>(
 params?: ListLobMailAutomationDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailAutomationDraftsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobMailAutomationDraftDiscardStatusUrl = (id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/drafts/${id}?${stringifiedParams}` : `/api/lob-mail/automation/drafts/${id}`
}

/**
 * @summary Check whether a tenant-owned draft has a durable discard marker
 */
export const getLobMailAutomationDraftDiscardStatus = async (id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams, options?: RequestInit): Promise<GetLobMailAutomationDraftDiscardStatus200> => {

  return customFetch<GetLobMailAutomationDraftDiscardStatus200>(getGetLobMailAutomationDraftDiscardStatusUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailAutomationDraftDiscardStatusQueryKey = (id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams,) => {
    return [
    `/api/lob-mail/automation/drafts/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailAutomationDraftDiscardStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError = ErrorType<void>>(id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailAutomationDraftDiscardStatusQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>> = ({ signal }) => getLobMailAutomationDraftDiscardStatus(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailAutomationDraftDiscardStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>>
export type GetLobMailAutomationDraftDiscardStatusQueryError = ErrorType<void>


export function useGetLobMailAutomationDraftDiscardStatus<TData = Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetLobMailAutomationDraftDiscardStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationDraftDiscardStatus<TData = Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationDraftDiscardStatus<TData = Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check whether a tenant-owned draft has a durable discard marker
 */

export function useGetLobMailAutomationDraftDiscardStatus<TData = Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError = ErrorType<void>>(
 id: string,
    params?: GetLobMailAutomationDraftDiscardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDraftDiscardStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailAutomationDraftDiscardStatusQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveLobMailAutomationDraftUrl = (id: string,
    params?: SaveLobMailAutomationDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/drafts/${id}?${stringifiedParams}` : `/api/lob-mail/automation/drafts/${id}`
}

/**
 * @summary Autosave an incomplete draft without creating a runnable automation
 */
export const saveLobMailAutomationDraft = async (id: string,
    lobAutomationDraftInput: LobAutomationDraftInput,
    params?: SaveLobMailAutomationDraftParams, options?: RequestInit): Promise<LobAutomationDraft> => {

  return customFetch<LobAutomationDraft>(getSaveLobMailAutomationDraftUrl(id,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobAutomationDraftInput)
  }
);}




export const getSaveLobMailAutomationDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobMailAutomationDraft>>, TError,{id: string;data: BodyType<LobAutomationDraftInput>;params?: SaveLobMailAutomationDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveLobMailAutomationDraft>>, TError,{id: string;data: BodyType<LobAutomationDraftInput>;params?: SaveLobMailAutomationDraftParams}, TContext> => {

const mutationKey = ['saveLobMailAutomationDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveLobMailAutomationDraft>>, {id: string;data: BodyType<LobAutomationDraftInput>;params?: SaveLobMailAutomationDraftParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  saveLobMailAutomationDraft(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveLobMailAutomationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveLobMailAutomationDraft>>>
    export type SaveLobMailAutomationDraftMutationBody = BodyType<LobAutomationDraftInput>
    export type SaveLobMailAutomationDraftMutationError = ErrorType<void>

    /**
 * @summary Autosave an incomplete draft without creating a runnable automation
 */
export const useSaveLobMailAutomationDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLobMailAutomationDraft>>, TError,{id: string;data: BodyType<LobAutomationDraftInput>;params?: SaveLobMailAutomationDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveLobMailAutomationDraft>>,
        TError,
        {id: string;data: BodyType<LobAutomationDraftInput>;params?: SaveLobMailAutomationDraftParams},
        TContext
      > => {
      return useMutation(getSaveLobMailAutomationDraftMutationOptions(options), queryClient);
    }

export const getDeleteLobMailAutomationDraftUrl = (id: string,
    params?: DeleteLobMailAutomationDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/drafts/${id}?${stringifiedParams}` : `/api/lob-mail/automation/drafts/${id}`
}

/**
 * @summary Discard a client draft
 */
export const deleteLobMailAutomationDraft = async (id: string,
    params?: DeleteLobMailAutomationDraftParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobMailAutomationDraftUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobMailAutomationDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>, TError,{id: string;params?: DeleteLobMailAutomationDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>, TError,{id: string;params?: DeleteLobMailAutomationDraftParams}, TContext> => {

const mutationKey = ['deleteLobMailAutomationDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>, {id: string;params?: DeleteLobMailAutomationDraftParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteLobMailAutomationDraft(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobMailAutomationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>>

    export type DeleteLobMailAutomationDraftMutationError = ErrorType<void>

    /**
 * @summary Discard a client draft
 */
export const useDeleteLobMailAutomationDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>, TError,{id: string;params?: DeleteLobMailAutomationDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobMailAutomationDraft>>,
        TError,
        {id: string;params?: DeleteLobMailAutomationDraftParams},
        TContext
      > => {
      return useMutation(getDeleteLobMailAutomationDraftMutationOptions(options), queryClient);
    }

export const getGetLobAutomationStatusUrl = (params: GetLobAutomationStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/status?${stringifiedParams}` : `/api/lob-mail/automation/status`
}

/**
 * @summary Read bounded side-effect-free saved mailing status
 */
export const getLobAutomationStatus = async (params: GetLobAutomationStatusParams, options?: RequestInit): Promise<AutomationStatusResponse> => {

  return customFetch<AutomationStatusResponse>(getGetLobAutomationStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAutomationStatusQueryKey = (params?: GetLobAutomationStatusParams,) => {
    return [
    `/api/lob-mail/automation/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAutomationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLobAutomationStatus>>, TError = ErrorType<void>>(params: GetLobAutomationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAutomationStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAutomationStatus>>> = ({ signal }) => getLobAutomationStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAutomationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAutomationStatus>>>
export type GetLobAutomationStatusQueryError = ErrorType<void>


export function useGetLobAutomationStatus<TData = Awaited<ReturnType<typeof getLobAutomationStatus>>, TError = ErrorType<void>>(
 params: GetLobAutomationStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationStatus<TData = Awaited<ReturnType<typeof getLobAutomationStatus>>, TError = ErrorType<void>>(
 params: GetLobAutomationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationStatus>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationStatus<TData = Awaited<ReturnType<typeof getLobAutomationStatus>>, TError = ErrorType<void>>(
 params: GetLobAutomationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read bounded side-effect-free saved mailing status
 */

export function useGetLobAutomationStatus<TData = Awaited<ReturnType<typeof getLobAutomationStatus>>, TError = ErrorType<void>>(
 params: GetLobAutomationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAutomationStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAutomationStatusIssuesUrl = (runId: number,
    params: GetLobAutomationStatusIssuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/status/runs/${runId}/issues?${stringifiedParams}` : `/api/lob-mail/automation/status/runs/${runId}/issues`
}

/**
 * @summary Read scoped recipient issues without recovering or retrying a run
 */
export const getLobAutomationStatusIssues = async (runId: number,
    params: GetLobAutomationStatusIssuesParams, options?: RequestInit): Promise<AutomationStatusIssues> => {

  return customFetch<AutomationStatusIssues>(getGetLobAutomationStatusIssuesUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAutomationStatusIssuesQueryKey = (runId: number,
    params?: GetLobAutomationStatusIssuesParams,) => {
    return [
    `/api/lob-mail/automation/status/runs/${runId}/issues`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAutomationStatusIssuesQueryOptions = <TData = Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError = ErrorType<void>>(runId: number,
    params: GetLobAutomationStatusIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAutomationStatusIssuesQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>> = ({ signal }) => getLobAutomationStatusIssues(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAutomationStatusIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>>
export type GetLobAutomationStatusIssuesQueryError = ErrorType<void>


export function useGetLobAutomationStatusIssues<TData = Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError = ErrorType<void>>(
 runId: number,
    params: GetLobAutomationStatusIssuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationStatusIssues>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationStatusIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationStatusIssues<TData = Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError = ErrorType<void>>(
 runId: number,
    params: GetLobAutomationStatusIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationStatusIssues>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationStatusIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationStatusIssues<TData = Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError = ErrorType<void>>(
 runId: number,
    params: GetLobAutomationStatusIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read scoped recipient issues without recovering or retrying a run
 */

export function useGetLobAutomationStatusIssues<TData = Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError = ErrorType<void>>(
 runId: number,
    params: GetLobAutomationStatusIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationStatusIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAutomationStatusIssuesQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobMailAutomationDefinitionsUrl = (params?: ListLobMailAutomationDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions?${stringifiedParams}` : `/api/lob-mail/automation/definitions`
}

/**
 * @summary List tenant automation definitions
 */
export const listLobMailAutomationDefinitions = async (params?: ListLobMailAutomationDefinitionsParams, options?: RequestInit): Promise<ListLobMailAutomationDefinitions200> => {

  return customFetch<ListLobMailAutomationDefinitions200>(getListLobMailAutomationDefinitionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailAutomationDefinitionsQueryKey = (params?: ListLobMailAutomationDefinitionsParams,) => {
    return [
    `/api/lob-mail/automation/definitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailAutomationDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError = ErrorType<void>>(params?: ListLobMailAutomationDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailAutomationDefinitionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>> = ({ signal }) => listLobMailAutomationDefinitions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailAutomationDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>>
export type ListLobMailAutomationDefinitionsQueryError = ErrorType<void>


export function useListLobMailAutomationDefinitions<TData = Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError = ErrorType<void>>(
 params: undefined |  ListLobMailAutomationDefinitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationDefinitions<TData = Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationDefinitions<TData = Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant automation definitions
 */

export function useListLobMailAutomationDefinitions<TData = Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailAutomationDefinitionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobMailAutomationDefinitionUrl = (params?: CreateLobMailAutomationDefinitionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions?${stringifiedParams}` : `/api/lob-mail/automation/definitions`
}

/**
 * CRM rules are validated and evaluated against the selected tenant's current imported CRM mirror; webhook assertions do not supply rule values. Sending still requires a reviewed run and user confirmation.
 * @summary Save a one-time, scheduled, or per-contact CRM event automation
 */
export const createLobMailAutomationDefinition = async (lobMailAutomationDefinitionInput: LobMailAutomationDefinitionInput,
    params?: CreateLobMailAutomationDefinitionParams, options?: RequestInit): Promise<LobMailAutomationDefinition> => {

  return customFetch<LobMailAutomationDefinition>(getCreateLobMailAutomationDefinitionUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationDefinitionInput)
  }
);}




export const getCreateLobMailAutomationDefinitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationDefinition>>, TError,{data: BodyType<LobMailAutomationDefinitionInput>;params?: CreateLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationDefinition>>, TError,{data: BodyType<LobMailAutomationDefinitionInput>;params?: CreateLobMailAutomationDefinitionParams}, TContext> => {

const mutationKey = ['createLobMailAutomationDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobMailAutomationDefinition>>, {data: BodyType<LobMailAutomationDefinitionInput>;params?: CreateLobMailAutomationDefinitionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createLobMailAutomationDefinition(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobMailAutomationDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof createLobMailAutomationDefinition>>>
    export type CreateLobMailAutomationDefinitionMutationBody = BodyType<LobMailAutomationDefinitionInput>
    export type CreateLobMailAutomationDefinitionMutationError = ErrorType<void>

    /**
 * @summary Save a one-time, scheduled, or per-contact CRM event automation
 */
export const useCreateLobMailAutomationDefinition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationDefinition>>, TError,{data: BodyType<LobMailAutomationDefinitionInput>;params?: CreateLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobMailAutomationDefinition>>,
        TError,
        {data: BodyType<LobMailAutomationDefinitionInput>;params?: CreateLobMailAutomationDefinitionParams},
        TContext
      > => {
      return useMutation(getCreateLobMailAutomationDefinitionMutationOptions(options), queryClient);
    }

export const getGetLobMailAutomationDefinitionUrl = (id: number,
    params?: GetLobMailAutomationDefinitionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions/${id}?${stringifiedParams}` : `/api/lob-mail/automation/definitions/${id}`
}

/**
 * @summary Load a complete active automation for editing
 */
export const getLobMailAutomationDefinition = async (id: number,
    params?: GetLobMailAutomationDefinitionParams, options?: RequestInit): Promise<LobMailAutomationDefinition> => {

  return customFetch<LobMailAutomationDefinition>(getGetLobMailAutomationDefinitionUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailAutomationDefinitionQueryKey = (id: number,
    params?: GetLobMailAutomationDefinitionParams,) => {
    return [
    `/api/lob-mail/automation/definitions/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailAutomationDefinitionQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError = ErrorType<void>>(id: number,
    params?: GetLobMailAutomationDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailAutomationDefinitionQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>> = ({ signal }) => getLobMailAutomationDefinition(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailAutomationDefinitionQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>>
export type GetLobMailAutomationDefinitionQueryError = ErrorType<void>


export function useGetLobMailAutomationDefinition<TData = Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError = ErrorType<void>>(
 id: number,
    params: undefined |  GetLobMailAutomationDefinitionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationDefinition>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationDefinition<TData = Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError = ErrorType<void>>(
 id: number,
    params?: GetLobMailAutomationDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationDefinition>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationDefinition<TData = Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError = ErrorType<void>>(
 id: number,
    params?: GetLobMailAutomationDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Load a complete active automation for editing
 */

export function useGetLobMailAutomationDefinition<TData = Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError = ErrorType<void>>(
 id: number,
    params?: GetLobMailAutomationDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationDefinition>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailAutomationDefinitionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLobMailAutomationDefinitionUrl = (id: number,
    params?: UpdateLobMailAutomationDefinitionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions/${id}?${stringifiedParams}` : `/api/lob-mail/automation/definitions/${id}`
}

/**
 * Shared changes clear pending previews and approvals. Schedule changes cancel obsolete pending scheduled occurrences. Processing or submitted mail is immutable. Live-send approvals remain separate.
 * @summary Replace local automation settings without submitting mail
 */
export const updateLobMailAutomationDefinition = async (id: number,
    lobMailAutomationDefinitionUpdateInput: LobMailAutomationDefinitionUpdateInput,
    params?: UpdateLobMailAutomationDefinitionParams, options?: RequestInit): Promise<LobMailAutomationDefinition> => {

  return customFetch<LobMailAutomationDefinition>(getUpdateLobMailAutomationDefinitionUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationDefinitionUpdateInput)
  }
);}




export const getUpdateLobMailAutomationDefinitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationDefinitionUpdateInput>;params?: UpdateLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationDefinitionUpdateInput>;params?: UpdateLobMailAutomationDefinitionParams}, TContext> => {

const mutationKey = ['updateLobMailAutomationDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>, {id: number;data: BodyType<LobMailAutomationDefinitionUpdateInput>;params?: UpdateLobMailAutomationDefinitionParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateLobMailAutomationDefinition(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobMailAutomationDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>>
    export type UpdateLobMailAutomationDefinitionMutationBody = BodyType<LobMailAutomationDefinitionUpdateInput>
    export type UpdateLobMailAutomationDefinitionMutationError = ErrorType<void>

    /**
 * @summary Replace local automation settings without submitting mail
 */
export const useUpdateLobMailAutomationDefinition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationDefinitionUpdateInput>;params?: UpdateLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobMailAutomationDefinition>>,
        TError,
        {id: number;data: BodyType<LobMailAutomationDefinitionUpdateInput>;params?: UpdateLobMailAutomationDefinitionParams},
        TContext
      > => {
      return useMutation(getUpdateLobMailAutomationDefinitionMutationOptions(options), queryClient);
    }

export const getArchiveLobMailAutomationDefinitionUrl = (id: number,
    params?: ArchiveLobMailAutomationDefinitionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions/${id}?${stringifiedParams}` : `/api/lob-mail/automation/definitions/${id}`
}

/**
 * @summary Stop future scheduling and cancel pending runs while retaining audit history
 */
export const archiveLobMailAutomationDefinition = async (id: number,
    lobMailAutomationVersionInput: LobMailAutomationVersionInput,
    params?: ArchiveLobMailAutomationDefinitionParams, options?: RequestInit): Promise<LobMailAutomationArchiveResult> => {

  return customFetch<LobMailAutomationArchiveResult>(getArchiveLobMailAutomationDefinitionUrl(id,params),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationVersionInput)
  }
);}




export const getArchiveLobMailAutomationDefinitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationVersionInput>;params?: ArchiveLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationVersionInput>;params?: ArchiveLobMailAutomationDefinitionParams}, TContext> => {

const mutationKey = ['archiveLobMailAutomationDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>, {id: number;data: BodyType<LobMailAutomationVersionInput>;params?: ArchiveLobMailAutomationDefinitionParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  archiveLobMailAutomationDefinition(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveLobMailAutomationDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>>
    export type ArchiveLobMailAutomationDefinitionMutationBody = BodyType<LobMailAutomationVersionInput>
    export type ArchiveLobMailAutomationDefinitionMutationError = ErrorType<void>

    /**
 * @summary Stop future scheduling and cancel pending runs while retaining audit history
 */
export const useArchiveLobMailAutomationDefinition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>, TError,{id: number;data: BodyType<LobMailAutomationVersionInput>;params?: ArchiveLobMailAutomationDefinitionParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveLobMailAutomationDefinition>>,
        TError,
        {id: number;data: BodyType<LobMailAutomationVersionInput>;params?: ArchiveLobMailAutomationDefinitionParams},
        TContext
      > => {
      return useMutation(getArchiveLobMailAutomationDefinitionMutationOptions(options), queryClient);
    }

export const getRescheduleLobMailAutomationRunUrl = (runId: number,
    params?: RescheduleLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/reschedule?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/reschedule`
}

/**
 * Keeps run identity and parent recurrence. Clears preview and approval state. Confirmation is blocked until the new due time. Does not submit mail.
 * @summary Change the due date of one unsubmitted occurrence only
 */
export const rescheduleLobMailAutomationRun = async (runId: number,
    lobMailAutomationRescheduleInput: LobMailAutomationRescheduleInput,
    params?: RescheduleLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationOccurrenceResult> => {

  return customFetch<LobMailAutomationOccurrenceResult>(getRescheduleLobMailAutomationRunUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationRescheduleInput)
  }
);}




export const getRescheduleLobMailAutomationRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRescheduleInput>;params?: RescheduleLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRescheduleInput>;params?: RescheduleLobMailAutomationRunParams}, TContext> => {

const mutationKey = ['rescheduleLobMailAutomationRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>, {runId: number;data: BodyType<LobMailAutomationRescheduleInput>;params?: RescheduleLobMailAutomationRunParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  rescheduleLobMailAutomationRun(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescheduleLobMailAutomationRunMutationResult = NonNullable<Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>>
    export type RescheduleLobMailAutomationRunMutationBody = BodyType<LobMailAutomationRescheduleInput>
    export type RescheduleLobMailAutomationRunMutationError = ErrorType<void>

    /**
 * @summary Change the due date of one unsubmitted occurrence only
 */
export const useRescheduleLobMailAutomationRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRescheduleInput>;params?: RescheduleLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rescheduleLobMailAutomationRun>>,
        TError,
        {runId: number;data: BodyType<LobMailAutomationRescheduleInput>;params?: RescheduleLobMailAutomationRunParams},
        TContext
      > => {
      return useMutation(getRescheduleLobMailAutomationRunMutationOptions(options), queryClient);
    }

export const getPauseLobMailAutomationDispatchUrl = (runId: number,
    params?: PauseLobMailAutomationDispatchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/dispatch/pause?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/dispatch/pause`
}

/**
 * Original confirming members and agency administrators may pause the durable queue. This does not recall accepted mail; already submitted requests may finish. Saved checks and provider outcomes remain unchanged.
 * @summary Pause future submissions on the same confirmed mailing
 */
export const pauseLobMailAutomationDispatch = async (runId: number,
    pauseLobMailAutomationDispatchBody: PauseLobMailAutomationDispatchBody,
    params?: PauseLobMailAutomationDispatchParams, options?: RequestInit): Promise<PauseLobMailAutomationDispatch200> => {

  return customFetch<PauseLobMailAutomationDispatch200>(getPauseLobMailAutomationDispatchUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pauseLobMailAutomationDispatchBody)
  }
);}




export const getPauseLobMailAutomationDispatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>, TError,{runId: number;data: BodyType<PauseLobMailAutomationDispatchBody>;params?: PauseLobMailAutomationDispatchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>, TError,{runId: number;data: BodyType<PauseLobMailAutomationDispatchBody>;params?: PauseLobMailAutomationDispatchParams}, TContext> => {

const mutationKey = ['pauseLobMailAutomationDispatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>, {runId: number;data: BodyType<PauseLobMailAutomationDispatchBody>;params?: PauseLobMailAutomationDispatchParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  pauseLobMailAutomationDispatch(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseLobMailAutomationDispatchMutationResult = NonNullable<Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>>
    export type PauseLobMailAutomationDispatchMutationBody = BodyType<PauseLobMailAutomationDispatchBody>
    export type PauseLobMailAutomationDispatchMutationError = ErrorType<void>

    /**
 * @summary Pause future submissions on the same confirmed mailing
 */
export const usePauseLobMailAutomationDispatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>, TError,{runId: number;data: BodyType<PauseLobMailAutomationDispatchBody>;params?: PauseLobMailAutomationDispatchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pauseLobMailAutomationDispatch>>,
        TError,
        {runId: number;data: BodyType<PauseLobMailAutomationDispatchBody>;params?: PauseLobMailAutomationDispatchParams},
        TContext
      > => {
      return useMutation(getPauseLobMailAutomationDispatchMutationOptions(options), queryClient);
    }

export const getCancelLobMailAutomationRunUrl = (runId: number,
    params?: CancelLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/cancel?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/cancel`
}

/**
 * @summary Cancel one unsubmitted occurrence without stopping recurrence
 */
export const cancelLobMailAutomationRun = async (runId: number,
    lobMailAutomationVersionInput: LobMailAutomationVersionInput,
    params?: CancelLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationOccurrenceResult> => {

  return customFetch<LobMailAutomationOccurrenceResult>(getCancelLobMailAutomationRunUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationVersionInput)
  }
);}




export const getCancelLobMailAutomationRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationVersionInput>;params?: CancelLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationVersionInput>;params?: CancelLobMailAutomationRunParams}, TContext> => {

const mutationKey = ['cancelLobMailAutomationRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelLobMailAutomationRun>>, {runId: number;data: BodyType<LobMailAutomationVersionInput>;params?: CancelLobMailAutomationRunParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  cancelLobMailAutomationRun(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelLobMailAutomationRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelLobMailAutomationRun>>>
    export type CancelLobMailAutomationRunMutationBody = BodyType<LobMailAutomationVersionInput>
    export type CancelLobMailAutomationRunMutationError = ErrorType<void>

    /**
 * @summary Cancel one unsubmitted occurrence without stopping recurrence
 */
export const useCancelLobMailAutomationRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationVersionInput>;params?: CancelLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelLobMailAutomationRun>>,
        TError,
        {runId: number;data: BodyType<LobMailAutomationVersionInput>;params?: CancelLobMailAutomationRunParams},
        TContext
      > => {
      return useMutation(getCancelLobMailAutomationRunMutationOptions(options), queryClient);
    }

export const getCreateLobMailAutomationRunUrl = (id: number,
    params?: CreateLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions/${id}/runs?${stringifiedParams}` : `/api/lob-mail/automation/definitions/${id}/runs`
}

/**
 * Resolves the current eligible audience and returns its count; this queues a run and does not send mail. Live availability and configuration are checked here; recipient review and explicit live confirmation are required at final confirmation.
 * @summary Create a reviewed run for a one-time automation
 */
export const createLobMailAutomationRun = async (id: number,
    lobMailAutomationPreparation?: LobMailAutomationPreparation,
    params?: CreateLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationRunCreated> => {

  return customFetch<LobMailAutomationRunCreated>(getCreateLobMailAutomationRunUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationPreparation)
  }
);}




export const getCreateLobMailAutomationRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationRun>>, TError,{id: number;data?: BodyType<LobMailAutomationPreparation>;params?: CreateLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationRun>>, TError,{id: number;data?: BodyType<LobMailAutomationPreparation>;params?: CreateLobMailAutomationRunParams}, TContext> => {

const mutationKey = ['createLobMailAutomationRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobMailAutomationRun>>, {id: number;data?: BodyType<LobMailAutomationPreparation>;params?: CreateLobMailAutomationRunParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  createLobMailAutomationRun(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobMailAutomationRunMutationResult = NonNullable<Awaited<ReturnType<typeof createLobMailAutomationRun>>>
    export type CreateLobMailAutomationRunMutationBody = BodyType<LobMailAutomationPreparation> | undefined
    export type CreateLobMailAutomationRunMutationError = ErrorType<void>

    /**
 * @summary Create a reviewed run for a one-time automation
 */
export const useCreateLobMailAutomationRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationRun>>, TError,{id: number;data?: BodyType<LobMailAutomationPreparation>;params?: CreateLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobMailAutomationRun>>,
        TError,
        {id: number;data?: BodyType<LobMailAutomationPreparation>;params?: CreateLobMailAutomationRunParams},
        TContext
      > => {
      return useMutation(getCreateLobMailAutomationRunMutationOptions(options), queryClient);
    }

export const getCreateLobMailAutomationEventRunUrl = (id: number,
    params?: CreateLobMailAutomationEventRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/definitions/${id}/events?${stringifiedParams}` : `/api/lob-mail/automation/definitions/${id}/events`
}

/**
 * Event data carries only CRM record identity and a stable event key. Rules are checked against the current tenant CRM mirror; a matching event creates a run for exactly one contact and still requires review and confirmation before dispatch.
 * @summary Evaluate a CRM contact against an enabled per-contact event automation
 */
export const createLobMailAutomationEventRun = async (id: number,
    lobMailEventStartInput: LobMailEventStartInput,
    params?: CreateLobMailAutomationEventRunParams, options?: RequestInit): Promise<LobMailAutomationEventRunResult> => {

  return customFetch<LobMailAutomationEventRunResult>(getCreateLobMailAutomationEventRunUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailEventStartInput)
  }
);}




export const getCreateLobMailAutomationEventRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationEventRun>>, TError,{id: number;data: BodyType<LobMailEventStartInput>;params?: CreateLobMailAutomationEventRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationEventRun>>, TError,{id: number;data: BodyType<LobMailEventStartInput>;params?: CreateLobMailAutomationEventRunParams}, TContext> => {

const mutationKey = ['createLobMailAutomationEventRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobMailAutomationEventRun>>, {id: number;data: BodyType<LobMailEventStartInput>;params?: CreateLobMailAutomationEventRunParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  createLobMailAutomationEventRun(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobMailAutomationEventRunMutationResult = NonNullable<Awaited<ReturnType<typeof createLobMailAutomationEventRun>>>
    export type CreateLobMailAutomationEventRunMutationBody = BodyType<LobMailEventStartInput>
    export type CreateLobMailAutomationEventRunMutationError = ErrorType<void>

    /**
 * @summary Evaluate a CRM contact against an enabled per-contact event automation
 */
export const useCreateLobMailAutomationEventRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationEventRun>>, TError,{id: number;data: BodyType<LobMailEventStartInput>;params?: CreateLobMailAutomationEventRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobMailAutomationEventRun>>,
        TError,
        {id: number;data: BodyType<LobMailEventStartInput>;params?: CreateLobMailAutomationEventRunParams},
        TContext
      > => {
      return useMutation(getCreateLobMailAutomationEventRunMutationOptions(options), queryClient);
    }

export const getStartLobMailPreparationUrl = (runId: number,
    params?: StartLobMailPreparationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/start?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/start`
}

/**
 * Saves the original actor and selected input identity. Continues without a browser; no repeat approvals are inferred. Existing Lob request and dispatch safeguards are unchanged.
 * @summary Authorize durable LIVE recipient checks and automatic dispatch handoff
 */
export const startLobMailPreparation = async (runId: number,
    mailPreparationStartInput: MailPreparationStartInput,
    params?: StartLobMailPreparationParams, options?: RequestInit): Promise<MailPreparationReceipt> => {

  return customFetch<MailPreparationReceipt>(getStartLobMailPreparationUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailPreparationStartInput)
  }
);}




export const getStartLobMailPreparationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startLobMailPreparation>>, TError,{runId: number;data: BodyType<MailPreparationStartInput>;params?: StartLobMailPreparationParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startLobMailPreparation>>, TError,{runId: number;data: BodyType<MailPreparationStartInput>;params?: StartLobMailPreparationParams}, TContext> => {

const mutationKey = ['startLobMailPreparation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startLobMailPreparation>>, {runId: number;data: BodyType<MailPreparationStartInput>;params?: StartLobMailPreparationParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  startLobMailPreparation(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartLobMailPreparationMutationResult = NonNullable<Awaited<ReturnType<typeof startLobMailPreparation>>>
    export type StartLobMailPreparationMutationBody = BodyType<MailPreparationStartInput>
    export type StartLobMailPreparationMutationError = ErrorType<void>

    /**
 * @summary Authorize durable LIVE recipient checks and automatic dispatch handoff
 */
export const useStartLobMailPreparation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startLobMailPreparation>>, TError,{runId: number;data: BodyType<MailPreparationStartInput>;params?: StartLobMailPreparationParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startLobMailPreparation>>,
        TError,
        {runId: number;data: BodyType<MailPreparationStartInput>;params?: StartLobMailPreparationParams},
        TContext
      > => {
      return useMutation(getStartLobMailPreparationMutationOptions(options), queryClient);
    }

export const getConfirmLobMailAutomationRunUrl = (runId: number,
    params?: ConfirmLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/confirm?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/confirm`
}

/**
 * Re-resolves the audience immediately before dispatch and rejects changed inputs. Large runs and incremental requests use durable actor-bound confirmation checks and short dispatch batches; continue HTTP 202 responses with the same approval body. Live paid dispatch requires the exact confirmation phrase, live-operation gate, and live-enabled configuration on every batch. Each piece retains its own merge variables and native QR tracking payload. Uncertain provider outcomes require reconciliation, never automatic replay.
 * @summary Confirm a reviewed run and dispatch its individual mail pieces
 */
export const confirmLobMailAutomationRun = async (runId: number,
    lobMailAutomationRunConfirmInput: LobMailAutomationRunConfirmInput,
    params?: ConfirmLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationRunDispatchResult | LobMailDispatchProgress> => {

  return customFetch<LobMailAutomationRunDispatchResult | LobMailDispatchProgress>(getConfirmLobMailAutomationRunUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationRunConfirmInput)
  }
);}




export const getConfirmLobMailAutomationRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRunConfirmInput>;params?: ConfirmLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRunConfirmInput>;params?: ConfirmLobMailAutomationRunParams}, TContext> => {

const mutationKey = ['confirmLobMailAutomationRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmLobMailAutomationRun>>, {runId: number;data: BodyType<LobMailAutomationRunConfirmInput>;params?: ConfirmLobMailAutomationRunParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  confirmLobMailAutomationRun(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmLobMailAutomationRunMutationResult = NonNullable<Awaited<ReturnType<typeof confirmLobMailAutomationRun>>>
    export type ConfirmLobMailAutomationRunMutationBody = BodyType<LobMailAutomationRunConfirmInput>
    export type ConfirmLobMailAutomationRunMutationError = ErrorType<void>

    /**
 * @summary Confirm a reviewed run and dispatch its individual mail pieces
 */
export const useConfirmLobMailAutomationRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmLobMailAutomationRun>>, TError,{runId: number;data: BodyType<LobMailAutomationRunConfirmInput>;params?: ConfirmLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmLobMailAutomationRun>>,
        TError,
        {runId: number;data: BodyType<LobMailAutomationRunConfirmInput>;params?: ConfirmLobMailAutomationRunParams},
        TContext
      > => {
      return useMutation(getConfirmLobMailAutomationRunMutationOptions(options), queryClient);
    }

export const getPreviewLobMailAutomationRunUrl = (runId: number,
    params?: PreviewLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}/preview?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}/preview`
}

/**
 * Resolves the current audience, validates sender/address/artwork/merge data and returns per-contact ready/held/repeat-review outcomes without creating Lob mail. The SHA-256 preview fingerprint binds later confirmation to the reviewed audience and payloads. Repeat sends require explicit per-contact approval IDs and the repeat-approval phrase.
 * @summary Preflight every recipient and show the resolved individual mail-piece payloads
 */
export const previewLobMailAutomationRun = async (runId: number,
    lobMailAutomationRunPreviewInput?: LobMailAutomationRunPreviewInput,
    params?: PreviewLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationRunPreview | LobMailPreviewProgress> => {

  return customFetch<LobMailAutomationRunPreview | LobMailPreviewProgress>(getPreviewLobMailAutomationRunUrl(runId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAutomationRunPreviewInput)
  }
);}




export const getPreviewLobMailAutomationRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobMailAutomationRun>>, TError,{runId: number;data?: BodyType<LobMailAutomationRunPreviewInput>;params?: PreviewLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobMailAutomationRun>>, TError,{runId: number;data?: BodyType<LobMailAutomationRunPreviewInput>;params?: PreviewLobMailAutomationRunParams}, TContext> => {

const mutationKey = ['previewLobMailAutomationRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobMailAutomationRun>>, {runId: number;data?: BodyType<LobMailAutomationRunPreviewInput>;params?: PreviewLobMailAutomationRunParams}> = (props) => {
          const {runId,data,params} = props ?? {};

          return  previewLobMailAutomationRun(runId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobMailAutomationRunMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobMailAutomationRun>>>
    export type PreviewLobMailAutomationRunMutationBody = BodyType<LobMailAutomationRunPreviewInput> | undefined
    export type PreviewLobMailAutomationRunMutationError = ErrorType<void>

    /**
 * @summary Preflight every recipient and show the resolved individual mail-piece payloads
 */
export const usePreviewLobMailAutomationRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobMailAutomationRun>>, TError,{runId: number;data?: BodyType<LobMailAutomationRunPreviewInput>;params?: PreviewLobMailAutomationRunParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobMailAutomationRun>>,
        TError,
        {runId: number;data?: BodyType<LobMailAutomationRunPreviewInput>;params?: PreviewLobMailAutomationRunParams},
        TContext
      > => {
      return useMutation(getPreviewLobMailAutomationRunMutationOptions(options), queryClient);
    }

export const getGetLobMailAutomationRunUrl = (runId: number,
    params?: GetLobMailAutomationRunParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs/${runId}?${stringifiedParams}` : `/api/lob-mail/automation/runs/${runId}`
}

/**
 * Payload/recipient PII is omitted. Confirmed dispatch checkpoints survive operator pauses; only abandoned unconfirmed processing is quarantined. Optional queue state is read-only.
 * @summary Read run status and per-recipient outcome summaries
 */
export const getLobMailAutomationRun = async (runId: number,
    params?: GetLobMailAutomationRunParams, options?: RequestInit): Promise<LobMailAutomationRunDetail> => {

  return customFetch<LobMailAutomationRunDetail>(getGetLobMailAutomationRunUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailAutomationRunQueryKey = (runId: number,
    params?: GetLobMailAutomationRunParams,) => {
    return [
    `/api/lob-mail/automation/runs/${runId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailAutomationRunQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError = ErrorType<void>>(runId: number,
    params?: GetLobMailAutomationRunParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailAutomationRunQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailAutomationRun>>> = ({ signal }) => getLobMailAutomationRun(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailAutomationRunQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailAutomationRun>>>
export type GetLobMailAutomationRunQueryError = ErrorType<void>


export function useGetLobMailAutomationRun<TData = Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError = ErrorType<void>>(
 runId: number,
    params: undefined |  GetLobMailAutomationRunParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationRun>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationRun<TData = Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError = ErrorType<void>>(
 runId: number,
    params?: GetLobMailAutomationRunParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomationRun>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomationRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomationRun<TData = Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError = ErrorType<void>>(
 runId: number,
    params?: GetLobMailAutomationRunParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read run status and per-recipient outcome summaries
 */

export function useGetLobMailAutomationRun<TData = Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError = ErrorType<void>>(
 runId: number,
    params?: GetLobMailAutomationRunParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomationRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailAutomationRunQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLobMailAutomationRunsUrl = (params?: ListLobMailAutomationRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/runs?${stringifiedParams}` : `/api/lob-mail/automation/runs`
}

/**
 * Returns safe run summaries with automation name, scheduled time, recipient count, preview time, and no recipient payloads or PII.
 * @summary List tenant automation runs by status
 */
export const listLobMailAutomationRuns = async (params?: ListLobMailAutomationRunsParams, options?: RequestInit): Promise<LobMailAutomationRunListResponse> => {

  return customFetch<LobMailAutomationRunListResponse>(getListLobMailAutomationRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLobMailAutomationRunsQueryKey = (params?: ListLobMailAutomationRunsParams,) => {
    return [
    `/api/lob-mail/automation/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLobMailAutomationRunsQueryOptions = <TData = Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError = ErrorType<void>>(params?: ListLobMailAutomationRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLobMailAutomationRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLobMailAutomationRuns>>> = ({ signal }) => listLobMailAutomationRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLobMailAutomationRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listLobMailAutomationRuns>>>
export type ListLobMailAutomationRunsQueryError = ErrorType<void>


export function useListLobMailAutomationRuns<TData = Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError = ErrorType<void>>(
 params: undefined |  ListLobMailAutomationRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationRuns>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationRuns<TData = Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLobMailAutomationRuns>>,
          TError,
          Awaited<ReturnType<typeof listLobMailAutomationRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLobMailAutomationRuns<TData = Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tenant automation runs by status
 */

export function useListLobMailAutomationRuns<TData = Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError = ErrorType<void>>(
 params?: ListLobMailAutomationRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLobMailAutomationRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLobMailAutomationRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnqueueDueLobMailAutomationRunsUrl = () => {




  return `/api/internal/lob-mail/automation/scheduler/tick`
}

/**
 * Internal scheduler endpoint authenticated by the configured scheduler bearer token. The API also polls on a 5–300 second timer controlled by LOB_MAIL_SCHEDULER_POLL_MS (default 30 seconds). This endpoint only creates reviewable runs; a user must preview and confirm each run before dispatch.
 * @summary Enqueue due scheduled automation runs
 */
export const enqueueDueLobMailAutomationRuns = async ( options?: RequestInit): Promise<LobMailAutomationSchedulerResult> => {

  return customFetch<LobMailAutomationSchedulerResult>(getEnqueueDueLobMailAutomationRunsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEnqueueDueLobMailAutomationRunsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>, TError,void, TContext> => {

const mutationKey = ['enqueueDueLobMailAutomationRuns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>, void> = () => {


          return  enqueueDueLobMailAutomationRuns(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnqueueDueLobMailAutomationRunsMutationResult = NonNullable<Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>>

    export type EnqueueDueLobMailAutomationRunsMutationError = ErrorType<void>

    /**
 * @summary Enqueue due scheduled automation runs
 */
export const useEnqueueDueLobMailAutomationRuns = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enqueueDueLobMailAutomationRuns>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEnqueueDueLobMailAutomationRunsMutationOptions(options), queryClient);
    }

export const getGetLobMailAutomationUrl = (params?: GetLobMailAutomationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation?${stringifiedParams}` : `/api/lob-mail/automation`
}

/**
 * @summary Get current tenant mail automation integration status and Lob assets
 */
export const getLobMailAutomation = async (params?: GetLobMailAutomationParams, options?: RequestInit): Promise<LobMailAutomationResponse> => {

  return customFetch<LobMailAutomationResponse>(getGetLobMailAutomationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobMailAutomationQueryKey = (params?: GetLobMailAutomationParams,) => {
    return [
    `/api/lob-mail/automation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobMailAutomationQueryOptions = <TData = Awaited<ReturnType<typeof getLobMailAutomation>>, TError = ErrorType<unknown>>(params?: GetLobMailAutomationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobMailAutomationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobMailAutomation>>> = ({ signal }) => getLobMailAutomation(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobMailAutomationQueryResult = NonNullable<Awaited<ReturnType<typeof getLobMailAutomation>>>
export type GetLobMailAutomationQueryError = ErrorType<unknown>


export function useGetLobMailAutomation<TData = Awaited<ReturnType<typeof getLobMailAutomation>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobMailAutomationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomation>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomation<TData = Awaited<ReturnType<typeof getLobMailAutomation>>, TError = ErrorType<unknown>>(
 params?: GetLobMailAutomationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobMailAutomation>>,
          TError,
          Awaited<ReturnType<typeof getLobMailAutomation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobMailAutomation<TData = Awaited<ReturnType<typeof getLobMailAutomation>>, TError = ErrorType<unknown>>(
 params?: GetLobMailAutomationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current tenant mail automation integration status and Lob assets
 */

export function useGetLobMailAutomation<TData = Awaited<ReturnType<typeof getLobMailAutomation>>, TError = ErrorType<unknown>>(
 params?: GetLobMailAutomationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobMailAutomation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobMailAutomationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewLobMailAudienceUrl = (params?: ReviewLobMailAudienceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/audience-review?${stringifiedParams}` : `/api/lob-mail/automation/audience-review`
}

/**
 * @summary Check selected artwork and QR merge fields and exclude incomplete recipients without sending mail
 */
export const reviewLobMailAudience = async (lobMailAudienceReviewInput: LobMailAudienceReviewInput,
    params?: ReviewLobMailAudienceParams, options?: RequestInit): Promise<LobMailAudienceReview> => {

  return customFetch<LobMailAudienceReview>(getReviewLobMailAudienceUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobMailAudienceReviewInput)
  }
);}




export const getReviewLobMailAudienceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewLobMailAudience>>, TError,{data: BodyType<LobMailAudienceReviewInput>;params?: ReviewLobMailAudienceParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewLobMailAudience>>, TError,{data: BodyType<LobMailAudienceReviewInput>;params?: ReviewLobMailAudienceParams}, TContext> => {

const mutationKey = ['reviewLobMailAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewLobMailAudience>>, {data: BodyType<LobMailAudienceReviewInput>;params?: ReviewLobMailAudienceParams}> = (props) => {
          const {data,params} = props ?? {};

          return  reviewLobMailAudience(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewLobMailAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof reviewLobMailAudience>>>
    export type ReviewLobMailAudienceMutationBody = BodyType<LobMailAudienceReviewInput>
    export type ReviewLobMailAudienceMutationError = ErrorType<void>

    /**
 * @summary Check selected artwork and QR merge fields and exclude incomplete recipients without sending mail
 */
export const useReviewLobMailAudience = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewLobMailAudience>>, TError,{data: BodyType<LobMailAudienceReviewInput>;params?: ReviewLobMailAudienceParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewLobMailAudience>>,
        TError,
        {data: BodyType<LobMailAudienceReviewInput>;params?: ReviewLobMailAudienceParams},
        TContext
      > => {
      return useMutation(getReviewLobMailAudienceMutationOptions(options), queryClient);
    }

export const getPreflightLobMailArtworkUrl = (params?: PreflightLobMailArtworkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/preflight?${stringifiedParams}` : `/api/lob-mail/automation/preflight`
}

/**
 * @summary Verify selected artwork and imported contact merge fields without sending mail
 */
export const preflightLobMailArtwork = async (lobArtworkPreflightInput: LobArtworkPreflightInput,
    params?: PreflightLobMailArtworkParams, options?: RequestInit): Promise<LobArtworkPreflightResult> => {

  return customFetch<LobArtworkPreflightResult>(getPreflightLobMailArtworkUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobArtworkPreflightInput)
  }
);}




export const getPreflightLobMailArtworkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightLobMailArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreflightLobMailArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof preflightLobMailArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreflightLobMailArtworkParams}, TContext> => {

const mutationKey = ['preflightLobMailArtwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof preflightLobMailArtwork>>, {data: BodyType<LobArtworkPreflightInput>;params?: PreflightLobMailArtworkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  preflightLobMailArtwork(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreflightLobMailArtworkMutationResult = NonNullable<Awaited<ReturnType<typeof preflightLobMailArtwork>>>
    export type PreflightLobMailArtworkMutationBody = BodyType<LobArtworkPreflightInput>
    export type PreflightLobMailArtworkMutationError = ErrorType<void>

    /**
 * @summary Verify selected artwork and imported contact merge fields without sending mail
 */
export const usePreflightLobMailArtwork = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightLobMailArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreflightLobMailArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof preflightLobMailArtwork>>,
        TError,
        {data: BodyType<LobArtworkPreflightInput>;params?: PreflightLobMailArtworkParams},
        TContext
      > => {
      return useMutation(getPreflightLobMailArtworkMutationOptions(options), queryClient);
    }

export const getGenerateLobQrMailingTokensUrl = (params?: GenerateLobQrMailingTokensParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-tokens?${stringifiedParams}` : `/api/lob-mail/automation/qr-tokens`
}

/**
 * @summary Reserve unique tokens only for eligible selected mailing-list recipients
 */
export const generateLobQrMailingTokens = async (lobQrTokenBatchInput: LobQrTokenBatchInput,
    params?: GenerateLobQrMailingTokensParams, options?: RequestInit): Promise<LobQrTokenBatch> => {

  return customFetch<LobQrTokenBatch>(getGenerateLobQrMailingTokensUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobQrTokenBatchInput)
  }
);}




export const getGenerateLobQrMailingTokensMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLobQrMailingTokens>>, TError,{data: BodyType<LobQrTokenBatchInput>;params?: GenerateLobQrMailingTokensParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateLobQrMailingTokens>>, TError,{data: BodyType<LobQrTokenBatchInput>;params?: GenerateLobQrMailingTokensParams}, TContext> => {

const mutationKey = ['generateLobQrMailingTokens'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLobQrMailingTokens>>, {data: BodyType<LobQrTokenBatchInput>;params?: GenerateLobQrMailingTokensParams}> = (props) => {
          const {data,params} = props ?? {};

          return  generateLobQrMailingTokens(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateLobQrMailingTokensMutationResult = NonNullable<Awaited<ReturnType<typeof generateLobQrMailingTokens>>>
    export type GenerateLobQrMailingTokensMutationBody = BodyType<LobQrTokenBatchInput>
    export type GenerateLobQrMailingTokensMutationError = ErrorType<void>

    /**
 * @summary Reserve unique tokens only for eligible selected mailing-list recipients
 */
export const useGenerateLobQrMailingTokens = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLobQrMailingTokens>>, TError,{data: BodyType<LobQrTokenBatchInput>;params?: GenerateLobQrMailingTokensParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLobQrMailingTokens>>,
        TError,
        {data: BodyType<LobQrTokenBatchInput>;params?: GenerateLobQrMailingTokensParams},
        TContext
      > => {
      return useMutation(getGenerateLobQrMailingTokensMutationOptions(options), queryClient);
    }

export const getGetLobQrMailingTokensUrl = (params: GetLobQrMailingTokensParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-tokens?${stringifiedParams}` : `/api/lob-mail/automation/qr-tokens`
}

export const getLobQrMailingTokens = async (params: GetLobQrMailingTokensParams, options?: RequestInit): Promise<LobQrTokenBatch> => {

  return customFetch<LobQrTokenBatch>(getGetLobQrMailingTokensUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobQrMailingTokensQueryKey = (params?: GetLobQrMailingTokensParams,) => {
    return [
    `/api/lob-mail/automation/qr-tokens`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobQrMailingTokensQueryOptions = <TData = Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError = ErrorType<void>>(params: GetLobQrMailingTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobQrMailingTokensQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobQrMailingTokens>>> = ({ signal }) => getLobQrMailingTokens(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobQrMailingTokensQueryResult = NonNullable<Awaited<ReturnType<typeof getLobQrMailingTokens>>>
export type GetLobQrMailingTokensQueryError = ErrorType<void>


export function useGetLobQrMailingTokens<TData = Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError = ErrorType<void>>(
 params: GetLobQrMailingTokensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrMailingTokens>>,
          TError,
          Awaited<ReturnType<typeof getLobQrMailingTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrMailingTokens<TData = Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError = ErrorType<void>>(
 params: GetLobQrMailingTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrMailingTokens>>,
          TError,
          Awaited<ReturnType<typeof getLobQrMailingTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrMailingTokens<TData = Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError = ErrorType<void>>(
 params: GetLobQrMailingTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobQrMailingTokens<TData = Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError = ErrorType<void>>(
 params: GetLobQrMailingTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrMailingTokens>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobQrMailingTokensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateLobQrTestProofUrl = (params?: GenerateLobQrTestProofParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-proof?${stringifiedParams}` : `/api/lob-mail/automation/qr-proof`
}

/**
 * @summary Explicitly generate an isolated Lob test-mode aesthetic proof
 */
export const generateLobQrTestProof = async (lobQrProofInput: LobQrProofInput,
    params?: GenerateLobQrTestProofParams, options?: RequestInit): Promise<LobQrTestProof> => {

  return customFetch<LobQrTestProof>(getGenerateLobQrTestProofUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobQrProofInput)
  }
);}




export const getGenerateLobQrTestProofMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLobQrTestProof>>, TError,{data: BodyType<LobQrProofInput>;params?: GenerateLobQrTestProofParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateLobQrTestProof>>, TError,{data: BodyType<LobQrProofInput>;params?: GenerateLobQrTestProofParams}, TContext> => {

const mutationKey = ['generateLobQrTestProof'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLobQrTestProof>>, {data: BodyType<LobQrProofInput>;params?: GenerateLobQrTestProofParams}> = (props) => {
          const {data,params} = props ?? {};

          return  generateLobQrTestProof(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateLobQrTestProofMutationResult = NonNullable<Awaited<ReturnType<typeof generateLobQrTestProof>>>
    export type GenerateLobQrTestProofMutationBody = BodyType<LobQrProofInput>
    export type GenerateLobQrTestProofMutationError = ErrorType<void>

    /**
 * @summary Explicitly generate an isolated Lob test-mode aesthetic proof
 */
export const useGenerateLobQrTestProof = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLobQrTestProof>>, TError,{data: BodyType<LobQrProofInput>;params?: GenerateLobQrTestProofParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLobQrTestProof>>,
        TError,
        {data: BodyType<LobQrProofInput>;params?: GenerateLobQrTestProofParams},
        TContext
      > => {
      return useMutation(getGenerateLobQrTestProofMutationOptions(options), queryClient);
    }

export const getGetLobQrTestProofUrl = (params: GetLobQrTestProofParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-proof?${stringifiedParams}` : `/api/lob-mail/automation/qr-proof`
}

export const getLobQrTestProof = async (params: GetLobQrTestProofParams, options?: RequestInit): Promise<LobQrTestProof> => {

  return customFetch<LobQrTestProof>(getGetLobQrTestProofUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobQrTestProofQueryKey = (params?: GetLobQrTestProofParams,) => {
    return [
    `/api/lob-mail/automation/qr-proof`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobQrTestProofQueryOptions = <TData = Awaited<ReturnType<typeof getLobQrTestProof>>, TError = ErrorType<void>>(params: GetLobQrTestProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobQrTestProofQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobQrTestProof>>> = ({ signal }) => getLobQrTestProof(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobQrTestProofQueryResult = NonNullable<Awaited<ReturnType<typeof getLobQrTestProof>>>
export type GetLobQrTestProofQueryError = ErrorType<void>


export function useGetLobQrTestProof<TData = Awaited<ReturnType<typeof getLobQrTestProof>>, TError = ErrorType<void>>(
 params: GetLobQrTestProofParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrTestProof>>,
          TError,
          Awaited<ReturnType<typeof getLobQrTestProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrTestProof<TData = Awaited<ReturnType<typeof getLobQrTestProof>>, TError = ErrorType<void>>(
 params: GetLobQrTestProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobQrTestProof>>,
          TError,
          Awaited<ReturnType<typeof getLobQrTestProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobQrTestProof<TData = Awaited<ReturnType<typeof getLobQrTestProof>>, TError = ErrorType<void>>(
 params: GetLobQrTestProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobQrTestProof<TData = Awaited<ReturnType<typeof getLobQrTestProof>>, TError = ErrorType<void>>(
 params: GetLobQrTestProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobQrTestProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobQrTestProofQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewLobPrintLayoutUrl = (params?: PreviewLobPrintLayoutParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/layout-preview?${stringifiedParams}` : `/api/lob-mail/automation/layout-preview`
}

/**
 * @summary Read-only exact HTML and QR print-layout preflight
 */
export const previewLobPrintLayout = async (lobPrintLayoutInput: LobPrintLayoutInput,
    params?: PreviewLobPrintLayoutParams, options?: RequestInit): Promise<LobPrintLayoutResponse> => {

  return customFetch<LobPrintLayoutResponse>(getPreviewLobPrintLayoutUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobPrintLayoutInput)
  }
);}




export const getPreviewLobPrintLayoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobPrintLayout>>, TError,{data: BodyType<LobPrintLayoutInput>;params?: PreviewLobPrintLayoutParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobPrintLayout>>, TError,{data: BodyType<LobPrintLayoutInput>;params?: PreviewLobPrintLayoutParams}, TContext> => {

const mutationKey = ['previewLobPrintLayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobPrintLayout>>, {data: BodyType<LobPrintLayoutInput>;params?: PreviewLobPrintLayoutParams}> = (props) => {
          const {data,params} = props ?? {};

          return  previewLobPrintLayout(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobPrintLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobPrintLayout>>>
    export type PreviewLobPrintLayoutMutationBody = BodyType<LobPrintLayoutInput>
    export type PreviewLobPrintLayoutMutationError = ErrorType<unknown>

    /**
 * @summary Read-only exact HTML and QR print-layout preflight
 */
export const usePreviewLobPrintLayout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobPrintLayout>>, TError,{data: BodyType<LobPrintLayoutInput>;params?: PreviewLobPrintLayoutParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobPrintLayout>>,
        TError,
        {data: BodyType<LobPrintLayoutInput>;params?: PreviewLobPrintLayoutParams},
        TContext
      > => {
      return useMutation(getPreviewLobPrintLayoutMutationOptions(options), queryClient);
    }

export const getPreviewLobCampaignPrintLayoutUrl = (id: string,
    params?: PreviewLobCampaignPrintLayoutParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/campaigns/${id}/layout-preview?${stringifiedParams}` : `/api/lob-mail/campaigns/${id}/layout-preview`
}

export const previewLobCampaignPrintLayout = async (id: string,
    lobPrintLayoutInput: LobPrintLayoutInput,
    params?: PreviewLobCampaignPrintLayoutParams, options?: RequestInit): Promise<LobPrintLayoutResponse> => {

  return customFetch<LobPrintLayoutResponse>(getPreviewLobCampaignPrintLayoutUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobPrintLayoutInput)
  }
);}




export const getPreviewLobCampaignPrintLayoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>, TError,{id: string;data: BodyType<LobPrintLayoutInput>;params?: PreviewLobCampaignPrintLayoutParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>, TError,{id: string;data: BodyType<LobPrintLayoutInput>;params?: PreviewLobCampaignPrintLayoutParams}, TContext> => {

const mutationKey = ['previewLobCampaignPrintLayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>, {id: string;data: BodyType<LobPrintLayoutInput>;params?: PreviewLobCampaignPrintLayoutParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  previewLobCampaignPrintLayout(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobCampaignPrintLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>>
    export type PreviewLobCampaignPrintLayoutMutationBody = BodyType<LobPrintLayoutInput>
    export type PreviewLobCampaignPrintLayoutMutationError = ErrorType<unknown>

    export const usePreviewLobCampaignPrintLayout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>, TError,{id: string;data: BodyType<LobPrintLayoutInput>;params?: PreviewLobCampaignPrintLayoutParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobCampaignPrintLayout>>,
        TError,
        {id: string;data: BodyType<LobPrintLayoutInput>;params?: PreviewLobCampaignPrintLayoutParams},
        TContext
      > => {
      return useMutation(getPreviewLobCampaignPrintLayoutMutationOptions(options), queryClient);
    }

export const getRequestLobQrLogoUploadUrl = (params?: RequestLobQrLogoUploadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-logo/upload-url?${stringifiedParams}` : `/api/lob-mail/automation/qr-logo/upload-url`
}

export const requestLobQrLogoUpload = async (lobQrLogoInput: LobQrLogoInput,
    params?: RequestLobQrLogoUploadParams, options?: RequestInit): Promise<RequestLobQrLogoUpload200> => {

  return customFetch<RequestLobQrLogoUpload200>(getRequestLobQrLogoUploadUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobQrLogoInput)
  }
);}




export const getRequestLobQrLogoUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLobQrLogoUpload>>, TError,{data: BodyType<LobQrLogoInput>;params?: RequestLobQrLogoUploadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestLobQrLogoUpload>>, TError,{data: BodyType<LobQrLogoInput>;params?: RequestLobQrLogoUploadParams}, TContext> => {

const mutationKey = ['requestLobQrLogoUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestLobQrLogoUpload>>, {data: BodyType<LobQrLogoInput>;params?: RequestLobQrLogoUploadParams}> = (props) => {
          const {data,params} = props ?? {};

          return  requestLobQrLogoUpload(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestLobQrLogoUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestLobQrLogoUpload>>>
    export type RequestLobQrLogoUploadMutationBody = BodyType<LobQrLogoInput>
    export type RequestLobQrLogoUploadMutationError = ErrorType<unknown>

    export const useRequestLobQrLogoUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLobQrLogoUpload>>, TError,{data: BodyType<LobQrLogoInput>;params?: RequestLobQrLogoUploadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestLobQrLogoUpload>>,
        TError,
        {data: BodyType<LobQrLogoInput>;params?: RequestLobQrLogoUploadParams},
        TContext
      > => {
      return useMutation(getRequestLobQrLogoUploadMutationOptions(options), queryClient);
    }

export const getRegisterLobQrLogoUrl = (params?: RegisterLobQrLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-logo/register?${stringifiedParams}` : `/api/lob-mail/automation/qr-logo/register`
}

export const registerLobQrLogo = async (lobQrLogoInput: LobQrLogoInput,
    params?: RegisterLobQrLogoParams, options?: RequestInit): Promise<RegisterLobQrLogo200> => {

  return customFetch<RegisterLobQrLogo200>(getRegisterLobQrLogoUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobQrLogoInput)
  }
);}




export const getRegisterLobQrLogoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: RegisterLobQrLogoParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: RegisterLobQrLogoParams}, TContext> => {

const mutationKey = ['registerLobQrLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerLobQrLogo>>, {data: BodyType<LobQrLogoInput>;params?: RegisterLobQrLogoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  registerLobQrLogo(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterLobQrLogoMutationResult = NonNullable<Awaited<ReturnType<typeof registerLobQrLogo>>>
    export type RegisterLobQrLogoMutationBody = BodyType<LobQrLogoInput>
    export type RegisterLobQrLogoMutationError = ErrorType<unknown>

    export const useRegisterLobQrLogo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: RegisterLobQrLogoParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerLobQrLogo>>,
        TError,
        {data: BodyType<LobQrLogoInput>;params?: RegisterLobQrLogoParams},
        TContext
      > => {
      return useMutation(getRegisterLobQrLogoMutationOptions(options), queryClient);
    }

export const getPreviewLobQrLogoUrl = (params?: PreviewLobQrLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/qr-logo/preview?${stringifiedParams}` : `/api/lob-mail/automation/qr-logo/preview`
}

export const previewLobQrLogo = async (lobQrLogoInput: LobQrLogoInput,
    params?: PreviewLobQrLogoParams, options?: RequestInit): Promise<PreviewLobQrLogo200> => {

  return customFetch<PreviewLobQrLogo200>(getPreviewLobQrLogoUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobQrLogoInput)
  }
);}




export const getPreviewLobQrLogoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: PreviewLobQrLogoParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: PreviewLobQrLogoParams}, TContext> => {

const mutationKey = ['previewLobQrLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobQrLogo>>, {data: BodyType<LobQrLogoInput>;params?: PreviewLobQrLogoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  previewLobQrLogo(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobQrLogoMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobQrLogo>>>
    export type PreviewLobQrLogoMutationBody = BodyType<LobQrLogoInput>
    export type PreviewLobQrLogoMutationError = ErrorType<unknown>

    export const usePreviewLobQrLogo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobQrLogo>>, TError,{data: BodyType<LobQrLogoInput>;params?: PreviewLobQrLogoParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobQrLogo>>,
        TError,
        {data: BodyType<LobQrLogoInput>;params?: PreviewLobQrLogoParams},
        TContext
      > => {
      return useMutation(getPreviewLobQrLogoMutationOptions(options), queryClient);
    }

export const getGetLobContactMailpiecesUrl = (params: GetLobContactMailpiecesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/contact-mailpieces?${stringifiedParams}` : `/api/lob-mail/automation/contact-mailpieces`
}

export const getLobContactMailpieces = async (params: GetLobContactMailpiecesParams, options?: RequestInit): Promise<GetLobContactMailpieces200> => {

  return customFetch<GetLobContactMailpieces200>(getGetLobContactMailpiecesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobContactMailpiecesQueryKey = (params?: GetLobContactMailpiecesParams,) => {
    return [
    `/api/lob-mail/automation/contact-mailpieces`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobContactMailpiecesQueryOptions = <TData = Awaited<ReturnType<typeof getLobContactMailpieces>>, TError = ErrorType<unknown>>(params: GetLobContactMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobContactMailpiecesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobContactMailpieces>>> = ({ signal }) => getLobContactMailpieces(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobContactMailpiecesQueryResult = NonNullable<Awaited<ReturnType<typeof getLobContactMailpieces>>>
export type GetLobContactMailpiecesQueryError = ErrorType<unknown>


export function useGetLobContactMailpieces<TData = Awaited<ReturnType<typeof getLobContactMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobContactMailpiecesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobContactMailpieces>>,
          TError,
          Awaited<ReturnType<typeof getLobContactMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobContactMailpieces<TData = Awaited<ReturnType<typeof getLobContactMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobContactMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobContactMailpieces>>,
          TError,
          Awaited<ReturnType<typeof getLobContactMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobContactMailpieces<TData = Awaited<ReturnType<typeof getLobContactMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobContactMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobContactMailpieces<TData = Awaited<ReturnType<typeof getLobContactMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobContactMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobContactMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobContactMailpiecesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobAutomationMailpieceProofUrl = (id: string,
    params: GetLobAutomationMailpieceProofParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/mailpiece-proof/${id}?${stringifiedParams}` : `/api/lob-mail/automation/mailpiece-proof/${id}`
}

export const getLobAutomationMailpieceProof = async (id: string,
    params: GetLobAutomationMailpieceProofParams, options?: RequestInit): Promise<GetLobAutomationMailpieceProof200> => {

  return customFetch<GetLobAutomationMailpieceProof200>(getGetLobAutomationMailpieceProofUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAutomationMailpieceProofQueryKey = (id: string,
    params?: GetLobAutomationMailpieceProofParams,) => {
    return [
    `/api/lob-mail/automation/mailpiece-proof/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAutomationMailpieceProofQueryOptions = <TData = Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError = ErrorType<unknown>>(id: string,
    params: GetLobAutomationMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAutomationMailpieceProofQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>> = ({ signal }) => getLobAutomationMailpieceProof(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAutomationMailpieceProofQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>>
export type GetLobAutomationMailpieceProofQueryError = ErrorType<unknown>


export function useGetLobAutomationMailpieceProof<TData = Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetLobAutomationMailpieceProofParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationMailpieceProof<TData = Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetLobAutomationMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAutomationMailpieceProof<TData = Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetLobAutomationMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAutomationMailpieceProof<TData = Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetLobAutomationMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAutomationMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAutomationMailpieceProofQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLobCampaignMailpieceProofUrl = (id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/campaigns/${id}/mailpiece-proof/${pieceId}?${stringifiedParams}` : `/api/lob-mail/campaigns/${id}/mailpiece-proof/${pieceId}`
}

export const getLobCampaignMailpieceProof = async (id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams, options?: RequestInit): Promise<GetLobCampaignMailpieceProof200> => {

  return customFetch<GetLobCampaignMailpieceProof200>(getGetLobCampaignMailpieceProofUrl(id,pieceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobCampaignMailpieceProofQueryKey = (id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams,) => {
    return [
    `/api/lob-mail/campaigns/${id}/mailpiece-proof/${pieceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobCampaignMailpieceProofQueryOptions = <TData = Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError = ErrorType<unknown>>(id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobCampaignMailpieceProofQueryKey(id,pieceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>> = ({ signal }) => getLobCampaignMailpieceProof(id,pieceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && pieceId !== null && pieceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobCampaignMailpieceProofQueryResult = NonNullable<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>>
export type GetLobCampaignMailpieceProofQueryError = ErrorType<unknown>


export function useGetLobCampaignMailpieceProof<TData = Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    pieceId: string,
    params: undefined |  GetLobCampaignMailpieceProofParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignMailpieceProof<TData = Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>,
          TError,
          Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobCampaignMailpieceProof<TData = Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobCampaignMailpieceProof<TData = Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError = ErrorType<unknown>>(
 id: string,
    pieceId: string,
    params?: GetLobCampaignMailpieceProofParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobCampaignMailpieceProof>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobCampaignMailpieceProofQueryOptions(id,pieceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewLobAutomationArtworkUrl = (params?: PreviewLobAutomationArtworkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork-preview?${stringifiedParams}` : `/api/lob-mail/automation/artwork-preview`
}

/**
 * Read-only browser preview. Only verified tenant-owned print assets may appear as URLs; arbitrary remote artwork is rejected.
 * @summary Preview published HTML faces and provide registered print URLs for one tenant-owned contact
 */
export const previewLobAutomationArtwork = async (lobArtworkPreflightInput: LobArtworkPreflightInput,
    params?: PreviewLobAutomationArtworkParams, options?: RequestInit): Promise<PreviewLobAutomationArtwork200> => {

  return customFetch<PreviewLobAutomationArtwork200>(getPreviewLobAutomationArtworkUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobArtworkPreflightInput)
  }
);}




export const getPreviewLobAutomationArtworkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobAutomationArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreviewLobAutomationArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLobAutomationArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreviewLobAutomationArtworkParams}, TContext> => {

const mutationKey = ['previewLobAutomationArtwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLobAutomationArtwork>>, {data: BodyType<LobArtworkPreflightInput>;params?: PreviewLobAutomationArtworkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  previewLobAutomationArtwork(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLobAutomationArtworkMutationResult = NonNullable<Awaited<ReturnType<typeof previewLobAutomationArtwork>>>
    export type PreviewLobAutomationArtworkMutationBody = BodyType<LobArtworkPreflightInput>
    export type PreviewLobAutomationArtworkMutationError = ErrorType<void>

    /**
 * @summary Preview published HTML faces and provide registered print URLs for one tenant-owned contact
 */
export const usePreviewLobAutomationArtwork = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLobAutomationArtwork>>, TError,{data: BodyType<LobArtworkPreflightInput>;params?: PreviewLobAutomationArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLobAutomationArtwork>>,
        TError,
        {data: BodyType<LobArtworkPreflightInput>;params?: PreviewLobAutomationArtworkParams},
        TContext
      > => {
      return useMutation(getPreviewLobAutomationArtworkMutationOptions(options), queryClient);
    }

export const getRequestLobMailArtworkUploadUrlUrl = (params?: RequestLobMailArtworkUploadUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork/upload-url?${stringifiedParams}` : `/api/lob-mail/automation/artwork/upload-url`
}

/**
 * @summary Reserve a tenant-, user-, and environment-scoped Lob artwork upload
 */
export const requestLobMailArtworkUploadUrl = async (lobArtworkUploadUrlInput: LobArtworkUploadUrlInput,
    params?: RequestLobMailArtworkUploadUrlParams, options?: RequestInit): Promise<LobArtworkUploadUrlResult> => {

  return customFetch<LobArtworkUploadUrlResult>(getRequestLobMailArtworkUploadUrlUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobArtworkUploadUrlInput)
  }
);}




export const getRequestLobMailArtworkUploadUrlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>, TError,{data: BodyType<LobArtworkUploadUrlInput>;params?: RequestLobMailArtworkUploadUrlParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>, TError,{data: BodyType<LobArtworkUploadUrlInput>;params?: RequestLobMailArtworkUploadUrlParams}, TContext> => {

const mutationKey = ['requestLobMailArtworkUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>, {data: BodyType<LobArtworkUploadUrlInput>;params?: RequestLobMailArtworkUploadUrlParams}> = (props) => {
          const {data,params} = props ?? {};

          return  requestLobMailArtworkUploadUrl(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestLobMailArtworkUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>>
    export type RequestLobMailArtworkUploadUrlMutationBody = BodyType<LobArtworkUploadUrlInput>
    export type RequestLobMailArtworkUploadUrlMutationError = ErrorType<void>

    /**
 * @summary Reserve a tenant-, user-, and environment-scoped Lob artwork upload
 */
export const useRequestLobMailArtworkUploadUrl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>, TError,{data: BodyType<LobArtworkUploadUrlInput>;params?: RequestLobMailArtworkUploadUrlParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestLobMailArtworkUploadUrl>>,
        TError,
        {data: BodyType<LobArtworkUploadUrlInput>;params?: RequestLobMailArtworkUploadUrlParams},
        TContext
      > => {
      return useMutation(getRequestLobMailArtworkUploadUrlMutationOptions(options), queryClient);
    }

export const getPrepareLobPostcardArtworkUrl = (params?: PrepareLobPostcardArtworkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork/prepare?${stringifiedParams}` : `/api/lob-mail/automation/artwork/prepare`
}

/**
 * @summary Prepare reviewed postcard or US Letter image/HTML artwork without contacting Lob
 */
export const prepareLobPostcardArtwork = async (lobPostcardPreparationInput: LobPostcardPreparationInput,
    params?: PrepareLobPostcardArtworkParams, options?: RequestInit): Promise<LobPostcardPreparationResult> => {

  return customFetch<LobPostcardPreparationResult>(getPrepareLobPostcardArtworkUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobPostcardPreparationInput)
  }
);}




export const getPrepareLobPostcardArtworkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareLobPostcardArtwork>>, TError,{data: BodyType<LobPostcardPreparationInput>;params?: PrepareLobPostcardArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof prepareLobPostcardArtwork>>, TError,{data: BodyType<LobPostcardPreparationInput>;params?: PrepareLobPostcardArtworkParams}, TContext> => {

const mutationKey = ['prepareLobPostcardArtwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareLobPostcardArtwork>>, {data: BodyType<LobPostcardPreparationInput>;params?: PrepareLobPostcardArtworkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  prepareLobPostcardArtwork(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrepareLobPostcardArtworkMutationResult = NonNullable<Awaited<ReturnType<typeof prepareLobPostcardArtwork>>>
    export type PrepareLobPostcardArtworkMutationBody = BodyType<LobPostcardPreparationInput>
    export type PrepareLobPostcardArtworkMutationError = ErrorType<void>

    /**
 * @summary Prepare reviewed postcard or US Letter image/HTML artwork without contacting Lob
 */
export const usePrepareLobPostcardArtwork = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareLobPostcardArtwork>>, TError,{data: BodyType<LobPostcardPreparationInput>;params?: PrepareLobPostcardArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prepareLobPostcardArtwork>>,
        TError,
        {data: BodyType<LobPostcardPreparationInput>;params?: PrepareLobPostcardArtworkParams},
        TContext
      > => {
      return useMutation(getPrepareLobPostcardArtworkMutationOptions(options), queryClient);
    }

export const getRegisterLobMailArtworkUrl = (params?: RegisterLobMailArtworkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/artwork/register?${stringifiedParams}` : `/api/lob-mail/automation/artwork/register`
}

/**
 * @summary Validate uploaded artwork and register verified Lob template faces or print assets
 */
export const registerLobMailArtwork = async (lobArtworkRegisterInput: LobArtworkRegisterInput,
    params?: RegisterLobMailArtworkParams, options?: RequestInit): Promise<LobArtworkRegisterResult> => {

  return customFetch<LobArtworkRegisterResult>(getRegisterLobMailArtworkUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lobArtworkRegisterInput)
  }
);}




export const getRegisterLobMailArtworkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobMailArtwork>>, TError,{data: BodyType<LobArtworkRegisterInput>;params?: RegisterLobMailArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerLobMailArtwork>>, TError,{data: BodyType<LobArtworkRegisterInput>;params?: RegisterLobMailArtworkParams}, TContext> => {

const mutationKey = ['registerLobMailArtwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerLobMailArtwork>>, {data: BodyType<LobArtworkRegisterInput>;params?: RegisterLobMailArtworkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  registerLobMailArtwork(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterLobMailArtworkMutationResult = NonNullable<Awaited<ReturnType<typeof registerLobMailArtwork>>>
    export type RegisterLobMailArtworkMutationBody = BodyType<LobArtworkRegisterInput>
    export type RegisterLobMailArtworkMutationError = ErrorType<void>

    /**
 * @summary Validate uploaded artwork and register verified Lob template faces or print assets
 */
export const useRegisterLobMailArtwork = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerLobMailArtwork>>, TError,{data: BodyType<LobArtworkRegisterInput>;params?: RegisterLobMailArtworkParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerLobMailArtwork>>,
        TError,
        {data: BodyType<LobArtworkRegisterInput>;params?: RegisterLobMailArtworkParams},
        TContext
      > => {
      return useMutation(getRegisterLobMailArtworkMutationOptions(options), queryClient);
    }

export const getGetRegisteredLobPrintArtworkUrl = (assetId: string,) => {




  return `/api/lob-mail/automation/artwork/print/${assetId}.pdf`
}

/**
 * @summary Serve only verified, registered print-ready artwork to Lob
 */
export const getRegisteredLobPrintArtwork = async (assetId: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetRegisteredLobPrintArtworkUrl(assetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRegisteredLobPrintArtworkQueryKey = (assetId: string,) => {
    return [
    `/api/lob-mail/automation/artwork/print/${assetId}.pdf`
    ] as const;
    }


export const getGetRegisteredLobPrintArtworkQueryOptions = <TData = Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError = ErrorType<void>>(assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegisteredLobPrintArtworkQueryKey(assetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>> = ({ signal }) => getRegisteredLobPrintArtwork(assetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: assetId !== null && assetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegisteredLobPrintArtworkQueryResult = NonNullable<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>>
export type GetRegisteredLobPrintArtworkQueryError = ErrorType<void>


export function useGetRegisteredLobPrintArtwork<TData = Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError = ErrorType<void>>(
 assetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>,
          TError,
          Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegisteredLobPrintArtwork<TData = Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError = ErrorType<void>>(
 assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>,
          TError,
          Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegisteredLobPrintArtwork<TData = Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError = ErrorType<void>>(
 assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve only verified, registered print-ready artwork to Lob
 */

export function useGetRegisteredLobPrintArtwork<TData = Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError = ErrorType<void>>(
 assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegisteredLobPrintArtwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegisteredLobPrintArtworkQueryOptions(assetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobMailAutomationKeyUrl = () => {




  return `/api/lob-mail/automation/key`
}

/**
 * @summary Rotate the bridge credential and reveal it once
 */
export const createLobMailAutomationKey = async ( options?: RequestInit): Promise<LobMailAutomationKeyResponse> => {

  return customFetch<LobMailAutomationKeyResponse>(getCreateLobMailAutomationKeyUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateLobMailAutomationKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationKey>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationKey>>, TError,void, TContext> => {

const mutationKey = ['createLobMailAutomationKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobMailAutomationKey>>, void> = () => {


          return  createLobMailAutomationKey(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobMailAutomationKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createLobMailAutomationKey>>>

    export type CreateLobMailAutomationKeyMutationError = ErrorType<unknown>

    /**
 * @summary Rotate the bridge credential and reveal it once
 */
export const useCreateLobMailAutomationKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobMailAutomationKey>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobMailAutomationKey>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateLobMailAutomationKeyMutationOptions(options), queryClient);
    }

export const getReceiveCrmMailAutomationEventUrl = (automationId: number,) => {




  return `/api/webhooks/crm-mail-automation/${automationId}/event`
}

/**
 * Authenticated by the tenant's mail automation bridge key. Only CRM record identity and stable event identity are accepted; matching uses current tenant CRM mirror values. This queues a reviewable run and never dispatches mail directly.
 * @summary Queue one-contact run from a Make event for a saved automation
 */
export const receiveCrmMailAutomationEvent = async (automationId: number,
    crmMailAutomationEventInput: CrmMailAutomationEventInput, options?: RequestInit): Promise<CrmMailAutomationWebhookResult> => {

  return customFetch<CrmMailAutomationWebhookResult>(getReceiveCrmMailAutomationEventUrl(automationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(crmMailAutomationEventInput)
  }
);}




export const getReceiveCrmMailAutomationEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>, TError,{automationId: number;data: BodyType<CrmMailAutomationEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>, TError,{automationId: number;data: BodyType<CrmMailAutomationEventInput>}, TContext> => {

const mutationKey = ['receiveCrmMailAutomationEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>, {automationId: number;data: BodyType<CrmMailAutomationEventInput>}> = (props) => {
          const {automationId,data} = props ?? {};

          return  receiveCrmMailAutomationEvent(automationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveCrmMailAutomationEventMutationResult = NonNullable<Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>>
    export type ReceiveCrmMailAutomationEventMutationBody = BodyType<CrmMailAutomationEventInput>
    export type ReceiveCrmMailAutomationEventMutationError = ErrorType<void>

    /**
 * @summary Queue one-contact run from a Make event for a saved automation
 */
export const useReceiveCrmMailAutomationEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>, TError,{automationId: number;data: BodyType<CrmMailAutomationEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receiveCrmMailAutomationEvent>>,
        TError,
        {automationId: number;data: BodyType<CrmMailAutomationEventInput>},
        TContext
      > => {
      return useMutation(getReceiveCrmMailAutomationEventMutationOptions(options), queryClient);
    }

export const getReviewAddressListDeletionUrl = (id: number,
    params?: ReviewAddressListDeletionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/deletion-review?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/deletion-review`
}

export const reviewAddressListDeletion = async (id: number,
    params?: ReviewAddressListDeletionParams, options?: RequestInit): Promise<AddressListDeletionReview> => {

  return customFetch<AddressListDeletionReview>(getReviewAddressListDeletionUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReviewAddressListDeletionQueryKey = (id: number,
    params?: ReviewAddressListDeletionParams,) => {
    return [
    `/api/lob-mail/address-book/lists/${id}/deletion-review`, ...(params ? [params] : [])
    ] as const;
    }


export const getReviewAddressListDeletionQueryOptions = <TData = Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError = ErrorType<unknown>>(id: number,
    params?: ReviewAddressListDeletionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReviewAddressListDeletionQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reviewAddressListDeletion>>> = ({ signal }) => reviewAddressListDeletion(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReviewAddressListDeletionQueryResult = NonNullable<Awaited<ReturnType<typeof reviewAddressListDeletion>>>
export type ReviewAddressListDeletionQueryError = ErrorType<unknown>


export function useReviewAddressListDeletion<TData = Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  ReviewAddressListDeletionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewAddressListDeletion>>,
          TError,
          Awaited<ReturnType<typeof reviewAddressListDeletion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewAddressListDeletion<TData = Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ReviewAddressListDeletionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewAddressListDeletion>>,
          TError,
          Awaited<ReturnType<typeof reviewAddressListDeletion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewAddressListDeletion<TData = Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ReviewAddressListDeletionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReviewAddressListDeletion<TData = Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError = ErrorType<unknown>>(
 id: number,
    params?: ReviewAddressListDeletionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewAddressListDeletion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReviewAddressListDeletionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteReviewedAddressListUrl = (params?: DeleteReviewedAddressListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/list-deletions?${stringifiedParams}` : `/api/lob-mail/address-book/list-deletions`
}

export const deleteReviewedAddressList = async (addressListDeletionInput: AddressListDeletionInput,
    params?: DeleteReviewedAddressListParams, options?: RequestInit): Promise<AddressListDeletionResult> => {

  return customFetch<AddressListDeletionResult>(getDeleteReviewedAddressListUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressListDeletionInput)
  }
);}




export const getDeleteReviewedAddressListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReviewedAddressList>>, TError,{data: BodyType<AddressListDeletionInput>;params?: DeleteReviewedAddressListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReviewedAddressList>>, TError,{data: BodyType<AddressListDeletionInput>;params?: DeleteReviewedAddressListParams}, TContext> => {

const mutationKey = ['deleteReviewedAddressList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReviewedAddressList>>, {data: BodyType<AddressListDeletionInput>;params?: DeleteReviewedAddressListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteReviewedAddressList(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReviewedAddressListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReviewedAddressList>>>
    export type DeleteReviewedAddressListMutationBody = BodyType<AddressListDeletionInput>
    export type DeleteReviewedAddressListMutationError = ErrorType<void>

    export const useDeleteReviewedAddressList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReviewedAddressList>>, TError,{data: BodyType<AddressListDeletionInput>;params?: DeleteReviewedAddressListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteReviewedAddressList>>,
        TError,
        {data: BodyType<AddressListDeletionInput>;params?: DeleteReviewedAddressListParams},
        TContext
      > => {
      return useMutation(getDeleteReviewedAddressListMutationOptions(options), queryClient);
    }

export const getGetLobAddressBookListsUrl = (params?: GetLobAddressBookListsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists?${stringifiedParams}` : `/api/lob-mail/address-book/lists`
}

export const getLobAddressBookLists = async (params?: GetLobAddressBookListsParams, options?: RequestInit): Promise<GetLobAddressBookLists200> => {

  return customFetch<GetLobAddressBookLists200>(getGetLobAddressBookListsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressBookListsQueryKey = (params?: GetLobAddressBookListsParams,) => {
    return [
    `/api/lob-mail/address-book/lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressBookListsQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressBookLists>>, TError = ErrorType<unknown>>(params?: GetLobAddressBookListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressBookListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressBookLists>>> = ({ signal }) => getLobAddressBookLists(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressBookListsQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressBookLists>>>
export type GetLobAddressBookListsQueryError = ErrorType<unknown>


export function useGetLobAddressBookLists<TData = Awaited<ReturnType<typeof getLobAddressBookLists>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLobAddressBookListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookLists>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookLists<TData = Awaited<ReturnType<typeof getLobAddressBookLists>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookLists>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookLists<TData = Awaited<ReturnType<typeof getLobAddressBookLists>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddressBookLists<TData = Awaited<ReturnType<typeof getLobAddressBookLists>>, TError = ErrorType<unknown>>(
 params?: GetLobAddressBookListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressBookListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLobAddressBookListUrl = (params?: CreateLobAddressBookListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists?${stringifiedParams}` : `/api/lob-mail/address-book/lists`
}

export const createLobAddressBookList = async (addressListInput: AddressListInput,
    params?: CreateLobAddressBookListParams, options?: RequestInit): Promise<LobAddressBookList> => {

  return customFetch<LobAddressBookList>(getCreateLobAddressBookListUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressListInput)
  }
);}




export const getCreateLobAddressBookListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookList>>, TError,{data: BodyType<AddressListInput>;params?: CreateLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookList>>, TError,{data: BodyType<AddressListInput>;params?: CreateLobAddressBookListParams}, TContext> => {

const mutationKey = ['createLobAddressBookList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLobAddressBookList>>, {data: BodyType<AddressListInput>;params?: CreateLobAddressBookListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createLobAddressBookList(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLobAddressBookListMutationResult = NonNullable<Awaited<ReturnType<typeof createLobAddressBookList>>>
    export type CreateLobAddressBookListMutationBody = BodyType<AddressListInput>
    export type CreateLobAddressBookListMutationError = ErrorType<unknown>

    export const useCreateLobAddressBookList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLobAddressBookList>>, TError,{data: BodyType<AddressListInput>;params?: CreateLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLobAddressBookList>>,
        TError,
        {data: BodyType<AddressListInput>;params?: CreateLobAddressBookListParams},
        TContext
      > => {
      return useMutation(getCreateLobAddressBookListMutationOptions(options), queryClient);
    }

export const getUpdateLobAddressBookListUrl = (id: number,
    params?: UpdateLobAddressBookListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}`
}

export const updateLobAddressBookList = async (id: number,
    addressListUpdate: AddressListUpdate,
    params?: UpdateLobAddressBookListParams, options?: RequestInit): Promise<LobAddressBookList> => {

  return customFetch<LobAddressBookList>(getUpdateLobAddressBookListUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressListUpdate)
  }
);}




export const getUpdateLobAddressBookListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookList>>, TError,{id: number;data: BodyType<AddressListUpdate>;params?: UpdateLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookList>>, TError,{id: number;data: BodyType<AddressListUpdate>;params?: UpdateLobAddressBookListParams}, TContext> => {

const mutationKey = ['updateLobAddressBookList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLobAddressBookList>>, {id: number;data: BodyType<AddressListUpdate>;params?: UpdateLobAddressBookListParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateLobAddressBookList(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLobAddressBookListMutationResult = NonNullable<Awaited<ReturnType<typeof updateLobAddressBookList>>>
    export type UpdateLobAddressBookListMutationBody = BodyType<AddressListUpdate>
    export type UpdateLobAddressBookListMutationError = ErrorType<void>

    export const useUpdateLobAddressBookList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLobAddressBookList>>, TError,{id: number;data: BodyType<AddressListUpdate>;params?: UpdateLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLobAddressBookList>>,
        TError,
        {id: number;data: BodyType<AddressListUpdate>;params?: UpdateLobAddressBookListParams},
        TContext
      > => {
      return useMutation(getUpdateLobAddressBookListMutationOptions(options), queryClient);
    }

export const getDeleteLobAddressBookListUrl = (id: number,
    params: DeleteLobAddressBookListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}`
}

export const deleteLobAddressBookList = async (id: number,
    params: DeleteLobAddressBookListParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLobAddressBookListUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLobAddressBookListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookList>>, TError,{id: number;params: DeleteLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookList>>, TError,{id: number;params: DeleteLobAddressBookListParams}, TContext> => {

const mutationKey = ['deleteLobAddressBookList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLobAddressBookList>>, {id: number;params: DeleteLobAddressBookListParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteLobAddressBookList(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLobAddressBookListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLobAddressBookList>>>

    export type DeleteLobAddressBookListMutationError = ErrorType<void>

    export const useDeleteLobAddressBookList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLobAddressBookList>>, TError,{id: number;params: DeleteLobAddressBookListParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLobAddressBookList>>,
        TError,
        {id: number;params: DeleteLobAddressBookListParams},
        TContext
      > => {
      return useMutation(getDeleteLobAddressBookListMutationOptions(options), queryClient);
    }

export const getGetLobAddressBookListMembersUrl = (id: number,
    params?: GetLobAddressBookListMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/members?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/members`
}

export const getLobAddressBookListMembers = async (id: number,
    params?: GetLobAddressBookListMembersParams, options?: RequestInit): Promise<GetLobAddressBookListMembers200> => {

  return customFetch<GetLobAddressBookListMembers200>(getGetLobAddressBookListMembersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobAddressBookListMembersQueryKey = (id: number,
    params?: GetLobAddressBookListMembersParams,) => {
    return [
    `/api/lob-mail/address-book/lists/${id}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobAddressBookListMembersQueryOptions = <TData = Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError = ErrorType<unknown>>(id: number,
    params?: GetLobAddressBookListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobAddressBookListMembersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobAddressBookListMembers>>> = ({ signal }) => getLobAddressBookListMembers(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobAddressBookListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getLobAddressBookListMembers>>>
export type GetLobAddressBookListMembersQueryError = ErrorType<unknown>


export function useGetLobAddressBookListMembers<TData = Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetLobAddressBookListMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookListMembers>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookListMembers<TData = Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetLobAddressBookListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobAddressBookListMembers>>,
          TError,
          Awaited<ReturnType<typeof getLobAddressBookListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobAddressBookListMembers<TData = Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetLobAddressBookListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobAddressBookListMembers<TData = Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetLobAddressBookListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobAddressBookListMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobAddressBookListMembersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLockLobAddressBookListColumnUrl = (id: number,
    fieldKey: string,
    params?: LockLobAddressBookListColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/locks/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/locks/${fieldKey}`
}

export const lockLobAddressBookListColumn = async (id: number,
    fieldKey: string,
    lockLobAddressBookListColumnBody: LockLobAddressBookListColumnBody,
    params?: LockLobAddressBookListColumnParams, options?: RequestInit): Promise<LobAddressBookList> => {

  return customFetch<LobAddressBookList>(getLockLobAddressBookListColumnUrl(id,fieldKey,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lockLobAddressBookListColumnBody)
  }
);}




export const getLockLobAddressBookListColumnMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockLobAddressBookListColumn>>, TError,{id: number;fieldKey: string;data: BodyType<LockLobAddressBookListColumnBody>;params?: LockLobAddressBookListColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lockLobAddressBookListColumn>>, TError,{id: number;fieldKey: string;data: BodyType<LockLobAddressBookListColumnBody>;params?: LockLobAddressBookListColumnParams}, TContext> => {

const mutationKey = ['lockLobAddressBookListColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockLobAddressBookListColumn>>, {id: number;fieldKey: string;data: BodyType<LockLobAddressBookListColumnBody>;params?: LockLobAddressBookListColumnParams}> = (props) => {
          const {id,fieldKey,data,params} = props ?? {};

          return  lockLobAddressBookListColumn(id,fieldKey,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockLobAddressBookListColumnMutationResult = NonNullable<Awaited<ReturnType<typeof lockLobAddressBookListColumn>>>
    export type LockLobAddressBookListColumnMutationBody = BodyType<LockLobAddressBookListColumnBody>
    export type LockLobAddressBookListColumnMutationError = ErrorType<void>

    export const useLockLobAddressBookListColumn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockLobAddressBookListColumn>>, TError,{id: number;fieldKey: string;data: BodyType<LockLobAddressBookListColumnBody>;params?: LockLobAddressBookListColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lockLobAddressBookListColumn>>,
        TError,
        {id: number;fieldKey: string;data: BodyType<LockLobAddressBookListColumnBody>;params?: LockLobAddressBookListColumnParams},
        TContext
      > => {
      return useMutation(getLockLobAddressBookListColumnMutationOptions(options), queryClient);
    }

export const getOverrideLobAddressBookListCellUrl = (id: number,
    recipientRef: string,
    fieldKey: string,
    params?: OverrideLobAddressBookListCellParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/members/${recipientRef}/cells/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/members/${recipientRef}/cells/${fieldKey}`
}

export const overrideLobAddressBookListCell = async (id: number,
    recipientRef: string,
    fieldKey: string,
    overrideLobAddressBookListCellBody: OverrideLobAddressBookListCellBody,
    params?: OverrideLobAddressBookListCellParams, options?: RequestInit): Promise<LobAddressBookList> => {

  return customFetch<LobAddressBookList>(getOverrideLobAddressBookListCellUrl(id,recipientRef,fieldKey,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideLobAddressBookListCellBody)
  }
);}




export const getOverrideLobAddressBookListCellMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;data: BodyType<OverrideLobAddressBookListCellBody>;params?: OverrideLobAddressBookListCellParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof overrideLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;data: BodyType<OverrideLobAddressBookListCellBody>;params?: OverrideLobAddressBookListCellParams}, TContext> => {

const mutationKey = ['overrideLobAddressBookListCell'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof overrideLobAddressBookListCell>>, {id: number;recipientRef: string;fieldKey: string;data: BodyType<OverrideLobAddressBookListCellBody>;params?: OverrideLobAddressBookListCellParams}> = (props) => {
          const {id,recipientRef,fieldKey,data,params} = props ?? {};

          return  overrideLobAddressBookListCell(id,recipientRef,fieldKey,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OverrideLobAddressBookListCellMutationResult = NonNullable<Awaited<ReturnType<typeof overrideLobAddressBookListCell>>>
    export type OverrideLobAddressBookListCellMutationBody = BodyType<OverrideLobAddressBookListCellBody>
    export type OverrideLobAddressBookListCellMutationError = ErrorType<void>

    export const useOverrideLobAddressBookListCell = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;data: BodyType<OverrideLobAddressBookListCellBody>;params?: OverrideLobAddressBookListCellParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof overrideLobAddressBookListCell>>,
        TError,
        {id: number;recipientRef: string;fieldKey: string;data: BodyType<OverrideLobAddressBookListCellBody>;params?: OverrideLobAddressBookListCellParams},
        TContext
      > => {
      return useMutation(getOverrideLobAddressBookListCellMutationOptions(options), queryClient);
    }

export const getResetLobAddressBookListCellUrl = (id: number,
    recipientRef: string,
    fieldKey: string,
    params: ResetLobAddressBookListCellParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-book/lists/${id}/members/${recipientRef}/cells/${fieldKey}?${stringifiedParams}` : `/api/lob-mail/address-book/lists/${id}/members/${recipientRef}/cells/${fieldKey}`
}

export const resetLobAddressBookListCell = async (id: number,
    recipientRef: string,
    fieldKey: string,
    params: ResetLobAddressBookListCellParams, options?: RequestInit): Promise<LobAddressBookList> => {

  return customFetch<LobAddressBookList>(getResetLobAddressBookListCellUrl(id,recipientRef,fieldKey,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getResetLobAddressBookListCellMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;params: ResetLobAddressBookListCellParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;params: ResetLobAddressBookListCellParams}, TContext> => {

const mutationKey = ['resetLobAddressBookListCell'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetLobAddressBookListCell>>, {id: number;recipientRef: string;fieldKey: string;params: ResetLobAddressBookListCellParams}> = (props) => {
          const {id,recipientRef,fieldKey,params} = props ?? {};

          return  resetLobAddressBookListCell(id,recipientRef,fieldKey,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetLobAddressBookListCellMutationResult = NonNullable<Awaited<ReturnType<typeof resetLobAddressBookListCell>>>

    export type ResetLobAddressBookListCellMutationError = ErrorType<void>

    export const useResetLobAddressBookListCell = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetLobAddressBookListCell>>, TError,{id: number;recipientRef: string;fieldKey: string;params: ResetLobAddressBookListCellParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetLobAddressBookListCell>>,
        TError,
        {id: number;recipientRef: string;fieldKey: string;params: ResetLobAddressBookListCellParams},
        TContext
      > => {
      return useMutation(getResetLobAddressBookListCellMutationOptions(options), queryClient);
    }

export const getRecoverLobAddressImportValuesUrl = (id: string,
    params?: RecoverLobAddressImportValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/address-imports/${id}/recover-values?${stringifiedParams}` : `/api/lob-mail/address-imports/${id}/recover-values`
}

export const recoverLobAddressImportValues = async (id: string,
    params?: RecoverLobAddressImportValuesParams, options?: RequestInit): Promise<RecoverLobAddressImportValues200> => {

  return customFetch<RecoverLobAddressImportValues200>(getRecoverLobAddressImportValuesUrl(id,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRecoverLobAddressImportValuesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverLobAddressImportValues>>, TError,{id: string;params?: RecoverLobAddressImportValuesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverLobAddressImportValues>>, TError,{id: string;params?: RecoverLobAddressImportValuesParams}, TContext> => {

const mutationKey = ['recoverLobAddressImportValues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverLobAddressImportValues>>, {id: string;params?: RecoverLobAddressImportValuesParams}> = (props) => {
          const {id,params} = props ?? {};

          return  recoverLobAddressImportValues(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverLobAddressImportValuesMutationResult = NonNullable<Awaited<ReturnType<typeof recoverLobAddressImportValues>>>

    export type RecoverLobAddressImportValuesMutationError = ErrorType<void>

    export const useRecoverLobAddressImportValues = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverLobAddressImportValues>>, TError,{id: string;params?: RecoverLobAddressImportValuesParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recoverLobAddressImportValues>>,
        TError,
        {id: string;params?: RecoverLobAddressImportValuesParams},
        TContext
      > => {
      return useMutation(getRecoverLobAddressImportValuesMutationOptions(options), queryClient);
    }

export const getGetLobRecipientMailpiecesUrl = (params: GetLobRecipientMailpiecesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lob-mail/automation/mailpieces?${stringifiedParams}` : `/api/lob-mail/automation/mailpieces`
}

export const getLobRecipientMailpieces = async (params: GetLobRecipientMailpiecesParams, options?: RequestInit): Promise<GetLobRecipientMailpieces200> => {

  return customFetch<GetLobRecipientMailpieces200>(getGetLobRecipientMailpiecesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLobRecipientMailpiecesQueryKey = (params?: GetLobRecipientMailpiecesParams,) => {
    return [
    `/api/lob-mail/automation/mailpieces`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLobRecipientMailpiecesQueryOptions = <TData = Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError = ErrorType<unknown>>(params: GetLobRecipientMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLobRecipientMailpiecesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLobRecipientMailpieces>>> = ({ signal }) => getLobRecipientMailpieces(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLobRecipientMailpiecesQueryResult = NonNullable<Awaited<ReturnType<typeof getLobRecipientMailpieces>>>
export type GetLobRecipientMailpiecesQueryError = ErrorType<unknown>


export function useGetLobRecipientMailpieces<TData = Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobRecipientMailpiecesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobRecipientMailpieces>>,
          TError,
          Awaited<ReturnType<typeof getLobRecipientMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobRecipientMailpieces<TData = Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobRecipientMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLobRecipientMailpieces>>,
          TError,
          Awaited<ReturnType<typeof getLobRecipientMailpieces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLobRecipientMailpieces<TData = Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobRecipientMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLobRecipientMailpieces<TData = Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError = ErrorType<unknown>>(
 params: GetLobRecipientMailpiecesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLobRecipientMailpieces>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLobRecipientMailpiecesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReportsApiConnectionUrl = () => {




  return `/api/admin/reports-api`
}

/**
 * Cookie auth only. No View-As or caller client selection. Never returns a stored key.
 * @summary Agency-admin reports-only connection metadata
 */
export const getReportsApiConnection = async ( options?: RequestInit): Promise<ReportsApiConnection> => {

  return customFetch<ReportsApiConnection>(getGetReportsApiConnectionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsApiConnectionQueryKey = () => {
    return [
    `/api/admin/reports-api`
    ] as const;
    }


export const getGetReportsApiConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getReportsApiConnection>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsApiConnectionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsApiConnection>>> = ({ signal }) => getReportsApiConnection({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsApiConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsApiConnection>>>
export type GetReportsApiConnectionQueryError = ErrorType<unknown>


export function useGetReportsApiConnection<TData = Awaited<ReturnType<typeof getReportsApiConnection>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsApiConnection>>,
          TError,
          Awaited<ReturnType<typeof getReportsApiConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsApiConnection<TData = Awaited<ReturnType<typeof getReportsApiConnection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsApiConnection>>,
          TError,
          Awaited<ReturnType<typeof getReportsApiConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsApiConnection<TData = Awaited<ReturnType<typeof getReportsApiConnection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Agency-admin reports-only connection metadata
 */

export function useGetReportsApiConnection<TData = Awaited<ReturnType<typeof getReportsApiConnection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsApiConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsApiConnectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getIssueReportsApiKeyUrl = () => {




  return `/api/admin/reports-api/key`
}

/**
 * @summary Create or rotate a reports-only key, revealed once
 */
export const issueReportsApiKey = async (reportsApiKeyInput: ReportsApiKeyInput, options?: RequestInit): Promise<ReportsApiKeyReveal> => {

  return customFetch<ReportsApiKeyReveal>(getIssueReportsApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reportsApiKeyInput)
  }
);}




export const getIssueReportsApiKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueReportsApiKey>>, TError,{data: BodyType<ReportsApiKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof issueReportsApiKey>>, TError,{data: BodyType<ReportsApiKeyInput>}, TContext> => {

const mutationKey = ['issueReportsApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueReportsApiKey>>, {data: BodyType<ReportsApiKeyInput>}> = (props) => {
          const {data} = props ?? {};

          return  issueReportsApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IssueReportsApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof issueReportsApiKey>>>
    export type IssueReportsApiKeyMutationBody = BodyType<ReportsApiKeyInput>
    export type IssueReportsApiKeyMutationError = ErrorType<unknown>

    /**
 * @summary Create or rotate a reports-only key, revealed once
 */
export const useIssueReportsApiKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueReportsApiKey>>, TError,{data: BodyType<ReportsApiKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof issueReportsApiKey>>,
        TError,
        {data: BodyType<ReportsApiKeyInput>},
        TContext
      > => {
      return useMutation(getIssueReportsApiKeyMutationOptions(options), queryClient);
    }

export const getRevokeReportsApiKeyUrl = () => {




  return `/api/admin/reports-api/key`
}

/**
 * @summary Revoke the reports-only key
 */
export const revokeReportsApiKey = async ( options?: RequestInit): Promise<ReportsApiRevocation> => {

  return customFetch<ReportsApiRevocation>(getRevokeReportsApiKeyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeReportsApiKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeReportsApiKey>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeReportsApiKey>>, TError,void, TContext> => {

const mutationKey = ['revokeReportsApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeReportsApiKey>>, void> = () => {


          return  revokeReportsApiKey(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeReportsApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeReportsApiKey>>>

    export type RevokeReportsApiKeyMutationError = ErrorType<unknown>

    /**
 * @summary Revoke the reports-only key
 */
export const useRevokeReportsApiKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeReportsApiKey>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeReportsApiKey>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeReportsApiKeyMutationOptions(options), queryClient);
    }

export const getGetReportsBotToolSpecUrl = () => {




  return `/api/admin/reports-api/openapi.json`
}

/**
 * @summary Download narrow machine-tool specification
 */
export const getReportsBotToolSpec = async ( options?: RequestInit): Promise<GetReportsBotToolSpec200> => {

  return customFetch<GetReportsBotToolSpec200>(getGetReportsBotToolSpecUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportsBotToolSpecQueryKey = () => {
    return [
    `/api/admin/reports-api/openapi.json`
    ] as const;
    }


export const getGetReportsBotToolSpecQueryOptions = <TData = Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsBotToolSpecQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsBotToolSpec>>> = ({ signal }) => getReportsBotToolSpec({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsBotToolSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsBotToolSpec>>>
export type GetReportsBotToolSpecQueryError = ErrorType<unknown>


export function useGetReportsBotToolSpec<TData = Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBotToolSpec>>,
          TError,
          Awaited<ReturnType<typeof getReportsBotToolSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBotToolSpec<TData = Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBotToolSpec>>,
          TError,
          Awaited<ReturnType<typeof getReportsBotToolSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBotToolSpec<TData = Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download narrow machine-tool specification
 */

export function useGetReportsBotToolSpec<TData = Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBotToolSpec>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsBotToolSpecQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







